// @ts-nocheck
// import { SortTableRowInfo } from "../../components/UI/table/sort_table";
import {
  AccountModule,
  ClientModule,
  DraperyModule,
  NotificationsModule,
  RoomModule,
  RootState,
  SuppliersModule,
  WorkOrderModule,
  WorkroomSettingModule,
} from '../../redux';
import {
  BreadCrumbName,
  BreadCrumbSeparator,
  CalculatorForm,
  CalculatorSectionContainer,
  CalculatorTabs,
  ClientNameSeperator,
  ContentCalculator,
  ContentCalculatorSub,
  DisableAutocompleteInput,
  ErrorsIcon,
  FooterButtonContainer,
  FooterCancelBtn,
  // FooterSaveBtn,
  FooterSaveNextBtn,
  FooterSubContainer,
  HContainer,
  NoIssuesIcon,
  PageContent,
  ResetPanelConfirmation,
  SidebarAlertTitle,
  SidebarButton,
  SidebarCollapseIcon,
  SidebarContainer,
  SidebarContainerSub,
  SidebarExpandIcon,
  SidebarIssuesContainer,
  SidebarIssuesHeader,
  SidebarIssuesTitle,
  SidebarNoIssues,
  TabPanelBox,
  ValidationConfirmationCheckbox,
  ValidationConfirmationContainer,
  ValidationConfirmationElement,
  ValidationErrorElement,
  SidebarIssuesText,
  SidebarSummaryHeader,
} from './styles';
import ClientHoverBox, { getParentClients } from '../clients/client_hover_box';
import RedWarning from '../../assets/icons/red_warning.svg';
import {
  addDraperyOrderFabric,
  deleteDraperyOrderFabric,
  editDraperyOrderFabric,
} from '../../api/drapery-order-fabric';
import DesignTab, {
  AddOnItem,
  defaultBanding,
  defaultCording,
  defaultDraperyOrderDesign,
  defaultEmbellishment,
  defaultEmbellishmentsList,
  defaultFlange,
  defaultOtherEmbellishment,
  defaultTrim,
  defaultWidthEachPanelList,
  draperyLiningsList,
  duplicateDraperyOrderDesign,
  duplicateEmbellishment,
  duplicateLining,
  panelsConfiguration,
  validateDraperyOrderDesign,
  validateEmbellishmentChecked,
  validateEmbellishmentList,
  validateLiningsList,
} from './design-tab';
import {
  validateDraperyOrderDesign as validateDraperyOrderDesignOther,
  validateEmbellishmentList as validateEmbellishmentListOther,
} from './other-item-design-tab';
import {
  validateDraperyOrderDesign as validateDraperyOrderDesignRomanShades,
  validateEmbellishmentListRomanShade,
} from './roman-shade-design-tab';
import { DispatchProp, connect } from 'react-redux';
import FabricsTab, {
  defaultLiningsFabric,
  defaultMainFabric,
  duplicateFabric,
  filterMainFabric,
  validateDraperyOrderFabric,
  validateDraperyOrderLiningsFabric,
  validateDraperyOrderMainFabric,
  validateDraperyOrderMainFabricConfirmations,
} from './fabrics-tab';
import { Prompt, RouteComponentProps } from 'react-router-dom';
import React, { ChangeEvent, KeyboardEvent, PureComponent, createRef } from 'react';
import {
  addDraperyOrder,
  editDraperyOrder,
  getAllInfo,
  userCanCreateNewOrder,
} from '../../api/drapery-order';
import {
  bucketOrderSize,
  logOpenPhase,
  logSavePhase,
  startStopwatch,
  OrderSizeBucket,
} from '../../api/perf-telemetry';
import { checkGate } from '../../statsig';
import {
  getOrderCache,
  setOrderCache,
  invalidateOrderCache,
  OrderCachedBundle,
} from '../../api/order-cache';
import { invalidateClientProjectLists } from '../../api/project-list-cache';
import {
  getClientCacheClient,
  getClientCacheRooms,
  setClientCacheClient,
  setClientCacheRooms,
} from '../../api/client-cache';
import { shouldFetchInitialWorkOrderNum } from './work-order-init';
import UploadTab, { duplicateUploadTab } from './upload-tab';
import {
  addDraperyOrderDesingLining,
  editDraperyOrderDesignLining,
  searchDraperyOrderDesignLining,
} from '../../api/drapery-order-design-lining';
import {
  addDraperyOrderHardware,
  editDraperyOrderHardware,
} from '../../api/drapery-order-hardware';
import {
  addDraperyOrderHeadrail,
  editDraperyOrderHeadrail,
} from '../../api/drapery-order-headrail';
import {
  addDraperyOrderSummaryComponent,
  deleteDraperyOrderSummaryComponents,
  editDraperyOrderSummaryComponent,
  searchDraperyOrderSummaryComponents,
} from '../../api/drapery-order-summary-component';
import {
  addDraperyOrderDesign,
  editDraperyOrderDesign,
  getFileExtension,
} from '../../api/drapery-order-design';
import { addDraperyOrderSummary, editDraperyOrderSummary } from '../../api/drapery-order-summary';
import {
  addDraperyOrderDesingEmbellishment,
  deleteDraperyOrderDesignEmbellishment,
  editDraperyOrderDesignEmbellishment,
  searchDraperyOrderDesignEmbellishments,
} from '../../api/drapery-order-design-embellishment';
import { searchWorkroomSetting } from '../../api/workroom-setting';
import { validateMyShopItemPricing } from '../my-shop/standard-item-modal/pricing';
import SetupTab, { validateDraperyOrder } from './setup-tab';
import SummaryTab, {
  defaultDraperyOrderSummary,
  defaultDraperyOrderSummaryComponent,
  validateDraperyItemPricingTab,
  validateRipplefoldPricing,
  validateDraperyOrderSummary,
  validateDraperyOrderSummaryComponent,
} from './summary-tab';
import { Tab, TabList } from 'react-tabs';
import { ValidationError, ValidationErrorMap } from '@quipa/api';

import { AvatarModal } from '../../modals/avatar_modal';
import Bind from 'lodash-decorators/bind';
import { CategoryIds /*,ItemClasses*/ } from '../my-shop/types';
import ClientModal from '../../containers/client/client_modal';
//import DraperyPdf from "../work-order-pdf/drapery-pdf";
import HardwareTab, {
  defaultDraperyOrderHardware,
  duplicateDraperyOrderHardware,
} from './hardware-tab';
import PartsAndSuppliesOtherOrder, {
  defaultPartsAndSuppliesOrderHardware,
} from './parts-and-supplies-other-order';
import {
  addWorkOrder,
  editWorkOrder,
  getNextNum,
  getWorkOrderPDFContent,
  searchWorkOrders,
} from '../../api/work-order';
import ErrorMessageModal from '../../modals/drapery-order-error-modal';
import { FabricsOrLiningsItemDetailsFieldsPartial } from '../../redux/modules/my-shop/fabrics-or-linings-item-details-fields-reducer';
import { bundleSelectionsInitialState } from '../../redux/modules/my-shop/drapery-item-details-fields-reducer';
import { FormFields, FormFieldsPartial } from '../../redux/modules/my-shop/form-fields-reducer';
import LoadingModal from '../../modals/loading-modal';
import { PageHeader } from '../content/page_header';
import { RecommendationsOverridesModal } from '../../modals/recommendations_overrides_modal';
import { RecommendationsOverridesModalRomanShade } from '../../modals/recommendations_overrides_modal_roman_shade';
import { SearchSelectProps } from '../../components/UI/search_select/search_select';
import { Supplier } from '../../interfaces/supplier';
import SupplierModal from '../../containers/supplier/supplier_modal';
import { ValidationErrorInfo } from './interfaces-common';
import { confirmation } from '../../confirmation';
import { getAll } from '../../api/item';
import { getAll as getAllCategories } from '../../api/category';
import {
  addSupplier,
  getAll as getAllSuppliersList,
  getSupplier,
  getSuppliers as getAllSuppliers,
  searchSuppliers,
} from '../../api/supplier';
import { addRoom, getRooms } from '../../api/room';
import { theme } from '../../theme';
import { ModalName } from '../my-shop/types';
import StandardItemModal from '../my-shop/standard-item-modal/main';
import DraperyItemModal from '../my-shop/drapery-item-modal/main';
import { MyShopItem } from '../my-shop/my-shop';
import { Category } from '../../interfaces/category';
import { WorkroomSetting } from '../../redux/modules/workroom_setting';
import { RoomModal } from '../../modals/add_room_modal';
import { validateClientBillingType } from '../clients/client_more_details';
import { SortTableRowInfo } from '../../components/UI/table/sort_table';
import { WorkOrderPdfContent } from '../../redux/modules/work_order';
import { FadeLoader } from 'react-spinners';
import { ConfirmationModal } from '../../modals/confirmation_modal';
import { Config } from '../../utils';
import { getFabricsOrLiningsRecord } from '../../api/item';
import { getSelectedName } from '../my-shop/helpers';
import {
  addDraperyOrderPrice,
  addRomanShadeOrderPrice,
  updateDraperyOrderPrice,
  updateRomanShadeOrderPricing,
} from '../../api/drapery-order-price';
import { deleteClientProject, getAllClients, getClientApi, searchClients } from '../../api/client';
import moment from 'moment';

export const highlightStyle = {
  backgroundColor: theme.colors.errorBackground,
  borderRadius: 6,
  paddingLeft: 8,
};
const COLON_VALIDATION_MESSAGE = 'Cannot contain colon';

export const highlightStyleRoman = {
  backgroundColor: theme.colors.errorBackground,
  borderRadius: 6,
  paddingRight: 3,
};
import { getAll as getAllItems, getAllOtherItems } from '../../api/item';
import { getAccount, updateAccount, uploadImage } from '../../api/account';
import OtherItemDesignTab from './other-item-design-tab';
import RomanShadeDesignTab from './roman-shade-design-tab';
import { RomanShadeJson } from '@quipa/api/build-ts/client';
import { addDraperyOrderUpload, editDraperyOrderUpload } from '../../api/drapery-order-upload';
import RomanShadeSummaryTab, {
  defaultHardware,
  defaultHeadRail,
  defaultHeadRailSummaryComponent,
  duplicateHeadRail,
  filterHeadRail,
  validateRomanShadeItemPricingTab,
} from './roman-shade-summary-tab';
import RomanShadeModal from '../my-shop/roman-shade-modal/main';
import { callLambda, getPdfFileNameFromLambdaResponse } from '../../api/lambda';
import { openStoredPdf, storeFile } from '../../api/file-store';
import HardwareTabRomanShade, { defaultRomanShadeOrderHardware } from './hardware-tab-roman-shade';
import { trackView } from '../analytics/track_view';
import { MixpanelEvents } from '../analytics/mix_panel_events';
import { extractFabricFromUrl } from '../../api/fabric-agent';
import {
  buildFabricUrlImportPrefill,
  buildFabricUrlTrackingProps,
  getUrlDomain,
} from './fabric-url-prefill';
import { FABRIC_URL_PARSER_GATE } from './fabric-url-feature-flag';
import type { FabricUrlImportSubmitPayload } from './fabric-url-import';
import _ from 'lodash';
import { OrderDescription } from '../item_summary/order-description';
// import { LiningDetails } from '../item_summary/lining-details';
import { EmbellishmentDetails } from '../item_summary/embellishmentDetails';
import { RomanShadeDescription } from '../item_summary/romanShadeDescription';
import { RomanEmbellishmentDetails } from '../item_summary/romanEmbellishmentDetails';
import ArrowIcon from '../../assets/icons/chevron-right.svg';
import EditIcon from '../../assets/icons/pencil_black.svg';
import { WarningModal } from '../../modals/warning_modal';
import QuickAddClient from '../../modals/quick_add_client';
import { getAllStatuses } from '../../api/statuses';
import { ClientProject } from '../../interfaces/client';
import { PopoverScrollContext } from '../../ui_components/popover/popover';
import { FormValidationError } from '../../ui_components/validation/validationForm';
import HeadrailTabRomanShade, {
  defaultDraperyOrderHeadrail,
  duplicateDraperyOrderHeadrail,
} from './roman-shade-headrail-tab/headrail-tab';
import { handleUpdateLastViewedProject } from '../../helper/apiFunctions';
import Notebook from '../notebook/Notebook';
import { mapStoredUploadsToRemoteItems, uploadFileWithPresign } from '../../helper/presignedUpload';

const mergeDraperyOrderLiningFabric = ({
  draperyOrderLiningsList,
  draperyOrderAllFabrics,
  romanShadeJson,
  orderType,
}: {
  draperyOrderLiningsList: DraperyOrderDesignLining[];
  draperyOrderAllFabrics: DraperyModule.DraperyOrderFabric[];
  romanShadeJson?: any;
  orderType?: any;
}): DraperyOrderDesignLining[] => {
  const ensureDefaultLinings = (
    linings: DraperyOrderDesignLining[]
  ): DraperyOrderDesignLining[] => {
    const defaults = draperyLiningsList();
    const hasName = (name: string) =>
      linings.some((l) => l.name && l.name.toLowerCase() === name.toLowerCase());

    const updated = [...linings];
    defaults.forEach((def) => {
      if (!hasName(def.name)) {
        const normalizedName = def.name ? def.name.toLowerCase() : '';
        if (normalizedName === 'lining') {
          updated.unshift({ ...def });
        } else if (normalizedName === 'interlining') {
          updated.push({ ...def });
        } else {
          updated.push({ ...def });
        }
      }
    });
    return updated;
  };

  draperyOrderLiningsList = ensureDefaultLinings(draperyOrderLiningsList);
  //  const romanShadeProps = { valanceAndReturns: { backValance: 0 } }
  draperyOrderLiningsList = draperyOrderLiningsList
    .sort((a, b) => b.name.localeCompare(a.name))
    .map((dol, index) => {
      if (orderType && orderType === 'roman-shade-order') {
        if (index === 0) {
          if (
            !dol.active &&
            (!romanShadeJson.valanceAndReturns ||
              !romanShadeJson.valanceAndReturns.backValance ||
              romanShadeJson.valanceAndReturns.backValance <= 0)
          )
            return dol;
        } else {
          if (!dol.active) return dol;
        }
      } else {
        if (!dol.active) return dol;
      }

      // let fabric = draperyOrderAllFabrics.find(
      //     (fab) => fab.draperyOrderDesignLiningId === dol.id
      // );
      let string: string;
      let fabric = draperyOrderAllFabrics.filter((fab) => {
        let name = fab.name.split(' ');
        if (name.length > 2) {
          string = `Other interlining ${index}`;
        } else {
          string = fab.name.split(' ').join(' ');
        }
        return string.toLowerCase().includes(dol.name.toLowerCase());
      });
      const fabricNew = fabric.find(
        (fab) => fab.name.split(' ')[0].toLowerCase() === dol.name.toLowerCase()
      );
      const fabricName = fabricNew && fabricNew.name.split(' ')[0].toLowerCase();
      if (dol.active && fabricName !== dol.name.toLowerCase()) {
        dol = {
          ...dol,
          draperyOrderLiningsFabric: defaultLiningsFabric(dol.name.toUpperCase() + ' FABRIC'),
        };
      }

      if (fabricNew) {
        dol = {
          ...dol,
          draperyOrderLiningsFabric: {
            ...fabricNew,
            draperyOrderSummaryComponent: defaultDraperyOrderSummaryComponent(fabricNew.name),
          },
        };
      }

      return dol;
    });
  return draperyOrderLiningsList;
};

const addEmbellishment = (
  list: DraperyOrderDesignEmbellishment[],
  embellishment: DraperyOrderDesignEmbellishment,
  embellishmentInfo: EmbellishmentCheckInfo,
  draperyOrderFabrics: DraperyModule.DraperyOrderFabric[],
  draperyOrderSummaryComponents: DraperyModule.DraperyOrderSummaryComponent[]
) => {
  list.push(embellishment);
  embellishmentInfo.checked = true;
  const fabric = draperyOrderFabrics.find(
    (fabric) => fabric.draperyOrderDesignEmbellishmentId === embellishment.id
  );
  const component = fabric
    ? draperyOrderSummaryComponents.find(
        (component) => component.draperyOrderFabricId === fabric.id
      )
    : undefined;
  embellishment.draperyOrderFabric = fabric
    ? {
        ...fabric,
        draperyOrderSummaryComponent: component || defaultDraperyOrderSummaryComponent(fabric.name),
      }
    : undefined;
  if (!embellishment.draperyOrderFabric) {
    embellishment.subType = undefined;
  }
};

const shouldIncludeEmbellishmentFabric = (
  embellishment: DraperyOrderDesignEmbellishment
): boolean =>
  embellishment.type === 1 ||
  embellishment.type === 5 ||
  embellishment.subType === 0 ||
  embellishment.subType === 1;

const processErrors = (
  tabIndex: number,
  errors: ValidationErrorMap,
  section?: string
): ValidationErrorInfo[] => {
  return Object.keys(errors).map((key) => {
    let camelCase = '';
    const arr = errors[key].replace(',', '').split(' ');
    for (let i = 0; i < arr.length; i++) {
      if (/[A-Z]/.test(arr[i])) {
        camelCase = arr[i];
        break;
      }
    }

    return {
      tabIndex,
      name:
        errors[key].indexOf('value must contain at least one of supplierId, supplierName') >= 0
          ? `${section}.${camelCase}`
          : errors[key].indexOf('must be a number') >= 0
            ? `${section}.values.${camelCase}`
            : key,
      message: errors[key],
    };
  });
};

type CalculatorDraperyOrder = DraperyModule.DraperyOrder & {
  clientName: string;
  itemType?: any;
  estimateStatus?: string | null;
  estimateDate?: string | Date | null;
  estimateDateSent?: string | Date | null;
  estimateId?: number | null;
  estimateNumber?: string | null;
  estimateStatusSummary?: any;
  qbExportedAt?: string | Date | null;
};

const defaultDraperyOrder = (
  id?: number,
  clientId?: number,
  clientName?: string,
  quantity?: number | undefined
): CalculatorDraperyOrder => {
  if (!clientId && !clientName) {
    const searchParams = new URLSearchParams(window.location.search);
    const type = searchParams.get('type');

    const draperyItem =
      type && type === 'roman-shade-order'
        ? localStorage.getItem('romanShadeItem')
        : localStorage.getItem('draperyItem');
    clientId =
      draperyItem && JSON.parse(draperyItem).client ? JSON.parse(draperyItem).client.id : 0;
    clientName =
      draperyItem && JSON.parse(draperyItem).client
        ? JSON.parse(draperyItem).client.displayName
        : '';
    id = draperyItem && JSON.parse(draperyItem).orderId ? JSON.parse(draperyItem).orderId : 0;
  }
  return {
    id: id || 0,
    window: '',
    related: '',
    quantity: quantity !== undefined ? quantity : 1,
    hasRelatedWorkOrders: false,
    relatedWorkOrderIds: [],
    workOrderId: undefined,
    isReturnLeftoverMaterials: false,
    clientId: clientId || 0,
    clientName: clientName || '',
    status: 'New',
    editable: true,
    userConfirmation: {},
    hardwareQuantity: '1',
    hardwareDescription: '',
    hardwareUnitPrice: '',
    hardwareMarkup: '',
    hardwareCustomerFacingPrice: '',
    hardwareSih: {
      estimateDescription: 'Shipping & Handling for Hardware',
      quantity: '1',
      cost: '',
      markup: '',
      customerPrice: '',
      active: false,
    },
    archived: false,
    isDraft: false,
    newRomanShade: null,
    bundleConfigJson: null,
    estimateStatus: 'Not Created',
    estimateDate: null,
    estimateDateSent: null,
    estimateId: null,
    estimateNumber: null,
    estimateStatusSummary: undefined,
    qbExportedAt: null,
  };
};

const normalizeBundleSelections = (bundleSelections?: any) => {
  const normalizedSelections: any = {
    ...bundleSelectionsInitialState,
    ...(bundleSelections || {}),
  };
  Object.keys(normalizedSelections).forEach((key) => {
    normalizedSelections[key] = Boolean(normalizedSelections[key]);
  });
  return normalizedSelections;
};

const validateClient = (
  draperyOrder: DraperyModule.DraperyOrder,
  orderType?: string
): ValidationErrorInfo[] => {
  const prefixName = 'draperyOrder.';
  const tabIndex = 0;
  let errors: ValidationErrorInfo[] = [];
  if (
    !(draperyOrder.clientId && draperyOrder.clientId > 0) &&
    (!(draperyOrder.roomId && draperyOrder.roomId > 0) || !draperyOrder.roomId)
  ) {
    errors.push({
      tabIndex,
      name: prefixName + 'clientId',
      message: 'Please select a client.',
    });
    errors = errors.concat({
      tabIndex,
      name: prefixName + 'roomId',
      message: 'Please select a room.',
    });
  } else if (!(draperyOrder.clientId && draperyOrder.clientId > 0)) {
    errors.push({
      tabIndex,
      name: prefixName + 'clientId',
      message: 'Please select a client.',
    });
  } else if (!(draperyOrder.roomId && draperyOrder.roomId > 0) || !draperyOrder.roomId) {
    errors.push({
      tabIndex,
      name: prefixName + 'roomId',
      message: 'Please select a room.',
    });
  }
  if (!(draperyOrder.itemTypeId && draperyOrder.itemTypeId > 0) && orderType === 'custom-order') {
    errors.push({
      tabIndex,
      name: prefixName + 'itemTypeId',
      message: 'Please select item type.',
    });
  }
  if (
    draperyOrder.itemTypeName &&
    draperyOrder.itemTypeName.toLowerCase() === 'other' &&
    !draperyOrder.locationId &&
    orderType === 'custom-order'
  ) {
    errors.push({
      tabIndex,
      name: prefixName + 'locationId',
      message: 'Please specify Location/ID.',
    });
  }
  return errors;
};

const defaultWorkOrder = (
  accountId: number,
  workOrderNum?: number
): WorkOrderModule.WorkOrder & {
  draperyOrderId: number;
  pdfLink: string | null;
  pdfGeneratedAt: Date | null;
} => ({
  id: 0,
  num: workOrderNum || 0,
  accountId,
  draperyOrderId: 0,
  pdfLink: null,
  pdfGeneratedAt: null,
  dueDatePdf: null,
});

const getDefaultHardwareForOrderType = (orderType: string): DraperyModule.DraperyOrderHardware => {
  if (orderType === 'custom-order') {
    return defaultPartsAndSuppliesOrderHardware();
  }
  if (orderType === 'drapery-order') {
    return defaultDraperyOrderHardware();
  }
  return defaultRomanShadeOrderHardware();
};

const duplicateDraperyOrder = (draperyOrder: CalculatorDraperyOrder): CalculatorDraperyOrder => {
  return {
    ...draperyOrder,
    id: 0,
    draperyOrderDesignId: undefined,
    draperyOrderHardwareId: undefined,
    draperyOrderHeadrailId: undefined,
    draperyOrderUploadId: undefined,
    draperyOrderSummaryId: undefined,
    workOrderId: undefined,
    isReturnLeftoverMaterials: false,
    hasRelatedWorkOrders: false,
    editable: true,
    status: 'New',
    roomId: undefined,
    roomName: '',
    customRoom: '',
    window: '',
    related: '',
    quantity: draperyOrder.quantity,
    isDraft: false,
  };
};

const duplicateDraperyOrderFees = (
  fees: DraperyModule.DraperyOrderFee[] = []
): DraperyModule.DraperyOrderFee[] =>
  fees.map((fee) => ({
    ...fee,
    id: undefined,
    draperyOrderId: undefined,
    accountId: undefined,
    createdAt: undefined,
    updatedAt: undefined,
  }));

const getQueryParam = (key: string): string | null => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(key);
};

// tslint:disable-next-line:no-empty-interface
interface CalculatorOwnProps extends RouteComponentProps {
  handleCloseModal(): void;
  handleOpenSubscriptionPlanModal(): void;
  handleNotSavedOrder(changes: boolean): void;
  handleNewNavigation(val: string, saveCase?: boolean): void;
  triggerModal: boolean;
  cantLogOut: boolean;
  isConnected?: boolean;
  accountUser?: any;
  canAccessTeamSettings?: boolean;
}
export interface CalculatorProps extends CalculatorOwnProps {
  accountId: number;
  calculatorDefaults?: AccountModule.State['calculatorDefaults'];
  initialParentClientName?: string;
}

export interface EmbellishmentCheckInfo {
  checked: boolean;
  title: string;
  stateName: string;
}

export interface DraperyOrderDesignEmbellishment
  extends DraperyModule.DraperyOrderDesignEmbellishment {
  [key: string]: any;
  draperyOrderFabric?: DraperyOrderFabric;
  patternId?: number | null | undefined;
  subType?: number | null;
  topEdge?: any;
  bottomEdge?: any;
  leadReturnEdge?: any;
  styleType?: string | null;
  name?: string;
  price?: number;
  details?: string;
}

export interface DraperyOrderFabric extends DraperyModule.DraperyOrderFabric {
  [key: string]: any;
  supplierName?: string;
  patternId?: number | null | undefined;
  customSupplier?: string;
  draperyOrderSummaryComponent: DraperyModule.DraperyOrderSummaryComponent;
  itemId?: number;
  name?: string;
  yardsNeeded?: number;
  directionOfUse?: string | null;
  pattern?: string | null;
}

export interface DraperyOrderLiningsFabric extends DraperyModule.DraperyOrderFabric {
  supplierName?: string;
  customSupplier?: string;
  patternId?: number | null | undefined;
  draperyOrderSummaryComponent: DraperyModule.DraperyOrderSummaryComponent;
  isBackValance?: boolean;
}

export interface DraperyOrderDesignLining extends DraperyModule.DraperyOrderDesignLining {
  [key: string]: any;
  itemId?: any;
  draperyOrderLiningsFabric?: any;
  patternId?: number | null | undefined;
}

export interface ValidationConfirmationInfo extends ValidationErrorInfo {
  checked: boolean;
  value: string;
}

export interface FabricPatternItem
  extends FormFieldsPartial, FabricsOrLiningsItemDetailsFieldsPartial {}

export interface CalculatorState {
  [key: string]: any;
  tabIndex: number;
  isDuplicate: boolean;
  isSidebarHidden: boolean;
  areaScrollInfo: {
    scrollX: number;
    scrollY: number;
  };
  roomList: Array<{ key: string | number; label: string }>;
  workOrderList: WorkOrderModule.WorkOrder[];
  client?: ClientModule.Client;
  navigationConfirmed: boolean;
  isCopy: boolean;
  isChanged: boolean;
  isDrawingDirty: boolean;
  isWorkOrderValidation: boolean;

  pathIdForModal: string;
  pathNameForModal: string;
  previousPathNameForModal: string;
  isAddClientModalOpen: boolean;

  isAddSupplierModalOpen: boolean;
  isAddFabricsPatternModalOpen: boolean;
  imageModalOpen: boolean;
  imageModalRelatedName: string;
  isErrorMessageOpen: boolean;
  isRecommendationsOverridesModalOpen: boolean;
  isRecommendationsOverridesModalRomanShadeOpen: boolean;
  isCustomizeConstructionOpen: boolean;
  isLoadingConstructionDefaults: boolean;
  romanShadeSettings?: any;
  romanShadeSettingsChangedField: {
    foldSize: boolean;
    numOfPermanentFolds: boolean;
    bottomSkirtLength: boolean;
    frontValanceLength: boolean;
    sidesValanceLength: boolean;
    backValanceLength: boolean;
  };
  isLoadingOpen: boolean;
  fabricPatternModalCategoryId: number;
  draperyOrder: CalculatorDraperyOrder;
  draperyOrderDesign: DraperyModule.DraperyOrderDesign;
  draperyOrderHardware: DraperyModule.DraperyOrderHardware;
  draperyOrderHeadrail: DraperyModule.DraperyOrderHeadrail;
  draperyOrderUploads: {
    id: number;
    items: any[];
  };
  liningsList: DraperyOrderDesignLining[];
  isNoneLinings?: boolean;
  bandings: DraperyOrderDesignEmbellishment[];
  cordings: DraperyOrderDesignEmbellishment[];
  flanges: DraperyOrderDesignEmbellishment[];
  trims: DraperyOrderDesignEmbellishment[];
  othersEmbellishments: DraperyOrderDesignEmbellishment[];
  embellishmentsList: EmbellishmentCheckInfo[];
  isNoneEmbellishment?: boolean;
  removedEmbellishmentIds: number[];
  mainFabric: DraperyOrderFabric;
  draperyOrderSummary: DraperyModule.DraperyOrderSummary;
  draperyOrderFees: DraperyModule.DraperyOrderFee[];
  draperyOrderSummaryComponents: DraperyModule.DraperyOrderSummaryComponent[];
  workOrder: WorkOrderModule.WorkOrder;
  workOrderPdfStatus: 'none' | 'downloading' | 'error';
  workOrderPdfContent?: WorkOrderModule.WorkOrderPdfContent;
  isEditClientModalOpen: boolean;
  draperyOrderErrors?: ValidationErrorInfo[];
  draperyOrderDesignErrors?: ValidationErrorInfo[];
  draperyOrderFabricsErrors?: ValidationErrorInfo[];
  draperyOrderFabricsConfirmations?: ValidationConfirmationInfo[];
  draperyOrderHardwareErrors?: ValidationErrorInfo[];
  draperyOrderSummaryErrors?: ValidationErrorInfo[];
  romanShadePricingErrors?: ValidationErrorInfo[];
  myShopItemPricingErrors?: ValidationErrorInfo[];
  myShopClientBillingErrors?: ValidationErrorInfo[];
  activeModal?: string | null;
  selectedItemId: number | null;
  selectedItem: MyShopItem | null;
  activeItemClassId: number | null;
  categories: Category[];
  suppliers: Supplier[];
  formFieldName?: string;
  pricingTabIndex?: number;
  highlightedSection?: string | null;
  wideSheetFocusField?: string | null;
  fabricsPatternItems?: FabricPatternItem[];
  liningsPatternItems?: FabricPatternItem[];
  fabricsLinings?: DraperyOrderDesignLining[];
  draperyItemDetail: FormFields[];
  romanShadeItemDetails: FormFields[];
  workroomSetting: WorkroomSetting | null;
  isAddRoomModalOpen: boolean;
  clientId: number | null;
  clientName: string;
  includeInactive: boolean;
  sort: 'asc' | 'desc';
  clients: SortTableRowInfo[];
  workOrderPdfContentSummery?: WorkOrderPdfContent;
  draperyOrderPriceId: number;
  draperyOrderPriceRefreshKey: number;
  workRoomSettings: any;
  widthConfiguration: Array<number | undefined>;
  orderOriginState: number;
  orderOriginStateEmb: number;
  orderOriginStateLining: number;
  isModalOpenWo: boolean;
  supplierName: string;
  supplierId: number;
  customSupplier?: string;
  isError?: boolean;
  isModalClosed?: boolean;
  isLoading?: boolean;
  initialCalculatorLoading: boolean;
  summaryTabLoading: boolean;
  isLoadingCreateButton?: boolean;
  showDraperyItemModal: boolean;
  showRomanShadeItemModal: boolean;
  isDraft: boolean;
  checkedAllowExtraWidthOne: boolean;
  checkedAllowExtraWidthTwo: boolean;
  validateClient: boolean;
  patternId: number | undefined;
  isEditFabricsPatternModalOpen: boolean;
  isEditConstructionDetailsModalOpen: boolean;
  reloadOnSaveConstructions: boolean;
  isUpdateRomanShadeCSField: boolean;
  itemId?: number | string | null;
  workOrderEditMode: boolean;
  loadingUpdate: boolean;
  isUpdateChanged: boolean;
  copyState: any;
  noChanges: boolean;
  newDraperyOrderFabrics: any[];
  newTab: boolean;
  orderType?: string;
  itemType: string;
  workOrderReady: boolean;
  openPdf: boolean;
  romanShadeJson: RomanShadeJson;
  forceLogOut: boolean;
  headRail: any;
  hardware: any; //hardware info for summary component
  yardage: {
    mainFabricYardage: string | null;
    bandingsYardage: string[];
    cordingsPreMadeYardage: string[];
    flangesPreMadeYardage: string[];
    trimsPreMadeYardage: string[];
    cordingsFabricYardage: string[];
    flangesFabricYardage: string[];
    trimsFabricYardage: string[];
    liningsYardage: string[];
    otherEmbellishmentsYardage: string[];
  };
  stateObj: any;
  isWarningModalOpen: boolean;
  hasValuesOnHardwareTab: boolean;
  isCollapsedDesc: boolean;
  quickAddClientModal: boolean;
  clientAndRoomHighlight: boolean;
  extraItemOrder: number;
  remainingItemOrder: number;
  canCreateOrder: boolean;
  fabricUrlPrefill: any | null;
  fabricUrlDetailsPrefill: FabricsOrLiningsItemDetailsFieldsPartial | null;
  fabricUrlImportTrackingProps: ReturnType<typeof buildFabricUrlTrackingProps> | null;
  fabricUrlImportSessionId: string | null;
}

export class Calculator extends PureComponent<CalculatorProps & DispatchProp, CalculatorState> {
  public setFocusFirstFieldOnClientModal: any;
  public setFocusFirstFieldOnSupplierModal: any;
  private designTabRef = createRef<any>();
  private summaryRef = createRef<any>();
  private romanShadeSummaryRef = createRef<any>();
  private clientSearchCache = new Map<number, any>();
  private clientSearchCacheLoaded = false;
  private summaryTabLoadingRequests = 0;
  findFirstErrorsCalled = false;
  private notebookRef = createRef<any>();
  private drawingBgIdentifier = crypto.randomUUID();

  public constructor(props: CalculatorProps & DispatchProp) {
    super(props);
    const paramState = this.props.location.state;

    const orderType = props.history.location.state
      ? props.history.location.state.type
      : getQueryParam('type')
        ? getQueryParam('type')
        : 'drapery-order';

    this.state = {
      isDuplicate: false,
      forceLogOut: false,
      tabIndex: paramState && paramState.tab === 'summary' ? 5 : 0,
      isSidebarHidden: false,
      areaScrollInfo: {
        scrollX: 0,
        scrollY: 0,
      },
      roomList: [],
      workOrderList: [],
      navigationConfirmed: false,
      isCopy: false,
      isChanged: false,
      isDrawingDirty: false,
      isWorkOrderValidation: false,
      isEditClientModalOpen: false,
      pathIdForModal: '',
      romanShadeSettingsChangedField: {
        foldSize: false,
        numOfPermanentFolds: false,
        bottomSkirtLength: false,
        frontValanceLength: false,
        sidesValanceLength: false,
        backValanceLength: false,
      },
      pathNameForModal: '',
      previousPathNameForModal: '',
      isAddClientModalOpen: false,
      isAddSupplierModalOpen: false,
      isAddFabricsPatternModalOpen: false,
      fabricUrlPrefill: null,
      fabricUrlDetailsPrefill: null,
      fabricUrlImportTrackingProps: null,
      fabricUrlImportSessionId: null,
      imageModalOpen: false,
      imageModalRelatedName: '',
      isErrorMessageOpen: false,
      isRecommendationsOverridesModalOpen: false,
      isRecommendationsOverridesModalRomanShadeOpen: false,
      isCustomizeConstructionOpen: false,
      isLoadingConstructionDefaults: false,
      isLoadingOpen: false,
      fabricPatternModalCategoryId: 0,
      draperyOrder: paramState
        ? defaultDraperyOrder(
            paramState.draperyOrderId,
            paramState.clientId,
            paramState.clientDisplayName,
            paramState.quantity
          )
        : defaultDraperyOrder(),
      draperyOrderDesign: defaultDraperyOrderDesign(),
      draperyOrderUploads: {
        id: 0,
        items: [],
      },
      draperyOrderHardware: getDefaultHardwareForOrderType(orderType),
      draperyOrderHeadrail: defaultDraperyOrderHeadrail(),
      liningsList: draperyLiningsList(),
      isNoneLinings: false,
      bandings: [defaultEmbellishment('bandings')!],
      cordings: [defaultEmbellishment('cordings')!],
      flanges: [defaultEmbellishment('flanges')!],
      trims: [defaultEmbellishment('trims')!],
      othersEmbellishments: [defaultEmbellishment('othersEmbellishments')!],
      embellishmentsList: defaultEmbellishmentsList(),
      fabricsLinings: [],
      isNoneEmbellishment: false,
      removedEmbellishmentIds: [],
      mainFabric: defaultMainFabric(),
      draperyOrderSummary: defaultDraperyOrderSummary(),
      draperyOrderFees: [],
      draperyOrderSummaryComponents: [],
      headRail: defaultHeadRail(),
      hardware: defaultHardware(),
      workOrder: defaultWorkOrder(this.props.accountId),
      workOrderPdfStatus: 'none',

      highlightedSection: null,
      wideSheetFocusField: null,
      activeModal: null,
      selectedItemId: null,
      selectedItem: null,
      activeItemClassId: null,
      categories: [],
      formFieldName: '',
      suppliers: [],
      pricingTabIndex: undefined,
      draperyItemDetail: [],
      romanShadeItemDetails: [],
      workroomSetting: null,
      isAddRoomModalOpen: false,
      clientId: 0,
      clientName: '',
      includeInactive: false,
      clients: [],
      sort: 'asc',
      workOrderPdfContentSummery: undefined,
      draperyOrderPriceId: 0,
      draperyOrderPriceRefreshKey: 0,
      workRoomSettings: {},
      widthConfiguration: [],
      orderOriginState: -1,
      orderOriginStateEmb: -1,
      orderOriginStateLining: -1,
      isModalOpenWo: false,
      supplierName: '',
      supplierId: 0,
      isError: false,
      isModalClosed: false,
      isLoading: true,
      initialCalculatorLoading: true,
      summaryTabLoading: false,
      showDraperyItemModal: false,
      showRomanShadeItemModal: false,
      customSupplier: '',
      isDraft: false,
      checkedAllowExtraWidthOne: false,
      checkedAllowExtraWidthTwo: false,
      validateClient: false,
      patternId: 0,
      isEditFabricsPatternModalOpen: false,
      itemId: null,
      workOrderEditMode: false,
      loadingUpdate: false,
      isUpdateChanged: false,
      isEditConstructionDetailsModalOpen: false,
      reloadOnSaveConstructions: false,
      isUpdateRomanShadeCSField: false,
      copyState: {
        draperyOrder: paramState
          ? defaultDraperyOrder(
              paramState.draperyOrderId,
              paramState.clientId,
              paramState.clientDisplayName,
              paramState.quantity
            )
          : defaultDraperyOrder(),
        draperyOrderDesign: defaultDraperyOrderDesign(),
        draperyOrderHardware: getDefaultHardwareForOrderType(orderType),
        draperyOrderHeadrail: defaultDraperyOrderHeadrail(),
        draperyOrderUploads: { id: 0, items: [] },
        liningsList: draperyLiningsList(),
        isNoneLinings: false,
        bandings: [defaultEmbellishment('bandings')!],
        cordings: [defaultEmbellishment('cordings')!],
        flanges: [defaultEmbellishment('flanges')!],
        trims: [defaultEmbellishment('trims')!],
        othersEmbellishments: [defaultEmbellishment('othersEmbellishments')!],
        embellishmentsList: defaultEmbellishmentsList(),
        mainFabric: defaultMainFabric(),
        isNoneEmbellishment: false,
        draperyOrderSummaryComponents: [],
        draperyOrderSummary: defaultDraperyOrderSummary(),
        draperyOrderPriceId: 0,
      },
      noChanges: true,
      newDraperyOrderFabrics: [],
      newTab: false,
      orderType: props.history.location.state
        ? props.history.location.state.type
        : getQueryParam('type')
          ? getQueryParam('type')
          : 'drapery-order',
      itemType: '',
      workOrderReady: false,
      openPdf: false,
      romanShadeJson: {
        style: {
          type: '',
          function: -1,
          windowMount: -1,
          boardMount: -1,
        },
        dimensions: {
          finishedWidth: null,
          finishedLength: null,
          foldSize: null,
          numOfPermanentFolds: null,
          bottomSkirit: -1,
          bottomSkirtLength: null,
        },
        valanceAndReturns: {
          frontValance: -1,
          frontValanceLength: null,
          sides: null,
          sidesValanceLength: null,
          backValance: -1,
          backValanceLength: null,
        },
        headrail: {
          liftSystem: null,
          boardFace: null,
          boardDepth: null,
          controlType: null,
          controlLocationLeft: null,
          controlLocationRight: null,
        },
      },
      yardage: {
        mainFabricYardage: null,
        bandingsYardage: [],
        cordingsPreMadeYardage: [],
        flangesPreMadeYardage: [],
        trimsPreMadeYardage: [],
        cordingsFabricYardage: [],
        flangesFabricYardage: [],
        trimsFabricYardage: [],
        liningsYardage: [],
        otherEmbellishmentsYardage: [],
      },
      stateObj: {
        draperyOrder: paramState
          ? defaultDraperyOrder(
              paramState.draperyOrderId,
              paramState.clientId,
              paramState.clientDisplayName,
              paramState.quantity
            )
          : defaultDraperyOrder(),
        draperyOrderDesign: defaultDraperyOrderDesign(),
        draperyOrderHardware: getDefaultHardwareForOrderType(orderType),
        draperyOrderHeadrail: defaultDraperyOrderHeadrail(),
        draperyOrderUploads: { id: 0, items: [] },
        liningsList: draperyLiningsList(),
        isNoneLinings: false,
        bandings: [defaultEmbellishment('bandings')!],
        cordings: [defaultEmbellishment('cordings')!],
        flanges: [defaultEmbellishment('flanges')!],
        trims: [defaultEmbellishment('trims')!],
        othersEmbellishments: [defaultEmbellishment('othersEmbellishments')!],
        embellishmentsList: defaultEmbellishmentsList(),
        mainFabric: defaultMainFabric(),
        isNoneEmbellishment: false,
        draperyOrderSummaryComponents: [],
        draperyOrderSummary: defaultDraperyOrderSummary(),
        workOrder: defaultWorkOrder(this.props.accountId),
        draperyOrderPriceId: 0,
      },
      isWarningModalOpen: false,
      hasValuesOnHardwareTab: false,
      isCollapsedDesc: false,
      quickAddClientModal: false,
      clientAndRoomHighlight: false,
      extraItemOrder: 0,
      remainingItemOrder: 0,
      canCreateOrder: true,
    };
  }

  public async componentDidMount(): Promise<void> {
    const openStopwatch = startStopwatch();
    const openPhaseCtx = {
      order_type: this.state.orderType,
      order_id: this.state.draperyOrder.id || undefined,
    };
    const measureOpen = async <T,>(phase: string, op: () => Promise<T>): Promise<T> => {
      const sw = startStopwatch();
      try {
        return await op();
      } finally {
        logOpenPhase({ phase, duration_ms: sw.end(), ...openPhaseCtx });
      }
    };
    // if (!this.state.draperyOrder.id) {
    //   this.setState({ noChanges: false });
    // }
    // Track View with Mixpanel
    trackView(MixpanelEvents.ITEM_ORDER, {});
    if (this.state.tabIndex === 0) {
      trackView(MixpanelEvents.ITEM_ORDER_SETUP, {});
    } else if (this.state.tabIndex === 5) {
      trackView(MixpanelEvents.ITEM_ORDER_SUMMARY, {});
    }

    const parallelOpen = checkGate('perf_calc_parallel_open');
    const clientIdBeforeExisting = this.state.draperyOrder.clientId;
    let accountRes: any;
    let statusesRes: any;

    if (parallelOpen) {
      // Fire Group A (no inter-dependencies) concurrently
      const groupAResults = await Promise.all([
        measureOpen('account', () => getAccount(this.props.accountId)),
        measureOpen('all_statuses', () => getAllStatuses({ accountId: this.props.accountId })),
        measureOpen('client_1', () => this.getClient()),
        measureOpen('rooms_1', () => this.getRooms(this.state.draperyOrder.clientId || 0)),
      ]);
      accountRes = groupAResults[0];
      statusesRes = groupAResults[1];
    } else {
      accountRes = await measureOpen('account', () => getAccount(this.props.accountId));
    }
    if (accountRes && !accountRes.error) {
      this.setState((prev) => ({
        ...prev,
        extraItemOrder: accountRes.extraItemOrder,
        remainingItemOrder: accountRes.remainingItemOrder || 0,
      }));
    }
    if (!parallelOpen) {
      statusesRes = await measureOpen('all_statuses', () =>
        getAllStatuses({ accountId: this.props.accountId })
      );
    }
    if (statusesRes && !statusesRes.error) {
      const mapped_statusesRes =
        statusesRes && statusesRes.length > 0
          ? statusesRes.map((s: any) => {
              return {
                ...s,
                value: s.name,
              };
            })
          : [];
      this.setState((prev) => {
        return {
          ...prev,
          accountStatuses: [...mapped_statusesRes],
        };
      });
    }

    this.validateAll('workOrder');
    // End of code for Track View with Mixpanel

    if (this.state.draperyOrder.id === 0) {
      const can_create_order = await measureOpen('can_create_order', () =>
        userCanCreateNewOrder(this.props.accountId)
      );
      this.setState((prev) => ({ ...prev, canCreateOrder: can_create_order }));
      if (
        !can_create_order &&
        accountRes.remainingItemOrder === 0 &&
        this.state.orderType !== 'custom-order'
      ) {
        this.props.handleOpenSubscriptionPlanModal();
      }
    }
    let isLoading = true;
    this.setState((state) => ({ ...state, isLoading: true, isLoadingCreateButton: true }));

    if (this.state.draperyOrder.id === 0) {
      this.setState((state) => ({ ...state, isLoading }));
    }
    if (!parallelOpen) {
      await measureOpen('client_1', () => this.getClient());
      await measureOpen('rooms_1', () => this.getRooms(this.state.draperyOrder.clientId || 0));
    }
    if (this.state.draperyOrder.id !== 0) {
      await this.getExistingDraperyOrder();
      const clientIdAfterExisting = this.state.draperyOrder.clientId;
      const clientIdChanged = clientIdBeforeExisting !== clientIdAfterExisting;
      if (!parallelOpen || clientIdChanged) {
        await measureOpen('client_2', () => this.getClient());
        await measureOpen('rooms_2', () => this.getRooms(this.state.draperyOrder.clientId || 0));
      } else {
        logOpenPhase({ phase: 'client_2_skipped', duration_ms: 0, ...openPhaseCtx });
        logOpenPhase({ phase: 'rooms_2_skipped', duration_ms: 0, ...openPhaseCtx });
      }
      // this.setState((state) => ({ ...state, isLoading: false }));
    }
    if (this.state.orderType === 'roman-shade-order') {
      this.setState((prev) => {
        return {
          ...prev,
          isCustomizeConstructionOpen: true,
        };
      });
    }
    this.handleShowNewBadgeTab('new_tab_badge');
    // load drapery order
    let clientId;
    let clientName;
    let draperyItem = localStorage.getItem('draperyItem');
    if (draperyItem) {
      clientId =
        draperyItem && JSON.parse(draperyItem).client ? JSON.parse(draperyItem).client.id : 0;
      clientName =
        draperyItem && JSON.parse(draperyItem).client
          ? JSON.parse(draperyItem).client.displayName
          : '';
      if (clientId && clientName)
        this.props.history.push(
          `/calculator${this.state.orderType ? '?type=' + this.state.orderType : ''}`,
          {
            clientId,
            clientDisplayName: clientName,
          }
        );
    }
    localStorage.removeItem('draperyItem');
    if (this.state.orderType === 'roman-shade-order' && this.state.draperyOrder.id === 0) {
      await measureOpen('default_construction', () => this.getDefaultConstruction());
    }
    if (shouldFetchInitialWorkOrderNum(this.state.draperyOrder.id, this.state.workOrder.id)) {
      const workOrderNum = await measureOpen('next_work_order_num', () =>
        this.getNextWorkOrderNum()
      );
      this.setState((state) => ({
        ...state,
        workOrder: {
          ...state.workOrder,
          num: workOrderNum,
        },
        copyState: {
          ...state.copyState,
          workOrder: {
            ...state.workOrder,
            num: workOrderNum,
          },
        },
      }));
    }
    let res: any;
    if (parallelOpen) {
      const workroomPostPromise = measureOpen('workroom_setting_post', () =>
        searchWorkroomSetting(this.props.accountId, 1)
      );
      const workroomRomanPromise =
        this.state.orderType === 'roman-shade-order'
          ? measureOpen('workroom_setting_roman', () =>
              searchWorkroomSetting(this.props.accountId, 4)
            )
          : Promise.resolve(null as any);

      const groupBResults = (await Promise.all([
        workroomPostPromise,
        workroomRomanPromise,
        measureOpen('work_order_numbers', () => this.getWorkOrderNumbers()),
        measureOpen('fabrics_items', () => this.getFabricsItems({ isReload: false })),
        measureOpen('drapery_items', () =>
          this.getDraperyItems({
            isReload: false,
            showDraperyItemModal:
              this.state.orderType !== 'custom-order' &&
              Number(this.state.draperyOrder?.id || 0) === 0,
          })
        ),
        measureOpen('linings_items', () => this.getLiningsItems({ isReload: false })),
        measureOpen('fetch_all', () => this.fetchAll()),
      ])) as [any, any, void, void, void, void, void];

      res = groupBResults[0];
      const workroomRomanRes = groupBResults[1];
      if (workroomRomanRes && workroomRomanRes.length > 0) {
        this.setState((state) => ({
          ...state,
          romanShadeSettings: workroomRomanRes[0],
        }));
      }
    } else {
      res = await measureOpen('workroom_setting_post', () =>
        searchWorkroomSetting(this.props.accountId, 1)
      );

      if (this.state.orderType === 'roman-shade-order') {
        const resRomanShade = await measureOpen('workroom_setting_roman', () =>
          searchWorkroomSetting(this.props.accountId, 4)
        );

        if (resRomanShade.length > 0) {
          this.setState((state) => ({
            ...state,
            romanShadeSettings: resRomanShade[0],
          }));
        }
      }
    }

    let fabricPurchaser: any;
    let embellishmentsPurchaser: any;
    let liningsPurchaser: any;
    if (!res.error && res.length > 0) {
      fabricPurchaser = res[0].fabricPurchaser;
      embellishmentsPurchaser = res[0].embellishmentsPurchaser;
      liningsPurchaser = res[0].liningsPurchaser;
    }

    if (!parallelOpen) {
      await measureOpen('work_order_numbers', () => this.getWorkOrderNumbers());
      await measureOpen('fabrics_items', () => this.getFabricsItems({ isReload: false }));
      await measureOpen('drapery_items', () =>
        this.getDraperyItems({
          isReload: false,
          showDraperyItemModal:
            this.state.orderType !== 'custom-order' &&
            Number(this.state.draperyOrder?.id || 0) === 0,
        })
      );
      await measureOpen('linings_items', () => this.getLiningsItems({ isReload: false }));
      await measureOpen('fetch_all', () => this.fetchAll());
    }
    this.validateAll('workOrder');
    window.addEventListener('popstate', () => {
      let draperyItem: any = localStorage.getItem('draperyItem');
      if (draperyItem) {
        draperyItem = JSON.parse(draperyItem);
      } else {
        draperyItem = {};
      }
      draperyItem.showDraperyModal = false;

      let romanShadeItem: any = localStorage.getItem('romanShadeItem');
      if (romanShadeItem) {
        romanShadeItem = JSON.parse(romanShadeItem);
      } else {
        romanShadeItem = {};
      }
      romanShadeItem.showRomanShadeModal = false;

      localStorage.setItem('romanShadeItem', JSON.stringify(romanShadeItem));
      localStorage.setItem('draperyItem', JSON.stringify(draperyItem));
    });

    if (
      this.state.trims &&
      this.state.trims.length > 0 &&
      this.state.orderType === 'roman-shade-order' &&
      (this.state.draperyOrder.id === 0 || this.state.draperyOrder.newRomanShade)
    ) {
      const updatedTrimsIfRomanShade = this.state.trims.map((i) => {
        if (i.draperyOrderFabric) {
          return {
            ...i,
            subType: 0,
            draperyOrderFabric: {
              ...i.draperyOrderFabric,
              type: 8,
              name: 'TRIM (PRE-MADE) ',
              draperyOrderSummaryComponent: {
                ...i.draperyOrderFabric.draperyOrderSummaryComponent,
                item: 'TRIM (PRE-MADE) ',
              },
            },
          };
        }
        return {
          ...i,
          subType: 0,
        };
      });
      this.setState((prev) => {
        return {
          ...prev,
          trims: updatedTrimsIfRomanShade,
        };
      });
    }
    const {
      draperyOrder,
      bandings,
      cordings,
      draperyOrderDesign,
      draperyOrderHardware,
      draperyOrderHeadrail,
      draperyOrderUploads,
      draperyOrderPriceId,
      draperyOrderSummary,
      draperyOrderSummaryComponents,
      embellishmentsList,
      flanges,
      isNoneEmbellishment,
      isNoneLinings,
      liningsList,
      mainFabric,
      othersEmbellishments,
      trims,
      workOrder,
      // workroomSetting,
    } = this.state;

    this.setState((state) => ({
      ...state,
      workroomSetting: {
        ...res[0],
        fabricPurchaser: fabricPurchaser,
        embellishmentsPurchaser: embellishmentsPurchaser,
        liningsPurchaser: liningsPurchaser,
        buckram: '',
        draperyPinInstaller: '',
        hardwarePurchaser: '',
        id: undefined,
        name: '',
        presetAddExcessUnit: 'select unit',
        presetCutLengthJson: {
          lining: undefined,
          interlining: undefined,
        },
        presetDraperyFullnessJson: { value: undefined },
        presetEmbellishmentJson: {
          trimVertical: undefined,
          flangeVertical: undefined,
          trimHorizontal: undefined,
          cordingVertical: undefined,
          flangeHorizontal: undefined,
        },
        presetHEMSJson: {
          bottomHemFabricAllowance: undefined,
          bottomHemFinishedSize: undefined,
          sideHemFabricAllowance: undefined,
          sideHemFinishedSize: undefined,
          topHemFabricAllowance: undefined,
          topHemFinishedSize: undefined,
        },
        presetIsYardageAddExcess: false,
        presetIsYardageAddOneExtra: false,
        presetReturnOverlapJson: {
          leadSize: undefined,
          returnSize: undefined,
          overlapSize: undefined,
        },
        type: undefined,
      },
      copyState: {
        ...state.copyState,
        workroomSetting: {
          ...res[0],
          fabricPurchaser: fabricPurchaser,
          embellishmentsPurchaser: embellishmentsPurchaser,
          liningsPurchaser: liningsPurchaser,
          buckram: '',
          draperyPinInstaller: '',
          hardwarePurchaser: '',
          id: undefined,
          name: '',
          presetAddExcessUnit: 'select unit',
          presetCutLengthJson: {
            lining: undefined,
            interlining: undefined,
          },
          presetDraperyFullnessJson: { value: undefined },
          presetEmbellishmentJson: {
            trimVertical: undefined,
            flangeVertical: undefined,
            trimHorizontal: undefined,
            cordingVertical: undefined,
            flangeHorizontal: undefined,
          },
          presetHEMSJson: {
            bottomHemFabricAllowance: undefined,
            bottomHemFinishedSize: undefined,
            sideHemFabricAllowance: undefined,
            sideHemFinishedSize: undefined,
            topHemFabricAllowance: undefined,
            topHemFinishedSize: undefined,
          },
          presetIsYardageAddExcess: false,
          presetIsYardageAddOneExtra: false,
          presetReturnOverlapJson: {
            leadSize: undefined,
            returnSize: undefined,
            overlapSize: undefined,
          },
          type: undefined,
        },
      },
      stateObj: _.cloneDeep({
        draperyOrder,
        bandings,
        cordings,
        draperyOrderDesign,
        draperyOrderHardware,
        draperyOrderUploads,
        draperyOrderPriceId,
        draperyOrderSummary,
        draperyOrderSummaryComponents,
        embellishmentsList,
        flanges,
        isNoneEmbellishment,
        isNoneLinings,
        liningsList,
        mainFabric,
        othersEmbellishments,
        trims,
        workOrder,
        workroomSetting: {
          ...res[0],
          fabricPurchaser: fabricPurchaser,
          embellishmentsPurchaser: embellishmentsPurchaser,
          liningsPurchaser: liningsPurchaser,
          buckram: '',
          draperyPinInstaller: '',
          hardwarePurchaser: '',
          id: undefined,
          name: '',
          presetAddExcessUnit: 'select unit',
          presetCutLengthJson: {
            lining: undefined,
            interlining: undefined,
          },
          presetDraperyFullnessJson: { value: undefined },
          presetEmbellishmentJson: {
            trimVertical: undefined,
            flangeVertical: undefined,
            trimHorizontal: undefined,
            cordingVertical: undefined,
            flangeHorizontal: undefined,
          },
          presetHEMSJson: {
            bottomHemFabricAllowance: undefined,
            bottomHemFinishedSize: undefined,
            sideHemFabricAllowance: undefined,
            sideHemFinishedSize: undefined,
            topHemFabricAllowance: undefined,
            topHemFinishedSize: undefined,
          },
          presetIsYardageAddExcess: false,
          presetIsYardageAddOneExtra: false,
          presetReturnOverlapJson: {
            leadSize: undefined,
            returnSize: undefined,
            overlapSize: undefined,
          },
          type: undefined,
        },
      }),
    }));
    isLoading = false;

    this.setState((state) => ({
      ...state,
      isLoading,
      initialCalculatorLoading: false,
      isLoadingCreateButton: false,
    }));
    logOpenPhase({
      phase: 'total',
      duration_ms: openStopwatch.end(),
      order_type: this.state.orderType,
      order_id: this.state.draperyOrder.id || undefined,
      order_size_bucket: this.computeOrderSizeBucket(),
    });
  }

  private computeOrderSizeBucket(): OrderSizeBucket {
    const s = this.state;
    const embellishments =
      (s.bandings?.length || 0) +
      (s.cordings?.length || 0) +
      (s.flanges?.length || 0) +
      (s.trims?.length || 0) +
      (s.othersEmbellishments?.length || 0);
    return bucketOrderSize({
      embellishments,
      uploads: s.draperyOrderUploads?.items?.length,
    });
  }

  private resolveDraftFinalItemType(): string {
    const orderType = String(this.state.orderType || '');
    if (orderType === 'drapery-order') return 'drapery';
    if (orderType === 'roman-shade-order') return 'roman-shade';
    if (orderType === 'custom-order') {
      const rawCustomType = String(
        (this.state.draperyOrder as any)?.itemTypeName ||
          (this.state.draperyOrder as any)?.itemType?.name ||
          ''
      ).trim();
      const customType = rawCustomType.toLowerCase().replace(/\s+/g, '-');
      return customType ? `custom-${customType}` : 'custom';
    }
    return orderType || 'unknown';
  }

  private resolveDraftFinalEstimateStatus(): string {
    const estimateStatus =
      (this.state.draperyOrder as any)?.estimateStatus ||
      (this.state.draperyOrderSummary as any)?.estimateJson?.status ||
      (this.state.draperyOrderSummary as any)?.estimateJson?.num ||
      'Not Created';
    return String(estimateStatus || 'Not Created');
  }

  public async componentWillUnmount(): Promise<void> {
    // const duplicate = localStorage.getItem('duplicate');
    // if(duplicate){
    //     await deleteClientProject({ id: Number(duplicate), duplicateNotSaved: true } as unknown as ClientProject);
    //     localStorage.removeItem('duplicate');
    // }
    // Clear unsaved-change lock when leaving calculator to avoid blocking logout.
    this.props.handleNotSavedOrder(false);
    window.removeEventListener('popstate', () => {});
  }

  async componentDidUpdate(prevProps: any, prevState: any, snapshot?: any): Promise<void> {
    if (
      prevState.client !== this.state.client ||
      (prevState.workOrderEditMode !== this.state.workOrderEditMode && this.state.workOrderEditMode)
    ) {
      const { workOrder, workOrderEditMode } = this.state;
      if (this.state.draperyOrder?.workOrderId && !workOrderEditMode) return;
      // client additional price adjustment
      const client_details = this.state.client?.billToParent
        ? this.state.client?.billingDetails
        : this.state.client?.billingDetailsDirectly;
      const client_details_additional_type = client_details?.additionalPriceAdjustment || 'none';
      const client_details_additional_price = client_details?.additionalPriceAdjustmentValue || '0';
      // ------------------------------------
      this.setState((prev) => {
        return {
          ...prev,
          draperyOrderHardware: {
            ...prev.draperyOrderHardware,
            hardwareAdditionalPriceAdjustment: client_details_additional_price,
            hardwareAdditionalPriceAdjustmentType: client_details_additional_type,
          },
          draperyOrderHeadrail: {
            ...prev.draperyOrderHeadrail,
            headrailAdditionalPriceAdjustment: client_details_additional_price,
            headrailAdditionalPriceAdjustmentType: client_details_additional_type,
          },
        };
      });
    }

    const numberInputs = document.querySelectorAll('input[type="number"]');

    numberInputs.forEach((input) => {
      input.addEventListener('wheel', function (event) {
        event.preventDefault();

        event.stopPropagation();
      });
    });
    if (!this.state.draperyOrder.newRomanShade) {
      const pricingRowHasValues = (row: any) => {
        if (!row) return false;
        const estimateDescription = (row.estimateDescription || '').trim();
        const cost = String(row.cost ?? '').trim();
        const quantity = String(row.quantity ?? '').trim();
        const markup = String(row.markup ?? '').trim();
        const customerPrice = String(row.customerPrice ?? '').trim();

        const quantityHasValue = quantity !== '' && quantity !== '1';
        const markupHasValue = markup !== '' && markup !== '0';

        return (
          estimateDescription !== '' ||
          cost !== '' ||
          customerPrice !== '' ||
          quantityHasValue ||
          markupHasValue
        );
      };

      function hasValues(hardware: any, draperyOrder: any, orderType: string) {
        const checkItems = (items: any) =>
          items.some(
            (item: any) =>
              (item.finish || '').trim() !== '' ||
              (item.quantity || '').trim() !== '' ||
              (item.description || '').trim() !== ''
          );

        let checkRods, checkOtherItems;
        if (hardware && hardware.rods) {
          checkRods = checkItems(hardware.rods);
        }
        if (hardware && hardware.otherItems) {
          checkOtherItems = checkItems(hardware.otherItems);
        }

        const pricingSource = hardware;
        const mainPricingHasValues = pricingRowHasValues({
          estimateDescription: pricingSource?.hardwareDescription,
          cost: pricingSource?.hardwareUnitPrice,
          quantity: pricingSource?.hardwareQuantity,
          markup: pricingSource?.hardwareMarkup,
          customerPrice: pricingSource?.hardwareCustomerFacingPrice,
        });

        const hardwareSih = pricingSource ? (pricingSource as any).hardwareSih : undefined;
        const includeShipping = !!hardwareSih?.active;
        const shippingHasValues = includeShipping ? pricingRowHasValues(hardwareSih) : false;

        if (checkRods || checkOtherItems || mainPricingHasValues || shippingHasValues) {
          return true;
        } else {
          return false;
        }
      }
      const hasValuesOnHardwareTab = hasValues(
        this.state.draperyOrderHardware,
        this.state.draperyOrder,
        this.state.orderType
      );

      this.setState((state) => ({
        ...state,
        hasValuesOnHardwareTab,
      }));
    }
    if (prevState.tabIndex !== this.state.tabIndex) {
      const index_view_relation: any = {
        '0': MixpanelEvents.ITEM_ORDER_SETUP,
        '1': MixpanelEvents.ITEM_ORDER_DESIGN,
        '2': MixpanelEvents.ITEM_ORDER_FABRICS,
        '3': MixpanelEvents.ITEM_ORDER_HARDWARE,
        '4': MixpanelEvents.ITEM_ORDER_UPLOADS,
        '5': MixpanelEvents.ITEM_ORDER_SUMMARY,
      };
      trackView(index_view_relation[this.state.tabIndex], {});
    }
    const draperyOrderError = this.state.draperyOrderErrors || [];
    const draperyDesigneErrorr = this.state.draperyOrderDesignErrors || [];
    const draperFabricsError = this.state.draperyOrderFabricsErrors || [];
    const draperyOrderConfirmation = this.state.draperyOrderFabricsConfirmations || [];
    const draperyOrderSummery = this.state.draperyOrderSummaryErrors || [];
    let arrErrorr = [
      ...draperyOrderError,
      ...draperyDesigneErrorr,
      ...draperFabricsError,
      ...draperyOrderConfirmation,
      ...draperyOrderSummery,
    ];

    const {
      draperyOrder,
      bandings,
      cordings,
      draperyOrderDesign,
      draperyOrderHardware,
      draperyOrderHeadrail,
      draperyOrderUploads,
      draperyOrderPriceId,
      draperyOrderSummary,
      draperyOrderSummaryComponents,
      embellishmentsList,
      flanges,
      isNoneEmbellishment,
      isNoneLinings,
      liningsList,
      mainFabric,
      othersEmbellishments,
      trims,
      workOrder,
      workroomSetting,
    } = this.state;

    const originObjectToCompare = {
      draperyOrder,
      bandings,
      cordings,
      draperyOrderDesign,
      draperyOrderHardware,
      draperyOrderUploads,
      draperyOrderPriceId,
      draperyOrderSummary,
      draperyOrderSummaryComponents,
      embellishmentsList,
      flanges,
      isNoneEmbellishment,
      isNoneLinings,
      liningsList,
      mainFabric,
      othersEmbellishments,
      trims,
      workOrder,
      workroomSetting,
    };

    let stateObject = {
      ..._.cloneDeep(this.state.stateObj),
      mainFabric: {
        ..._.cloneDeep(this.state.stateObj).mainFabric,
        orderOrigin: mainFabric.orderOrigin,
      },
    };
    delete originObjectToCompare.draperyOrder.createdAt;
    const keysToDeleteIn = ['rods', 'otherItems'];
    for (const key of keysToDeleteIn) {
      //@ts-ignore
      originObjectToCompare.draperyOrderHardware[key].forEach((item: any) => {
        delete item.id;
      });
      stateObject.draperyOrderHardware[key].forEach((item: any) => {
        delete item.id;
      });
    }
    if (prevProps.triggerModal !== this.props.triggerModal) {
      if (this.props.cantLogOut) {
        if (this.state.workOrderEditMode) {
          const editConfirm = await this.showEditWorkOrderConfirm();
          if (!editConfirm) {
            this.setState((prev) => {
              return {
                ...prev,
                forceLogOut: true,
              };
            });
            this.props.handleNewNavigation('logout', true);
          }
        } else {
          const confirmed = await this.showSaveConfirm();
          if (confirmed) {
            if (this.state.draperyOrder.id === 0) {
              const can_create_order = await userCanCreateNewOrder(this.props.accountId);
              if (
                !can_create_order &&
                this.state.remainingItemOrder === 0 &&
                this.state.orderType !== 'custom-order'
              ) {
                this.props.handleOpenSubscriptionPlanModal();
                return;
              }
            }
            if (!(await this.handleSaveAll(true))) {
              return;
            }
            await this.getExistingDraperyOrder();
          } else {
            this.setState((prev) => {
              return {
                ...prev,
                forceLogOut: true,
              };
            });
            this.props.handleNewNavigation('logout', true);
          }
        }
      }
    }
    if (this.deepEqual(originObjectToCompare, stateObject) || this.state.isLoading) {
      this.props.handleNotSavedOrder(false);
      this.setState((state) => ({
        ...state,
        noChanges: true,
      }));
    } else {
      this.props.handleNotSavedOrder(true);
      this.setState((prev) => {
        return {
          ...prev,
          noChanges: false,
        };
      });
    }

    if (this.state.isEditConstructionDetailsModalOpen) {
      getAllItems({ isActiveOnly: true })
        .then((res) => {
          const foundDraperyItem = res.filter((i) =>
            this.state.orderType === 'roman-shade-order'
              ? i.name === 'Roman Shade'
              : i.name === 'Drapery'
          );

          this.setState((prev) => {
            return {
              ...prev,
              selectedItemId: this.state.isEditConstructionDetailsModalOpen
                ? foundDraperyItem[0].id
                : null,
            };
          });
        })
        .catch((err) => {
          console.error('Error fetching items:', err);
        });
    }

    if (this.state.reloadOnSaveConstructions) {
      if (!this.state.isEditConstructionDetailsModalOpen) {
        this.getDefaultConstruction();
      }
    }

    if (prevState.mainFabric.orderOrigin !== this.state.mainFabric.orderOrigin) {
      this.setState((prev) => {
        return {
          ...prev,
          copyState: {
            ...prev.copyState,
            mainFabric: {
              ...prev.copyState.mainFabric,
              orderOrigin: this.state.mainFabric.orderOrigin,
            },
          },
        };
      });
      if (prevState.mainFabric.orderOrigin !== -1 && this.state.mainFabric.orderOrigin === 1) {
        this.setState({
          mainFabric: {
            ...this.state.mainFabric,
            orderOrigin: this.state.mainFabric.orderOrigin,
          },
        });
      }
    }
    if (
      prevState.draperyOrder !== this.state.draperyOrder ||
      prevState.draperyOrderDesign !== this.state.draperyOrderDesign ||
      prevState.mainFabric !== this.state.mainFabric ||
      prevState.othersEmbellishments !== this.state.othersEmbellishments ||
      prevState.bandings !== this.state.bandings ||
      prevState.cordings !== this.state.cordings ||
      prevState.flanges !== this.state.flanges ||
      prevState.trims !== this.state.trims ||
      prevState.draperyOrderSummary !== this.state.draperyOrderSummary
    ) {
      if (this.state.workOrderEditMode) {
        this.setState({
          isUpdateChanged: true,
        });
      }
    }
    if (prevState.draperyOrderDesign.headingType !== this.state.draperyOrderDesign.headingType) {
      const { headingType, draperyType } = this.state.draperyOrderDesign;
      const isCustomizeConstructionopen = headingType
        ? headingType === 'rodandrings'
          ? !!draperyType
          : true
        : false;
      this.setState({
        isCustomizeConstructionOpen: isCustomizeConstructionopen,
      });
    }
    if (this.state.draperyOrderDesign.isWeight === null) {
      this.setState((prev) => {
        return {
          ...prev,
          draperyOrderDesign: {
            ...prev.draperyOrderDesign,
            isWeight: false,
          },
          copyState: {
            ...prev.copyState,
            draperyOrderDesign: {
              ...prev.draperyOrderDesign,
              isWeight: false,
            },
          },
        };
      });
    }
    if (
      arrErrorr.length > 0 &&
      !this.state.isError &&
      !this.findFirstErrorsCalled &&
      !this.state.isErrorMessageOpen
    ) {
      this.setState({ isError: true }, () => {
        this.findFirstErrors();
        this.findFirstErrorsCalled = true;
      });
    }
    if (
      this.state &&
      this.state.draperyOrderDesign &&
      this.state.draperyOrderDesign.ripplefoldOptions &&
      this.state.draperyOrderDesign.ripplefoldOptions.headerTape &&
      this.state.draperyOrderDesign.ripplefoldOptions.headerTape === 'other'
    ) {
      this.setState((prev) => {
        return {
          ...prev,
          draperyOrderDesign: {
            ...prev.draperyOrderDesign,
            ripplefoldOptions: {
              ...prev.draperyOrderDesign.ripplefoldOptions,
              headerTape: '',
            },
          },
        };
      });
    }
    if (
      this.state &&
      this.state.draperyOrderDesign &&
      this.state.draperyOrderDesign.ripplefoldOptions &&
      this.state.draperyOrderDesign.ripplefoldOptions.controlLocation &&
      this.state.draperyOrderDesign.ripplefoldOptions.controlLocation === 'other'
    ) {
      this.setState((prev) => {
        return {
          ...prev,
          draperyOrderDesign: {
            ...prev.draperyOrderDesign,
            ripplefoldOptions: {
              ...prev.draperyOrderDesign.ripplefoldOptions,
              controlLocation: '',
            },
          },
        };
      });
    }

    if (this.state.workOrderReady) {
      this.handleCreateOtherItemOrder(this.state.openPdf);
    }

    this.getDefaultValue();
  }

  public render(): JSX.Element {
    const { client, draperyOrder, roomList, workOrderEditMode } = this.state;
    const isPageLoading = Boolean(
      this.state.isLoading || this.state.initialCalculatorLoading || this.state.summaryTabLoading
    );

    const filteredRoomList = roomList.filter((room) => room.key === draperyOrder.roomId)[0];

    const quickAddProps = {
      active: this.state.quickAddClientModal,
      onCancel: () => this.handleShowQuickAddClientModal(false),
      getClient: this.getClient,
      resetOnClose: true,
      getRooms: this.getRooms,
      onClientSaved: this.handleClientChanged,
      client: undefined,
      accountId: this.props.accountId,
    };
    const releaseDate = new Date('2026-01-12');
    const secReleaseDate = new Date('2026-01-23');
    const thirtyDaysAfterRelease = new Date(releaseDate);
    const thirtyDaysAfterSecondRelease = new Date(secReleaseDate);
    thirtyDaysAfterRelease.setDate(thirtyDaysAfterRelease.getDate() + 30);
    thirtyDaysAfterSecondRelease.setDate(thirtyDaysAfterSecondRelease.getDate() + 30);
    const showHardwareBadge = thirtyDaysAfterRelease > new Date();
    const showHeadrailAndPartsBadge = thirtyDaysAfterSecondRelease > new Date();
    const showFabricUrlParser = checkGate(FABRIC_URL_PARSER_GATE);
    return (
      <>
        <Prompt
          message={(location: any): string | boolean => {
            if (
              (this.state.navigationConfirmed ||
                this.state.noChanges ||
                (!this.state.isChanged && this.state.draperyOrder.id) ||
                (this.state.draperyOrder.id && !this.state.stateObj.draperyOrder.id) ||
                // !this.state.isChanged ||
                this.state.forceLogOut) &&
              !this.state.workOrderEditMode
            ) {
              // const duplicate = localStorage.getItem('duplicate');
              //
              // if(duplicate){
              //     await deleteClientProject({ id: Number(duplicate)} as unknown as ClientProject);
              // }
              const handelDuplicate = async () => {
                const duplicate = localStorage.getItem('duplicate');
                if (duplicate) {
                  const { id, orderType } = JSON.parse(duplicate);
                  await deleteClientProject({
                    id: Number(id),
                    duplicateNotSaved: true,
                  } as unknown as ClientProject);
                  localStorage.removeItem('duplicate');

                  const canCreateOrder = await userCanCreateNewOrder(this.props.accountId);
                  if (
                    !canCreateOrder &&
                    this.state.remainingItemOrder >= 0 &&
                    orderType !== 'custom-order'
                  ) {
                    await updateAccount({
                      accountId: this.props.accountId,
                      remainingItemOrder: this.state.remainingItemOrder + 1,
                    });
                  }
                }
              };
              handelDuplicate();

              return true;
            } else {
              this.customNavigation(location);
              return false;
            }
          }}
        />

        <ConfirmationModal
          uiAcceptLabel="Setup"
          uiDeclineLabel="Cancel"
          uiHeader="Setup Needed"
          uiActive={this.state.showDraperyItemModal}
          uiOnConfirm={() => {
            let draperyItem: any = localStorage.getItem('draperyItem');
            if (draperyItem) {
              draperyItem = JSON.parse(draperyItem);
            } else {
              draperyItem = {};
            }
            draperyItem.showDraperyModal = true;
            draperyItem.client = this.state.client;
            draperyItem.orderId = this.state.draperyOrder.id;

            localStorage.setItem('draperyItem', JSON.stringify(draperyItem));
            this.props.history.push('/myshop', { type: getQueryParam('type') || 'drapery-order' });
          }}
          uiOnClose={() =>
            this.setState({ showDraperyItemModal: false }, () => {
              let draperyItem: any = localStorage.getItem('draperyItem');
              if (draperyItem) {
                draperyItem = JSON.parse(draperyItem);
              } else {
                draperyItem = {};
              }
              draperyItem.showDraperyModal = false;
              localStorage.setItem('draperyItem', JSON.stringify(draperyItem));
            })
          }
          uiOnRequestClose={() => this.setState({ showDraperyItemModal: false })}
          uiCloseOnOutsideClick={true}
          uiCloseOnEsc={true}
        >
          The Drapery item must be setup in My Shop prior to creating a Drapery Order.
        </ConfirmationModal>

        {/* For Roman Shade Pricing */}
        <ConfirmationModal
          uiAcceptLabel="Setup"
          uiDeclineLabel="Cancel"
          uiHeader="Setup Needed"
          uiActive={this.state.showRomanShadeItemModal}
          uiOnConfirm={() => {
            let draperyItem: any = localStorage.getItem('romanShadeItem');
            if (draperyItem) {
              draperyItem = JSON.parse(draperyItem);
            } else {
              draperyItem = {};
            }
            draperyItem.showRomanShadeModal = true;
            draperyItem.client = this.state.client;
            draperyItem.orderId = this.state.draperyOrder.id;

            localStorage.setItem('romanShadeItem', JSON.stringify(draperyItem));
            this.props.history.push('/myshop');
          }}
          uiOnClose={() =>
            this.setState({ showRomanShadeItemModal: false }, () => {
              let draperyItem: any = localStorage.getItem('romanShadeItem');
              if (draperyItem) {
                draperyItem = JSON.parse(draperyItem);
              } else {
                draperyItem = {};
              }
              draperyItem.showRomanShadeModal = false;
              localStorage.setItem('romanShadeItem', JSON.stringify(draperyItem));
            })
          }
          uiOnRequestClose={() => this.setState({ showRomanShadeItemModal: false })}
          uiCloseOnOutsideClick={true}
          uiCloseOnEsc={true}
        >
          Roman Shade must be setup in My Shop prior to creating a Roman Shade Order.
        </ConfirmationModal>
        <PageContent
          style={{
            position: 'relative',
            pointerEvents: isPageLoading ? 'none' : undefined,
          }}
        >
          {/* {this.state.workOrderPdfStatus === "downloading" &&
                        this.state.workOrderPdfContent && (
                            <DraperyPdf
                                filename={
                                    pdfFilenamePrefix
                                        ? `${pdfFilenamePrefix}-${this.state.workOrderPdfContent.workOrderNum}`
                                        : `${this.state.workOrderPdfContent.workOrderNum}`
                                }
                                workOrderPdfContent={
                                    this.state.workOrderPdfContent
                                }
                                onFinished={this.handleDraperyPdfFinished}
                            />
                        )} */}

          <FadeLoader
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(50%,-50%)',
              zIndex: 9999,
              display: isPageLoading ? 'block' : 'none',
            }}
            color="#3B97B1"
            aria-label="Loading Spinner"
            data-testid="loader"
          />

          <HContainer uiBaseLine className="flex-wrap justify-between">
            <div className="flex items-center">
              <PageHeader
                customStyle={{
                  padding: 0,
                }}
                classNameProps="text-xl md:text-2xl mb-0"
                title={
                  this.state.orderType === 'drapery-order'
                    ? this.state.isCopy
                      ? `Drapery Order - Copy`
                      : `Drapery Order`
                    : this.state.orderType === 'roman-shade-order'
                      ? this.state.isCopy
                        ? `Roman Shade Order - Copy`
                        : `Roman Shade Order`
                      : this.state.isCopy
                        ? `${
                            this.state.itemType
                              ? this.state.itemType + ' Order - Copy'
                              : 'Item Order - Copy'
                          }`
                        : `${this.state.itemType ? this.state.itemType + ' Order' : 'Item Order'}`
                }
              />
              {client && <ClientNameSeperator> - </ClientNameSeperator>}
              {client &&
                client.parent &&
                getParentClients(client.parent).map((ancestorClient) => (
                  <>
                    <ClientHoverBox
                      key={ancestorClient.id}
                      client={ancestorClient}
                      onClick={this.navigateToClient}
                      type="draperyOrder"
                    />
                    <ClientNameSeperator> | </ClientNameSeperator>
                  </>
                ))}
              {client && (
                <ClientHoverBox
                  key={client.id}
                  client={client}
                  onClick={this.navigateToClient}
                  type="draperyOrder"
                />
              )}
              {client && ![0, '', null, undefined].includes(draperyOrder.roomId) ? (
                roomList.length > 0 && (
                  <>
                    <BreadCrumbSeparator> / </BreadCrumbSeparator>
                    <BreadCrumbName>{`${
                      filteredRoomList ? filteredRoomList.label : ''
                    }`}</BreadCrumbName>

                    {draperyOrder.window && (
                      <>
                        <BreadCrumbSeparator> / </BreadCrumbSeparator>
                        <BreadCrumbName>{draperyOrder.window}</BreadCrumbName>
                      </>
                    )}
                  </>
                )
              ) : client &&
                [0, '', null, undefined].includes(draperyOrder.roomId) &&
                draperyOrder.customRoom ? (
                <>
                  <BreadCrumbSeparator> / </BreadCrumbSeparator>
                  <BreadCrumbName>{`${
                    draperyOrder.customRoom ? draperyOrder.customRoom : ''
                  }`}</BreadCrumbName>

                  {draperyOrder.window && (
                    <>
                      <BreadCrumbSeparator> / </BreadCrumbSeparator>
                      <BreadCrumbName>{draperyOrder.window}</BreadCrumbName>
                    </>
                  )}
                </>
              ) : null}
            </div>

            <div className="flex items-center" style={{ gap: '8px', marginBottom: '10px' }}>
              <div>
                <Notebook
                  row={
                    this.state?.draperyOrder?.id
                      ? {
                          client: this.state.client,
                          orderType: this.state.orderType,
                          itemType: this.state.itemType,
                          archived: this.state.draperyOrder.archived,
                          id: this.state?.draperyOrder?.id,
                          notebook: [],
                        }
                      : null
                  }
                  defaultTab="items"
                  notebookTabs={['projects', 'items']}
                  user={this.props.accountUser}
                  table={'items'}
                  orderOpen={open}
                  ref={this.notebookRef}
                  orderItemType={this.state?.draperyOrder?.itemType?.name}
                  roomName={this.state?.draperyOrder?.roomName}
                  newOrder={!this.state?.draperyOrder?.id}
                  client={this.state.client}
                  showIconTitle={true}
                  canAccessTeamSettings={this.props.canAccessTeamSettings}
                  closeOnOutsideClick={false}
                />
              </div>

              <div>
                <button
                  disabled={
                    isPageLoading ||
                    this.state.isLoadingCreateButton ||
                    this.state.loadingUpdate ||
                    this.state.workOrderEditMode ||
                    this.state.draperyOrder.archived
                  }
                  className="secondary_btn"
                  style={{ padding: '10px 16px' }}
                  type="button"
                  onClick={() => {
                    if (this.state.orderType === 'roman-shade-order') {
                      if (
                        ((this.state.trims &&
                          this.state.trims.length > 0 &&
                          this.state.trims[0].draperyOrderFabric &&
                          this.state.trims[0].draperyOrderFabric.name &&
                          this.state.trims[0].draperyOrderFabric.name.includes('TRIM FABRIC')) ||
                          this.state.hasValuesOnHardwareTab) &&
                        !this.state.draperyOrder.newRomanShade
                      ) {
                        this.openWarningModal();
                      } else if (!this.state.draperyOrder.archived) {
                        this.handleDuplicateRomanShadeOrder();
                      }
                    } else {
                      this.handleDuplicateDraperyOrder();
                    }
                  }}
                >
                  Duplicate
                </button>
              </div>

              {!this.state.draperyOrder.archived && (
                <div>
                  <button
                    disabled={
                      isPageLoading || this.state.isLoadingCreateButton || this.state.loadingUpdate
                    }
                    className="primary_btn"
                    style={{ padding: '10px 16px' }}
                    type="button"
                    onClick={() => {
                      if (this.state.workOrder.id > 0) {
                        if (
                          this.state.workOrderEditMode &&
                          this.state.orderType !== 'custom-order' &&
                          this.state.orderType !== 'roman-shade-order'
                        ) {
                          this.updateWorkOrder('delete_messag');
                        } else if (
                          this.state.workOrderEditMode &&
                          (this.state.orderType === 'custom-order' ||
                            this.state.orderType === 'roman-shade-order')
                        ) {
                          this.handleSaveFirst(false, this.state.yardage);
                        } else {
                          this.editNavigate(0);
                        }
                      } else {
                        if (this.state.orderType === 'custom-order') {
                          this.handleSaveFirst(true, this.state.yardage);
                        } else if (this.state.orderType === 'roman-shade-order') {
                          this.handleSaveFirst(false, this.state.yardage);
                        } else {
                          if (this.state.workOrder.id > 0) {
                            this.handleEditWorkOrder();
                          } else {
                            this.handleCreateWorkOrder('delete_messag');
                          }
                        }
                      }
                    }}
                  >
                    {this.state.workOrder.id > 0 && !this.state.workOrderEditMode && (
                      <EditIcon
                        className="inline-flex white_pencil"
                        style={{ width: '16px', height: '16px' }}
                      />
                    )}
                    {this.state.workOrder.id > 0
                      ? this.state.workOrderEditMode
                        ? 'Update'
                        : 'Edit'
                      : this.state.orderType !== 'custom-order'
                        ? 'Calculate'
                        : 'Create'}
                  </button>
                </div>
              )}
            </div>
          </HContainer>
          <CalculatorSectionContainer>
            <CalculatorForm
              id="draperyOrderForm"
              onKeyPress={this.handleKeyPressForm}
              uiPadding={false}
            >
              <DisableAutocompleteInput name="firstName" />
              <ContentCalculator>
                <ContentCalculatorSub>
                  <PopoverScrollContext.Provider value={this.state.areaScrollInfo}>
                    <CalculatorTabs
                      style={{ transition: 'all 0.2s' }}
                      forceRenderTabPanel
                      selectedIndex={this.state.tabIndex}
                      onSelect={(tabIndex) => this.setState({ tabIndex })}
                    >
                      <TabList>
                        <Tab>Setup</Tab>
                        <Tab>Design</Tab>
                        <Tab>
                          <span
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '8px',
                            }}
                          >
                            Fabrics
                            {showFabricUrlParser && <span className="new_pill">New</span>}
                          </span>
                        </Tab>
                        {this.state.orderType === 'drapery-order' ? (
                          <Tab
                            style={{
                              position: 'relative',
                            }}
                          >
                            <span
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '8px',
                              }}
                            >
                              Hardware
                              {showHardwareBadge ? <span className="new_pill">New</span> : null}
                            </span>
                          </Tab>
                        ) : this.state.orderType === 'roman-shade-order' ? (
                          <Tab
                            style={{
                              position: 'relative',
                            }}
                          >
                            <span
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '8px',
                              }}
                            >
                              Headrail
                              {showHeadrailAndPartsBadge ? (
                                <span className="new_pill">New</span>
                              ) : null}
                            </span>
                          </Tab>
                        ) : (
                          <Tab
                            style={{
                              position: 'relative',
                            }}
                          >
                            <span
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '8px',
                              }}
                            >
                              Parts & Supplies
                              {showHeadrailAndPartsBadge ? (
                                <span
                                  style={{
                                    background: 'rgb(255, 96, 132)',
                                    color: 'white',
                                    border: '1px solid white',
                                    borderRadius: '25px',
                                    padding: '0px 7px',
                                    textTransform: 'uppercase',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                  }}
                                >
                                  New
                                </span>
                              ) : null}
                            </span>
                          </Tab>
                        )}
                        <Tab
                          style={{
                            position: 'relative',
                          }}
                        >
                          Uploads
                        </Tab>
                        <Tab>Summary</Tab>
                      </TabList>
                      {this.renderSetupTab()}

                      {this.renderDesignTab()}

                      {this.renderFabricsTab()}

                      {this.state.orderType !== 'roman-shade-order'
                        ? this.renderHardwareTab()
                        : this.renderHeadrailTab()}

                      {this.renderUploadTab()}

                      {this.renderSummaryTab()}
                    </CalculatorTabs>
                  </PopoverScrollContext.Provider>

                  {this.renderSidebar()}
                </ContentCalculatorSub>
                <FooterSubContainer>
                  <FooterButtonContainer className="flex-col md:flex-row justify-between">
                    <div>
                      <FooterCancelBtn
                        className="cancel_btn"
                        uiColor="primary"
                        disabled={this.state.loadingUpdate}
                        uiDisabled={this.state.loadingUpdate}
                        type="button"
                        onClick={() =>
                          workOrderEditMode
                            ? this.cancelEditingWorkOrder()
                            : this.toggleCancelModal()
                        }
                      >
                        Cancel
                      </FooterCancelBtn>
                    </div>

                    <div className="steps_container">
                      <div
                        onClick={() => this.handleNavigateTab('back')}
                        className={`back_step ${this.state.tabIndex === 0 ? 'disabled' : ''}`}
                      >
                        <div>
                          <ArrowIcon className="back_icon" />
                        </div>

                        <div>
                          <span className="back_step_name">Back</span>
                        </div>
                      </div>

                      <div className="steps_separator" />

                      <div
                        onClick={() => this.handleNavigateTab('next')}
                        className={`next_step ${this.state.tabIndex === 5 ? 'disabled' : ''}`}
                      >
                        <div>
                          <span className="next_step_name">Next</span>
                        </div>

                        <div>
                          <ArrowIcon className="next_icon" />
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center">
                      {/* {!workOrderEditMode && (
                                                <FooterSaveBtn
                                                    type="button"
                                                    onClick={() =>
                                                        this.handleSaveAll(false)
                                                    }
                                                >
                                                    Save
                                                </FooterSaveBtn>
                                            )} */}

                      {workOrderEditMode ? (
                        <FooterSaveNextBtn
                          disabled={this.state.loadingUpdate}
                          uiDisabled={this.state.loadingUpdate}
                          uiColor="primary"
                          type="button"
                          onClick={() =>
                            this.state.orderType === 'custom-order'
                              ? this.handleSaveFirst(false, this.state.yardage)
                              : this.state.orderType === 'roman-shade-order'
                                ? this.handleSaveFirst(false, this.state.yardage)
                                : this.updateWorkOrder('delete_messag')
                          }
                        >
                          Update
                        </FooterSaveNextBtn>
                      ) : (
                        <FooterSaveNextBtn
                          className="primary_btn"
                          uiColor="primary"
                          type="button"
                          onClick={() => this.handleSaveAndNext()}
                        >
                          Save & Close
                        </FooterSaveNextBtn>
                      )}
                    </div>
                  </FooterButtonContainer>
                </FooterSubContainer>
              </ContentCalculator>
            </CalculatorForm>
          </CalculatorSectionContainer>
        </PageContent>

        <WarningModal
          uiActive={this.state.isWarningModalOpen}
          uiOnConfirm={() => {
            this.setState({
              isWarningModalOpen: false,
            });
          }}
          uiOnRequestClose={() => {
            this.setState({
              isWarningModalOpen: false,
            });
          }}
          uiCloseOnOutsideClick={true}
          uiCloseOnEsc={true}
          uiHeader="Cannot Duplicate"
        >
          <p>
            {`Some options selected on this Roman Shade Order form are no longer available in our updated form. This order is unable to be duplicated; please create a new order instead.`}
          </p>
        </WarningModal>

        <ClientModal
          isModalOpen={this.state.isAddClientModalOpen}
          onModalClose={this.handleCloseClientModal}
          onClientSaved={this.handleClientChanged}
          getRooms={this.getRooms}
          resetOnClose
          setFocusFirstField={(fn) => (this.setFocusFirstFieldOnClientModal = fn)}
          getClient={this.getClient}
        />
        {client && client.id > 0 && (
          <ClientModal
            key={client.id}
            client={client}
            isModalOpen={this.state.isEditClientModalOpen}
            onModalClose={this.closeEditClientModal}
            onClientSaved={this.onClientEdited}
            resetOnClose
            setFocusFirstField={(fn) => (this.setFocusFirstFieldOnClientModal = fn)}
            tabIndex={1}
            highlightedSection={this.state.highlightedSection}
            clearHighlightSection={this.clearHighlightSection}
            updateStateByName={this.updateStateByName}
          />
        )}

        <QuickAddClient {...quickAddProps} />

        <RoomModal
          draperyOrder={this.state.draperyOrder}
          handleSearchSelectChange={this.handleSearchSelectChange}
          handleSearchClient={this.handleSearchClient}
          isModalOpen={this.state.isAddRoomModalOpen}
          uiHeader="Add New Room"
          closeModal={() => this.setState({ isAddRoomModalOpen: false })}
          addRoom={this.handleAddRoom}
        />
        <SupplierModal
          accountId={this.props.accountId}
          isModalOpen={this.state.isAddSupplierModalOpen}
          onModalClose={this.handleCloseSupplierModal}
          onSave={this.handleSupplierChanged}
          resetOnClose
          setFocusFirstField={(fn) => (this.setFocusFirstFieldOnSupplierModal = fn)}
        />

        <AvatarModal
          uiActive={this.state.imageModalOpen}
          uiOnRequestClose={this.handleCloseImageModal}
          onSave={this.handleSaveImage}
          isRect
          ratio={this.state.imageModalRelatedName.endsWith('Fabric.imageId') ? 0.5 : undefined}
          header={
            this.state.imageModalRelatedName.endsWith('Fabric.imageId')
              ? 'Upload Image'
              : 'Pleat Type Image'
          }
        />
        <ErrorMessageModal
          isModalOpen={this.state.isErrorMessageOpen}
          onModalClose={this.toggleErrorMessage}
        />
        <RecommendationsOverridesModal
          editMode={this.state.workOrderEditMode}
          data={this.state}
          active={this.state.isRecommendationsOverridesModalOpen}
          onRequestClose={this.handleCancelRecommendationsOverrides}
          isFunctional={this.state.draperyOrderDesign.category === 0}
          panelType={this.state.draperyOrderDesign.panelType}
          draperyOrderId={this.state.draperyOrder.id}
          selectedPanels={this.state.draperyOrderDesign.category}
          handleConfirm={this.handleConfirmRecommendationOverride}
          draperyOrderDesign={this.state.draperyOrderDesign}
          newDraperyOrderFabrics={this.state.newDraperyOrderFabrics}
          workOrderEditMode={this.state.workOrderEditMode}
          resetDraperyOrderNewFabrics={this.resetDraperyOrderNewFabrics}
          handleSaveAll={this.saveAll}
          resetAfterUpdatingEmbellishments={this.resetAfterUpdatingEmbellishments}
          isCopy={this.state.isCopy}
        />
        <RecommendationsOverridesModalRomanShade
          editMode={this.state.workOrderEditMode}
          data={this.state}
          active={this.state.isRecommendationsOverridesModalRomanShadeOpen}
          onRequestClose={this.handleCancelRecommendationsRomanShadeOverrides}
          isFunctional={false}
          panelType={this.state.draperyOrderDesign.panelType}
          draperyOrderId={this.state.draperyOrder.id}
          selectedPanels={this.state.draperyOrderDesign.category}
          handleConfirm={this.handleConfirmRecommendationOverride}
          draperyOrderDesign={this.state.draperyOrderDesign}
          newDraperyOrderFabrics={this.state.newDraperyOrderFabrics}
          workOrderEditMode={this.state.workOrderEditMode}
          resetDraperyOrderNewFabrics={this.resetDraperyOrderNewFabrics}
          handleSaveAll={this.saveAll}
          resetAfterUpdatingEmbellishments={this.resetAfterUpdatingEmbellishments}
          isCopy={this.state.isCopy}
          dispatch={this.props.dispatch}
        />
        <LoadingModal
          message="Creating work order..."
          isModalOpen={this.state.isLoadingOpen}
          onModalClose={this.toggleLoadingModal}
        />
      </>
    );
  }

  public renderSidebar(): JSX.Element {
    return (
      <SidebarContainer
        className={`absolute top-0 right-0 h-full lg:relative z-50 ${
          !this.state.isSidebarHidden ? 'w-1/2 lg:w-1/3 max-w-xs pl-2' : 'w-0 max-w-0'
        }`}
        style={{ backgroundColor: 'white' }}
      >
        <div className="absolute" style={{ left: -30 }}>
          <SidebarButton onClick={this.toggleSidebar}>
            {this.state.isSidebarHidden ? <SidebarExpandIcon /> : <SidebarCollapseIcon />}
            {!!(
              (this.state.draperyOrderErrors && this.state.draperyOrderErrors.length) ||
              (this.state.draperyOrderDesignErrors && this.state.draperyOrderDesignErrors.length) ||
              (this.state.draperyOrderFabricsErrors &&
                this.state.draperyOrderFabricsErrors.length) ||
              (this.state.draperyOrderFabricsConfirmations &&
                this.state.draperyOrderFabricsConfirmations.length > 0 &&
                (this.state.mainFabric.directionOfUse === 1
                  ? !this.state.checkedAllowExtraWidthOne
                  : !this.state.checkedAllowExtraWidthTwo)) ||
              (this.state.draperyOrderSummaryErrors && this.state.draperyOrderSummaryErrors.length)
            ) && <ErrorsIcon />}
          </SidebarButton>
        </div>
        {!this.state.isSidebarHidden && (
          <SidebarContainerSub>{this.renderIssues()}</SidebarContainerSub>
        )}
      </SidebarContainer>
    );
  }

  public renderItemSummary(data: {
    isDraperyOrder: boolean;
    isCustomOrder: boolean;
    isRomanShadeOrder: boolean;
    roomValue: any;
    nameValue: string;
    salesDescriptionSettingsMapped: any;
    salesDescriptionSettingsMappedRoman: any;
    mainFabric: any;
    quantity?: number;
  }): JSX.Element {
    const { isCollapsedDesc } = this.state;

    if (isCollapsedDesc) {
      return <></>;
    }

    const drapery_order_design = this.state.draperyOrderDesign;

    // Comment if client doesn't want drapery pinning and weights in estimate description shown
    const item_details =
      this.state.draperyItemDetail && this.state.draperyItemDetail.length > 0
        ? this.state.draperyItemDetail[0]
        : null;
    const shouldShowBundledQuantity =
      (data.isRomanShadeOrder
        ? Boolean(this.state.romanShadeItemDetails?.[0]?.isBundlingSelected)
        : Boolean(item_details?.isBundlingSelected)) &&
      data.quantity !== undefined &&
      data.quantity !== null &&
      `${data.quantity}`.trim() !== '';

    // Comment if client doesn't want drapery pinning and weights in estimate description shown
    const drapery_pinning_case = drapery_order_design && drapery_order_design.isPinSet;
    const drapery_pinning =
      (drapery_pinning_case && {
        id: 'draperyPinning',
        name: 'Drapery Pinning',
        price: (item_details && item_details.draperyPinningWidthPricing) || '',
      }) ||
      {};

    // Comment if client doesn't want drapery pinning and weights in estimate description shown
    const add_ons_with_pricing = item_details && item_details.addOnsWithPricing;

    // Comment if client doesn't want drapery pinning and weights in estimate description shown
    const found_weight_selected =
      add_ons_with_pricing &&
      add_ons_with_pricing.length > 0 &&
      add_ons_with_pricing.find((i: any) => {
        if (drapery_order_design && drapery_order_design.weightRadio === 'standard-corner') {
          return i.id === 'standardCorner';
        } else if (drapery_order_design && drapery_order_design.weightRadio === 'beaded-chain') {
          return i.id === 'beadedChain';
        }
        return false;
      });

    const add_ons = (drapery_order_design && [...drapery_order_design.addOns]) || [];

    // Comment if client doesn't want drapery pinning and weights in estimate description shown
    if (found_weight_selected) add_ons.unshift(found_weight_selected);
    if (drapery_pinning_case && drapery_pinning) add_ons.unshift(drapery_pinning);

    const data_main_fabric = data && data.mainFabric ? data.mainFabric : {};
    const { isMatchRepeatAtSeams, isPleatToPattern } = data_main_fabric;
    const mainFabricVerticalRepeat = Number(data_main_fabric?.values?.verticalRepeat || 0);
    const mainFabricHorizontalRepeat = Number(data_main_fabric?.values?.horizontalRepeat || 0);
    const isMatchRepeatActive = mainFabricVerticalRepeat > 0 || mainFabricHorizontalRepeat > 0;
    const isPleatToPatternActive = mainFabricHorizontalRepeat > 0;

    const match_and_pattern_array = [];

    if (isMatchRepeatAtSeams && isMatchRepeatActive) match_and_pattern_array.push('Match Repeat');
    if (isPleatToPattern && isPleatToPatternActive)
      match_and_pattern_array.push('Pleat to Pattern');

    if (data.isDraperyOrder || data.isCustomOrder) {
      return (
        <div className="item-summary-content">
          <div>
            {data.roomValue} {data.nameValue}
          </div>
          {shouldShowBundledQuantity && <div>Quantity: {data.quantity}</div>}
          <OrderDescription
            editMode={this.state.workOrderEditMode}
            isDraperyOrder={data.isDraperyOrder}
            salesDescriptionSettingsMapped={data.salesDescriptionSettingsMapped}
            data={{
              draperyOrderDesign: this.state.draperyOrderDesign,
              liningsList: this.state.liningsList,
              liningsPatternItems: this.state.liningsPatternItems,
            }}
            draperyItemDetail={this.state.draperyItemDetail}
          />
          {/* <LiningDetails
            salesDescriptionSettingsMapped={data.salesDescriptionSettingsMapped}
            data={{ liningsList: this.state.liningsList }}
          /> */}
          <EmbellishmentDetails
            salesDescriptionSettingsMapped={data.salesDescriptionSettingsMapped}
            data={{
              embellishmentsList: this.state.embellishmentsList,
              othersEmbellishments: this.state.othersEmbellishments,
              orderType: this.state.orderType,
              bandings: this.state.bandings,
              cordings: this.state.cordings,
              flanges: this.state.flanges,
              trims: this.state.trims,
            }}
          />

          {match_and_pattern_array && match_and_pattern_array.length > 0 && (
            <div className="flex items-center">
              <span>{match_and_pattern_array.join(' / ')}</span>
            </div>
          )}

          {add_ons.length > 0 && (
            <div>
              <span>Add-ons: </span>
              <span>{add_ons.map((i) => i.name).join(', ')}</span>
            </div>
          )}
        </div>
      );
    }

    if (data.isRomanShadeOrder) {
      return (
        <div className="item-summary-content">
          <div>
            {data.roomValue} {data.nameValue}
          </div>
          {shouldShowBundledQuantity && <div>Quantity: {data.quantity}</div>}
          <RomanShadeDescription
            salesDescriptionSettingsMapped={data.salesDescriptionSettingsMappedRoman}
            liningsList={this.state.liningsList}
            liningsPatternItems={this.state.liningsPatternItems}
            description={this.state.draperyOrderDesign.description}
            romanShadeJson={this.state.draperyOrderDesign.romanShadeJson}
          />
          <RomanEmbellishmentDetails
            salesDescriptionSettingsMapped={data.salesDescriptionSettingsMappedRoman}
            data={{
              orderType: this.state.orderType,
              embellishmentsList: this.state.embellishmentsList,
              bandings: this.state.bandings,
              cordings: this.state.cordings,
              flanges: this.state.flanges,
              trims: this.state.trims,
              othersEmbellishments: this.state.othersEmbellishments,
            }}
          />
        </div>
      );
    }

    return <></>;
  }

  public renderIssues(): JSX.Element | null {
    const hasDraperyOrderIssues =
      this.state.draperyOrderErrors && this.state.draperyOrderErrors.length > 0;
    const hasDraperyOrderDesignIssues =
      this.state.draperyOrderDesignErrors && this.state.draperyOrderDesignErrors.length > 0;
    const hasDraperyOrderFabricsIssues =
      this.state.draperyOrderFabricsErrors && this.state.draperyOrderFabricsErrors.length > 0;
    const hasDraperyOrderFabricsConfirmations =
      this.state.draperyOrderFabricsConfirmations &&
      this.state.draperyOrderFabricsConfirmations.length > 0;
    const hasDraperyOrderHardwareIssues =
      this.state.draperyOrderHardwareErrors && this.state.draperyOrderHardwareErrors.length > 0;
    const hasDraperyOrderSummaryIssues =
      this.state.draperyOrderSummaryErrors && this.state.draperyOrderSummaryErrors.length > 0;

    const hasMyShpItemPricingErrors =
      this.state.myShopItemPricingErrors && this.state.myShopItemPricingErrors.length > 0;
    const hasMyShopClientBillingErrors =
      this.state.myShopClientBillingErrors && this.state.myShopClientBillingErrors.length > 0;

    const ripplefoldPricingErrors =
      this.state.orderType === 'drapery-order'
        ? validateRipplefoldPricing(this.state.draperyItemDetail)
        : [];
    const romanShadePricingErrors =
      this.state.romanShadePricingErrors && this.state.romanShadePricingErrors.length > 0;

    const hasIssues =
      hasDraperyOrderIssues ||
      hasDraperyOrderDesignIssues ||
      hasDraperyOrderFabricsIssues ||
      hasDraperyOrderFabricsConfirmations ||
      hasDraperyOrderHardwareIssues ||
      hasDraperyOrderSummaryIssues ||
      hasMyShpItemPricingErrors ||
      hasMyShopClientBillingErrors ||
      ripplefoldPricingErrors ||
      romanShadePricingErrors;

    if (!hasIssues) return null;

    const isDraperyOrder: boolean =
      !this.state.orderType || this.state.orderType === 'drapery-order';
    const isCustomOrder: boolean = !this.state.orderType || this.state.orderType === 'custom-order';
    const isRomanShadeOrder: boolean =
      !this.state.orderType || this.state.orderType === 'roman-shade-order';

    const selectedRoom = this.state.roomList.find(
      (room) => room.key === this.state.draperyOrder.roomId
    );
    const roomValue = selectedRoom ? selectedRoom.label : undefined;

    let nameValue = '';

    if (isDraperyOrder || isRomanShadeOrder) {
      if (this.state.draperyOrder.window) {
        if (roomValue && this.state.draperyOrder.window) {
          nameValue += '/ ';
        }
        nameValue += `${this.state.draperyOrder.window}`;
      }
    } else if (isCustomOrder) {
      if (
        this.state.draperyOrder &&
        this.state.draperyOrder.itemType &&
        this.state.draperyOrder.itemType.name
      ) {
        if (roomValue && this.state.draperyOrder.itemType.name) {
          nameValue += '/ ';
        }
        nameValue += `${this.state.draperyOrder.itemType.name}`;
      }
    }

    const { draperyItemDetail } = this.state;

    const draperyItemDetailObj: any = draperyItemDetail;

    let salesDescriptionSettingsMapped = [];
    if (draperyItemDetailObj && draperyItemDetailObj.length > 0) {
      if (draperyItemDetailObj[0].salesDescriptionSettings) {
        salesDescriptionSettingsMapped = draperyItemDetailObj[0].salesDescriptionSettings;
      }
    }

    const { romanShadeItemDetails } = this.state;

    const romanShadeItemDetailsObj: any = romanShadeItemDetails;

    let salesDescriptionSettingsMappedRoman: any[] = [];

    if (romanShadeItemDetailsObj && romanShadeItemDetailsObj.length > 0) {
      const firstDraperyItem = romanShadeItemDetailsObj[0];

      if (firstDraperyItem.salesDescriptionSettings) {
        salesDescriptionSettingsMappedRoman = firstDraperyItem.salesDescriptionSettings;
      }
    }

    return (
      <SidebarIssuesContainer>
        <div className="item_summary_container">
          <div
            onClick={() => {
              this.handleToggleDesc();
            }}
            className={`item_summary_header ${
              this.state.isCollapsedDesc ? 'is_collapsed_summary_desc' : ''
            }`}
          >
            <SidebarSummaryHeader>Item Summary</SidebarSummaryHeader>
            <svg
              className="arrow-icon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 9L12 15L18 9"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <br></br>

          {this.renderItemSummary({
            isDraperyOrder,
            isCustomOrder,
            isRomanShadeOrder,
            roomValue,
            nameValue,
            salesDescriptionSettingsMapped,
            salesDescriptionSettingsMappedRoman,
            mainFabric: this.state.mainFabric,
            quantity: this.state.draperyOrder.quantity,
          })}
        </div>
        <div
          style={
            hasIssues === true
              ? {
                  border: '1px solid #CDCDCD',
                  padding: '10px',
                  marginTop: '10px',
                  height: 'calc(100% - 150px)',
                  overflowY: 'auto',
                  borderRadius: '10px',
                }
              : {}
          }
        >
          {hasIssues === true && (
            <>
              <SidebarIssuesHeader style={{ color: '#E11900', fontWeight: '500' }}>
                <RedWarning />
                ISSUES
              </SidebarIssuesHeader>
              <SidebarIssuesText style={{ color: '#E11900', fontWeight: '500' }}>
                Click the issues below to navigate to the issue
              </SidebarIssuesText>
            </>
          )}
          {this.state.orderType === 'roman-shade-order'
            ? romanShadePricingErrors && (
                <>
                  <SidebarIssuesTitle>Pricing</SidebarIssuesTitle>
                  <ul>{this.renderValidationErrorElement(this.state.romanShadePricingErrors!)}</ul>
                </>
              )
            : ripplefoldPricingErrors &&
              ripplefoldPricingErrors.length > 0 && (
                <>
                  <SidebarIssuesTitle>Pricing</SidebarIssuesTitle>
                  <ul>{this.renderValidationErrorElement(ripplefoldPricingErrors.slice(0, 10))}</ul>
                </>
              )}
          {hasDraperyOrderHardwareIssues && (
            <>
              <SidebarIssuesTitle>Parts & Supplies</SidebarIssuesTitle>
              <ul>{this.renderValidationErrorElement(this.state.draperyOrderHardwareErrors!)}</ul>
            </>
          )}
          {hasDraperyOrderIssues && (
            <>
              <SidebarIssuesTitle>Setup</SidebarIssuesTitle>
              <ul>{this.renderValidationErrorElement(this.state.draperyOrderErrors!)}</ul>
            </>
          )}
          {hasDraperyOrderDesignIssues && (
            <>
              <SidebarIssuesTitle>Design</SidebarIssuesTitle>
              <ul>
                {this.renderValidationErrorElement(
                  this.state.draperyOrderDesignErrors!.slice(0, 10)
                )}
              </ul>
            </>
          )}
          {(hasDraperyOrderFabricsIssues || hasDraperyOrderFabricsConfirmations) && (
            <>
              <SidebarIssuesTitle>Fabrics</SidebarIssuesTitle>

              {hasDraperyOrderFabricsIssues && (
                <ul>
                  {this.renderValidationErrorElement(
                    this.state.draperyOrderFabricsErrors!.slice(0, 10)
                  )}
                </ul>
              )}
              {hasDraperyOrderFabricsConfirmations && (
                <>
                  <SidebarAlertTitle>Alert!</SidebarAlertTitle>
                  {this.renderValidationConfirmationElement(
                    this.state.draperyOrderFabricsConfirmations!.slice(0, 10)
                  )}
                </>
              )}
            </>
          )}
          {hasDraperyOrderSummaryIssues && (
            <>
              <SidebarIssuesTitle>Summary</SidebarIssuesTitle>
              <ul>
                {this.renderValidationErrorElement(
                  this.state.draperyOrderSummaryErrors!.slice(0, 10)
                )}
              </ul>
            </>
          )}
          {hasMyShpItemPricingErrors && (
            <>
              <SidebarIssuesTitle>Pricing for Fabrics</SidebarIssuesTitle>
              <ul>
                {this.renderValidationErrorElement(
                  this.state.myShopItemPricingErrors!.slice(0, 10)
                )}
              </ul>
            </>
          )}
          {hasMyShopClientBillingErrors && (
            <>
              <SidebarIssuesTitle>Client Billing Type</SidebarIssuesTitle>
              <ul>
                {this.renderValidationErrorElement(
                  this.state.myShopClientBillingErrors!.slice(0, 10)
                )}
              </ul>
            </>
          )}
          {this.state.isWorkOrderValidation && !hasIssues && (
            <>
              <SidebarNoIssues>
                <NoIssuesIcon />
                <span>All issues are resolved!</span>
              </SidebarNoIssues>
            </>
          )}
        </div>
      </SidebarIssuesContainer>
    );
  }

  public renderValidationConfirmationElement(confirmations: ValidationConfirmationInfo[]) {
    const { mainFabric } = this.state;
    return confirmations.map((confirmation, key) => (
      <>
        <ValidationConfirmationContainer>
          <ValidationConfirmationCheckbox
            id={confirmation.value}
            name={confirmation.value}
            checked={
              mainFabric.directionOfUse === 1
                ? this.state.checkedAllowExtraWidthOne
                : this.state.checkedAllowExtraWidthTwo
            }
            onChange={this.handleInputChangeForBoolean}
          />
          <ValidationConfirmationElement
            key={`${confirmation.value}-val-confirm-element`}
            onClick={() =>
              this.navigateValidation(
                confirmation.tabIndex,
                confirmation.name,
                0,
                0,
                confirmation.nameOther
              )
            }
            className="mb-2"
          >
            {confirmation.message}
          </ValidationConfirmationElement>
        </ValidationConfirmationContainer>
      </>
    ));
  }

  public renderValidationErrorElement(errors: ValidationErrorInfo[]) {
    return errors.map((error, index) => (
      <ValidationErrorElement
        key={`${error.tabIndex}-${error.name}-${index}`}
        onClick={() =>
          this.navigateValidation(
            error.tabIndex,
            error.name,
            error.itemId,
            error.itemClassId,
            error.nameOther
          )
        }
        className={`mb-2 ${
          (error.name.includes('draperyOrder.clientId') ||
            error.name.includes('draperyOrder.roomId') ||
            error.name.includes('draperyOrder.itemTypeId')) &&
          this.state.clientAndRoomHighlight
            ? 'text-[red]'
            : ''
        }`}
      >
        {error.message}
      </ValidationErrorElement>
    ));
  }

  public handleShowQuickAddClientModal = (open_case: boolean) => {
    const key1 = 'draperyOrder.clientId';
    const key2 = 'draperyOrder.clientName';
    this.setState((prev) => {
      return {
        ...prev,
        pathIdForModal: key1,
        pathNameForModal: key2,
        quickAddClientModal: open_case,
      };
    });
  };

  public renderSetupTab(): JSX.Element {
    const selectedRoom = this.state.roomList.find(
      (room) => room.key === this.state.draperyOrder.roomId
    );
    const roomValue = selectedRoom ? selectedRoom.label : undefined;
    const disabled = !this.state.draperyOrder.editable;
    this.state.roomList.sort((a, b) => a.label.localeCompare(b.label));

    return (
      <TabPanelBox>
        <SetupTab
          roomList={this.state.roomList}
          workOrderList={this.state.workOrderList}
          draperyOrder={this.state.draperyOrder}
          roomValue={roomValue}
          disabled={disabled}
          handleOpenClientModalClick={this.handleOpenClientModalClick}
          handleSearchSelectChange={this.handleSearchSelectChange}
          handleSearchClient={this.handleSearchClient}
          handleSearchRoom={this.handleSearchRoom}
          handleSearchItemType={this.handleSearchItemType}
          handleSearchSelectClear={this.handleSearchSelectClear}
          handleSelectListChange={this.handleSelectListChange}
          handleAddRoom={this.handleAddRoom}
          handleInputChangeForString={this.handleInputChangeForString}
          handleInputChangeForBoolean={this.handleInputChangeForBoolean}
          handleInputChangeForNumber={this.handleInputChangeForNumber}
          openModalClick={this.addNewRoom}
          updateStateByName={this.updateStateByName}
          highlightedSection={this.state.highlightedSection}
          workOrderEditMode={this.state.workOrderEditMode}
          isCopy={this.state.isCopy}
          isAddRoomModalOpen={this.state.isAddRoomModalOpen}
          isAddClientModalOpen={this.state.isAddClientModalOpen}
          orderType={this.state.orderType}
          handleShowQuickAddClientModal={this.handleShowQuickAddClientModal}
        />
      </TabPanelBox>
    );
  }

  public renderDesignTab(): JSX.Element {
    const { dispatch } = this.props;

    return (
      /*removed "onScroll={this.onTabAreaScoll}" property and onTabAreaScroll function, 
              its slowing down ui, due to re-renders*/
      <TabPanelBox>
        {this.state.orderType === 'custom-order' ? (
          <OtherItemDesignTab
            ref={this.designTabRef}
            draperyOrderDesign={this.state.draperyOrderDesign}
            liningsList={this.state.liningsList}
            isNoneLinings={this.state.isNoneLinings}
            embellishmentsList={this.state.embellishmentsList}
            isNoneEmbellishment={this.state.isNoneEmbellishment}
            isCustomizeConstructionOpen={this.state.isCustomizeConstructionOpen}
            disabled={!this.state.draperyOrder.editable}
            openImageModal={this.handleOpenImageModal}
            resetPanelConf={this.handleResetPanelConf}
            resetPleatType={this.handleResetPleatType}
            addNewLining={this.handleAddNewLining}
            addEmbellishment={this.handleAddEmbellishment}
            deleteEmbellishment={this.handleDeleteEmbellishment}
            toggleCustomizeConstruction={this.handleToggleCustomizeConstruction}
            handleInputChangeForNumber={this.handleInputChangeForNumber}
            handleInputChangeForString={this.handleInputChangeForString}
            handleInputChangeForNumberPrice={this.handleInputChangeForNumberPrice}
            handleInputChangeForBoolean={this.handleInputChangeForBoolean}
            handleSelectListChange={this.handleSelectListChange}
            updateStateByName={this.updateStateByName}
            onShapeChanged={this.handleShapeChanged}
            getEmbellishmentsByIndex={this.getEmbellishmentsByIndex}
            highlightedSection={this.state.highlightedSection}
            handleBuckramSelect={this.handleBuckramSelect}
            handleFullnessSelect={this.handleFullnessSelect}
            data={this.state}
            workroomSetting={this.state.workroomSetting}
            handleInputBlur={this.handleInputBlur}
            draperyItemDetail={this.state.draperyItemDetail}
            dispatch={dispatch}
            handleChangeRipplefoldOptions={this.handleChangeRipplefoldOptions}
            handleRemoveRipplefoldDetail={this.handleRemoveRipplefoldDetail}
            workOrderEditMode={this.state.workOrderEditMode}
            handleRemoveDraperyDesignCategory={this.handleRemoveDraperyDesignCategory}
            openConstructionDetailsEditModal={this.openConstructionDetailsEditModal}
            resetDraperyOrderEmbellishments={this.resetDraperyOrderEmbellishments}
            resetLinings={this.resetLinings}
            orderType={this.state.orderType}
            numberingTrims={this.numberingTrims}
          />
        ) : this.state.orderType === 'roman-shade-order' ? (
          <RomanShadeDesignTab
            ref={this.designTabRef}
            draperyOrderDesign={this.state.draperyOrderDesign}
            liningsList={this.state.liningsList}
            isNoneLinings={this.state.isNoneLinings}
            embellishmentsList={this.state.embellishmentsList}
            isNoneEmbellishment={this.state.isNoneEmbellishment}
            isCustomizeConstructionOpen={this.state.isCustomizeConstructionOpen}
            romanShadeFieldsChanged={this.romanShadeFieldsChanged}
            disabled={!this.state.draperyOrder.editable}
            openImageModal={this.handleOpenImageModal}
            resetPanelConf={this.handleResetPanelConf}
            resetPleatType={this.handleResetPleatType}
            addNewLining={this.handleAddNewLining}
            addEmbellishment={this.handleAddEmbellishment}
            deleteEmbellishment={this.handleDeleteEmbellishment}
            toggleCustomizeConstruction={this.handleToggleCustomizeConstruction}
            handleInputChangeForNumber={this.handleInputChangeForNumber}
            handleInputChangeForString={this.handleInputChangeForString}
            handleInputChangeForNumberPrice={this.handleInputChangeForNumberPrice}
            handleInputChangeForBoolean={this.handleInputChangeForBoolean}
            handleSelectListChange={this.handleSelectListChange}
            updateStateByName={this.updateStateByName}
            onShapeChanged={this.handleShapeChanged}
            getEmbellishmentsByIndex={this.getEmbellishmentsByIndex}
            highlightedSection={this.state.highlightedSection}
            handleBuckramSelect={this.handleBuckramSelect}
            handleFullnessSelect={this.handleFullnessSelect}
            data={this.state}
            workroomSetting={this.state.workroomSetting}
            handleInputBlur={this.handleInputBlur}
            draperyItemDetail={this.state.draperyItemDetail}
            dispatch={dispatch}
            handleChangeRipplefoldOptions={this.handleChangeRipplefoldOptions}
            handleRemoveRipplefoldDetail={this.handleRemoveRipplefoldDetail}
            workOrderEditMode={this.state.workOrderEditMode}
            handleRemoveDraperyDesignCategory={this.handleRemoveDraperyDesignCategory}
            openConstructionDetailsEditModal={this.openConstructionDetailsEditModal}
            resetDraperyOrderEmbellishments={this.resetDraperyOrderEmbellishments}
            resetLinings={this.resetLinings}
            orderType={this.state.orderType}
            romanShadeJson={this.state.draperyOrderDesign.romanShadeJson}
            handleRemoveRomanShadeCategory={this.handleRemoveRomanShadeCategory}
            numberingTrims={this.numberingTrims}
          />
        ) : (
          <DesignTab
            ref={this.designTabRef}
            draperyOrderDesign={this.state.draperyOrderDesign}
            liningsList={this.state.liningsList}
            isNoneLinings={this.state.isNoneLinings}
            embellishmentsList={this.state.embellishmentsList}
            isNoneEmbellishment={this.state.isNoneEmbellishment}
            isCustomizeConstructionOpen={this.state.isCustomizeConstructionOpen}
            disabled={!this.state.draperyOrder.editable}
            openImageModal={this.handleOpenImageModal}
            resetPanelConf={this.handleResetPanelConf}
            resetPleatType={this.handleResetPleatType}
            addNewLining={this.handleAddNewLining}
            addEmbellishment={this.handleAddEmbellishment}
            deleteEmbellishment={this.handleDeleteEmbellishment}
            toggleCustomizeConstruction={this.handleToggleCustomizeConstruction}
            handleInputChangeForNumber={this.handleInputChangeForNumber}
            handleInputChangeForString={this.handleInputChangeForString}
            handleInputChangeForNumberPrice={this.handleInputChangeForNumberPrice}
            handleInputChangeForBoolean={this.handleInputChangeForBoolean}
            handleSelectListChange={this.handleSelectListChange}
            updateStateByName={this.updateStateByName}
            onShapeChanged={this.handleShapeChanged}
            getEmbellishmentsByIndex={this.getEmbellishmentsByIndex}
            highlightedSection={this.state.highlightedSection}
            handleBuckramSelect={this.handleBuckramSelect}
            handleFullnessSelect={this.handleFullnessSelect}
            data={this.state}
            workroomSetting={this.state.workroomSetting}
            handleInputBlur={this.handleInputBlur}
            draperyItemDetail={this.state.draperyItemDetail}
            dispatch={dispatch}
            handleChangeRipplefoldOptions={this.handleChangeRipplefoldOptions}
            handleRemoveRipplefoldDetail={this.handleRemoveRipplefoldDetail}
            workOrderEditMode={this.state.workOrderEditMode}
            handleRemoveDraperyDesignCategory={this.handleRemoveDraperyDesignCategory}
            openConstructionDetailsEditModal={this.openConstructionDetailsEditModal}
            resetDraperyOrderEmbellishments={this.resetDraperyOrderEmbellishments}
            resetLinings={this.resetLinings}
            orderType={this.state.orderType}
            numberingTrims={this.numberingTrims}
            handleChooseAddOns={this.handleChooseAddOns}
          />
        )}
      </TabPanelBox>
    );
  }

  public renderFabricsTab(): JSX.Element {
    const disabled = !this.state.draperyOrder.editable;
    const [pathName, pathIndex] = this.state.pathNameForModal.split('.');
    let index = pathIndex !== undefined ? parseInt(pathIndex) : undefined;

    const selectedFabricsItem =
      this.state.fabricsPatternItems && this.state.fabricsPatternItems.length > 0
        ? this.state.fabricsPatternItems.find((item) => {
            if (pathName === 'mainFabric') {
              return item.name === this.state.mainFabric.pattern;
              // return item.id === this.state.mainFabric.patternId;
            }
            if (pathName === 'bandings' && index !== undefined) {
              const { draperyOrderFabric } = this.state.bandings[index];
              return draperyOrderFabric ? item.name === draperyOrderFabric.pattern : false;
              // return draperyOrderFabric ? item.id === draperyOrderFabric.patternId : false;
            }

            if (pathName === 'cordings' && index !== undefined) {
              const { draperyOrderFabric } = this.state.cordings[index];
              return draperyOrderFabric ? item.name === draperyOrderFabric.pattern : false;
              // return draperyOrderFabric ? item.id === draperyOrderFabric.patternId : false;
            }

            if (pathName === 'trims' && index !== undefined) {
              const { draperyOrderFabric } = this.state.trims[index];
              return draperyOrderFabric ? item.name === draperyOrderFabric.pattern : false;
              // return draperyOrderFabric ? item.id === draperyOrderFabric.patternId : false;
            }

            if (pathName === 'flanges' && index !== undefined) {
              const { draperyOrderFabric } = this.state.flanges[index];
              return draperyOrderFabric ? item.name === draperyOrderFabric.pattern : false;
              // return draperyOrderFabric ? item.id === draperyOrderFabric.patternId : false;
            }

            if (pathName === 'othersEmbellishments' && index !== undefined) {
              const { draperyOrderFabric } = this.state.othersEmbellishments[index];
              return draperyOrderFabric ? item.name === draperyOrderFabric.pattern : false;
              // return draperyOrderFabric ? item.id === draperyOrderFabric.patternId : false;
            }
            return false;
          })
        : null;

    const selectedLiningsItem =
      this.state.liningsPatternItems && this.state.liningsPatternItems.length > 0
        ? this.state.liningsPatternItems.find((item) => {
            if (pathName === 'liningsList' && index !== undefined) {
              const { draperyOrderLiningsFabric } = this.state.liningsList[index];
              return draperyOrderLiningsFabric
                ? item.name === draperyOrderLiningsFabric.pattern
                : false;
            }
            return false;
          })
        : null;

    return (
      <TabPanelBox>
        <FabricsTab
          accountId={this.props.accountId}
          bandings={this.state.bandings}
          romanShadeSettings={this.state.romanShadeSettings}
          cordings={this.state.cordings}
          flanges={this.state.flanges}
          trims={this.state.trims}
          draperyOrder={this.state.draperyOrder}
          draperyOrderDesign={this.state.draperyOrderDesign}
          disabledLeftover={disabled}
          othersEmbellishments={this.state.othersEmbellishments}
          mainFabric={this.state.mainFabric}
          embellishmentsList={this.state.embellishmentsList}
          liningsList={this.state.liningsList}
          disabled={!this.state.draperyOrder.editable}
          onSupplierSearch={this.handleSearchSupplier}
          openSupplierModalClick={this.handleOpenSupplierModalClick}
          onFabricsPatternSearch={this.handleSearchFabricsPattern}
          onFabricsLiningPatternSearch={this.handleSearchFabricsLiningPattern}
          openFabricsPatternModalClick={this.handleOpenPatternModalClick}
          openEditFabricsPatternModalClick={this.handleOpenEditPatternModal}
          openImageModal={this.handleOpenImageModal}
          onAddSupplierByName={this.handleAddSupplierByName}
          handleInputChangeForNumber={this.handleInputChangeForNumber}
          handleInputChangeForString={this.handleInputChangeForString}
          handleInputChangeForBoolean={this.handleInputChangeForBoolean}
          handleSelectListChange={this.handleSelectListChange}
          handleSearchSelectChange={this.handleSearchSelectChange}
          handleSearchSelectClear={this.handleSearchSelectClear}
          highlightedSection={this.state.highlightedSection}
          fabricsPatternItems={this.state.fabricsPatternItems}
          liningsPatternItems={this.state.liningsPatternItems}
          workroomSetting={
            this.state.orderType !== 'roman-shade-order'
              ? this.state.workroomSetting
              : this.state.romanShadeSettings
          }
          orderOriginStateEmb={this.state.orderOriginStateEmb}
          changeTrimValue={this.changeTrimValue}
          updateStateByName={this.updateStateByName}
          clearHighlightSection={(e: any) => {
            if (
              this.state.draperyOrderFabricsConfirmations &&
              this.state.draperyOrderFabricsConfirmations.length > 0
            ) {
              this.clearHighlightSection(e.target.name);
            }
          }}
          workOrderEditMode={this.state.workOrderEditMode}
          isCopy={this.state.isCopy}
          orderType={this.state.orderType}
          // pass romanShadeProps to fabrics tab and check for
          romanShadeProps={this.state.draperyOrderDesign.romanShadeJson}
          onFabricUrlSubmit={this.handleFabricUrlSubmit}
        />
        {this.state.isAddFabricsPatternModalOpen && (
          <>
            <StandardItemModal
              isModalOpen={true}
              onModalClose={this.handleCloseFabricsPatternModal}
              categories={this.state.categories}
              openModalClick={this.openSupplierModalaOnWo}
              suppliers={this.state.suppliers}
              itemId={this.state.selectedItemId}
              activeItemClassId={this.state.activeItemClassId}
              reloadGrid={this.handlePatternSelectAfterAdd}
              pathIdForModal={this.state.pathIdForModal}
              pathNameForModal={this.state.pathNameForModal}
              fabricPatternModalCategoryId={this.state.fabricPatternModalCategoryId}
              supplierName={this.state.supplierName}
              supplierId={this.state.supplierId}
              resetSupplier={this.resetSupplier}
              fromCalculator={true}
              draperyOrderFabricsErrors={this.state.draperyOrderFabricsErrors}
              highlightedSection={this.state.highlightedSection}
              wideSheetFocusField={this.state.wideSheetFocusField}
              updateFabricsTab={this.updateFabrics}
              useWideSheet={true}
              isSupplierModalOpen={this.state.isModalOpenWo}
              prefill={this.state.fabricUrlPrefill}
              detailsPrefill={this.state.fabricUrlDetailsPrefill}
            />
            <SupplierModal
              accountId={this.props.accountId}
              isModalOpen={this.state.isModalOpenWo}
              onModalClose={this.closeSupplierModal}
              onSave={this.handleSupplierChanged}
              resetOnClose
              setFocusFirstField={(fn) => (this.setFocusFirstFieldOnSupplierModal = fn)}
            />
          </>
        )}
        {this.state.isEditFabricsPatternModalOpen &&
          (selectedFabricsItem || selectedLiningsItem) && (
            <>
              <StandardItemModal
                isModalOpen={true}
                onModalClose={this.handleCloseEditFabricsPatternModal}
                categories={this.state.categories}
                openModalClick={this.openSupplierModalaOnWo}
                suppliers={this.state.suppliers}
                itemId={
                  selectedFabricsItem
                    ? selectedFabricsItem.id || null
                    : selectedLiningsItem
                      ? selectedLiningsItem.id || null
                      : null
                }
                activeItemClassId={this.state.activeItemClassId}
                reloadGrid={this.handlePatternSelectAfterAdd}
                pathIdForModal={this.state.pathIdForModal}
                pathNameForModal={this.state.pathNameForModal}
                fabricPatternModalCategoryId={this.state.fabricPatternModalCategoryId}
                supplierName={this.state.supplierName}
                supplierId={this.state.supplierId}
                resetSupplier={this.resetSupplier}
                updateFabricsTab={
                  selectedFabricsItem
                    ? this.updateFabrics
                    : selectedLiningsItem
                      ? this.updateLinings
                      : undefined
                }
                fromCalculator={true}
                draperyOrderFabricsErrors={this.state.draperyOrderFabricsErrors}
                highlightedSection={this.state.highlightedSection}
                wideSheetFocusField={this.state.wideSheetFocusField}
                useWideSheet={true}
                isSupplierModalOpen={this.state.isModalOpenWo}
              />
              <SupplierModal
                accountId={this.props.accountId}
                isModalOpen={this.state.isModalOpenWo}
                onModalClose={this.closeSupplierModal}
                onSave={this.handleSupplierChanged}
                resetOnClose
                setFocusFirstField={(fn) => (this.setFocusFirstFieldOnSupplierModal = fn)}
              />
            </>
          )}
        {this.state.isEditConstructionDetailsModalOpen &&
        this.state.orderType === 'roman-shade-order' ? (
          <RomanShadeModal
            isModalOpen={true}
            reloadOnSave={this.reloadOnSave}
            fetchAll={this.fetchAll}
            onModalClose={this.closeEditContructionsModal}
            categories={this.state.categories}
            activeItemClassId={5}
            suppliers={this.state.suppliers}
            itemId={this.state.selectedItemId}
            reloadGrid={this.handlePatternSelectAfterAdd}
            isPleatModalOpen={false}
            updateStateByName={this.updateStateByName}
            openModalClick={this.openSupplierModalaOnWo}
            supplierName={this.state.supplierName}
            supplierId={this.state.supplierId}
            tabIndex={2}
          />
        ) : (
          this.state.isEditConstructionDetailsModalOpen && (
            <DraperyItemModal
              reloadOnSave={this.reloadOnSave}
              isModalOpen={true}
              onModalClose={this.closeEditContructionsModal}
              categories={this.state.categories}
              suppliers={this.state.suppliers}
              fetchAll={this.fetchAll}
              itemId={this.state.selectedItemId}
              reloadGrid={this.reloadGrid}
              isPleatModalOpen={false}
              tabIndex={2}
              updateStateByName={this.updateStateByName}
            />
          )
        )}
      </TabPanelBox>
    );
  }

  public renderHardwareTab(): JSX.Element {
    const disabled = this.state.workOrderEditMode ? false : !this.state.draperyOrder.editable;
    const isRomanShadeOrder = this.state.orderType === 'roman-shade-order';
    const isCustomOrder = this.state.orderType === 'custom-order';

    return (
      <TabPanelBox>
        {!isRomanShadeOrder &&
          (isCustomOrder ? (
            <PartsAndSuppliesOtherOrder
              handleInputChangeForNumber={this.handleInputChangeForNumber}
              draperyOrderHardware={this.state.draperyOrderHardware}
              handleRemovePurchaser={this.handleRemovePurchaser}
              updateHardwareState={this.updateHardwareState}
              handleSearchSelectChange={this.handleSearchSelectChange}
              handleSearchSelectClear={this.handleSearchSelectClear}
              onSupplierSearch={this.handleSearchSupplier}
              onAddSupplierByName={this.handleAddSupplierByName}
              openSupplierModalClick={this.handleOpenSupplierModalClick}
              disabled={disabled}
              handleDeleteTableRow={this.handleDeleteTableRow}
              onHardwarePricingChange={this.handleHardwarePricingChange}
              onToggleHardwareShipping={this.handleToggleHardwareShipping}
            />
          ) : (
            <HardwareTab
              handleInputChangeForNumber={this.handleInputChangeForNumber}
              draperyOrderHardware={this.state.draperyOrderHardware}
              draperyOrder={this.state.draperyOrder}
              handleRemovePurchaser={this.handleRemovePurchaser}
              updateHardwareState={this.updateHardwareState}
              handleSearchSelectChange={this.handleSearchSelectChange}
              handleSearchSelectClear={this.handleSearchSelectClear}
              onSupplierSearch={this.handleSearchSupplier}
              onAddSupplierByName={this.handleAddSupplierByName}
              openSupplierModalClick={this.handleOpenSupplierModalClick}
              disabled={disabled}
              handleDeleteTableRow={this.handleDeleteTableRow}
              onHardwarePricingChange={this.handleHardwarePricingChange}
              onToggleHardwareShipping={this.handleToggleHardwareShipping}
              orderType={this.state.orderType}
            />
          ))}
      </TabPanelBox>
    );
  }

  public renderHeadrailTab(): JSX.Element {
    const disabled = this.state.workOrderEditMode ? false : !this.state.draperyOrder.editable;
    const isRomanShadeOrder = this.state.orderType === 'roman-shade-order';

    return (
      <TabPanelBox>
        {isRomanShadeOrder && (
          <HeadrailTabRomanShade
            handleInputChangeForNumber={this.handleInputChangeForNumber}
            draperyOrderHeadrail={this.state.draperyOrderHeadrail}
            draperyOrder={this.state.draperyOrder}
            handleRemovePurchaser={this.handleRemovePurchaser}
            updateHardwareState={this.updateHardwareState}
            handleSearchSelectChange={this.handleSearchSelectChange}
            handleSearchSelectClear={this.handleSearchSelectClear}
            onSupplierSearch={this.handleSearchSupplier}
            onAddSupplierByName={this.handleAddSupplierByName}
            openSupplierModalClick={this.handleOpenSupplierModalClick}
            disabled={disabled}
            handleDeleteTableRow={this.handleDeleteTableRow}
            onHardwarePricingChange={this.handleHardwarePricingChange}
            onToggleHardwareShipping={this.handleToggleHardwareShipping}
            orderType={this.state.orderType}
          />
        )}
      </TabPanelBox>
    );
  }

  public renderUploadTab(): JSX.Element {
    const disabled = this.state.workOrderEditMode ? false : !this.state.draperyOrder.editable;
    return (
      <TabPanelBox>
        <UploadTab
          disabled={disabled}
          handleAddUploads={this.handleAddUploads}
          draperyOrderUploads={this.state.draperyOrderUploads}
          accountId={this.props.accountId}
          isLoading={this.state.isLoading}
          changeIsLoading={this.changeIsLoading}
          orderType={this.state.orderType}
        />
      </TabPanelBox>
    );
  }

  public handleChooseAddOns = (item: AddOnItem, index: number) => {
    this.setState((prev) => {
      let design_obj = prev.draperyOrderDesign;
      let add_ons_arr = (design_obj && design_obj.addOns) || [];

      const new_array = add_ons_arr.some((i) => i.id === item.id)
        ? add_ons_arr.filter((i) => i.id !== item.id)
        : [...add_ons_arr, { ...item, index }];

      return {
        ...prev,
        draperyOrderDesign: {
          ...design_obj,
          addOns: new_array.sort((a, b) => a.index - b.index),
        },
      };
    });
  };

  @Bind()
  private closeEditContructionsModal(): void {
    this.setState((prev) => {
      return {
        ...prev,
        isEditConstructionDetailsModalOpen: false,
        selectedItemId: null,
      };
    });
    this.props.handleCloseModal();
  }

  @Bind()
  private reloadOnSave(): void {
    this.setState((prev) => {
      return {
        ...prev,
        reloadOnSaveConstructions: true,
        isEditConstructionDetailsModalOpen: false,
        isUpdateRomanShadeCSField: this.state.orderType === 'roman-shade-order' ? true : false,
      };
    });
  }

  @Bind()
  private async reloadGrid(): Promise<void> {
    getAllItems({ isActiveOnly: true })
      .then((res) => {})
      .catch((err) => {
        console.error('Error fetching items:', err);
      });
  }

  @Bind()
  private async openConstructionDetailsEditModal(): Promise<void> {
    if (this.state.orderType === 'roman-shade-order') {
      await getAll().then((res) => {
        const romanShadeItem = res.filter((item) => item.name === 'Roman Shade');
        if (romanShadeItem && romanShadeItem[0]) {
          const item = romanShadeItem[0];

          const romanShadeDefaultSupplier =
            this.state.suppliers && this.state.suppliers.length > 0
              ? this.state.suppliers.find((i) => {
                  if (item && item.supplierId) {
                    return i.id === item.supplierId;
                  }
                  return false;
                })
              : false;

          this.setState((prev: any) => {
            return {
              ...prev,
              supplierName: romanShadeDefaultSupplier
                ? romanShadeDefaultSupplier.displayName
                : prev.supplierName,
              supplierId: item.supplierId,
              isEditConstructionDetailsModalOpen: true,
            };
          });
        }
      });
      return;
    }
    this.setState((prev) => {
      return {
        ...prev,
        isEditConstructionDetailsModalOpen: true,
      };
    });
  }

  public renderSummaryTab(): JSX.Element {
    const {
      activeModal,
      selectedItem,
      categories,
      suppliers,
      selectedItemId,
      // activeItemClassId,
      pricingTabIndex,
      highlightedSection,
      fabricsPatternItems,
      liningsPatternItems,
      // mainFabric,
    } = this.state;
    let index;
    if (
      selectedItem &&
      selectedItem.categoryId === 110 &&
      liningsPatternItems &&
      liningsPatternItems.length > 0
    ) {
      index = liningsPatternItems.findIndex((item) => item.id === selectedItem.id);
    } else if (
      selectedItem &&
      selectedItem.categoryId === 101 &&
      fabricsPatternItems &&
      fabricsPatternItems.length > 0
    ) {
      index = fabricsPatternItems.findIndex((item) => item.id === selectedItem.id);
    }

    let selectedFabricsItem = null;
    let selectedLiningsItem = null;
    if (selectedItem) {
      selectedFabricsItem =
        this.state.fabricsPatternItems && this.state.fabricsPatternItems.length > 0
          ? this.state.fabricsPatternItems.find((i) => i.name === selectedItem.name)
          : null;

      selectedLiningsItem =
        this.state.liningsPatternItems && this.state.liningsPatternItems.length > 0
          ? this.state.liningsPatternItems.find((i) => i.name === selectedItem.name)
          : null;
    }

    return (
      <TabPanelBox>
        {this.state.orderType === 'roman-shade-order' ? (
          <RomanShadeSummaryTab
            handleBundleConfigSettings={this.handleBundleConfigSettings}
            ref={this.romanShadeSummaryRef}
            dispatch={this.props.dispatch}
            accountId={parseFloat(localStorage.getItem('accountId') || '0')}
            draperyOrderId={this.state.draperyOrder.id}
            draperyOrderSummary={this.state.draperyOrderSummary}
            draperyOrderFees={this.state.draperyOrderFees}
            bandings={this.state.bandings}
            cordings={this.state.cordings}
            draperyOrderHeadrail={this.state.draperyOrderHeadrail}
            flanges={this.state.flanges}
            trims={this.state.trims}
            othersEmbellishments={this.state.othersEmbellishments}
            mainFabric={this.state.mainFabric}
            headRail={this.state.headRail}
            hardware={this.state.hardware}
            isLoadingCreateButton={this.state.isLoadingCreateButton}
            embellishmentsList={this.state.embellishmentsList}
            draperyOrderSummaryComponents={this.state.draperyOrderSummaryComponents}
            draperyOrderEditable={this.state.draperyOrder.editable}
            workOrder={this.state.workOrder}
            workOrderStatus={this.state.workOrderPdfStatus}
            handleDuplicate={this.handleDuplicateRomanShadeOrder}
            handleEditWorkOrder={this.handleEditWorkOrder}
            handleDownloadWorkOrderPdf={this.handleDownloadWorkOrderPdf}
            handleAddSummaryComponent={this.handleAddSummaryComponent}
            handleDeleteSummaryComponent={this.handleDeleteSummaryComponent}
            handleInputChangeForNumber={this.handleInputChangeForNumber}
            handleInputChangeForString={this.handleInputChangeForString}
            handleInputChangeForBoolean={this.handleInputChangeForBoolean}
            handleSelectListChange={this.handleSelectListChange}
            highlightedSection={this.state.highlightedSection}
            data={this.state}
            returnDates={this.returnDates}
            handleChangeDates={this.handleChangeDates}
            draperyItemDetail={this.state.draperyItemDetail}
            workOrderPdfContentSummery={this.state.workOrderPdfContentSummery}
            draperyOrderPriceId={this.state.draperyOrderPriceId}
            draperyOrderPriceRefreshKey={this.state.draperyOrderPriceRefreshKey}
            draperyOrder={this.state.draperyOrder}
            updateStateByName={this.updateStateByName}
            editNavigate={this.editNavigate}
            updateWorkOrder={this.updateWorkOrder}
            workOrderEditMode={this.state.workOrderEditMode}
            loadingUpdate={this.state.loadingUpdate}
            isLoading={this.state.isLoading}
            onLoadingChange={this.changeSummaryTabLoading}
            handleCreateOtherItemOrder={this.handleSaveFirst}
            setYardage={this.setYardage}
            yardage={this.state.yardage}
            isConnected={this.props.isConnected}
            handleDraperyOrderFeesChange={this.handleDraperyOrderFeesChange}
            handleDraperyOrderFeesBundleChange={this.handleDraperyOrderFeesBundleChange}
            accountUser={this.props.accountUser}
            canAccessTeamSettings={this.props.canAccessTeamSettings}
          />
        ) : (
          <SummaryTab
            ref={this.summaryRef}
            forceLogOut={this.state.forceLogOut}
            dispatch={this.props.dispatch}
            accountId={parseFloat(localStorage.getItem('accountId') || '0')}
            draperyOrderId={this.state.draperyOrder.id}
            draperyOrderSummary={this.state.draperyOrderSummary}
            draperyOrderFees={this.state.draperyOrderFees}
            bandings={this.state.bandings}
            cordings={this.state.cordings}
            isLoadingCreateButton={this.state.isLoadingCreateButton}
            flanges={this.state.flanges}
            trims={this.state.trims}
            othersEmbellishments={this.state.othersEmbellishments}
            mainFabric={this.state.mainFabric}
            embellishmentsList={this.state.embellishmentsList}
            draperyOrderSummaryComponents={this.state.draperyOrderSummaryComponents}
            draperyOrderEditable={this.state.draperyOrder.editable}
            workOrder={this.state.workOrder}
            workOrderStatus={this.state.workOrderPdfStatus}
            handleDuplicate={this.handleDuplicateDraperyOrder}
            handleCreateWorkOrder={this.handleCreateWorkOrder}
            handleEditWorkOrder={this.handleEditWorkOrder}
            handleDownloadWorkOrderPdf={this.handleDownloadWorkOrderPdf}
            handleAddSummaryComponent={this.handleAddSummaryComponent}
            handleDeleteSummaryComponent={this.handleDeleteSummaryComponent}
            handleInputChangeForNumber={this.handleInputChangeForNumber}
            handleInputChangeForString={this.handleInputChangeForString}
            handleInputChangeForBoolean={this.handleInputChangeForBoolean}
            handleSelectListChange={this.handleSelectListChange}
            highlightedSection={this.state.highlightedSection}
            data={this.state}
            returnDates={this.returnDates}
            handleChangeDates={this.handleChangeDates}
            draperyItemDetail={this.state.draperyItemDetail}
            workOrderPdfContentSummery={this.state.workOrderPdfContentSummery}
            draperyOrderPriceId={this.state.draperyOrderPriceId}
            draperyOrderPriceRefreshKey={this.state.draperyOrderPriceRefreshKey}
            draperyOrder={this.state.draperyOrder}
            updateStateByName={this.updateStateByName}
            editNavigate={this.editNavigate}
            updateWorkOrder={this.updateWorkOrder}
            workOrderEditMode={this.state.workOrderEditMode}
            loadingUpdate={this.state.loadingUpdate}
            isLoading={this.state.isLoading}
            onLoadingChange={this.changeSummaryTabLoading}
            handleCreateOtherItemOrder={this.handleSaveFirst}
            setYardage={this.setYardage}
            yardage={this.state.yardage}
            hardware={this.state.hardware}
            draperyOrderHardware={this.state.draperyOrderHardware}
            isConnected={this.props.isConnected}
            handleBundleConfigSettings={this.handleBundleConfigSettings}
            handleDraperyOrderFeesChange={this.handleDraperyOrderFeesChange}
            handleDraperyOrderFeesBundleChange={this.handleDraperyOrderFeesBundleChange}
            accountUser={this.props.accountUser}
            canAccessTeamSettings={this.props.canAccessTeamSettings}
          />
        )}
        {activeModal === ModalName.StandardItem && selectedItem && (
          <>
            <StandardItemModal
              validateAll={this.validateAll}
              highlightedSection={highlightedSection}
              itemName={selectedItem.name}
              isModalOpen={true}
              onModalClose={this.closeModal}
              categories={categories}
              suppliers={suppliers}
              clearHighlightSection={this.clearHighlightSection}
              highLightSection={this.highlightSection}
              client={this.state.client}
              // selectedItem={selectedItem}
              itemId={selectedItemId}
              activeItemClassId={3}
              tabIndex={pricingTabIndex}
              // Commented out because it causes the bug task 1483
              // mainFabric={this.state.mainFabric}
              updateStateByName={this.updateStateByName}
              indexOfMainFabric={index}
              categoryId={selectedItem.categoryId}
              draperyOrderFabricsErrors={this.state.draperyOrderFabricsErrors}
              updateFabricsTab={
                selectedFabricsItem
                  ? this.updateFabrics
                  : selectedLiningsItem
                    ? this.updateLinings
                    : undefined
              }
              reloadGrid={this.handlePatternSelectAfterAdd}
              fromCalculator={true}
              resetSupplier={this.resetSupplier}
              openModalClick={this.openSupplierModalaOnWo}
              supplierName={this.state.supplierName}
              supplierId={this.state.supplierId}
              wideSheetFocusField={this.state.wideSheetFocusField}
              useWideSheet={true}
              isSupplierModalOpen={this.state.isModalOpenWo}
            />
            <SupplierModal
              accountId={this.props.accountId}
              isModalOpen={this.state.isModalOpenWo}
              onModalClose={this.closeSupplierModal}
              onSave={this.handleSupplierChanged}
              resetOnClose
              setFocusFirstField={(fn) => (this.setFocusFirstFieldOnSupplierModal = fn)}
            />
          </>
        )}
        {activeModal === ModalName.DraperyItem && selectedItem && (
          <DraperyItemModal
            reloadGrid={this.handlePatternSelectAfterAdd}
            validateAll={this.validateAll}
            isModalOpen={true}
            onModalClose={this.closeModal}
            fetchAll={this.fetchAll}
            categories={categories}
            suppliers={suppliers}
            itemId={selectedItem.id}
            updateStateByName={this.updateStateByName}
          />
        )}
        {activeModal === ModalName.RomanShadeItem && selectedItem && (
          <>
            <RomanShadeModal
              isModalOpen={true}
              fetchAll={this.fetchAll}
              onModalClose={this.closeModal}
              categories={categories}
              activeItemClassId={5}
              suppliers={suppliers}
              itemId={selectedItem.id}
              reloadGrid={this.handlePatternSelectAfterAdd}
              isPleatModalOpen={false}
              updateStateByName={this.updateStateByName}
              openModalClick={this.openSupplierModalaOnWo}
              supplierName={this.state.supplierName}
              supplierId={this.state.supplierId}
            />
            <SupplierModal
              accountId={this.props.accountId}
              isModalOpen={this.state.isModalOpenWo}
              onModalClose={this.closeSupplierModal}
              onSave={this.handleSupplierChanged}
              resetOnClose
              setFocusFirstField={(fn) => (this.setFocusFirstFieldOnSupplierModal = fn)}
            />
          </>
        )}
      </TabPanelBox>
    );
  }

  @Bind()
  private closeModal() {
    this.setState({
      activeModal: null,
      activeItemClassId: null,
      highlightedSection: '',
      wideSheetFocusField: null,
      selectedItemId: null,
    });
  }
  @Bind()
  private async onClientEdited(client: ClientModule.Client) {
    this.setState({
      client,
    });

    await this.loadClients();
    this.validateAll('update');
  }
  private async loadClients(): Promise<void> {
    const { accountId } = this.props;
    const { includeInactive } = this.state;

    const res = await getAllClients({
      accountId,
      sort: { column: 'displayName', value: this.state.sort.toUpperCase() },
      includeInactive,
    });

    if (!res.error) {
      const convertToSortTableRowInfo = (client: ClientModule.BasicClientInfo) => {
        const rowInfo: SortTableRowInfo = client;
        if (client.subClients) {
          rowInfo.subList = client.subClients.map(convertToSortTableRowInfo);
        }
        return rowInfo;
      };

      this.setState({
        clients: res.map(convertToSortTableRowInfo),
      });
    }
  }
  @Bind()
  private closeEditClientModal() {
    this.setState({
      isEditClientModalOpen: false,
    });
  }

  @Bind()
  private async getCategories(): Promise<Category[]> {
    const catRes = await getAllCategories({ isActiveOnly: true });
    this.setState({ categories: catRes });
    return catRes;
  }

  private async getSuppliers(): Promise<Supplier[] | undefined> {
    const res: any = await getAllSuppliers();
    this.setState({ suppliers: res });

    if (!res.error) {
      return res;
    }
  }

  @Bind()
  private async fetchAll() {
    await this.getCategories();
    await this.getSuppliers();
  }

  @Bind()
  private validateClientBillingTypeTab(): boolean {
    let myShopClientBillingErrors: ValidationErrorInfo[] = [];
    let billingType: string | undefined;

    if (this.state.client && this.state.client.billToParent === true) {
      if (this.state.client.billingDetails) {
        billingType = this.state.client.billingDetails.billingType;
      }
    } else {
      if (this.state.client && this.state.client.billingDetailsDirectly) {
        billingType = this.state.client.billingDetailsDirectly.billingType;
      }
    }

    if (this.state.client) {
      myShopClientBillingErrors = validateClientBillingType(0, billingType);
    }

    if (myShopClientBillingErrors.length > 0) {
      this.setState((state) => ({
        ...state,
        myShopClientBillingErrors,
      }));
      return false;
    } else {
      this.setState((state) => ({
        ...state,
        myShopClientBillingErrors,
      }));
      return true;
    }
  }

  @Bind()
  private validateMyShopItemPricingTab(): boolean {
    let myShopItemPricingErrors: ValidationErrorInfo[] = [];
    const { fabricsPatternItems, mainFabric, liningsPatternItems } = this.state;
    const liningsList = this.state.liningsList;
    const trimsList = this.state.trims;
    const flangeList = this.state.flanges;
    const bandingList = this.state.bandings;
    const cordingList = this.state.cordings;
    const otherList = this.state.othersEmbellishments;
    let selectedPatternLinings: FabricPatternItem[] = [];
    let selectedPatternFabrics: FabricPatternItem[] = [];
    let selectedPatternTrims: FabricPatternItem[] = [];
    let selectedPatternFlanges: FabricPatternItem[] = [];
    let selectedPatternBandings: FabricPatternItem[] = [];
    let selectedPatternCordings: FabricPatternItem[] = [];
    let selectedPatternOthersEmbellishments: FabricPatternItem[] = [];

    if (fabricsPatternItems && fabricsPatternItems.length > 0) {
      selectedPatternFabrics = fabricsPatternItems.filter(
        (item) =>
          item.id === mainFabric.patternId ||
          item.id === Number(mainFabric.itemId) ||
          item.name === mainFabric.pattern
      );
    }
    if (liningsPatternItems && liningsPatternItems.length > 0) {
      liningsList.map((list, index) => {
        const selectedLiningPattern = liningsPatternItems.find((item) => {
          if (
            list.draperyOrderLiningsFabric &&
            (item.id === list.draperyOrderLiningsFabric.patternId ||
              item.id === Number(list.draperyOrderLiningsFabric.itemId) ||
              item.name === list.draperyOrderLiningsFabric.pattern)
          ) {
            return true;
          }
          return false;
        });
        if (selectedLiningPattern) {
          selectedPatternLinings.push(selectedLiningPattern);
        }
      });
    }
    if (fabricsPatternItems && fabricsPatternItems.length > 0) {
      trimsList.map((list) => {
        const selectedTrimPattern = fabricsPatternItems.find((item) => {
          if (
            list.draperyOrderFabric &&
            (item.id === list.draperyOrderFabric.patternId ||
              item.id === Number(list.draperyOrderFabric.itemId) ||
              item.name === list.draperyOrderFabric.pattern)
          ) {
            return true;
          }
          return false;
        });
        if (selectedTrimPattern) {
          selectedPatternTrims.push(selectedTrimPattern);
        }
      });

      flangeList.map((list) => {
        const selectedFlangePattern = fabricsPatternItems.find((item) => {
          if (
            list.draperyOrderFabric &&
            (item.id === list.draperyOrderFabric.patternId ||
              item.id === Number(list.draperyOrderFabric.itemId) ||
              item.name === list.draperyOrderFabric.pattern)
          ) {
            return true;
          }
          return false;
        });
        if (selectedFlangePattern) {
          selectedPatternFlanges.push(selectedFlangePattern);
        }
      });

      bandingList.map((list) => {
        const selectedBandingPattern = fabricsPatternItems.find((item) => {
          if (
            list.draperyOrderFabric &&
            (item.id === list.draperyOrderFabric.patternId ||
              item.id === Number(list.draperyOrderFabric.itemId) ||
              item.name === list.draperyOrderFabric.pattern)
          ) {
            return true;
          }
          return false;
        });
        if (selectedBandingPattern) {
          selectedPatternBandings.push(selectedBandingPattern);
        }
      });

      cordingList.map((list) => {
        const selectedCordingPattern = fabricsPatternItems.find((item) => {
          if (
            list.draperyOrderFabric &&
            (item.id === list.draperyOrderFabric.patternId ||
              item.id === Number(list.draperyOrderFabric.itemId) ||
              item.name === list.draperyOrderFabric.pattern)
          ) {
            return true;
          }
          return false;
        });
        if (selectedCordingPattern) {
          selectedPatternCordings.push(selectedCordingPattern);
        }
      });

      otherList.map((list) => {
        const selectedOtherPattern = fabricsPatternItems.find((item) => {
          if (
            list.draperyOrderFabric &&
            (item.id === list.draperyOrderFabric.patternId ||
              item.id === Number(list.draperyOrderFabric.itemId))
          ) {
            return true;
          }
          return false;
        });
        if (selectedOtherPattern) {
          selectedPatternOthersEmbellishments.push(selectedOtherPattern);
        }
      });
    }

    for (let i = 0; i < selectedPatternLinings.length; i++) {
      if (selectedPatternLinings[i] && this.state.client) {
        const liningsListItem = liningsList.find((list) => {
          if (
            list.draperyOrderLiningsFabric &&
            (list.draperyOrderLiningsFabric.patternId === selectedPatternLinings[i].id ||
              Number(list.draperyOrderLiningsFabric.itemId) === selectedPatternLinings[i].id ||
              list.draperyOrderLiningsFabric.pattern === selectedPatternLinings[i].name)
          ) {
            return true;
          }
          return false;
        });
        if (
          liningsListItem &&
          liningsListItem.draperyOrderLiningsFabric &&
          liningsListItem.draperyOrderLiningsFabric.orderOrigin === 1
        ) {
          myShopItemPricingErrors = myShopItemPricingErrors.concat(
            validateMyShopItemPricing(
              1,
              selectedPatternLinings[i],
              this.state.client,
              this.state.orderType,
              `liningsList.${i}.draperyOrderLiningsFabric.pattern`
            )
          );
        }
      }
    }

    for (let i = 0; i < selectedPatternFabrics.length; i++) {
      if (selectedPatternFabrics[i] && this.state.client && mainFabric.orderOrigin === 1) {
        myShopItemPricingErrors = myShopItemPricingErrors.concat(
          validateMyShopItemPricing(
            1,
            selectedPatternFabrics[i],
            this.state.client,
            this.state.orderType,
            'mainFabric.pattern'
          )
        );
      }
    }

    for (let i = 0; i < selectedPatternTrims.length; i++) {
      if (selectedPatternTrims[i] && this.state.client) {
        const trimListItem = trimsList.find((list) => {
          if (
            list.draperyOrderFabric &&
            (list.draperyOrderFabric.patternId === selectedPatternTrims[i].id ||
              Number(list.draperyOrderFabric.itemId) === selectedPatternTrims[i].id ||
              list.draperyOrderFabric.pattern === selectedPatternTrims[i].name)
          ) {
            return true;
          }
          return false;
        });
        if (
          trimListItem &&
          trimListItem.draperyOrderFabric &&
          trimListItem.draperyOrderFabric.orderOrigin === 1
        ) {
          myShopItemPricingErrors = myShopItemPricingErrors.concat(
            validateMyShopItemPricing(
              1,
              selectedPatternTrims[i],
              this.state.client,
              this.state.orderType,
              `trims.${i}.draperyOrderFabric.pattern`
            )
          );
        }
      }
    }

    for (let i = 0; i < selectedPatternFlanges.length; i++) {
      if (selectedPatternFlanges[i] && this.state.client) {
        const flangeListItem = flangeList.find((list) => {
          if (
            list.draperyOrderFabric &&
            (list.draperyOrderFabric.patternId === selectedPatternFlanges[i].id ||
              Number(list.draperyOrderFabric.itemId) === selectedPatternFlanges[i].id ||
              list.draperyOrderFabric.pattern === selectedPatternFlanges[i].name)
          ) {
            return true;
          }
          return false;
        });
        if (
          flangeListItem &&
          flangeListItem.draperyOrderFabric &&
          flangeListItem.draperyOrderFabric.orderOrigin === 1
        ) {
          myShopItemPricingErrors = myShopItemPricingErrors.concat(
            validateMyShopItemPricing(
              1,
              selectedPatternFlanges[i],
              this.state.client,
              this.state.orderType,
              `flanges.${i}.draperyOrderFabric.pattern`
            )
          );
        }
      }
    }

    for (let i = 0; i < selectedPatternBandings.length; i++) {
      if (selectedPatternBandings[i] && this.state.client) {
        const bandingListItem = bandingList.find((list) => {
          if (
            list.draperyOrderFabric &&
            (list.draperyOrderFabric.patternId === selectedPatternBandings[i].id ||
              Number(list.draperyOrderFabric.itemId) === selectedPatternBandings[i].id ||
              list.draperyOrderFabric.pattern === selectedPatternBandings[i].name)
          ) {
            return true;
          }
          return false;
        });
        if (
          bandingListItem &&
          bandingListItem.draperyOrderFabric &&
          bandingListItem.draperyOrderFabric.orderOrigin === 1
        ) {
          myShopItemPricingErrors = myShopItemPricingErrors.concat(
            validateMyShopItemPricing(
              1,
              selectedPatternBandings[i],
              this.state.client,
              this.state.orderType,
              `bandings.${i}.draperyOrderFabric.pattern`
            )
          );
        }
      }
    }
    for (let i = 0; i < selectedPatternCordings.length; i++) {
      if (selectedPatternCordings[i] && this.state.client) {
        const cordingListItem = cordingList.find((list) => {
          if (
            list.draperyOrderFabric &&
            (list.draperyOrderFabric.patternId === selectedPatternCordings[i].id ||
              Number(list.draperyOrderFabric.itemId) === selectedPatternCordings[i].id ||
              list.draperyOrderFabric.pattern === selectedPatternCordings[i].name)
          ) {
            return true;
          }
          return false;
        });
        if (
          cordingListItem &&
          cordingListItem.draperyOrderFabric &&
          cordingListItem.draperyOrderFabric.orderOrigin === 1
        ) {
          myShopItemPricingErrors = myShopItemPricingErrors.concat(
            validateMyShopItemPricing(
              1,
              selectedPatternCordings[i],
              this.state.client,
              this.state.orderType,
              `cordings.${i}.draperyOrderFabric.pattern`
            )
          );
        }
      }
    }

    for (let i = 0; i < selectedPatternOthersEmbellishments.length; i++) {
      if (selectedPatternOthersEmbellishments[i] && this.state.client) {
        const otherListItem = otherList.find((list) => {
          if (
            list.draperyOrderFabric &&
            (list.draperyOrderFabric.patternId === selectedPatternOthersEmbellishments[i].id ||
              Number(list.draperyOrderFabric.itemId) === selectedPatternOthersEmbellishments[i].id)
          ) {
            return true;
          }
          return false;
        });
        if (
          otherListItem &&
          otherListItem.draperyOrderFabric &&
          otherListItem.draperyOrderFabric.orderOrigin === 1
        ) {
          myShopItemPricingErrors = myShopItemPricingErrors.concat(
            validateMyShopItemPricing(
              1,
              selectedPatternOthersEmbellishments[i],
              this.state.client,
              this.state.orderType,
              `othersEmbellishments.${i}.draperyOrderFabric.pattern`
            )
          );
        }
      }
    }

    const uniquemyShopItemPricingErrors = myShopItemPricingErrors.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          (t) =>
            JSON.stringify(t.name) === JSON.stringify(item.name) &&
            t.itemClassId === item.itemClassId &&
            t.itemId === item.itemId
        )
    );

    this.setState((state) => ({
      ...state,
      myShopItemPricingErrors: uniquemyShopItemPricingErrors,
    }));
    return !myShopItemPricingErrors.length;
  }
  private handleSaveAll = async (confirmed?: boolean): Promise<boolean> => {
    if (localStorage.getItem('duplicate')) localStorage.removeItem('duplicate');
    if (!this.validateAll('save')) {
      this.setState((state) => ({ ...state, clientAndRoomHighlight: true }));
      this.toggleErrorMessage();
      return false;
    }
    this.setState((state) => ({ ...state, isLoading: true }));

    if (!(await this.saveAll(undefined, confirmed, 'save'))) {
      this.setState((state) => ({ ...state, isLoading: false }));
      return false;
    }
    this.setState((state) => ({ ...state, isLoading: false }));
    return true;
  };

  private handleUnexpectedSaveError = (error: any): void => {
    console.error('Unexpected save error:', error);
    const message = error?.response?.data?.message || error?.message || 'Internal server error';

    this.setState((state) => ({
      ...state,
      draperyOrderErrors: [{ tabIndex: -1, name: '', message }],
    }));
  };

  private addNewRoom = () => {
    this.setState({ isAddRoomModalOpen: true });
  };

  private handleSaveAndNext = async (): Promise<boolean> => {
    if (this.state.draperyOrder.id === 0) {
      const can_create_order = await userCanCreateNewOrder(this.props.accountId);
      if (
        !can_create_order &&
        this.state.remainingItemOrder === 0 &&
        this.state.orderType !== 'custom-order'
      ) {
        this.props.handleOpenSubscriptionPlanModal();
        return true;
      }
    }
    if (!this.state.client || !this.state) {
      this.setState((state) => ({ ...state, clientAndRoomHighlight: true }));
      this.toggleErrorMessage();
      return false;
    }

    if (!(await this.handleSaveAll())) {
      return false;
    }
    // const currentTabIndex = this.state.tabIndex;
    let obj: Record<string, number | boolean> = {
      tabIndex: 1,
    };

    let callbackFunc = undefined;

    if (this.state.draperyOrder.clientId) {
      // Track lastViewedAt for project
      await handleUpdateLastViewedProject(this.state.draperyOrder.clientId);
    }
    this.props.history.push('/clients/' + this.state.draperyOrder.clientId);
    this.props.handleNotSavedOrder(false);
    this.setState(
      (state) => ({
        ...state,
        ...obj,
      }),
      callbackFunc
    );
    return true;
  };

  @Bind()
  private handleNavigateTab(direction: any): void {
    const direction_case =
      direction === 'back' ? this.state.tabIndex !== 0 : this.state.tabIndex !== 5;

    if (direction_case) {
      this.setState((prev) => {
        const direction_move = direction === 'back' ? prev.tabIndex - 1 : prev.tabIndex + 1;
        return {
          ...prev,
          tabIndex: direction_move,
        };
      });
    }
  }

  private openWarningModal = () => {
    this.setState({
      isWarningModalOpen: true,
    });
  };

  @Bind()
  private editNavigate(tab: number): void {
    trackView(MixpanelEvents.UPDATE_ORDER, {
      orderId: this.state.draperyOrder.id,
      orderType: this.state.orderType,
      element: 'order_form',
    });

    this.setState({
      tabIndex: tab,
      workOrderEditMode: true,
    });
  }

  private updateWorkOrder = async (val: string): Promise<void> => {
    const newDraperyOrderFabricsKeys = [
      'bandings',
      'cordings',
      'flanges',
      'trims',
      'mainFabric',
      'liningsList',
      'othersEmbellishments',
    ];
    this.setState((state) => ({
      ...state,
      loadingUpdate: true,
      isLoading: true,
    }));
    // if (!(await this.saveAll(val))) {
    //     this.setState({
    //         loadingUpdate: false,
    //     })
    //     return
    // }
    setTimeout(async () => {
      let oldRomanShadeCalc = !this.state.draperyOrder.newRomanShade;

      this.setState({ isWorkOrderValidation: true }, async () => {
        if (!this.validateAll('workOrder')) {
          this.toggleErrorMessage();
          this.setState({
            loadingUpdate: false,
            isLoading: false,
          });
          return;
        }
        this.addDraperyOrderNewFabrics(newDraperyOrderFabricsKeys);
        this.setState((state) => ({
          ...state,
          tabIndex: 5,
          isRecommendationsOverridesModalOpen: this.state.orderType !== 'roman-shade-order',
          isRecommendationsOverridesModalRomanShadeOpen:
            this.state.orderType === 'roman-shade-order' && !oldRomanShadeCalc,
          isLoading: false,
        }));
      });

      if (this.state.orderType === 'roman-shade-order' && oldRomanShadeCalc) {
        const panelJson = {
          pannel1Width: undefined,
          pannel2Width: undefined,
          pannel3Width: undefined,
          pannel4Width: undefined,
          pannel5Width: undefined,
        };

        await this.handleConfirmRecommendationOverride(panelJson, this.state.workRoomSettings, []);

        this.setState((state) => ({
          workOrderEditMode: false,
        }));
      }
    }, 500);
    this.setState({ isChanged: false });
  };

  @Bind()
  private async saveAll(val?: string, confirmed?: boolean, mode?: string): Promise<boolean> {
    const saveStopwatch = startStopwatch();
    const phaseCtx = {
      order_type: this.state.orderType,
      order_id: this.state.draperyOrder.id || undefined,
      order_size_bucket: this.computeOrderSizeBucket(),
    };
    const measure = async <T,>(phase: string, op: () => Promise<T>): Promise<T> => {
      const sw = startStopwatch();
      try {
        return await op();
      } finally {
        logSavePhase({ phase, duration_ms: sw.end(), ...phaseCtx });
      }
    };
    let succeeded = false;
    try {
      // const { tabIndex } = this.state;
      if (!(await measure('design_tab', () => this.saveDraperyOrderDesignTab()))) {
        return false;
      }
      let draperyOrderId = await measure('order_api_1', () => this.saveDraperyOrderApi());
      if (!draperyOrderId) {
        return false;
      }

      const parallelSave = checkGate('perf_calc_parallel_save');

      // FE-4 section dirty tracking: when on, compare each of the 4 parallel
      // sub-saves' relevant state slices against the snapshot captured at
      // load/last-save. If unchanged, skip that sub-save. Falls back to "all
      // dirty" when there's no snapshot yet or the gate is off.
      const sectionDirty = checkGate('perf_calc_section_dirty');
      const currentSlices = sectionDirty ? this.captureCurrentSectionSlices() : null;
      const snapshot = this.lastSavedSnapshot;
      const isDirty = (section: 'fabrics' | 'hardware' | 'upload' | 'summary'): boolean => {
        if (section === "summary" && this.hasPendingSummaryComponentCreates()) {
          return true;
        }
        if (!sectionDirty || !currentSlices || !snapshot) {
          return true;
        }
        return !_.isEqual(currentSlices[section], snapshot[section]);
      };
      const runOrSkip = async <T,>(
        section: 'fabrics' | 'hardware' | 'upload' | 'summary',
        phase: string,
        op: () => Promise<T>
      ): Promise<boolean | T> => {
        if (!isDirty(section)) {
          logSavePhase({ phase: `${phase}_skipped`, duration_ms: 0, ...phaseCtx });
          return true;
        }
        return measure(phase, op);
      };

      if (parallelSave) {
        const fabricsSaved = await runOrSkip('fabrics', 'fabrics_tab', () =>
          this.saveDraperyOrderFabricsTab(draperyOrderId as number, mode)
        );
        if (!fabricsSaved) {
          return false;
        }

        const results = await Promise.all([
          runOrSkip('hardware', 'hardware_tab', () => this.saveHardwareTab()),
          runOrSkip('upload', 'upload_tab', () => this.saveUploadTab()),
          runOrSkip('summary', 'summary_tab', () => this.saveSummaryTab()),
        ]);
        if (results.some((ok) => !ok)) {
          return false;
        }
      } else {
        if (
          !(await runOrSkip('fabrics', 'fabrics_tab', () =>
            this.saveDraperyOrderFabricsTab(draperyOrderId as number, mode)
          ))
        ) {
          return false;
        }
        if (!(await runOrSkip('hardware', 'hardware_tab', () => this.saveHardwareTab()))) {
          return false;
        }
        if (!(await runOrSkip('upload', 'upload_tab', () => this.saveUploadTab()))) {
          return false;
        }
        if (!(await runOrSkip('summary', 'summary_tab', () => this.saveSummaryTab()))) {
          return false;
        }
      }

      draperyOrderId = await measure('order_api_2', () => this.saveDraperyOrderApi());
      if (!draperyOrderId) {
        return false;
      }
      const isRomanShadeOrder = this.state.orderType === 'roman-shade-order';
      const { dispatch } = this.props;
      if (!val && !isRomanShadeOrder) {
        const notification: NotificationsModule.Notification = {
          id: 0,
          message: 'Success!',
          subMessage: 'Your progress has been saved',
          type: 'info',
        };
        dispatch(NotificationsModule.addNotification(notification));
      }

      this.setChanges(false);
      // FE-4a: drop the cached bundle so the next open re-fetches the canonical
      // server state, including any backend-side computed fields the save just
      // updated.
      if (this.state.draperyOrder.id) {
        invalidateOrderCache(this.state.draperyOrder.id);
      }
      // Also drop any cached project-list entries for this client, since a save
      // could change a project's price/status/etc. that the project list shows.
      if (this.state.draperyOrder.clientId) {
        invalidateClientProjectLists(this.state.draperyOrder.clientId);
      }
      // FE-4 section dirty tracking: refresh the saved snapshot so subsequent
      // saves can correctly identify which sections changed since this one.
      this.captureSavedSnapshot();
      succeeded = true;
      return true;
    } catch (error) {
      this.handleUnexpectedSaveError(error);
      return false;
    } finally {
      logSavePhase({
        phase: succeeded ? 'total' : 'total_failed',
        duration_ms: saveStopwatch.end(),
        ...phaseCtx,
      });
    }
  }

  @Bind()
  private async saveDraperyOrderDesignTab(): Promise<boolean> {
    const phaseCtx = {
      order_type: this.state.orderType,
      order_id: this.state.draperyOrder.id || undefined,
    };
    const measure = async <T,>(phase: string, op: () => Promise<T>): Promise<T> => {
      const sw = startStopwatch();
      try {
        return await op();
      } finally {
        logSavePhase({ phase, duration_ms: sw.end(), ...phaseCtx });
      }
    };
    if (!(await measure('design.drawing', () => this.saveDraperyOrderDrawing()))) {
      return false;
    }
    const draperyOrderDesignId = await measure('design.design_api', () =>
      this.saveDraperyOrderDesignApi()
    );
    if (!draperyOrderDesignId) {
      return false;
    }

    // linings_list, embellishment_list, and delete_embellishment_list all only
    // depend on draperyOrderDesignId — no inter-dependency. Run them concurrently
    // when the parallel-save flag is on.
    if (checkGate('perf_calc_parallel_save')) {
      const results = await Promise.all([
        measure('design.linings_list', () => this.saveLiningsList(draperyOrderDesignId as any)),
        measure('design.embellishment_list', () =>
          this.saveEmbellishmentList(draperyOrderDesignId)
        ),
        measure('design.delete_embellishment_list', () => this.deleteEmbellishmentList()),
      ]);
      if (results.some((ok) => !ok)) {
        return false;
      }
    } else {
      if (
        !(await measure('design.linings_list', () =>
          this.saveLiningsList(draperyOrderDesignId as any)
        ))
      ) {
        return false;
      }
      if (
        !(await measure('design.embellishment_list', () =>
          this.saveEmbellishmentList(draperyOrderDesignId)
        ))
      ) {
        return false;
      }
      if (
        !(await measure('design.delete_embellishment_list', () => this.deleteEmbellishmentList()))
      ) {
        return false;
      }
    }
    return true;
  }

  @Bind()
  private async saveHardwareTab(): Promise<boolean> {
    if (!(await this.saveHardwareTabApi())) {
      return false;
    }

    return true;
  }

  @Bind()
  private async saveHardwareTabApi(): Promise<boolean> {
    if (!this.validateHardwareTab()) {
      return false;
    }

    const { accountId } = this.props;
    const { draperyOrderHardware, draperyOrderHeadrail, draperyOrder } = this.state;
    const isHeadrail = this.state.orderType === 'roman-shade-order';

    if (isHeadrail) {
      const normalizedHeadrailSih = this.normalizeShippingRowDecimals(
        draperyOrderHeadrail.headrailSih,
        'customerFacingPrice'
      );
      const normalizedHeadrailMarkup = this.normalizeMarkupValue(draperyOrderHeadrail.markup);
      const headrailPayload = {
        ...draperyOrderHeadrail,
        markup: normalizedHeadrailMarkup,
        headrailSih: normalizedHeadrailSih,
        supplierId:
          draperyOrderHeadrail.supplierId && draperyOrderHeadrail.supplierId !== 0
            ? draperyOrderHeadrail.supplierId
            : null,
      };

      if (draperyOrder.draperyOrderHeadrailId) {
        const res = await editDraperyOrderHeadrail(headrailPayload);

        this.processResponseErrors(res, 3, 'draperyOrderHardwareErrors');
        if (res.error) {
          return false;
        }
        return true;
      }

      const res = await addDraperyOrderHeadrail({
        ...headrailPayload,
        accountId,
      });

      this.processResponseErrors(res, 3, 'draperyOrderHardwareErrors');
      if (res.error) {
        return false;
      }

      this.updateStateByName(`draperyOrder.draperyOrderHeadrailId`, res.id, true);
      this.updateStateByName(`draperyOrderHeadrail.id`, res.id, true);

      return true;
    }

    const normalizedHardwareSih = this.normalizeShippingRowDecimals(
      (draperyOrderHardware as any).hardwareSih,
      'customerPrice'
    );
    const normalizedHardwareMarkup = this.normalizeMarkupValue(draperyOrderHardware.hardwareMarkup);
    const hardwarePayload = {
      ...draperyOrderHardware,
      hardwareMarkup: normalizedHardwareMarkup,
      hardwareSih: normalizedHardwareSih,
      supplierId:
        draperyOrderHardware.supplierId && draperyOrderHardware.supplierId !== 0
          ? draperyOrderHardware.supplierId
          : null,
    };

    if (draperyOrder.draperyOrderHardwareId) {
      const res = await editDraperyOrderHardware(hardwarePayload);

      this.processResponseErrors(res, 3, 'draperyOrderHardwareErrors');
      if (res.error) {
        return false;
      }
      return true;
    }

    const res = await addDraperyOrderHardware({
      ...hardwarePayload,
      accountId,
    });

    this.processResponseErrors(res, 3, 'draperyOrderHardwareErrors');
    if (res.error) {
      return false;
    }

    this.updateStateByName(`draperyOrder.draperyOrderHardwareId`, res.id, true);
    this.updateStateByName(`draperyOrderHardware.id`, res.id, true);

    return true;
  }

  @Bind()
  private async saveUploadTab(): Promise<boolean> {
    if (!(await this.saveUploadTabApi())) {
      return false;
    }

    return true;
  }

  @Bind()
  private async saveUploadTabApi(): Promise<boolean> {
    const { accountId } = this.props;
    const { draperyOrderUploads, draperyOrder } = this.state;

    const formData = new FormData();
    const files = Array.isArray(draperyOrderUploads.items) ? draperyOrderUploads.items : [];
    const useDirectUpload = Config.fileStoreUrl.includes('localhost');
    const remoteUploadsPayload: Array<{
      source: string;
      description: string;
      type: string;
      remoteKey?: string;
    }> = [];

    for (const f of files) {
      const hasRemoteUpload =
        (f.remoteUploaded && (f.remoteSource || f.remoteKey)) || (!!f.remoteSource && f.isPdf);

      if (hasRemoteUpload) {
        const remoteSource =
          (typeof f.remoteSource === 'string' && f.remoteSource.length > 0
            ? f.remoteSource
            : typeof f.remoteKey === 'string'
              ? `/${f.remoteKey}`
              : '') || '';

        if (remoteSource) {
          remoteUploadsPayload.push({
            source: remoteSource,
            description: f.description || '',
            type: f.fileType || f.mimeType || f.type || 'application/pdf',
            remoteKey: f.remoteKey,
          });
        }
        continue;
      }

      if (!f.blobToSend) {
        continue;
      }

      if (useDirectUpload) {
        const croppedFile = new File([f.blobToSend], f.name, {
          type: f.type,
          lastModified: Date.now(),
        });
        formData.append(`files`, croppedFile);
        formData.append(`descriptions`, f.description);
        continue;
      }

      const normalizedFileType = (f.fileType || f.mimeType || f.type || '')
        .toString()
        .toLowerCase();
      const uploadType = normalizedFileType.includes('pdf') ? 'pdf' : 'image';
      const remoteInfo = await uploadFileWithPresign({
        accountId,
        contentType: f.type || f.mimeType || undefined,
        file: f.blobToSend,
        fileName: f.name || `upload.${uploadType === 'pdf' ? 'pdf' : 'png'}`,
        uploadType,
      });

      remoteUploadsPayload.push({
        source: remoteInfo.remoteSource,
        description: f.description || '',
        type: remoteInfo.normalizedType,
        remoteKey: remoteInfo.remoteKey,
      });
    }

    if (remoteUploadsPayload.length > 0) {
      formData.append('remoteUploads', JSON.stringify(remoteUploadsPayload));
    }
    formData.append('accountId', accountId.toString());
    formData.append('fileStoreUrl', Config.fileStoreUrl);
    formData.append('preserveFileName', 'true');

    if (draperyOrder.draperyOrderUploadId) {
      formData.append('id', draperyOrderUploads.id.toString());
      const res = await editDraperyOrderUpload(formData);

      this.processResponseErrors(res, 4, 'draperyOrderUploadErrors');
      if (res.error) {
        return false;
      }
      this.setState((prev) => ({
        ...prev,
        draperyOrderUploads: {
          ...prev.draperyOrderUploads,
          items: mapStoredUploadsToRemoteItems(res.items),
        },
      }));
      return true;
    }

    const res = await addDraperyOrderUpload(formData);

    this.processResponseErrors(res, 4, 'draperyOrderUploadErrors');
    if (res.error) {
      return false;
    }

    this.updateStateByName(`draperyOrder.draperyOrderUploadId`, res.id, true);
    this.updateStateByName(`draperyOrderUploads.id`, res.id, true);
    this.setState((prev) => ({
      ...prev,
      draperyOrderUploads: {
        ...prev.draperyOrderUploads,
        id: res.id,
        items: mapStoredUploadsToRemoteItems(res.items),
      },
    }));

    return true;
  }

  private setYardage = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    const nameList = name.split('.');

    if (nameList.length === 1) {
      let processedValue = value.replace(/^0+(?=\d)/, '');
      if (processedValue === '') {
        processedValue = '';
      }
      const regex = /^\d{0,5}(\.\d{0,2})?$/;
      if (regex.test(processedValue)) {
        this.setState((state) => ({
          ...state,
          yardage: {
            ...state.yardage,
            [nameList[0]]: processedValue,
          },
        }));
      }
    } else if (nameList.length === 2) {
      const index = +nameList[1];
      const fabricName = [...this.state.yardage[nameList[0]]];
      let processedValue = value.replace(/^0+(?=\d)/, '');
      if (processedValue === '') {
        processedValue = '';
      }
      const regex = /^\d{0,5}(\.\d{0,2})?$/;
      if (regex.test(processedValue)) {
        fabricName[index] = processedValue;
        this.setState((state) => ({
          ...state,
          yardage: {
            ...state.yardage,
            [nameList[0]]: fabricName,
          },
        }));
      }
    }
  };

  @Bind()
  private async saveDraperyOrderFabricsTab(draperyOrderId: any, mode?: string): Promise<boolean> {
    const {
      mainFabric,
      embellishmentsList,
      liningsList,
      isNoneEmbellishment,
      draperyOrderDesign,
      headRail,
    } = this.state;
    let yardage: any;

    yardage = this.state.yardage;

    if (this.state.orderType !== 'drapery-order') {
      if (this.state.orderType === 'roman-shade-order') {
        mainFabric.yardsNeeded = yardage.mainFabricYardage || mainFabric.yardsNeeded || null;
      } else {
        mainFabric.yardsNeeded = this.state.yardage.mainFabricYardage || null;
      }
    }

    if (
      !(await this.saveDraperyOrderFabricApi({
        name: `mainFabric`,
        fabric: mainFabric,
        draperyOrderDesignEmbellishmentId: undefined,
        draperyOrderDesignLiningId: undefined,
        mode,
        draperyOrderId,
      }))
    ) {
      return false;
    }
    if (this.state.orderType === 'roman-shade-order') {
      if (
        !(await this.saveDraperyOrderFabricApi({
          name: `headRail`,
          fabric: headRail,
          draperyOrderDesignEmbellishmentId: undefined,
          draperyOrderDesignLiningId: undefined,
          mode,
          draperyOrderId,
        }))
      ) {
        return false;
      }
    }
    const arr = [
      ...this.state.trims,
      ...this.state.bandings,
      ...this.state.flanges,
      ...this.state.cordings,
      ...this.state.othersEmbellishments,
    ];
    if (isNoneEmbellishment) {
      arr.forEach((item) => {
        if (item.id > 0) {
          this.deleteDraperyOrderFabricApi(item!.id);
          this.setState({
            bandings: [defaultEmbellishment('bandings')!],
            cordings: [defaultEmbellishment('cordings')!],
            flanges: [defaultEmbellishment('flanges')!],
            trims: [defaultEmbellishment('trims')!],
            othersEmbellishments: [defaultEmbellishment('othersEmbellishments')!],
          });
        }
      });
    }
    if (
      liningsList &&
      liningsList[0] &&
      liningsList[0].active === false &&
      (!draperyOrderDesign.romanShadeJson ||
        !draperyOrderDesign.romanShadeJson.valanceAndReturns ||
        !draperyOrderDesign.romanShadeJson.valanceAndReturns.backValance ||
        draperyOrderDesign.romanShadeJson.valanceAndReturns.backValance <= 0) &&
      liningsList &&
      liningsList[1] &&
      liningsList[1].active === false
    ) {
      this.setState({
        liningsList: [
          {
            active: false,
            description: '',
            draperyOrderDesignId: liningsList[0].draperyOrderDesignId,
            id: liningsList[0].id,
            draperyOrderLiningsFabric: undefined,
            name: 'Lining',
          },
          {
            active: false,
            description: '',
            draperyOrderDesignId: liningsList[1].draperyOrderDesignId,
            id: liningsList[1].id,
            draperyOrderLiningsFabric: undefined,
            name: 'Interlining',
          },
        ],
      });
    }

    const fabricSaveTasks: Array<() => Promise<boolean>> = [];

    let otherEmbellishmentIndex = 0;
    for (const [index, embellishmentInfo] of embellishmentsList.entries()) {
      if (embellishmentInfo.checked) {
        const { name, list } = this.getEmbellishmentsByIndex(index);
        for (const [subIndex, embellishment] of list.entries()) {
          if (
            embellishment.draperyOrderFabric &&
            (subIndex >= 0 ? true : embellishment.subType === 0 || embellishment.subType === 1)
          ) {
            if (Object.keys(this.state.yardage).length) {
              if (embellishment.draperyOrderFabric.name.toLowerCase().includes('banding')) {
                let bandingIndex = -1;
                bandingIndex = this.state.bandings.findIndex((item) => {
                  if (item.draperyOrderFabric && embellishment.draperyOrderFabric) {
                    return item.draperyOrderFabric.name === embellishment.draperyOrderFabric.name;
                  }
                  return false;
                });
                if (bandingIndex !== -1) {
                  embellishment.draperyOrderFabric.yardsNeeded =
                    this.state.yardage.bandingsYardage &&
                    this.state.yardage.bandingsYardage[bandingIndex]
                      ? this.state.yardage.bandingsYardage[bandingIndex]
                      : null;
                } else {
                  console.warn('No corresponding banding found for embellishment:', embellishment);
                }
              }
              if (embellishment.draperyOrderFabric.name.toLowerCase().includes('cording')) {
                if (embellishment.subType === 0) {
                  // Use cordingsPreMadeYardage
                  const cordingIndex = this.state.cordings
                    .filter((item) => item.subType === 0)
                    .findIndex((item) => {
                      if (item.draperyOrderFabric && embellishment.draperyOrderFabric) {
                        return (
                          item.draperyOrderFabric.name === embellishment.draperyOrderFabric.name
                        );
                      }
                      return false;
                    });
                  if (cordingIndex !== -1) {
                    embellishment.draperyOrderFabric.yardsNeeded =
                      this.state.yardage.cordingsPreMadeYardage &&
                      this.state.yardage.cordingsPreMadeYardage[cordingIndex]
                        ? this.state.yardage.cordingsPreMadeYardage[cordingIndex]
                        : null;
                  }
                } else if (embellishment.subType === 1) {
                  // Use cordingsFabricYardage
                  const cordingIndex = this.state.cordings
                    .filter((item) => item.subType === 1)
                    .findIndex((item) => {
                      if (item.draperyOrderFabric && embellishment.draperyOrderFabric) {
                        return (
                          item.draperyOrderFabric.name === embellishment.draperyOrderFabric.name
                        );
                      }
                      return false;
                    });
                  if (cordingIndex !== -1) {
                    embellishment.draperyOrderFabric.yardsNeeded =
                      this.state.yardage.cordingsFabricYardage &&
                      this.state.yardage.cordingsFabricYardage[cordingIndex]
                        ? this.state.yardage.cordingsFabricYardage[cordingIndex]
                        : null;
                  }
                }
              }
              if (embellishment.draperyOrderFabric.name.toLowerCase().includes('flange')) {
                if (embellishment.subType === 0) {
                  const flangeIndex = this.state.flanges
                    .filter((item) => item.subType === 0)
                    .findIndex((item) => {
                      if (item.draperyOrderFabric && embellishment.draperyOrderFabric) {
                        return (
                          item.draperyOrderFabric.name === embellishment.draperyOrderFabric.name
                        );
                      }
                      return false;
                    });
                  if (flangeIndex !== -1) {
                    embellishment.draperyOrderFabric.yardsNeeded =
                      this.state.yardage.flangesPreMadeYardage &&
                      this.state.yardage.flangesPreMadeYardage[flangeIndex]
                        ? this.state.yardage.flangesPreMadeYardage[flangeIndex]
                        : null;
                  }
                } else if (embellishment.subType === 1) {
                  const flangeIndex = this.state.flanges
                    .filter((item) => item.subType === 1)
                    .findIndex((item) => {
                      if (item.draperyOrderFabric && embellishment.draperyOrderFabric) {
                        return (
                          item.draperyOrderFabric.name === embellishment.draperyOrderFabric.name
                        );
                      }
                      return false;
                    });
                  if (flangeIndex !== -1) {
                    embellishment.draperyOrderFabric.yardsNeeded =
                      this.state.yardage.flangesFabricYardage &&
                      this.state.yardage.flangesFabricYardage[flangeIndex]
                        ? this.state.yardage.flangesFabricYardage[flangeIndex]
                        : null;
                  }
                }
              }
              if (embellishment.draperyOrderFabric.name.toLowerCase().includes('trim')) {
                if (this.state.orderType === 'roman-shade-order') {
                  if (embellishment.subType === 0) {
                    const trimIndex = this.state.trims
                      .filter((item) => item.subType === 0)
                      .findIndex((item) => {
                        if (item.draperyOrderFabric && embellishment.draperyOrderFabric) {
                          return (
                            item.draperyOrderFabric.name === embellishment.draperyOrderFabric.name
                          );
                        }
                        return false;
                      });
                    if (trimIndex !== -1) {
                      embellishment.draperyOrderFabric.yardsNeeded =
                        yardage.trimsPreMadeYardage && yardage.trimsPreMadeYardage[trimIndex]
                          ? yardage.trimsPreMadeYardage[trimIndex]
                          : null;
                    }
                  } else if (embellishment.subType === 1) {
                    const trimIndex = this.state.trims
                      .filter((item) => item.subType === 1)
                      .findIndex((item) => {
                        if (item.draperyOrderFabric && embellishment.draperyOrderFabric) {
                          return (
                            item.draperyOrderFabric.name === embellishment.draperyOrderFabric.name
                          );
                        }
                        return false;
                      });
                    if (trimIndex !== -1) {
                      embellishment.draperyOrderFabric.yardsNeeded =
                        yardage.trimsFabricYardage && yardage.trimsFabricYardage[trimIndex]
                          ? yardage.trimsFabricYardage[trimIndex]
                          : null;
                    }
                  }
                } else {
                  if (embellishment.subType === 0) {
                    const trimIndex = this.state.trims
                      .filter((item) => item.subType === 0)
                      .findIndex((item) => {
                        if (item.draperyOrderFabric && embellishment.draperyOrderFabric) {
                          return (
                            item.draperyOrderFabric.name === embellishment.draperyOrderFabric.name
                          );
                        }
                        return false;
                      });
                    if (trimIndex !== -1) {
                      embellishment.draperyOrderFabric.yardsNeeded =
                        this.state.yardage.trimsPreMadeYardage &&
                        this.state.yardage.trimsPreMadeYardage[trimIndex]
                          ? this.state.yardage.trimsPreMadeYardage[trimIndex]
                          : null;
                    }
                  } else if (embellishment.subType === 1) {
                    const trimIndex = this.state.trims
                      .filter((item) => item.subType === 1)
                      .findIndex((item) => {
                        if (item.draperyOrderFabric && embellishment.draperyOrderFabric) {
                          return (
                            item.draperyOrderFabric.name === embellishment.draperyOrderFabric.name
                          );
                        }
                        return false;
                      });
                    if (trimIndex !== -1) {
                      embellishment.draperyOrderFabric.yardsNeeded =
                        this.state.yardage.trimsFabricYardage &&
                        this.state.yardage.trimsFabricYardage[trimIndex]
                          ? this.state.yardage.trimsFabricYardage[trimIndex]
                          : null;
                    }
                  }
                }
              }
            }
            const isOtherEmbellishment = !['banding', 'trim', 'flange', 'cording'].some(
              (item) =>
                (embellishment.draperyOrderFabric &&
                  embellishment.draperyOrderFabric.name &&
                  embellishment.draperyOrderFabric.name.toLowerCase().includes(item)) ||
                false
            );
            if (
              isOtherEmbellishment &&
              embellishment.draperyOrderFabric &&
              Object.keys(this.state.yardage).length
            ) {
              if (this.state.orderType === 'roman-shade-order') {
                embellishment.draperyOrderFabric.yardsNeeded =
                  yardage.otherEmbellishmentsYardage &&
                  yardage.otherEmbellishmentsYardage[otherEmbellishmentIndex]
                    ? yardage.otherEmbellishmentsYardage[otherEmbellishmentIndex]
                    : null;
              } else {
                embellishment.draperyOrderFabric.yardsNeeded =
                  this.state.yardage.otherEmbellishmentsYardage &&
                  this.state.yardage.otherEmbellishmentsYardage[otherEmbellishmentIndex]
                    ? this.state.yardage.otherEmbellishmentsYardage[otherEmbellishmentIndex]
                    : null;
              }
              otherEmbellishmentIndex += 1;
            }

            embellishment.draperyOrderFabric.yardsRecommended =
              embellishment.draperyOrderFabric.name.split(" FABRIC")[0] === ""
                ? embellishment.draperyOrderFabric.yardsRecommended || null
                : null;

            const fabricPayload = {
              name: `${name}.${subIndex}.draperyOrderFabric`,
              fabric: embellishment.draperyOrderFabric,
              draperyOrderDesignEmbellishmentId: embellishment.id,
              draperyOrderDesignLiningId: undefined,
              mode,
              draperyOrderId,
            };
            fabricSaveTasks.push(() => this.saveDraperyOrderFabricApi(fabricPayload));
          }
        }
      }
    }

    for (const [index, liningInfo] of liningsList.entries()) {
      const { active, draperyOrderLiningsFabric } = liningInfo;
      // back valance selected romanShadeProps
      if (
        (index === 0 &&
          (active ||
            (draperyOrderDesign.romanShadeJson &&
              draperyOrderDesign.romanShadeJson.valanceAndReturns &&
              draperyOrderDesign.romanShadeJson.valanceAndReturns.backValance &&
              draperyOrderDesign.romanShadeJson.valanceAndReturns.backValance > 0)) &&
          draperyOrderLiningsFabric) ||
        (index !== 0 && active && draperyOrderLiningsFabric)
      ) {
        // if ((active || (draperyOrderDesign.romanShadeJson && draperyOrderDesign.romanShadeJson.valanceAndReturns.backValance && draperyOrderDesign.romanShadeJson.valanceAndReturns.backValance > 0)) && draperyOrderLiningsFabric) {
        if (this.state.orderType !== 'drapery-order') {
          draperyOrderLiningsFabric.yardsNeeded =
            yardage.liningsYardage && yardage.liningsYardage[index]
              ? yardage.liningsYardage[index]
              : null;
        }
        const liningPayload = {
          name: `liningsList.${index}.draperyOrderLiningsFabric`,
          fabric: draperyOrderLiningsFabric,
          draperyOrderDesignEmbellishmentId: undefined,
          draperyOrderDesignLiningId: liningInfo.id,
          mode,
          draperyOrderId,
        };
        fabricSaveTasks.push(() => this.saveDraperyOrderFabricApi(liningPayload));
      }
    }

    if (checkGate('perf_calc_parallel_save')) {
      const results = await Promise.all(fabricSaveTasks.map((task) => task()));
      if (results.some((ok) => !ok)) {
        return false;
      }
    } else {
      for (const task of fabricSaveTasks) {
        if (!(await task())) {
          return false;
        }
      }
    }
    return true;
  }

  @Bind()
  private async saveSummaryTab(): Promise<boolean> {
    const {
      draperyOrderSummaryComponents,
      mainFabric,
      embellishmentsList,
      headRail,
      draperyOrderSummary,
      hardware,
    } = this.state;
    const phaseCtx = {
      order_type: this.state.orderType,
      order_id: this.state.draperyOrder.id || undefined,
    };
    const measure = async <T,>(phase: string, op: () => Promise<T>): Promise<T> => {
      const sw = startStopwatch();
      try {
        return await op();
      } finally {
        logSavePhase({ phase, duration_ms: sw.end(), ...phaseCtx });
      }
    };
    const hardwareSummaryItemName =
      this.state.orderType === 'custom-order' ? 'PARTS & SUPPLIES' : 'HARDWARE';
    const hardwareSummaryComponent = {
      ...hardware.draperyOrderSummaryComponent,
      item: hardwareSummaryItemName,
      isStaticHardware: true,
    };
    const draperyOrderSummaryComponentsForDelete: DraperyModule.DraperyOrderSummaryComponent[] = [];

    for (let i = 0; i < draperyOrderSummaryComponents.length; i++) {
      if (!draperyOrderSummaryComponents[i].item) {
        draperyOrderSummaryComponents.splice(i, 1);
        i--;
      }
    }
    const draperyOrderSummaryId = await measure('summary.summary_api', () =>
      this.saveDraperyOrderSummaryApi()
    );
    if (!draperyOrderSummaryId) {
      return false;
    }
    const hardwarePurchaserIsWorkroom = this.state.draperyOrderHardware?.purchaser === 1;
    const hardwareReceiverIsWorkroom = this.state.draperyOrderHardware?.receiver === 1;
    const hardwareAllowedReceiver =
      !!this.state.draperyOrderHardware &&
      (hardwarePurchaserIsWorkroom || hardwareReceiverIsWorkroom);
    const includeHardwareComponent =
      this.state.orderType !== 'roman-shade-order' && hardwareAllowedReceiver;

    // All component writes below depend only on draperyOrderSummaryId. They have
    // no inter-dependency, so under perf_calc_parallel_save they run concurrently
    // and delete_components runs after the components loop completes (it consumes
    // the saved-component objects).
    if (checkGate('perf_calc_parallel_save')) {
      const parallelTasks: Promise<any>[] = [];

      parallelTasks.push(
        measure('summary.main_fabric_component', () =>
          this.saveDraperyOrderSummaryComponentApi(
            `mainFabric.draperyOrderSummaryComponent`,
            mainFabric.draperyOrderSummaryComponent,
            draperyOrderSummaryId as any,
            mainFabric.id
          )
        )
      );

      if (this.state.orderType === 'roman-shade-order') {
        parallelTasks.push(
          measure('summary.headrail_component', () =>
            this.saveDraperyOrderSummaryComponentApi(
              `headRail.draperyOrderSummaryComponent`,
              headRail.draperyOrderSummaryComponent,
              draperyOrderSummaryId as any,
              headRail.id
            )
          )
        );
      }

      if (includeHardwareComponent) {
        parallelTasks.push(
          measure('summary.hardware_component', () =>
            this.saveDraperyOrderSummaryComponentApi(
              `hardware.draperyOrderSummaryComponent`,
              hardwareSummaryComponent,
              draperyOrderSummaryId as any,
              hardware.id
            )
          )
        );
      }

      const embellishmentsStopwatch = startStopwatch();
      const embellishmentPromises: Promise<any>[] = [];
      for (const [index, embellishmentInfo] of embellishmentsList.entries()) {
        if (embellishmentInfo.checked) {
          const { name, list } = this.getEmbellishmentsByIndex(index);
          for (const [subIndex, embellishment] of list.entries()) {
            const fabric = embellishment.draperyOrderFabric;
            if (fabric && shouldIncludeEmbellishmentFabric(embellishment)) {
              embellishmentPromises.push(
                this.saveDraperyOrderSummaryComponentApi(
                  `${name}.${subIndex}.draperyOrderFabric.draperyOrderSummaryComponent`,
                  fabric.draperyOrderSummaryComponent,
                  draperyOrderSummaryId as any,
                  fabric.id
                )
              );
            }
          }
        }
      }
      parallelTasks.push(
        Promise.all(embellishmentPromises).finally(() => {
          logSavePhase({
            phase: 'summary.embellishment_components',
            duration_ms: embellishmentsStopwatch.end(),
            ...phaseCtx,
          });
        })
      );

      const componentsLoopStopwatch = startStopwatch();
      const savedComponentSlots: any[] = new Array(draperyOrderSummaryComponents.length);
      const componentPromises: Promise<any>[] = draperyOrderSummaryComponents.map(
        (component, index) =>
          this.saveDraperyOrderSummaryComponentApi(
            `draperyOrderSummaryComponents.${index}`,
            component,
            draperyOrderSummaryId as any
          ).then((saved: any) => {
            savedComponentSlots[index] = saved;
            return saved;
          })
      );
      parallelTasks.push(
        Promise.all(componentPromises).finally(() => {
          logSavePhase({
            phase: 'summary.components_loop',
            duration_ms: componentsLoopStopwatch.end(),
            ...phaseCtx,
          });
        })
      );

      const results = await Promise.all(parallelTasks);

      // Flatten: each scalar task contributes its result; each batched task
      // contributes its array. A `false` anywhere means a sub-save returned
      // failure.
      const flat: any[] = [];
      for (const r of results) {
        if (Array.isArray(r)) {
          flat.push(...r);
        } else {
          flat.push(r);
        }
      }
      if (flat.some((ok) => !ok)) {
        return false;
      }

      for (const saved of savedComponentSlots) {
        if (saved && typeof saved === 'object') {
          draperyOrderSummaryComponentsForDelete.push(
            saved as DraperyModule.DraperyOrderSummaryComponent
          );
        }
      }
    } else {
      if (
        !(await measure('summary.main_fabric_component', () =>
          this.saveDraperyOrderSummaryComponentApi(
            `mainFabric.draperyOrderSummaryComponent`,
            mainFabric.draperyOrderSummaryComponent,
            draperyOrderSummaryId as any,
            mainFabric.id
          )
        ))
      ) {
        return false;
      }

      if (this.state.orderType === 'roman-shade-order') {
        if (
          !(await measure('summary.headrail_component', () =>
            this.saveDraperyOrderSummaryComponentApi(
              `headRail.draperyOrderSummaryComponent`,
              headRail.draperyOrderSummaryComponent,
              draperyOrderSummaryId as any,
              headRail.id
            )
          ))
        ) {
          return false;
        }
      }

      if (includeHardwareComponent) {
        if (
          !(await measure('summary.hardware_component', () =>
            this.saveDraperyOrderSummaryComponentApi(
              `hardware.draperyOrderSummaryComponent`,
              hardwareSummaryComponent,
              draperyOrderSummaryId as any,
              hardware.id
            )
          ))
        ) {
          return false;
        }
      }

      const embellishmentComponentsStopwatch = startStopwatch();
      for (const [index, embellishmentInfo] of embellishmentsList.entries()) {
        if (embellishmentInfo.checked) {
          const { name, list } = this.getEmbellishmentsByIndex(index);
          for (const [subIndex, embellishment] of list.entries()) {
            const fabric = embellishment.draperyOrderFabric;
            if (fabric && shouldIncludeEmbellishmentFabric(embellishment)) {
              if (
                !(await this.saveDraperyOrderSummaryComponentApi(
                  `${name}.${subIndex}.draperyOrderFabric.draperyOrderSummaryComponent`,
                  fabric.draperyOrderSummaryComponent,
                  draperyOrderSummaryId as any,
                  fabric.id
                ))
              ) {
                logSavePhase({
                  phase: 'summary.embellishment_components',
                  duration_ms: embellishmentComponentsStopwatch.end(),
                  ...phaseCtx,
                });
                return false;
              }
            }
          }
        }
      }
      logSavePhase({
        phase: 'summary.embellishment_components',
        duration_ms: embellishmentComponentsStopwatch.end(),
        ...phaseCtx,
      });

      const componentsLoopStopwatch = startStopwatch();
      for (const [index, component] of draperyOrderSummaryComponents.entries()) {
        const savedComponent = await this.saveDraperyOrderSummaryComponentApi(
          `draperyOrderSummaryComponents.${index}`,
          component,
          draperyOrderSummaryId as any
        );
        if (!savedComponent) {
          logSavePhase({
            phase: 'summary.components_loop',
            duration_ms: componentsLoopStopwatch.end(),
            ...phaseCtx,
          });
          return false;
        }
        if (savedComponent && typeof savedComponent === 'object') {
          draperyOrderSummaryComponentsForDelete.push(
            savedComponent as DraperyModule.DraperyOrderSummaryComponent
          );
        }
      }
      logSavePhase({
        phase: 'summary.components_loop',
        duration_ms: componentsLoopStopwatch.end(),
        ...phaseCtx,
      });
    }

    await measure('summary.delete_components', () =>
      deleteDraperyOrderSummaryComponents({
        draperyOrderSummaryComponents: draperyOrderSummaryComponentsForDelete,
        draperyOrderSummaryId: draperyOrderSummaryId as any,
        receiver: this.state.draperyOrderHardware.receiver,
        purchaser: this.state.draperyOrderHardware.purchaser,
      })
    );

    return true;
  }

  @Bind()
  private async saveDraperyOrderDrawing(): Promise<boolean> {
    // perf_skip_clean_drawing_save: when on, skip the ~1.5s file upload if
    // the user hasn't modified the canvas since the order was opened AND there
    // is already a persisted drawing URL on the server. Only safe when both
    // conditions hold — for a new order with no existing drawing we still need
    // to upload (legacy code returns false for a null blob, which we preserve).
    const skipClean = checkGate('perf_skip_clean_drawing_save');
    const hasExistingDrawing = !!(
      this.state.draperyOrderDesign && (this.state.draperyOrderDesign as any).drawing
    );
    if (skipClean && !this.state.isDrawingDirty && hasExistingDrawing) {
      return true;
    }
    const drawingBlob = await this.drawingBlob();
    if (drawingBlob) {
      if (!(await this.saveDrawingImageApi(new File([drawingBlob], 'name')))) {
        return false;
      }
      // Drawing is now persisted; subsequent saves can skip the upload until
      // the user edits the canvas again.
      this.setState({ isDrawingDirty: false });
    } else {
      return false;
    }
    return true;
  }

  @Bind()
  private async saveLiningsList(draperyOrderDesignId?: number): Promise<boolean> {
    const { liningsList } = this.state;
    const resolvedDraperyOrderDesignId = draperyOrderDesignId || this.state.draperyOrderDesign.id;
    for (const [index, lining] of liningsList.entries()) {
      if (!(await this.saveLiningApi(index, lining, resolvedDraperyOrderDesignId))) {
        return false;
      }
    }
    return true;
  }

  @Bind()
  private async saveEmbellishmentList(draperyOrderDesignId: any): Promise<boolean> {
    const { embellishmentsList } = this.state;
    for (const [index, embellishmentInfo] of embellishmentsList.entries()) {
      if (embellishmentInfo.checked) {
        const { list, name } = this.getEmbellishmentsByIndex(index);
        for (const [subIndex, embellishment] of list.entries()) {
          if (
            !(await this.saveEmbellishmentListApi(
              name,
              subIndex,
              embellishment,
              draperyOrderDesignId
            ))
          ) {
            return false;
          }
        }
      }
    }
    return true;
  }

  @Bind()
  private async deleteEmbellishmentList(): Promise<boolean> {
    // remove embellishemts
    for (const id of this.state.removedEmbellishmentIds) {
      if (id && !(await this.deleteEmbellishmentApi(id))) {
        return false;
      }
    }
    const arr = [
      ...this.state.trims,
      ...this.state.bandings,
      ...this.state.flanges,
      ...this.state.cordings,
      ...this.state.othersEmbellishments,
    ];
    if (this.state.isNoneEmbellishment) {
      arr.forEach((item) => {
        if (item.id > 0) {
          this.deleteEmbellishmentApi(item!.id);
          this.setState({
            bandings: [defaultEmbellishment('bandings')!],
            cordings: [defaultEmbellishment('cordings')!],
            flanges: [defaultEmbellishment('flanges')!],
            trims: [defaultEmbellishment('trims')!],
            othersEmbellishments: [defaultEmbellishment('othersEmbellishments')!],
          });
        }
      });
    }
    this.setState((state) => ({
      ...state,
      removedEmbellishmentIds: [],
    }));
    return true;
  }

  @Bind()
  private processResponseErrors(
    res: any,
    tabIndex: number,
    errorName: string,
    section?: string
  ): void {
    if (!res.error) {
      return;
    }
    if (res.payload.name === 'ValidationError') {
      const errors = (res.payload as Error as ValidationError).errors;

      this.setState((state) => ({
        ...state,
        [errorName]: processErrors(tabIndex, errors, section),
      }));
    } else {
      this.setState((state) => ({
        ...state,
        [errorName]: [{ tabIndex, name: '', message: res.payload.message }],
      }));
    }
  }

  private async saveDrawingImageApi(file: File): Promise<boolean> {
    const { accountId } = this.props;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('accountId', accountId.toString());
    formData.append('fileStoreUrl', Config.fileStoreUrl);
    const res = await uploadImage(formData);
    this.processResponseErrors(res, -1, 'draperyOrderErrors');
    if (res.error) {
      return false;
    }
    this.updateStateByName(`draperyOrderDesign.drawing`, res.url, true);
    return true;
  }

  @Bind()
  private async saveDraperyOrderApi(): Promise<boolean> {
    const { accountId } = this.props;
    if (localStorage.getItem('duplicate')) localStorage.removeItem('duplicate');
    const { draperyOrder, draperyOrderFees, draperyOrderPriceId } = this.state;
    // Update drapery order
    if (draperyOrder.id) {
      const res = await editDraperyOrder({
        ...draperyOrder,
        roomId: draperyOrder.roomId || undefined,
        clientId: draperyOrder.clientId || undefined,
        draperyOrderPriceId: draperyOrderPriceId || undefined,
        draperyOrderFees,
        isDraft: this.state.draperyOrder.isDraft,
        orderType: this.state.orderType,
      });

      this.processResponseErrors(res, -1, 'draperyOrderErrors');
      trackView(MixpanelEvents.SAVE_ORDER, {
        orderId: this.state.draperyOrder.id,
        orderType: this.state.orderType,
        element: 'order_update',
      });

      if (res.error) {
        trackView(MixpanelEvents.SAVE_ORDER, {
          orderId: this.state.draperyOrder.id,
          orderType: this.state.orderType,
          be_error_text:
            res.error && res.message
              ? res.message
              : res.error
                ? res.error
                : 'Error with saving order',
        });
        return false;
      }

      return draperyOrder.id;
    }
    const canCreateOrder = await userCanCreateNewOrder(this.props.accountId);
    const new_roman_shade = this.state.orderType === 'roman-shade-order' ? 1 : null;
    let notebookData = this.notebookRef?.current?.getData() || [];
    let notebookItems = notebookData?.['items']?.map((n: any) => {
      return {
        tabType: n.type,
        table: n.table,
        creatorId: n?.creator?.id,
        content: n.content || null,
        resolved: false,
        resolvedById: null,
        orderId: null,
        projectId: null,
        mentionedUserIds: n.mentionedUserIds,
      };
    });
    const res = await addDraperyOrder({
      ...draperyOrder,
      accountId,
      orderType: this.state.orderType,
      draperyOrderFees,
      newRomanShade: new_roman_shade,
      isFromExtraOrderCredit: !canCreateOrder && this.state.remainingItemOrder > 0 ? true : false,
      notebookItems: notebookItems,
    });
    if (
      !canCreateOrder &&
      this.state.remainingItemOrder > 0 &&
      this.state.orderType !== 'custom-order'
    ) {
      await updateAccount({ accountId, remainingItemOrder: this.state.remainingItemOrder - 1 });
    }
    this.processResponseErrors(res, -1, 'draperyOrderErrors');

    if (this.state.isDuplicate) {
      trackView(MixpanelEvents.SAVE_ORDER, {
        orderId: this.state.draperyOrder.id,
        orderType: this.state.orderType,
        element: 'order_duplicate',
      });
    }

    if (res.error) {
      trackView(MixpanelEvents.SAVE_ORDER, {
        orderId: this.state.draperyOrder.id,
        orderType: this.state.orderType,
        be_error_text:
          res.error && res.message
            ? res.message
            : res.error
              ? res.error
              : 'Error with saving order',
      });
      return false;
    }
    this.updateStateByName(`draperyOrder.id`, res.id, true);
    this.updateStateByName(`draperyOrder.newRomanShade`, res.newRomanShade, true);
    return res.id;
  }

  @Bind()
  private async saveDraperyOrderDesignApi(): Promise<number | false> {
    const { accountId } = this.props;
    let { draperyOrder, draperyOrderDesign } = this.state;

    let foundDrawingBg = draperyOrderDesign?.drawingShapeJson?.find(
      (f: any) => f?.type === 'image'
    );
    let uploadedImageSrc = foundDrawingBg?.imageSrc;

    if (foundDrawingBg?.imageBlob) {
      const f = foundDrawingBg.file;
      const normalizedFileType = (f.fileType || f.mimeType || f.type || '')
        .toString()
        .toLowerCase();
      const uploadType = normalizedFileType.includes('pdf') ? 'pdf' : 'image';
      const remoteInfo = await uploadFileWithPresign({
        accountId,
        contentType: f?.type || f?.mimeType || undefined,
        file: foundDrawingBg?.imageBlob,
        fileName: `${this.drawingBgIdentifier}.${getFileExtension(f?.name)}` || `upload.png`,
        uploadType,
      });
      uploadedImageSrc = `${Config.fileStoreUrl}${remoteInfo.remoteSource}` || '';
    }

    const drawingShapeJson = draperyOrderDesign.drawingShapeJson.map((i: any) => {
      if (i.type !== 'image') return i;

      return {
        ...i,
        imageSrc: uploadedImageSrc,
        imageBlob: undefined,
        file: undefined,
      };
    });

    this.setState((prev) => {
      return {
        ...prev,
        draperyOrderDesign: {
          ...prev?.draperyOrderDesign,
          drawingShapeJson: drawingShapeJson,
        },
      };
    });

    if (draperyOrder.draperyOrderDesignId) {
      let payload = {
        ...draperyOrderDesign,
        drawingShapeJson: drawingShapeJson,
        drawingBgIdentifier: draperyOrderDesign?.drawingBgIdentifier || this.drawingBgIdentifier,
        draperyOrderDesignEmbellishments:
          draperyOrderDesign.draperyOrderDesignEmbellishments &&
          draperyOrderDesign.draperyOrderDesignEmbellishments.length > 0
            ? draperyOrderDesign.draperyOrderDesignEmbellishments
            : undefined,
        draperyOrderDesignLinings:
          draperyOrderDesign.draperyOrderDesignLinings &&
          draperyOrderDesign.draperyOrderDesignLinings.length > 0
            ? draperyOrderDesign.draperyOrderDesignLinings
            : undefined,
        isNoneLinings: this.state.isNoneLinings,
        isNoneEmbellishment: this.state.isNoneEmbellishment,
      };
      if (
        draperyOrderDesign &&
        draperyOrderDesign.customLiningsJson &&
        draperyOrderDesign.customLiningsJson.liningVerticalAllowance
      ) {
        payload = {
          ...payload,
          customLiningsJson: {
            ...payload.customLiningsJson,
            liningVerticalAllowance: Number(payload.customLiningsJson.liningVerticalAllowance),
          },
        };
        if (isNaN(draperyOrderDesign.customLiningsJson.liningVerticalAllowance)) {
          delete payload.customLiningsJson.liningVerticalAllowance;
        }
      }
      if (
        draperyOrderDesign &&
        draperyOrderDesign.customLiningsJson &&
        draperyOrderDesign.customLiningsJson.interliningVerticalAllowance
      ) {
        payload = {
          ...payload,
          customLiningsJson: {
            ...payload.customLiningsJson,
            interliningVerticalAllowance: Number(
              payload.customLiningsJson.interliningVerticalAllowance
            ),
          },
        };
        if (isNaN(draperyOrderDesign.customLiningsJson.interliningVerticalAllowance)) {
          delete payload.customLiningsJson.interliningVerticalAllowance;
        }
      }
      const res = await editDraperyOrderDesign(payload);
      this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
      if (res.error) {
        return false;
      }
      return draperyOrder.draperyOrderDesignId;
    }
    // Add drapery order design
    let payload = {
      ...draperyOrderDesign,
      drawingShapeJson: drawingShapeJson,
      drawingBgIdentifier: this.drawingBgIdentifier,
      accountId,
      isNoneLinings: this.state.isNoneLinings,
      isNoneEmbellishment: this.state.isNoneEmbellishment,
    };
    if (
      draperyOrderDesign &&
      draperyOrderDesign.customLiningsJson &&
      draperyOrderDesign.customLiningsJson.liningVerticalAllowance
    ) {
      payload = {
        ...payload,
        customLiningsJson: {
          ...payload.customLiningsJson,
          liningVerticalAllowance: Number(payload.customLiningsJson.liningVerticalAllowance),
        },
      };
      if (isNaN(draperyOrderDesign.customLiningsJson.liningVerticalAllowance)) {
        delete payload.customLiningsJson.liningVerticalAllowance;
      }
    }
    if (
      draperyOrderDesign &&
      draperyOrderDesign.customLiningsJson &&
      draperyOrderDesign.customLiningsJson.interliningVerticalAllowance
    ) {
      payload = {
        ...payload,
        customLiningsJson: {
          ...payload.customLiningsJson,
          interliningVerticalAllowance: Number(
            payload.customLiningsJson.interliningVerticalAllowance
          ),
        },
      };
      if (isNaN(draperyOrderDesign.customLiningsJson.interliningVerticalAllowance)) {
        delete payload.customLiningsJson.interliningVerticalAllowance;
      }
    }
    const res = await addDraperyOrderDesign(payload);
    this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
    if (res.error) {
      return false;
    }
    await this.updateStateByName(`draperyOrder.draperyOrderDesignId`, res.id, true);
    await this.updateStateByName(`draperyOrderDesign.id`, res.id, true);
    return res.id;
  }

  @Bind()
  private async saveLiningApi(
    index: number,
    lining: DraperyOrderDesignLining,
    draperyOrderDesignId?: number
  ): Promise<boolean> {
    const { accountId } = this.props;
    const { draperyOrderDesign } = this.state;
    const resolvedDraperyOrderDesignId = draperyOrderDesign.id || draperyOrderDesignId;
    this.updateStateByName(
      `liningsList.${index}.draperyOrderDesignId`,
      resolvedDraperyOrderDesignId,
      true
    );
    this.updateStateByName(`liningsList.${index}.description`, lining.description || '', true);

    // const romanShadeProps = { valanceAndReturns: { backValance: 0 } };

    if (
      (index === 0 &&
        !lining.active &&
        (!this.state.draperyOrderDesign.romanShadeJson ||
          !this.state.draperyOrderDesign.romanShadeJson.valanceAndReturns ||
          !this.state.draperyOrderDesign.romanShadeJson.valanceAndReturns.backValance ||
          this.state.draperyOrderDesign.romanShadeJson.valanceAndReturns.backValance <= 0) &&
        lining.draperyOrderLiningsFabric &&
        lining.draperyOrderLiningsFabric.draperyOrderId) ||
      (index !== 0 &&
        !lining.active &&
        lining.draperyOrderLiningsFabric &&
        lining.draperyOrderLiningsFabric.draperyOrderId)
    ) {
      const id = lining.draperyOrderLiningsFabric.id;

      if (id && id !== 0) {
        const res = await deleteDraperyOrderFabric({ id });
        const res1 = await editDraperyOrderDesignLining(lining);

        this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');

        if (res1.error) {
          return false;
        }
        if (res.error) {
          return false;
        }
      }

      return true;
    }
    // Update lining
    if (lining.id) {
      const res = await editDraperyOrderDesignLining(lining);
      this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
      if (res.error) {
        return false;
      }
      return true;
    }
    // Add lining
    const res = await addDraperyOrderDesingLining({
      ...lining,
      accountId,
      draperyOrderDesignId: resolvedDraperyOrderDesignId,
    });
    this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
    if (res.error) {
      return false;
    }
    this.updateStateByName(`liningsList.${index}.id`, res.id, true);
    return true;
  }

  @Bind()
  private async saveEmbellishmentListApi(
    name: string,
    index: number,
    embellishment: DraperyOrderDesignEmbellishment,
    draperyOrderDesignId: any
  ): Promise<boolean> {
    const { accountId } = this.props;
    const { draperyOrderDesign } = this.state;
    const resolvedDraperyOrderDesignId = draperyOrderDesign.id || draperyOrderDesignId;
    // Set draperyOrderDesign id
    this.updateStateByName(
      `${name}.${index}.draperyOrderDesignId`,
      resolvedDraperyOrderDesignId,
      true
    );
    if (embellishment.appliedType === null) {
      this.updateStateByName(`${name}.${index}.appliedType`, undefined, true);
    }
    if (embellishment.id) {
      // Update embellishment
      const res = await editDraperyOrderDesignEmbellishment({
        ...embellishment,
        draperyOrderDesignId: resolvedDraperyOrderDesignId,
      });
      this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
      if (res.error) {
        return false;
      }
    } else {
      // Add embellishment
      const res = await addDraperyOrderDesingEmbellishment({
        ...embellishment,
        draperyOrderDesignId: resolvedDraperyOrderDesignId,
        accountId,
      });
      this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
      if (res.error) {
        return false;
      }
      this.updateStateByName(`${name}.${index}.id`, res.id, true);
    }
    return true;
  }

  @Bind()
  private async deleteEmbellishmentApi(id: number): Promise<boolean> {
    const res = await deleteDraperyOrderDesignEmbellishment(id);
    this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
    if (res.error) {
      return false;
    }
    return true;
  }
  @Bind()
  private async deleteDraperyOrderFabricApi(id: number): Promise<boolean> {
    const res = await deleteDraperyOrderDesignEmbellishment(id);
    this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
    if (res.error) {
      return false;
    }
    return true;
  }

  @Bind()
  private async saveDraperyOrderFabricApi({
    name,
    fabric,
    draperyOrderDesignEmbellishmentId,
    draperyOrderDesignLiningId,
    mode,
    draperyOrderId,
  }: {
    name: string;
    fabric: DraperyModule.DraperyOrderFabric & { supplierName?: string } & {
      customSupplier?: string;
    };
    draperyOrderDesignEmbellishmentId?: number;
    draperyOrderDesignLiningId?: number;
    mode?: string;
    draperyOrderId: any;
  }): Promise<boolean> {
    const { accountId } = this.props;
    const { draperyOrder } = this.state;
    this.updateStateByName(`${name}.draperyOrderId`, draperyOrderId, true);
    this.updateStateByName(
      `${name}.draperyOrderDesignEmbellishmentId`,
      draperyOrderDesignEmbellishmentId,
      true
    );
    this.updateStateByName(`${name}.draperyOrderDesignLiningId`, draperyOrderDesignLiningId, true);
    // fabric.customSupplier = fabric.supplierName
    if (!fabric.supplierId) {
      fabric.supplierId = undefined;
      // fabric.supplierName = undefined;
    }
    // alert("test " + fabric.yardsNeeded + " " + fabric.yardsRecommended)
    // Update fabric
    if (fabric.id) {
      const res = await editDraperyOrderFabric({
        ...fabric,
        supplierName: fabric.supplierId ? undefined : fabric.supplierName,
        imageId: fabric.imageId,
        accountId,
        yardsNeeded:
          this.state.orderType === 'roman-shade-order' &&
          mode === 'workOrder' &&
          fabric.yardsRecommended
            ? fabric.yardsRecommended
            : this.state.orderType === 'custom-order' &&
                fabric.name === 'LINING FABRIC' &&
                this.state.yardage &&
                this.state.yardage &&
                this.state.yardage.liningsYardage &&
                this.state.yardage.liningsYardage.length > 0
              ? this.state.yardage.liningsYardage[0]
              : this.state.orderType === 'custom-order' &&
                  fabric.name === 'INTERLINING FABRIC' &&
                  this.state.yardage &&
                  this.state.yardage &&
                  this.state.yardage.liningsYardage &&
                  this.state.yardage.liningsYardage.length > 1
                ? this.state.yardage.liningsYardage[1]
                : fabric.yardsNeeded,
        noValue:
          this.state.orderType === 'custom-order' ||
          (fabric.type && fabric.type === 8) ||
          this.state.orderType === 'roman-shade-order'
            ? null
            : 0,
      });
      this.processResponseErrors(res, 2, 'draperyOrderFabricsErrors', name);
      if (res.error) {
        return false;
      }
      return true;
    }

    // Add fabric
    const res = await addDraperyOrderFabric({
      ...fabric,
      supplierName: fabric.supplierId ? undefined : fabric.supplierName,
      customSupplier: fabric.customSupplier,
      accountId,
      draperyOrderId,
      yardsNeeded:
        this.state.orderType === 'roman-shade-order' &&
        mode === 'workOrder' &&
        fabric.yardsRecommended
          ? fabric.yardsRecommended
          : this.state.orderType === 'custom-order' &&
              fabric.name === 'LINING FABRIC' &&
              this.state.yardage &&
              this.state.yardage &&
              this.state.yardage.liningsYardage &&
              this.state.yardage.liningsYardage.length > 0
            ? this.state.yardage.liningsYardage[0]
            : this.state.orderType === 'custom-order' &&
                fabric.name === 'INTERLINING FABRIC' &&
                this.state.yardage &&
                this.state.yardage &&
                this.state.yardage.liningsYardage &&
                this.state.yardage.liningsYardage.length > 1
              ? this.state.yardage.liningsYardage[1]
              : fabric.yardsNeeded,
      draperyOrderDesignEmbellishmentId,
      patternId: fabric.itemId ? fabric.itemId : fabric.patternId ? fabric.patternId : undefined,
      noValue:
        this.state.orderType === 'custom-order' ||
        (fabric.type && fabric.type === 8) ||
        this.state.orderType === 'roman-shade-order'
          ? null
          : 0,
    });
    this.processResponseErrors(res, 2, 'draperyOrderFabricsErrors', name);
    if (res.error) {
      return false;
    }
    fabric.id = res.id;
    await this.setSavingStateByName(`${name}.id`, res.id);
    return true;
  }

  @Bind()
  private async saveDraperyOrderSummaryApi(): Promise<boolean> {
    const { accountId } = this.props;
    const { draperyOrderSummary } = this.state;

    // Default Not Created if no estimate num
    if (draperyOrderSummary.estimateJson && !draperyOrderSummary.estimateJson.num) {
      draperyOrderSummary.estimateJson.num = 'Not Created';
    }
    if (draperyOrderSummary.invoiceJson && !draperyOrderSummary.invoiceJson.paid) {
      draperyOrderSummary.invoiceJson.paid = 'Not Created';
    }
    // Update drapery order summary
    if (draperyOrderSummary.id) {
      const res = await editDraperyOrderSummary(draperyOrderSummary);
      this.processResponseErrors(res, 2, 'draperyOrderSummaryErrors');
      if (res.error) {
        return false;
      }
      return draperyOrderSummary.id;
    }
    // Add drapery order summary
    const res = await addDraperyOrderSummary({
      ...draperyOrderSummary,
      accountId,
    });
    this.processResponseErrors(res, 2, 'draperyOrderSummaryErrors');
    if (res.error) {
      return false;
    }
    this.updateStateByName(`draperyOrder.draperyOrderSummaryId`, res.id, true);
    this.updateStateByName(`draperyOrderSummary.id`, res.id, true);
    return res.id;
  }

  @Bind()
  private async saveDraperyOrderSummaryComponentApi(
    name: string,
    component: DraperyModule.DraperyOrderSummaryComponent,
    draperyOrderSummaryId: number,
    draperyOrderFabricId?: number,
  ): Promise<boolean | DraperyModule.DraperyOrderSummaryComponent> {
    const { accountId } = this.props;
    if (!component) {
      return true;
    }
    const resolvedDraperyOrderFabricId =
      draperyOrderFabricId && draperyOrderFabricId !== 0
        ? draperyOrderFabricId
        : component.draperyOrderFabricId && component.draperyOrderFabricId !== 0
          ? component.draperyOrderFabricId
          : undefined;

    this.updateStateByName(`${name}.draperyOrderSummaryId`, draperyOrderSummaryId, true);
    this.updateStateByName(`${name}.draperyOrderFabricId`, resolvedDraperyOrderFabricId, true);

    // Update summary component
    component['draperyOrderSummaryId'] = draperyOrderSummaryId;
    if (resolvedDraperyOrderFabricId) {
      component.draperyOrderFabricId = resolvedDraperyOrderFabricId;
    }
    if (component && (component.item === "HARDWARE" || component.item === "PARTS & SUPPLIES")) {
      delete component.draperyOrderFabricId;
      component.quantity =
        this.state.draperyOrderHardware && this.state.draperyOrderHardware.hardwareQuantity
          ? this.state.draperyOrderHardware.hardwareQuantity
          : undefined;
    }
    if (component && component.id) {
      const res = await editDraperyOrderSummaryComponent(component);
      this.processResponseErrors(res, 2, 'draperyOrderSummaryErrors');
      if (res.error) {
        return false;
      }
      return component;
    }
    // Add summary component
    if (component && component.id === 0) {
      const res = await addDraperyOrderSummaryComponent({
        ...component,
        accountId,
        draperyOrderSummaryId,
        draperyOrderFabricId: resolvedDraperyOrderFabricId,
      });
      this.processResponseErrors(res, 2, 'draperyOrderSummaryErrors');
      if (res.error) {
        return false;
      }
      component.id = res.id;
      this.updateStateByName(`${name}.id`, res.id, true);
    }
    return component;
  }

  @Bind()
  private async handleCreateWorkOrder(val: string): Promise<void> {
    if (this.state.draperyOrder.id === 0) {
      const can_create_order = await userCanCreateNewOrder(this.props.accountId);
      if (
        !can_create_order &&
        this.state.remainingItemOrder === 0 &&
        this.state.orderType !== 'custom-order'
      ) {
        this.props.handleOpenSubscriptionPlanModal();
        return;
      }
    }

    if (!this.state.client) {
      this.setState((state) => ({ ...state, clientAndRoomHighlight: true }));
      this.toggleErrorMessage();
      return;
    }
    this.setState((state) => ({ ...state, isLoading: true }));
    if (!(await this.saveAll(val))) {
      this.setState((state) => ({ ...state, isLoading: false }));
      return;
    }
    this.setState({ isWorkOrderValidation: true }, async () => {
      if (!this.validateAll('workOrder')) {
        this.toggleErrorMessage();
        this.setState((state) => ({ ...state, isLoading: false }));
        return;
      }
      // if (!(await this.saveAll())) {
      //     return;
      // }
      this.setState((state) => ({
        ...state,
        tabIndex: 5,
        isRecommendationsOverridesModalOpen: true,
        isLoading: false,
      }));
    });
  }

  @Bind()
  private validateAll(mode: 'save' | 'workOrder' | 'update'): boolean {
    this.clearErrors();
    let noError = true;
    if (this.state.validateClient && !this.validateClient(this.state.orderType)) {
      if (mode === 'save') {
        // this.setState((state) => ({
        //   ...state,
        //   isSidebarHidden: false,
        // }));
      }

      noError = false;
    }

    if (mode === 'workOrder') {
      if (!this.validateDraperyOrder()) {
        noError = false;
      }
      if (!this.validateDraperyOrderDesignTab()) {
        noError = false;
      }
      if (!this.validateDraperyOrderFabricsTab()) {
        noError = false;
      }
      if (!this.validateClientBillingTypeTab()) {
        noError = false;
      }
      if (!this.validateDraperyOrderFabricsConfirmation()) {
        noError = false;
      }
      if (!this.validateHardwareTab()) {
        noError = false;
      }
      if (!this.validateSummaryTab()) {
        noError = false;
      }
      if (this.state.orderType === 'roman-shade-order' && !this.validateRomanShadePricings()) {
        noError = false;
      }
      if (
        !this.state.myShopClientBillingErrors ||
        (this.state.myShopClientBillingErrors && !this.state.myShopClientBillingErrors.length)
      ) {
        if (!this.validateMyShopItemPricingTab()) {
          noError = false;
        }
      }
    } else {
      this.validateDraperyOrder();
      this.validateDraperyOrderDesignTab();
      this.validateDraperyOrderFabricsTab();
      this.validateDraperyOrderFabricsConfirmation();
      this.validateHardwareTab();
      this.validateSummaryTab();
      this.validateClientBillingTypeTab();
      if (this.state.orderType === 'roman-shade-order') {
        this.validateRomanShadePricings();
      }
      if (
        !this.state.myShopClientBillingErrors ||
        (this.state.myShopClientBillingErrors && !this.state.myShopClientBillingErrors.length)
      ) {
        this.validateMyShopItemPricingTab();
      }
    }

    return noError;
  }

  @Bind()
  private validateClient(orderType?: string): boolean {
    const { draperyOrder } = this.state;

    const draperyOrderErrors: ValidationErrorInfo[] = validateClient(draperyOrder, orderType);
    if (draperyOrderErrors.length > 0) {
      this.setState((state) => ({
        ...state,
        draperyOrderErrors,
      }));
      return false;
    }
    return true;
  }

  @Bind()
  private validateDraperyOrder(): boolean {
    const { draperyOrder } = this.state;

    const draperyOrderErrors: ValidationErrorInfo[] = validateDraperyOrder(
      draperyOrder,
      this.state.orderType
    );
    this.setState((state) => ({
      ...state,
      draperyOrderErrors,
    }));
    return !draperyOrderErrors.length;
  }

  @Bind()
  private validateDraperyOrderDesignTab(): boolean {
    if (this.state.isLoadingConstructionDefaults) {
      return true;
    }
    const {
      draperyOrderDesign,
      draperyItemDetail,
      liningsList,
      isNoneLinings,
      embellishmentsList,
      isNoneEmbellishment,
      mainFabric,
      romanShadeJson,
    } = this.state;

    let draperyOrderDesignErrors: ValidationErrorInfo[] =
      this.state.orderType === 'custom-order'
        ? validateDraperyOrderDesignOther(
            draperyOrderDesign,
            draperyItemDetail,
            embellishmentsList,
            liningsList,
            mainFabric,
            this.clearHighlightSection
          )
        : this.state.orderType === 'roman-shade-order'
          ? validateDraperyOrderDesignRomanShades(
              draperyOrderDesign,
              draperyItemDetail,
              embellishmentsList,
              liningsList,
              mainFabric,
              this.clearHighlightSection,
              romanShadeJson,
              this.state.draperyOrder.quantity,
              (this.state && this.state.draperyOrder && this.state.draperyOrder.newRomanShade) ||
                null,
              (this.state && this.state.draperyOrder && this.state.draperyOrder.id) || null
            )
          : validateDraperyOrderDesign(
              draperyOrderDesign,
              draperyItemDetail,
              embellishmentsList,
              liningsList,
              mainFabric,
              this.clearHighlightSection
            );
    draperyOrderDesignErrors = draperyOrderDesignErrors.concat(
      validateLiningsList(liningsList, isNoneLinings)
    );
    draperyOrderDesignErrors = draperyOrderDesignErrors.concat(
      validateEmbellishmentChecked(embellishmentsList, isNoneEmbellishment)
    );
    for (const [index, embellishmentInfo] of embellishmentsList.entries()) {
      const { name, list } = this.getEmbellishmentsByIndex(index);
      if (embellishmentInfo.checked) {
        if (this.state.orderType === 'custom-order') {
          draperyOrderDesignErrors = draperyOrderDesignErrors.concat(
            validateEmbellishmentListOther(embellishmentInfo, list, name, this.state.orderType)
          );
        } else if (this.state.orderType === 'roman-shade-order') {
          draperyOrderDesignErrors = draperyOrderDesignErrors.concat(
            validateEmbellishmentListRomanShade(embellishmentInfo, list, name)
          );
        } else {
          draperyOrderDesignErrors = draperyOrderDesignErrors.concat(
            validateEmbellishmentList(embellishmentInfo, list, name)
          );
        }
      }
    }
    this.setState((state) => ({
      ...state,
      draperyOrderDesignErrors,
    }));
    return !draperyOrderDesignErrors.length;
  }

  @Bind()
  private validateDraperyOrderFabricsTab(): boolean {
    const { draperyOrderDesign, mainFabric, embellishmentsList, liningsList } = this.state;

    let draperyOrderFabricsErrors: ValidationErrorInfo[] = validateDraperyOrderMainFabric(
      mainFabric,
      draperyOrderDesign,
      this.state.fabricsPatternItems,
      this.state.workroomSetting,
      this.state.orderType,
      this.state.client
    );
    for (const [index, embellishmentInfo] of embellishmentsList.entries()) {
      if (embellishmentInfo.checked) {
        const { name, list } = this.getEmbellishmentsByIndex(index);
        for (const [subIndex, embellishment] of list.entries()) {
          if (embellishment.draperyOrderFabric && shouldIncludeEmbellishmentFabric(embellishment)) {
            draperyOrderFabricsErrors = draperyOrderFabricsErrors.concat(
              validateDraperyOrderFabric(
                name,
                subIndex,
                embellishment,
                embellishment.draperyOrderFabric,
                this.state.fabricsPatternItems,
                this.state.workroomSetting,
                list,
                this.state.orderType
              )
            );
          }
        }
      }
    }

    for (const [index, liningInfo] of liningsList.entries()) {
      const { active, draperyOrderLiningsFabric, name } = liningInfo;

      let checkCase =
        this.state.draperyOrderDesign &&
        this.state.draperyOrderDesign.romanShadeJson &&
        this.state.draperyOrderDesign.romanShadeJson.valanceAndReturns &&
        this.state.draperyOrderDesign.romanShadeJson.valanceAndReturns.backValance === 1
          ? true
          : false;
      if (
        active ||
        (checkCase && liningInfo.name === 'Lining' && liningsList[0] && !liningsList[0].active)
      ) {
        draperyOrderFabricsErrors = draperyOrderFabricsErrors.concat(
          validateDraperyOrderLiningsFabric(
            name,
            index,
            draperyOrderLiningsFabric,
            this.state.liningsPatternItems,
            this.state.workroomSetting,
            this.state.orderType
          )
        );
      }
    }

    this.setState((state) => ({
      ...state,
      draperyOrderFabricsErrors,
    }));
    return !draperyOrderFabricsErrors.length;
  }

  @Bind()
  private validateHardwareTab(): boolean {
    const draperyOrderHardwareErrors: ValidationErrorInfo[] = [];

    if (this.state.orderType === 'custom-order') {
      const hasInvalidOtherItemName =
        this.state.draperyOrderHardware?.otherItems?.some(
          (item: any) => item?.newItem && typeof item?.item === 'string' && item.item.includes(':')
        ) || false;

      if (hasInvalidOtherItemName) {
        draperyOrderHardwareErrors.push({
          tabIndex: 3,
          name: 'draperyOrderHardware.otherItems.item',
          message: COLON_VALIDATION_MESSAGE,
        });
      }
    }

    this.setState((state) => ({
      ...state,
      draperyOrderHardwareErrors,
    }));

    return !draperyOrderHardwareErrors.length;
  }

  @Bind()
  private validateDraperyOrderFabricsConfirmation(): boolean {
    const { draperyOrder, mainFabric, draperyOrderDesign } = this.state;

    const draperyOrderFabricsValidationConfirmations: ValidationConfirmationInfo[] =
      validateDraperyOrderMainFabricConfirmations(draperyOrder, mainFabric, draperyOrderDesign);
    this.setState((state) => ({
      ...state,
      draperyOrderFabricsConfirmations: draperyOrderFabricsValidationConfirmations,
    }));

    return draperyOrderFabricsValidationConfirmations.length > 0
      ? mainFabric.directionOfUse === 1
        ? this.state.checkedAllowExtraWidthOne
        : this.state.checkedAllowExtraWidthTwo
      : true;
  }

  @Bind()
  private validateRomanShadePricings(): boolean {
    let romanShadePricingErrors = validateRomanShadeItemPricingTab(
      this.state.romanShadeItemDetails,
      this.state.draperyOrder.newRomanShade,
      this.state.draperyOrder.id
    );
    this.setState((prev) => {
      return {
        ...prev,
        romanShadePricingErrors,
      };
    });
    return !romanShadePricingErrors.length;
  }

  @Bind()
  private validateSummaryTab(): boolean {
    const { draperyOrderSummary, mainFabric, embellishmentsList } = this.state;

    let draperyOrderSummaryErrors = validateDraperyOrderSummary(draperyOrderSummary);
    draperyOrderSummaryErrors = draperyOrderSummaryErrors.concat(
      validateDraperyOrderSummaryComponent(
        mainFabric.draperyOrderSummaryComponent,
        `mainFabric.draperyOrderSummaryComponent.`,
        true
      )
    );
    for (const [index, embellishmentInfo] of embellishmentsList.entries()) {
      if (embellishmentInfo.checked) {
        const { name, list } = this.getEmbellishmentsByIndex(index);
        for (const [subIndex, embellishment] of list.entries()) {
          if (embellishment.draperyOrderFabric && shouldIncludeEmbellishmentFabric(embellishment)) {
            draperyOrderSummaryErrors = draperyOrderSummaryErrors.concat(
              validateDraperyOrderSummaryComponent(
                embellishment.draperyOrderFabric.draperyOrderSummaryComponent,
                `${name}.${subIndex}.draperyOrderFabric.draperyOrderSummaryComponent.`,
                true
              )
            );
          }
        }
      }
    }
    // for (const [index, component] of draperyOrderSummaryComponents.entries()) {
    //   draperyOrderSummaryErrors = draperyOrderSummaryErrors.concat(
    //     validateDraperyOrderSummaryComponent(component, `draperyOrderSummaryComponents.${index}.`)
    //   );
    // }

    if (
      this.state.orderType === 'drapery-order' &&
      this.state.draperyItemDetail &&
      this.state.draperyItemDetail.length > 0
    ) {
      draperyOrderSummaryErrors = draperyOrderSummaryErrors.concat(
        validateDraperyItemPricingTab(this.state.draperyItemDetail)
      );
    }
    this.setState((state) => ({
      ...state,
      draperyOrderSummaryErrors,
    }));
    return !draperyOrderSummaryErrors.length;
  }

  @Bind()
  private async getExistingDraperyOrder(reset?: boolean): Promise<void> {
    const { accountId } = this.props;
    const fnStopwatch = startStopwatch();
    const phaseCtx = {
      order_type: this.state.orderType,
      order_id: this.state.draperyOrder.id || undefined,
    };

    // FE-4a: short-circuit the 5 backend fetches when we have a fresh cached
    // bundle for this orderId. We still run the full processing pipeline below
    // since state setup is non-trivial and not cached.
    const useOrderCache = !reset && checkGate('perf_calc_client_cache');
    const cachedBundle: OrderCachedBundle | null = useOrderCache
      ? getOrderCache(this.state.draperyOrder.id)
      : null;
    if (cachedBundle) {
      logOpenPhase({ phase: 'cache_hit', duration_ms: 0, ...phaseCtx });
    }

    let draperyOrderAllInfo: DraperyModule.DraperyOrderAllInfo;
    if (cachedBundle) {
      draperyOrderAllInfo = cachedBundle.draperyOrderAllInfo;
    } else {
      const getAllInfoStopwatch = startStopwatch();
      const res = await getAllInfo(this.state.draperyOrder.id);
      logOpenPhase({ phase: 'get_all_info', duration_ms: getAllInfoStopwatch.end(), ...phaseCtx });
      this.processResponseErrors(res, -1, 'draperyOrderErrors');
      if (res.error) {
        return;
      }
      draperyOrderAllInfo = res;
    }
    let type = -1;
    if (draperyOrderAllInfo.draperyOrderDesign) {
      if (draperyOrderAllInfo.draperyOrderDesign.headingType === 'rodandrings') {
        switch (draperyOrderAllInfo.draperyOrderDesign.draperyType) {
          case 'full-length':
            type = 1;
            break;
          case 'cafe-curtain':
            type = 2;
            break;
        }
      }

      if (draperyOrderAllInfo.draperyOrderDesign.headingType === 'ripplefold') {
        type = 3;
      }

      if (this.state.orderType === 'roman-shade-order') {
        type = 4;
      }
    }

    // FE-3e: kick off the 4 follow-up fetches in parallel when flag is on.
    // Each pre-fired promise still self-times via `timedSearch`.
    // FE-4a: skip pre-firing entirely when we're using cached data.
    const useParallelInner = checkGate('perf_calc_parallel_open');
    const shouldFetch = !cachedBundle;
    const timedSearch = <T,>(phase: string, op: () => Promise<T>): Promise<T> => {
      const sw = startStopwatch();
      return op().finally(() => {
        logOpenPhase({ phase, duration_ms: sw.end(), ...phaseCtx });
      });
    };
    const designIdForFetch = draperyOrderAllInfo.draperyOrderDesignId;
    const summaryIdForFetch = draperyOrderAllInfo.draperyOrderSummaryId;
    const wsP =
      shouldFetch && useParallelInner
        ? timedSearch('workroom_setting', () => searchWorkroomSetting(accountId, type))
        : null;
    const linP =
      shouldFetch && useParallelInner && designIdForFetch !== undefined
        ? timedSearch('design_lining', () => searchDraperyOrderDesignLining(designIdForFetch))
        : null;
    const sumP =
      shouldFetch && useParallelInner && summaryIdForFetch
        ? timedSearch('summary_components', () =>
            searchDraperyOrderSummaryComponents(summaryIdForFetch)
          )
        : null;
    const embP =
      shouldFetch && useParallelInner && designIdForFetch !== undefined
        ? timedSearch('design_embellishments', () =>
            searchDraperyOrderDesignEmbellishments(designIdForFetch)
          )
        : null;

    const resWork = cachedBundle
      ? cachedBundle.resWork
      : await (wsP ??
          timedSearch('workroom_setting', () => searchWorkroomSetting(accountId, type)));
    let wsIndex = 0;
    if (resWork.length > 1) {
      if (type === 2) {
        wsIndex = resWork.findIndex((ws: any) => ws.name === 'Drapery | Cafe Curtain');
      } else if (type === 3) {
        wsIndex = resWork.findIndex((ws: any) => ws.name === 'Drapery | Ripplefold');
      }
    }
    // if (draperyOrderAllInfo.draperyOrderDesign && resWork[wsIndex]) {
    //   draperyOrderAllInfo.draperyOrderDesign.buckram = resWork[wsIndex].buckram;
    // }
    let draperyOrderLiningsList: DraperyOrderDesignLining[] = draperyLiningsList();
    // let isLiningSelected: boolean = false;
    let isEmbellishmentSelected: boolean = false;
    let liningResForCache: any = null;
    if (draperyOrderAllInfo.draperyOrderDesignId !== undefined) {
      const res = cachedBundle
        ? cachedBundle.liningRes
        : await (linP ??
            timedSearch('design_lining', () =>
              searchDraperyOrderDesignLining(draperyOrderAllInfo.draperyOrderDesignId!)
            ));
      liningResForCache = res;
      if (res) {
        this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
        if (res.error) {
          return;
        }
        draperyOrderLiningsList = res && res.length > 0 ? res : this.state.liningsList;
        draperyOrderLiningsList = mergeDraperyOrderLiningFabric({
          draperyOrderLiningsList,
          draperyOrderAllFabrics: draperyOrderAllInfo.draperyOrderFabrics,
          romanShadeJson:
            draperyOrderAllInfo &&
            draperyOrderAllInfo.draperyOrderDesign &&
            draperyOrderAllInfo.draperyOrderDesign.romanShadeJson
              ? draperyOrderAllInfo.draperyOrderDesign.romanShadeJson
              : {},
          orderType: this.state.orderType,
        });
      }
    }
    // for (const lining of draperyOrderLiningsList) {
    //     isLiningSelected = isLiningSelected || lining.active;
    // }

    let draperyOrderSummaryComponents: DraperyModule.DraperyOrderSummaryComponent[] = [];
    let summaryResForCache: any = null;
    if (draperyOrderAllInfo.draperyOrderSummaryId) {
      const res = cachedBundle
        ? cachedBundle.summaryRes
        : await (sumP ??
            timedSearch('summary_components', () =>
              searchDraperyOrderSummaryComponents(draperyOrderAllInfo.draperyOrderSummaryId)
            ));
      summaryResForCache = res;
      if (res) {
        this.processResponseErrors(res, 2, 'draperyOrderSummaryErrors');
        if (res.error) {
          return;
        }
        draperyOrderSummaryComponents = res;
      }
    }

    const embellishmentsList: EmbellishmentCheckInfo[] = defaultEmbellishmentsList();
    const bandings: DraperyOrderDesignEmbellishment[] = [];
    const cordings: DraperyOrderDesignEmbellishment[] = [];
    const flanges: DraperyOrderDesignEmbellishment[] = [];
    const trims: DraperyOrderDesignEmbellishment[] = [];
    const othersEmbellishments: DraperyOrderDesignEmbellishment[] = [];
    let embellishmentResForCache: any = null;
    if (draperyOrderAllInfo.draperyOrderDesignId !== undefined) {
      const res = cachedBundle
        ? cachedBundle.embellishmentRes
        : await (embP ??
            timedSearch('design_embellishments', () =>
              searchDraperyOrderDesignEmbellishments(draperyOrderAllInfo.draperyOrderDesignId!)
            ));
      embellishmentResForCache = res;
      if (res) {
        this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
        if (res.error) {
          return;
        }
      }
      const draperyOrderEmbellishmentList: DraperyOrderDesignEmbellishment[] = res || [];

      for (const embellishment of draperyOrderEmbellishmentList) {
        if (embellishment.type === 1) {
          addEmbellishment(
            bandings,
            embellishment,
            embellishmentsList[0],
            draperyOrderAllInfo.draperyOrderFabrics,
            draperyOrderSummaryComponents
          );
        }
        if (embellishment.type === 2) {
          addEmbellishment(
            cordings,
            embellishment,
            embellishmentsList[1],
            draperyOrderAllInfo.draperyOrderFabrics,
            draperyOrderSummaryComponents
          );
        }
        if (embellishment.type === 3) {
          addEmbellishment(
            flanges,
            embellishment,
            embellishmentsList[2],
            draperyOrderAllInfo.draperyOrderFabrics,
            draperyOrderSummaryComponents
          );
        }
        if (embellishment.type === 4) {
          addEmbellishment(
            trims,
            embellishment,
            embellishmentsList[3],
            draperyOrderAllInfo.draperyOrderFabrics,
            draperyOrderSummaryComponents
          );
        }
        if (embellishment.type === 5) {
          addEmbellishment(
            othersEmbellishments,
            embellishment,
            embellishmentsList[4],
            draperyOrderAllInfo.draperyOrderFabrics,
            draperyOrderSummaryComponents
          );
        }
      }

      if (!embellishmentsList[0].checked) {
        bandings.push(defaultBanding());
      }
      if (!embellishmentsList[1].checked) {
        cordings.push(defaultCording());
      }
      if (!embellishmentsList[2].checked) {
        flanges.push(defaultFlange());
      }
      if (!embellishmentsList[3].checked) {
        const check_case =
          this.state.orderType === 'roman-shade-order' &&
          (this.state.draperyOrder.id === 0 || this.state.draperyOrder.newRomanShade);
        trims.push(defaultTrim(check_case));
      }
      if (!embellishmentsList[4].checked) {
        othersEmbellishments.push(defaultOtherEmbellishment());
      }
    }
    for (const embellishmentInfo of embellishmentsList) {
      isEmbellishmentSelected = isEmbellishmentSelected || embellishmentInfo.checked;
    }

    const mainFabric = draperyOrderAllInfo.draperyOrderFabrics.find(
      (fab) => fab.name === 'MAIN FABRIC'
    );

    // console.log('this is my fabric', mainFabric);

    if (mainFabric) {
      const horizontalRepeat = Number(mainFabric?.values?.horizontalRepeat || 0);
      const verticalRepeat = Number(mainFabric?.values?.verticalRepeat || 0);
      const hasHorizontalRepeat = horizontalRepeat > 0;
      const hasAnyRepeat = hasHorizontalRepeat || verticalRepeat > 0;

      if (!hasHorizontalRepeat) {
        mainFabric.isPleatToPattern = false;
      }
      if (!hasAnyRepeat) {
        mainFabric.isMatchRepeatAtSeams = false;
      }
    }
    const headRail = draperyOrderAllInfo.draperyOrderFabrics.find((fab) => fab.name === 'HEADRAIL');

    const component = mainFabric
      ? draperyOrderSummaryComponents.find(
          (component) => component.draperyOrderFabricId === mainFabric.id
        )
      : undefined;

    const componentHeadrail = headRail
      ? draperyOrderSummaryComponents.find(
          (component) => component.draperyOrderFabricId === headRail.id
        )
      : undefined;

    const hardwareSummaryItemName =
      this.state.orderType === 'custom-order' ? 'PARTS & SUPPLIES' : 'HARDWARE';
    const componentHardware = draperyOrderSummaryComponents.find(
      (component) =>
        component.isStaticHardware &&
        (component.item === hardwareSummaryItemName ||
          (this.state.orderType === 'custom-order' && component.item === 'HARDWARE'))
    );
    const defaultHardwareForSummary = defaultHardware();

    let purchaserFromApi = draperyOrderAllInfo.draperyOrderHardware
      ? draperyOrderAllInfo.draperyOrderHardware.purchaser
      : undefined;
    const isNonePurchaser =
      this.state.orderType === 'drapery-order' &&
      draperyOrderAllInfo.id !== 0 &&
      (purchaserFromApi === undefined || purchaserFromApi === 0);

    if (isNonePurchaser) {
      purchaserFromApi = 3;
    }

    const defaultHardwareForOrderType = getDefaultHardwareForOrderType(this.state.orderType);
    let draperyOrderHardwareData = draperyOrderAllInfo.draperyOrderHardware
      ? {
          ...defaultHardwareForOrderType,
          ...draperyOrderAllInfo.draperyOrderHardware,
          purchaser: purchaserFromApi,
        }
      : defaultHardwareForOrderType;

    if (this.state.orderType === 'custom-order') {
      const otherItems = Array.isArray(draperyOrderHardwareData.otherItems)
        ? draperyOrderHardwareData.otherItems
        : [];
      if (otherItems.length === 0) {
        draperyOrderHardwareData = {
          ...draperyOrderHardwareData,
          otherItems: defaultHardwareForOrderType.otherItems,
        };
      }
      draperyOrderHardwareData = {
        ...draperyOrderHardwareData,
        rods: [],
      };
    }

    if (draperyOrderHardwareData.supplierId) {
      try {
        const supplierDetails = await getSupplier({
          supplierId: draperyOrderHardwareData.supplierId,
        });
        if (supplierDetails && supplierDetails.displayName) {
          draperyOrderHardwareData = {
            ...draperyOrderHardwareData,
            supplier: supplierDetails.displayName,
          };
        }
      } catch (error) {
        console.error(error);
      }
    }

    const headrailFromApi = draperyOrderAllInfo.draperyOrderHeadrail;
    const defaultHeadrail = defaultDraperyOrderHeadrail();
    let draperyOrderHeadrailData = headrailFromApi
      ? { ...defaultHeadrail, ...headrailFromApi }
      : defaultHeadrail;

    if (!Array.isArray(draperyOrderHeadrailData.otherItems)) {
      draperyOrderHeadrailData = {
        ...draperyOrderHeadrailData,
        otherItems: defaultHeadrail.otherItems,
      };
    }

    if (draperyOrderAllInfo.id !== 0) {
      draperyOrderHeadrailData = {
        ...draperyOrderHeadrailData,
        purchaser: headrailFromApi?.purchaser,
        receiver: headrailFromApi?.receiver,
      };
    }

    if (draperyOrderHeadrailData.supplierId) {
      try {
        const supplierDetails = await getSupplier({
          supplierId: draperyOrderHeadrailData.supplierId,
        });
        if (supplierDetails && supplierDetails.displayName) {
          draperyOrderHeadrailData = {
            ...draperyOrderHeadrailData,
            supplier: supplierDetails.displayName,
          };
        }
      } catch (error) {
        console.error(error);
      }
    }

    if (
      draperyOrderAllInfo.draperyOrderSummary &&
      draperyOrderAllInfo.draperyOrderSummary.notes === null
    )
      draperyOrderAllInfo.draperyOrderSummary.notes = '';

    const draperyOrderUploadsRest = draperyOrderAllInfo.draperyOrderUpload;
    if (draperyOrderUploadsRest) {
      draperyOrderUploadsRest.items = mapStoredUploadsToRemoteItems(draperyOrderUploadsRest.items);
    }

    const bandingsYardage = [...this.state.yardage.bandingsYardage];
    let cordingsPreMadeYardage = [...this.state.yardage.cordingsPreMadeYardage];
    let cordingsFabricYardage = [...this.state.yardage.cordingsFabricYardage];
    let flangesPreMadeYardage = [...this.state.yardage.flangesPreMadeYardage];
    let flangesFabricYardage = [...this.state.yardage.flangesFabricYardage];
    const trimsPreMadeYardage = [...this.state.yardage.trimsPreMadeYardage];
    const trimsFabricYardage = [...this.state.yardage.trimsFabricYardage];
    let otherEmbellishmentsYardage = [...this.state.yardage.otherEmbellishmentsYardage];
    let liningsYardage = [...this.state.yardage.liningsYardage];

    bandings.forEach((nextBanding, index) => {
      const currentBanding = this.state.bandings[index];
      if (
        (currentBanding &&
          currentBanding.draperyOrderFabric &&
          nextBanding.draperyOrderFabric &&
          nextBanding.draperyOrderFabric.yardsNeeded !== undefined &&
          nextBanding.draperyOrderFabric.yardsNeeded !== null &&
          currentBanding.draperyOrderFabric.yardsNeeded !==
            nextBanding.draperyOrderFabric.yardsNeeded &&
          this.state.workOrderEditMode) ||
        (!this.state.workOrderEditMode &&
          nextBanding.draperyOrderFabric &&
          nextBanding.draperyOrderFabric.yardsNeeded !== undefined &&
          nextBanding.draperyOrderFabric.yardsNeeded !== null)
      ) {
        bandingsYardage[index] = nextBanding.draperyOrderFabric.yardsNeeded.toString();
      }
    });

    trims
      .filter((item) => item.subType === 0)
      .forEach((nextTrim, index) => {
        const currentTrim = trims.filter((item) => item.subType === 0)[index];
        if (
          currentTrim &&
          currentTrim.draperyOrderFabric &&
          nextTrim.draperyOrderFabric &&
          nextTrim.draperyOrderFabric.yardsNeeded !== undefined &&
          nextTrim.draperyOrderFabric.yardsNeeded !== null
        ) {
          if (nextTrim.subType === 0) {
            trimsPreMadeYardage[index] = nextTrim.draperyOrderFabric.yardsNeeded.toString();
          }
        }
      });
    trims
      .filter((item) => item.subType === 1)
      .forEach((nextTrim, index) => {
        const currentTrim = trims.filter((item) => item.subType === 1)[index];
        if (
          currentTrim &&
          currentTrim.draperyOrderFabric &&
          nextTrim.draperyOrderFabric &&
          nextTrim.draperyOrderFabric.yardsNeeded !== undefined &&
          nextTrim.draperyOrderFabric.yardsNeeded !== null
        ) {
          if (nextTrim.subType === 1) {
            trimsFabricYardage[index] = nextTrim.draperyOrderFabric.yardsNeeded.toString();
          }
        }
      });

    cordings
      .filter((item) => item.subType === 0)
      .forEach((nextCording, index) => {
        const currentCording = cordings.filter((item) => item.subType === 0)[index];
        if (
          currentCording &&
          currentCording.draperyOrderFabric &&
          nextCording.draperyOrderFabric &&
          nextCording.draperyOrderFabric.yardsNeeded !== undefined &&
          nextCording.draperyOrderFabric.yardsNeeded !== null
        ) {
          if (nextCording.subType === 0) {
            cordingsPreMadeYardage[index] = nextCording.draperyOrderFabric.yardsNeeded.toString();
          }
        }
      });
    cordings
      .filter((item) => item.subType === 1)
      .forEach((nextCording, index) => {
        const currentCording = cordings.filter((item) => item.subType === 1)[index];
        if (
          currentCording &&
          currentCording.draperyOrderFabric &&
          nextCording.draperyOrderFabric &&
          nextCording.draperyOrderFabric.yardsNeeded !== undefined &&
          nextCording.draperyOrderFabric.yardsNeeded !== null
        ) {
          if (nextCording.subType === 1) {
            cordingsFabricYardage[index] = nextCording.draperyOrderFabric.yardsNeeded.toString();
          }
        }
      });
    flanges
      .filter((item) => item.subType === 0)
      .forEach((nextFlange, index) => {
        const currentFlange = flanges.filter((item) => item.subType === 0)[index];
        if (
          currentFlange &&
          currentFlange.draperyOrderFabric &&
          nextFlange.draperyOrderFabric &&
          nextFlange.draperyOrderFabric.yardsNeeded !== undefined &&
          nextFlange.draperyOrderFabric.yardsNeeded !== null
        ) {
          if (nextFlange.subType === 0) {
            flangesPreMadeYardage[index] = nextFlange.draperyOrderFabric.yardsNeeded.toString();
          }
        }
      });
    flanges
      .filter((item) => item.subType === 1)
      .forEach((nextFlange, index) => {
        const currentFlange = flanges.filter((item) => item.subType === 1)[index];
        if (
          currentFlange &&
          currentFlange.draperyOrderFabric &&
          nextFlange.draperyOrderFabric &&
          nextFlange.draperyOrderFabric.yardsNeeded !== undefined &&
          nextFlange.draperyOrderFabric.yardsNeeded !== null
        ) {
          if (nextFlange.subType === 1) {
            flangesFabricYardage[index] = nextFlange.draperyOrderFabric.yardsNeeded.toString();
          }
        }
      });

    draperyOrderLiningsList.forEach((nextLining: any, index: any) => {
      const currentLining = draperyOrderLiningsList[index];
      if (
        (currentLining &&
          currentLining.draperyOrderLiningsFabric &&
          nextLining.draperyOrderLiningsFabric &&
          nextLining.draperyOrderLiningsFabric.yardsNeeded !== undefined &&
          nextLining.draperyOrderLiningsFabric.yardsNeeded !== null &&
          this.state.workOrderEditMode) ||
        (!this.state.workOrderEditMode &&
          nextLining.draperyOrderLiningsFabric &&
          nextLining.draperyOrderLiningsFabric.yardsNeeded !== undefined &&
          nextLining.draperyOrderLiningsFabric.yardsNeeded !== null)
      ) {
        liningsYardage[index] = nextLining.draperyOrderLiningsFabric.yardsNeeded.toString();
      }
    });

    othersEmbellishments.forEach((nextOtherEmbellishmnet, index) => {
      const currentothersEmbellishment = othersEmbellishments[index];
      if (
        currentothersEmbellishment &&
        currentothersEmbellishment.draperyOrderFabric &&
        nextOtherEmbellishmnet.draperyOrderFabric &&
        nextOtherEmbellishmnet.draperyOrderFabric.yardsNeeded !== undefined &&
        nextOtherEmbellishmnet.draperyOrderFabric.yardsNeeded !== null
      ) {
        if (nextOtherEmbellishmnet) {
          otherEmbellishmentsYardage[index] =
            nextOtherEmbellishmnet.draperyOrderFabric.yardsNeeded.toString();
        }
      }
    });

    // client additional price adjustment
    const client_details = this.state.client?.billToParent
      ? this.state.client?.billingDetails
      : this.state.client?.billingDetailsDirectly;
    const client_details_additional_type = client_details?.additionalPriceAdjustment || 'none';
    const client_details_additional_price = client_details?.additionalPriceAdjustmentValue || '0';
    // ------------------------------------

    if (draperyOrderAllInfo?.draperyOrderDesign?.drawingBgIdentifier) {
      this.drawingBgIdentifier = draperyOrderAllInfo?.draperyOrderDesign?.drawingBgIdentifier || '';
    }

    this.setState(
      (state) => {
        const bundleConfigJsonFromOrder = draperyOrderAllInfo.bundleConfigJson;
        const bundleConfigJson =
          bundleConfigJsonFromOrder !== undefined && bundleConfigJsonFromOrder !== null
            ? bundleConfigJsonFromOrder
            : state.orderType === 'roman-shade-order' &&
                state.romanShadeItemDetails &&
                state.romanShadeItemDetails.length > 0
              ? normalizeBundleSelections(state.romanShadeItemDetails[0].bundleSelections)
              : state.orderType !== 'roman-shade-order' &&
                  state.draperyItemDetail &&
                  state.draperyItemDetail.length > 0
                ? normalizeBundleSelections(state.draperyItemDetail[0].bundleSelections)
                : null;

        return {
          ...state,
          yardage: {
            mainFabricYardage: mainFabric ? mainFabric.yardsNeeded : '',
            trimsPreMadeYardage,
            trimsFabricYardage,
            cordingsPreMadeYardage,
            cordingsFabricYardage,
            flangesPreMadeYardage,
            flangesFabricYardage,
            liningsYardage,
            bandingsYardage,
            otherEmbellishmentsYardage,
          },
          draperyOrder: {
            id: draperyOrderAllInfo.id,
            clientId: draperyOrderAllInfo.clientId,
            clientName: reset
              ? state.copyState.draperyOrder && state.copyState.draperyOrder.clientName
              : state.client
                ? state.client.displayName
                : '',
            editable: draperyOrderAllInfo.editable && !draperyOrderAllInfo.archived,
            draperyOrderDesignId: draperyOrderAllInfo.draperyOrderDesignId,
            draperyOrderUploadId: draperyOrderAllInfo.draperyOrderUploadId,
            draperyOrderHardwareId: draperyOrderAllInfo.draperyOrderHardwareId,
            draperyOrderHeadrailId: draperyOrderAllInfo.draperyOrderHeadrailId,
            draperyOrderSummaryId: draperyOrderAllInfo.draperyOrderSummaryId,
            bundleConfigJson,
            roomId: draperyOrderAllInfo.roomId,
            customRoom: draperyOrderAllInfo.customRoom,
            workOrderId: draperyOrderAllInfo.workOrderId,
            relatedWorkOrderIds: draperyOrderAllInfo.relatedWorkOrders.map(
              (workOrder) => workOrder.id
            ),
            window: draperyOrderAllInfo.window,
            related: draperyOrderAllInfo.related,
            quantity: draperyOrderAllInfo.quantity,
            hasRelatedWorkOrders: draperyOrderAllInfo.hasRelatedWorkOrders,
            isReturnLeftoverMaterials: draperyOrderAllInfo.isReturnLeftoverMaterials,
            status: draperyOrderAllInfo.status,
            userConfirmation: draperyOrderAllInfo.userConfirmation,
            archived: draperyOrderAllInfo.archived,
            roomName: draperyOrderAllInfo.room ? draperyOrderAllInfo.room.name : '',
            itemTypeId: draperyOrderAllInfo.itemTypeId,
            itemTypeName: draperyOrderAllInfo.itemType ? draperyOrderAllInfo.itemType.name : '',
            isDraft: draperyOrderAllInfo.isDraft,
            itemType: draperyOrderAllInfo.itemType,
            locationId: draperyOrderAllInfo.locationId,
            newRomanShade: draperyOrderAllInfo.newRomanShade,
            createdAt: draperyOrderAllInfo.createdAt,
            qbEstimateId: draperyOrderAllInfo.qbEstimateId,
            qbEstimateNumber: draperyOrderAllInfo.qbEstimateNumber,
            qbExportedAt: draperyOrderAllInfo.qbExportedAt,
            estimateStatus: draperyOrderAllInfo.estimateStatus,
            estimateDate: draperyOrderAllInfo.estimateDate,
            estimateDateSent: draperyOrderAllInfo.estimateDateSent,
            estimateId: draperyOrderAllInfo.estimateId,
            estimateNumber: draperyOrderAllInfo.estimateNumber,
            estimateStatusSummary: draperyOrderAllInfo.estimateStatusSummary,
            notebook: Array.isArray(draperyOrderAllInfo.notebook)
              ? draperyOrderAllInfo.notebook
              : [],
          },
          draperyOrderFees: draperyOrderAllInfo.draperyOrderFees || [],
          checkedAllowExtraWidthOne:
            !!draperyOrderAllInfo.userConfirmation.allowExtraWideMainFabric,
          checkedAllowExtraWidthTwo:
            !!draperyOrderAllInfo.userConfirmation.allowExtraWideMainFabric,
          draperyOrderUploads: draperyOrderUploadsRest || {
            id: 0,
            items: [],
          },
          draperyOrderHardware: draperyOrderHardwareData,
          draperyOrderHeadrail: draperyOrderHeadrailData,
          draperyOrderDesign: draperyOrderAllInfo.draperyOrderDesign || defaultDraperyOrderDesign(),
          liningsList: draperyOrderLiningsList,
          isNoneLinings:
            draperyOrderAllInfo.draperyOrderDesign &&
            draperyOrderAllInfo.draperyOrderDesign.isNoneLinings,
          bandings,
          cordings,
          flanges,
          trims,
          othersEmbellishments,
          embellishmentsList,
          isNoneEmbellishment:
            draperyOrderAllInfo.draperyOrderDesign &&
            draperyOrderAllInfo.draperyOrderDesign.isNoneEmbellishment,
          mainFabric: mainFabric
            ? filterMainFabric(
                mainFabric,
                component || defaultDraperyOrderSummaryComponent(mainFabric.name)
              )
            : defaultMainFabric(),
          headRail: headRail
            ? filterHeadRail(
                headRail,
                componentHeadrail || defaultHeadRailSummaryComponent(headRail.name)
              )
            : defaultHeadRail(),
          hardware: componentHardware
            ? {
                draperyOrderSummaryComponent: {
                  ...componentHardware,
                  item: hardwareSummaryItemName,
                },
              }
            : {
                ...defaultHardwareForSummary,
                draperyOrderSummaryComponent: {
                  ...defaultHardwareForSummary.draperyOrderSummaryComponent,
                  item: hardwareSummaryItemName,
                },
              },
          draperyOrderSummary: draperyOrderAllInfo.draperyOrderSummary
            ? {
                ...draperyOrderAllInfo.draperyOrderSummary,
                productionJson: {
                  ...draperyOrderAllInfo.draperyOrderSummary.productionJson,
                  dueDate:
                    this.state.draperyOrderSummary.productionJson.dueDate !== undefined
                      ? this.state.draperyOrderSummary.productionJson.dueDate
                      : draperyOrderAllInfo.draperyOrderSummary.productionJson.dueDate,
                },
              }
            : defaultDraperyOrderSummary(),
          draperyOrderSummaryComponents: draperyOrderSummaryComponents.filter(
            (component) =>
              !component.draperyOrderFabricId &&
              !(
                component.isStaticHardware === true &&
                ['HARDWARE', 'PARTS & SUPPLIES'].includes(component.item)
              )
          ),
          workOrder: draperyOrderAllInfo.workOrder || defaultWorkOrder(accountId),
          draperyOrderPriceId: draperyOrderAllInfo.draperyOrderPriceId,
          workroomSetting: resWork[wsIndex],
          copyState: {
            ...state.copyState,
            draperyOrder: {
              customRoom: draperyOrderAllInfo.customRoom,
              id: draperyOrderAllInfo.id,
              clientId: draperyOrderAllInfo.clientId,
              clientName: reset
                ? state.copyState.draperyOrder && state.copyState.draperyOrder.clientName
                : state.client
                  ? state.client.displayName
                  : '',
              editable: draperyOrderAllInfo.editable && !draperyOrderAllInfo.archived,
              draperyOrderDesignId: draperyOrderAllInfo.draperyOrderDesignId,
              draperyOrderUploadId: draperyOrderAllInfo.draperyOrderUploadId,
              draperyOrderHardwareId: draperyOrderAllInfo.draperyOrderHardwareId,
              draperyOrderHeadrailId: draperyOrderAllInfo.draperyOrderHeadrailId,
              draperyOrderSummaryId: draperyOrderAllInfo.draperyOrderSummaryId,
              roomId: draperyOrderAllInfo.roomId,
              workOrderId: draperyOrderAllInfo.workOrderId,
              relatedWorkOrderIds: draperyOrderAllInfo.relatedWorkOrders.map(
                (workOrder) => workOrder.id
              ),
              window: draperyOrderAllInfo.window,
              related: draperyOrderAllInfo.related,
              quantity: draperyOrderAllInfo.quantity,
              hasRelatedWorkOrders: draperyOrderAllInfo.hasRelatedWorkOrders,
              isReturnLeftoverMaterials: draperyOrderAllInfo.isReturnLeftoverMaterials,
              status: draperyOrderAllInfo.status,
              userConfirmation: draperyOrderAllInfo.userConfirmation,
              archived: draperyOrderAllInfo.archived,
              roomName: draperyOrderAllInfo.room ? draperyOrderAllInfo.room.name : '',
              itemTypeId: draperyOrderAllInfo.itemTypeId,
              itemTypeName: draperyOrderAllInfo.itemType ? draperyOrderAllInfo.itemType.name : '',
              isDraft: draperyOrderAllInfo.isDraft,
              itemType: draperyOrderAllInfo.itemType,
              locationId: draperyOrderAllInfo.locationId,
              newRomanShade: draperyOrderAllInfo.newRomanShade,
              notebook: Array.isArray(draperyOrderAllInfo.notebook)
                ? draperyOrderAllInfo.notebook
                : [],
            },
            draperyOrderUploads: draperyOrderUploadsRest || {
              id: 0,
              items: [],
            },
            draperyOrderHardware: draperyOrderHardwareData,
            draperyOrderHeadrail: draperyOrderHeadrailData,
            draperyOrderDesign:
              draperyOrderAllInfo.draperyOrderDesign || defaultDraperyOrderDesign(),
            liningsList: draperyOrderLiningsList,
            isNoneLinings:
              draperyOrderAllInfo.draperyOrderDesign &&
              draperyOrderAllInfo.draperyOrderDesign.isNoneLinings,
            bandings,
            cordings,
            flanges,
            trims,
            othersEmbellishments,
            embellishmentsList,
            isNoneEmbellishment:
              draperyOrderAllInfo.draperyOrderDesign &&
              draperyOrderAllInfo.draperyOrderDesign.isNoneEmbellishment,
            mainFabric: mainFabric
              ? filterMainFabric(
                  mainFabric,
                  component || defaultDraperyOrderSummaryComponent(mainFabric.name)
                )
              : defaultMainFabric(),
            draperyOrderSummary: draperyOrderAllInfo.draperyOrderSummary
              ? {
                  ...draperyOrderAllInfo.draperyOrderSummary,
                  productionJson: {
                    ...draperyOrderAllInfo.draperyOrderSummary.productionJson,
                    dueDate:
                      this.state.draperyOrderSummary.productionJson.dueDate !== undefined
                        ? this.state.draperyOrderSummary.productionJson.dueDate
                        : draperyOrderAllInfo.draperyOrderSummary.productionJson.dueDate,
                  },
                }
              : defaultDraperyOrderSummary(),
            draperyOrderSummaryComponents: draperyOrderSummaryComponents.filter(
              (component) => !component.draperyOrderFabricId
            ),
            workOrder: draperyOrderAllInfo.workOrder || defaultWorkOrder(accountId),
            draperyOrderPriceId: draperyOrderAllInfo.draperyOrderPriceId,
            workroomSetting: resWork[wsIndex],
          },
          // isLoading: false,
          stateObj: _.cloneDeep({
            ...state.stateObj,
            draperyOrder: {
              customRoom: draperyOrderAllInfo.customRoom,
              id: draperyOrderAllInfo.id,
              clientId: draperyOrderAllInfo.clientId,
              clientName: reset
                ? state.copyState.draperyOrder && state.copyState.draperyOrder.clientName
                : state.client
                  ? state.client.displayName
                  : '',
              editable: draperyOrderAllInfo.editable && !draperyOrderAllInfo.archived,
              draperyOrderDesignId: draperyOrderAllInfo.draperyOrderDesignId,
              draperyOrderUploadId: draperyOrderAllInfo.draperyOrderUploadId,
              draperyOrderHardwareId: draperyOrderAllInfo.draperyOrderHardwareId,
              draperyOrderHeadrailId: draperyOrderAllInfo.draperyOrderHeadrailId,
              draperyOrderSummaryId: draperyOrderAllInfo.draperyOrderSummaryId,
              roomId: draperyOrderAllInfo.roomId,
              workOrderId: draperyOrderAllInfo.workOrderId,
              relatedWorkOrderIds: draperyOrderAllInfo.relatedWorkOrders.map(
                (workOrder) => workOrder.id
              ),
              window: draperyOrderAllInfo.window,
              related: draperyOrderAllInfo.related,
              quantity: draperyOrderAllInfo.quantity,
              hasRelatedWorkOrders: draperyOrderAllInfo.hasRelatedWorkOrders,
              isReturnLeftoverMaterials: draperyOrderAllInfo.isReturnLeftoverMaterials,
              status: draperyOrderAllInfo.status,
              userConfirmation: draperyOrderAllInfo.userConfirmation,
              archived: draperyOrderAllInfo.archived,
              roomName: draperyOrderAllInfo.room ? draperyOrderAllInfo.room.name : '',
              itemTypeId: draperyOrderAllInfo.itemTypeId,
              itemTypeName: draperyOrderAllInfo.itemType ? draperyOrderAllInfo.itemType.name : '',
              isDraft: draperyOrderAllInfo.isDraft,
              itemType: draperyOrderAllInfo.itemType,
              locationId: draperyOrderAllInfo.locationId,
              newRomanShade: draperyOrderAllInfo.newRomanShade,
              notebook: Array.isArray(draperyOrderAllInfo.notebook)
                ? draperyOrderAllInfo.notebook
                : [],
            },
            draperyOrderUploads: draperyOrderUploadsRest || {
              id: 0,
              items: [],
            },
            draperyOrderHardware: draperyOrderHardwareData,
            draperyOrderHeadrail: draperyOrderHeadrailData,
            draperyOrderDesign:
              draperyOrderAllInfo.draperyOrderDesign || defaultDraperyOrderDesign(),
            liningsList: draperyOrderLiningsList,
            isNoneLinings:
              draperyOrderAllInfo.draperyOrderDesign &&
              draperyOrderAllInfo.draperyOrderDesign.isNoneLinings,
            bandings,
            cordings,
            flanges,
            trims,
            othersEmbellishments,
            embellishmentsList,
            isNoneEmbellishment:
              draperyOrderAllInfo.draperyOrderDesign &&
              draperyOrderAllInfo.draperyOrderDesign.isNoneEmbellishment,
            mainFabric: mainFabric
              ? filterMainFabric(
                  mainFabric,
                  component || defaultDraperyOrderSummaryComponent(mainFabric.name)
                )
              : defaultMainFabric(),
            draperyOrderSummary: draperyOrderAllInfo.draperyOrderSummary
              ? {
                  ...draperyOrderAllInfo.draperyOrderSummary,
                  productionJson: {
                    ...draperyOrderAllInfo.draperyOrderSummary.productionJson,
                    dueDate:
                      this.state.draperyOrderSummary.productionJson.dueDate !== undefined
                        ? this.state.draperyOrderSummary.productionJson.dueDate
                        : draperyOrderAllInfo.draperyOrderSummary.productionJson.dueDate,
                  },
                }
              : defaultDraperyOrderSummary(),
            draperyOrderSummaryComponents: draperyOrderSummaryComponents.filter(
              (component) => !component.draperyOrderFabricId
            ),
            workOrder: draperyOrderAllInfo.workOrder || defaultWorkOrder(accountId),
            draperyOrderPriceId: draperyOrderAllInfo.draperyOrderPriceId,
            workroomSetting: resWork[wsIndex],
          }),
        };
      },
      () => {
        // FE-4 section dirty tracking: capture the snapshot of "saved sections"
        // right after the load completes so subsequent saves can compare against
        // it.
        this.captureSavedSnapshot();
      }
    );
    // FE-4a: write the just-fetched bundle to the cache on success. We only do
    // this when we actually fetched (not when we hit the cache), so the cache
    // stays valid until invalidated by a save or its TTL expires.
    if (useOrderCache && !cachedBundle && this.state.draperyOrder.id) {
      setOrderCache(this.state.draperyOrder.id, {
        draperyOrderAllInfo,
        resWork,
        liningRes: liningResForCache,
        summaryRes: summaryResForCache,
        embellishmentRes: embellishmentResForCache,
      });
    }
    logOpenPhase({
      phase: 'get_existing_drapery_order',
      duration_ms: fnStopwatch.end(),
      ...phaseCtx,
    });
  }

  private handleDraperyOrderFeesChange = (
    draperyOrderFees: DraperyModule.DraperyOrderFee[]
  ): void => {
    this.setState({ draperyOrderFees });
  };

  private handleDraperyOrderFeesBundleChange = (
    draperyOrderFees: DraperyModule.DraperyOrderFee[]
  ): void => {
    this.setState(
      (state) => ({ ...state, draperyOrderFees }),
      () => {
        if (this.state.draperyOrder && this.state.draperyOrder.id) {
          this.saveDraperyOrderApi();
        }
      }
    );
  };

  @Bind()
  private handleShowNewBadgeTab(key: string): void {
    if (typeof window !== 'undefined') {
      const itemForCheck = window.localStorage.getItem(key);
      if (itemForCheck) {
        const parsedItem = JSON.parse(itemForCheck);
        const now = new Date();
        const checkCase = now.getTime() > parsedItem.expiry;
        this.setState((prev) => {
          return {
            ...prev,
            newTab: !checkCase,
          };
        });
        return;
      }
    }
  }

  @Bind()
  private async getRooms(clientId: number): Promise<void> {
    if (!clientId) {
      return;
    }

    const useCache = checkGate('perf_calc_client_room_cache');
    // Cache holds the RAW /room/getAll response so it can be shared with the
    // client page (which consumes the same shape). The calculator re-maps to
    // {key, label} for its select-list UI.
    const mapForCalculator = (rooms: any[]) =>
      rooms.map((room: any) => ({ key: room.id, label: room.name }));

    if (useCache) {
      const cachedRooms = getClientCacheRooms(clientId);
      if (cachedRooms) {
        this.setState((state) => ({ ...state, roomList: mapForCalculator(cachedRooms) }));
        return;
      }
    }

    const res = await getRooms(clientId, '');
    if (res.error) {
      return;
    }
    this.setState((state) => ({ ...state, roomList: mapForCalculator(res) }));
    if (useCache) {
      setClientCacheRooms(clientId, res);
    }
  }

  @Bind()
  private async getWorkOrderNumbers(): Promise<void> {
    const { accountId } = this.props;

    const res = await searchWorkOrders(accountId);
    if (res.error) {
      return;
    }
    this.setState((state) => ({
      ...state,
      workOrderList: res.payload,
    }));
  }

  @Bind()
  private async getClient(): Promise<void> {
    const clientId = this.state.draperyOrder.clientId;
    if (!clientId) {
      return;
    }

    const useCache = checkGate('perf_calc_client_room_cache');
    if (useCache) {
      const cachedClient = getClientCacheClient(clientId);
      if (cachedClient) {
        this.setState(
          (state) => ({ ...state, client: cachedClient }),
          () => {
            this.validateAll('update');
          }
        );
        return;
      }
    }

    const res = await getClientApi({ clientId });
    if (res.error) {
      return;
    }
    this.setState(
      (state) => ({
        ...state,
        client: res,
      }),
      () => {
        this.validateAll('update');
      }
    );
    if (useCache) {
      setClientCacheClient(clientId, res);
    }
  }

  @Bind()
  private async getFabricsItems({
    isReload = false,
    pathNameForModal,
    pathIdForModal,
  }: {
    isReload?: boolean;
    pathNameForModal?: string;
    pathIdForModal?: string;
  }): Promise<void> {
    const prevFabricPatternsItems = this.state.fabricsPatternItems
      ? [...this.state.fabricsPatternItems]
      : [];
    const newFabricsPatternsItems = await getAll({
      categoryId: CategoryIds.FabricsAndTrims,
      searchChildren: true,
      includeDetails: true,
    });
    this.setState({
      fabricsPatternItems: newFabricsPatternsItems,
    });

    //isReload is set to true, after a new fabric pattern item is added
    if (isReload) {
      //below helps select newly added item for the Pattern Name/# dropdown
      //and also sets defaults for that newly added pattern
      let selectedPattern = null;
      if (!prevFabricPatternsItems || !prevFabricPatternsItems.length) {
        selectedPattern = newFabricsPatternsItems[0];
      } else {
        let newFound = newFabricsPatternsItems.find(
          (newI) => !prevFabricPatternsItems.some((prevI) => prevI.id === newI.id)
        );

        if (newFound) {
          selectedPattern = newFound;
        }
      }
      if (
        pathNameForModal &&
        pathIdForModal &&
        selectedPattern &&
        !pathNameForModal.includes('mainFabric')
      ) {
        this.updateStateByName(pathIdForModal, selectedPattern.id);
        this.updateStateByName(pathNameForModal, selectedPattern.name);
        this.setDraperyOrderFabricPatternDefaults({
          patternId: selectedPattern.id,
          pathId: pathNameForModal,
        });
      } else if (selectedPattern && selectedPattern.id) {
        this.updateStateByName('mainFabric.patternId', selectedPattern.id);
        this.updateStateByName('mainFabric.pattern', selectedPattern.name);
        this.setFabricsPatternDefaults({
          patternId: selectedPattern.id,
        });
      }
    }
  }

  @Bind()
  private async getDraperyItems({
    isReload = false,
    showDraperyItemModal,
  }: {
    isReload?: boolean;
    pathIdForModal?: string;
    pathNameForModal?: string;
    showDraperyItemModal?: boolean;
  }): Promise<void> {
    try {
      const newDraperyItemDetail = await getAll({
        includeDetails: true,
      });
      const draperyItems = newDraperyItemDetail.filter((item) => item.name === 'Drapery');
      const romanShadeItems = newDraperyItemDetail.filter((item) => item.name === 'Roman Shade');
      if (showDraperyItemModal) {
        if (this.state.orderType === 'roman-shade-order') {
          this.handleShowRomanShadePricingModal(romanShadeItems);
        } else {
          this.handleShowModal(draperyItems);
        }
      }
      let other_item_details: any = draperyItems;
      const updatedDraperyItemDetail = [...other_item_details];
      const updatedRomanShadeItemDetail = [...romanShadeItems];

      const add_ons_with_pricing =
        updatedDraperyItemDetail &&
        updatedDraperyItemDetail.length > 0 &&
        updatedDraperyItemDetail[0] &&
        updatedDraperyItemDetail[0].addOnsWithPricing;

      let temp_drapery_order_add_ons =
        (this.state.draperyOrderDesign &&
          this.state.draperyOrderDesign.addOns && [...this.state.draperyOrderDesign.addOns]) ||
        [];

      let new_add_ons: any[] = [];
      if (
        temp_drapery_order_add_ons &&
        temp_drapery_order_add_ons.length > 0 &&
        add_ons_with_pricing &&
        add_ons_with_pricing.length > 0
      ) {
        new_add_ons = temp_drapery_order_add_ons.map((i) => {
          const found = add_ons_with_pricing.find((f: any) => f.id === i.id);
          if (found) {
            return {
              ...found,
              price: found.price,
            };
          }
          return i;
        });
      }

      this.setState((prev) => {
        const nextState = {
          draperyItemDetail: updatedDraperyItemDetail,
          romanShadeItemDetails: updatedRomanShadeItemDetail,
          draperyOrderDesign: {
            ...prev.draperyOrderDesign,
            addOns: new_add_ons,
          },
        };

        if (
          prev.orderType === 'roman-shade-order' &&
          (prev.draperyOrder.bundleConfigJson === null ||
            prev.draperyOrder.bundleConfigJson === undefined)
        ) {
          return {
            ...nextState,
            draperyOrder: {
              ...prev.draperyOrder,
              bundleConfigJson: normalizeBundleSelections(
                updatedRomanShadeItemDetail?.[0]?.bundleSelections
              ),
            },
          };
        } else if (
          prev.orderType !== 'roman-shade-order' &&
          (prev.draperyOrder.bundleConfigJson === null ||
            prev.draperyOrder.bundleConfigJson === undefined)
        ) {
          return {
            ...nextState,
            draperyOrder: {
              ...prev.draperyOrder,
              bundleConfigJson: normalizeBundleSelections(
                updatedDraperyItemDetail?.[0]?.bundleSelections
              ),
            },
          };
        }

        return nextState;
      });
    } catch (error) {
      console.error(error);
    }
  }

  @Bind()
  private handleShowModal(draperyItems: FormFields[]): void {
    if (Number(this.state.draperyOrder?.id || 0) > 0) {
      return;
    }

    const draperyItemDetailsKeys = [
      'pricingTypeId',
      'clientPricingAction',
      'clientPricingValue',
      'partialWidthRoundUpTypeId',
      'pleatTypesWithPricing',
      'liningAndInterliningWithPricing',
      'cafeCurtainsWidthInches',
      'cafeCurtainsWidthPricing',
      'extraLargePanelsLengthInches',
      'extraLargePanelsLengthPricing',
      'extraLargePanelsWidthInches',
      'extraLargePanelsWidthPricing',
      'draperyPinningWidthPricing',
      'specialityFabricsMarkUpPercentage',
      'embellishmentsWithPricing',
      'addOnsWithPricing',
      'salesDescriptionSettings',
      'orderingDescriptionSettings',
    ];
    if (!draperyItems[0]['isClientPricingActionOn']) {
      const index = draperyItemDetailsKeys.findIndex((key) => key === 'clientPricingValue');
      if (index >= 0) draperyItemDetailsKeys.splice(index, 1);
    }
    if (!draperyItems[0]['isPartialWidthRoundingOn']) {
      const index = draperyItemDetailsKeys.findIndex((key) => key === 'partialWidthRoundUpTypeId');
      if (index >= 0) draperyItemDetailsKeys.splice(index, 1);
    }
    for (const key of draperyItemDetailsKeys) {
      if (draperyItems[0] && draperyItems[0][key]) {
        if (Array.isArray(draperyItems[0][key])) {
          for (let i = 0; i < draperyItems[0][key].length; i++) {
            if (draperyItems[0][key][i] && draperyItems[0][key][i].price === '') {
              this.setState({ showDraperyItemModal: true });
              return;
            }
          }
        } else if (draperyItems[0][key] === '') {
          this.setState({ showDraperyItemModal: true });
          return;
        }
      } else {
        this.setState({ showDraperyItemModal: true });
        return;
      }
    }
  }

  @Bind()
  private handleShowRomanShadePricingModal(romanShadeItem: any): void {
    const pricingKeys = [
      'clientPricingValue',
      'pleatTypesWithPricing',
      'liningAndInterliningWithPricing',
      'valanceAndReturns',
      'embellishmentsWithPricing',
    ];

    for (const key of pricingKeys) {
      if (key === 'clientPricingValue' && !romanShadeItem?.[0]?.isClientPricingActionOn) {
        continue;
      }

      if (key === 'embellishmentsWithPricing') {
        if (Array.isArray(romanShadeItem[0][key])) {
          for (let i = 0; i < romanShadeItem[0][key].length; i++) {
            if (
              romanShadeItem[0][key][i] &&
              romanShadeItem[0][key][i].group &&
              romanShadeItem[0][key][i].group.name !== 'Trim from fabric' &&
              romanShadeItem[0][key][i].group.items &&
              romanShadeItem[0][key][i].group.items.length > 0
            ) {
              for (let j = 0; j < romanShadeItem[0][key][i].group.items.length; j++) {
                if (
                  romanShadeItem[0][key][i].group.items[j] &&
                  romanShadeItem[0][key][i].group.items[j].price === ''
                ) {
                  if (this.state.draperyOrder.newRomanShade || this.state.draperyOrder.id === 0) {
                    this.setState((prev) => {
                      return {
                        ...prev,
                        showRomanShadeItemModal: true,
                      };
                    });
                  }
                }
              }
            }
          }
        }
      } else if (romanShadeItem[0] && romanShadeItem[0][key]) {
        if (Array.isArray(romanShadeItem[0][key])) {
          for (let i = 0; i < romanShadeItem[0][key].length; i++) {
            if (romanShadeItem[0][key][i] && romanShadeItem[0][key][i].price === '') {
              if (this.state.draperyOrder.newRomanShade || this.state.draperyOrder.id === 0) {
                this.setState((prev) => {
                  return {
                    ...prev,
                    showRomanShadeItemModal: true,
                  };
                });
              }
            }
          }
        } else if (romanShadeItem[0][key] === '') {
          if (this.state.draperyOrder.newRomanShade || this.state.draperyOrder.id === 0) {
            this.setState((prev) => {
              return {
                ...prev,
                showRomanShadeItemModal: true,
              };
            });
          }
          return;
        }
      } else {
        if (this.state.draperyOrder.newRomanShade || this.state.draperyOrder.id === 0) {
          this.setState((prev) => {
            return {
              ...prev,
              showRomanShadeItemModal: true,
            };
          });
        }
      }
    }
  }

  @Bind()
  private async getLiningsItems({
    isReload = false,
    pathIdForModal,
    pathNameForModal,
  }: {
    isReload?: boolean;
    pathIdForModal?: string;
    pathNameForModal?: string;
  }): Promise<void> {
    const prevLiningPatternItems = this.state.liningsPatternItems
      ? [...this.state.liningsPatternItems]
      : [];

    const newLiningPatternItems = await getAll({
      categoryId: CategoryIds.Linings,
      searchChildren: true,
      includeDetails: true,
    });

    this.setState({
      liningsPatternItems: newLiningPatternItems,
    });

    //isReload is set to true, after a new lining pattern item is added
    if (isReload) {
      //below helps select newly added item for the Pattern Name/# dropdown
      //and also sets defaults for that newly added pattern
      let selectedPattern = null;
      if (!prevLiningPatternItems || !prevLiningPatternItems.length) {
        selectedPattern = newLiningPatternItems[0];
      } else {
        let newFound = newLiningPatternItems.find(
          (newI) => !prevLiningPatternItems.some((prevI) => prevI.id === newI.id)
        );

        if (newFound) {
          selectedPattern = newFound;
        }
      }
      if (selectedPattern && selectedPattern.id && pathIdForModal && pathNameForModal) {
        this.updateStateByName(pathIdForModal, selectedPattern.id);
        this.updateStateByName(pathNameForModal, selectedPattern.name);
        this.setLiningsPatternDefaults({
          patternId: selectedPattern.id,
          pathId: pathIdForModal,
        });
      }
    }
  }

  @Bind()
  private async handlePatternSelectAfterAdd() {
    const { pathIdForModal, pathNameForModal } = this.state;
    const isLiningPattern =
      pathIdForModal.includes('liningsList') || pathNameForModal.includes('liningsList');
    const isReload = true;
    //reload the list of items
    if (isLiningPattern) {
      await this.getLiningsItems({
        isReload,
        pathIdForModal,
        pathNameForModal,
      });
    } else {
      await this.getFabricsItems({
        isReload,
        pathIdForModal,
        pathNameForModal,
      });
      await this.getDraperyItems({
        isReload,
        showDraperyItemModal: false,
      });
    }
  }

  @Bind()
  private async getNextWorkOrderNum(): Promise<number> {
    const { accountId } = this.props;

    const res = await getNextNum(accountId);
    if (res.error) {
      return 0;
    } else {
      return res;
    }
  }

  private async saveRomanShadePricing(workroomSettings: any) {
    const { workOrderEditMode } = this.state;

    if (workOrderEditMode) {
      const payload = {
        ...this.state,
        draperyOrderUploads: null,
        stateObj: { ...this.state.stateObj, draperyOrderUploads: null },
        copyState: { ...this.state.copyState, draperyOrderUploads: null },
      };
      const updateRes = await updateRomanShadeOrderPricing(
        payload,
        workroomSettings,
        this.state.draperyOrderPriceId,
        this.state.client
      );
      if (!updateRes.error) {
        await editDraperyOrder({
          ...this.state.draperyOrder,
          workOrderId: this.state.workOrder.id,
          draperyOrderPriceId: updateRes.id,
        });
        this.setState((state) => ({
          ...state,
          draperyOrderPriceId: updateRes.id || 0,
          draperyOrderPriceRefreshKey: state.draperyOrderPriceRefreshKey + 1,
          loadingUpdate: false,
          isLoading: false,
          copyState: {
            ...state.copyState,
            draperyOrderPriceId: updateRes.id || 0,
          },
          stateObj: {
            ...state.stateObj,
            draperyOrderPriceId: updateRes.id || 0,
          },
        }));

        // trackView(MixpanelEvents.SAVE_ORDER, { orderId: this.state.draperyOrder.id, orderType: this.state.orderType, element: 'order_update' });
      }
    } else if (!this.state.draperyOrderPriceId) {
      const payload = {
        ...this.state,
        draperyOrderUploads: null,
        stateObj: { ...this.state.stateObj, draperyOrderUploads: null },
        copyState: { ...this.state.copyState, draperyOrderUploads: null },
      };
      const response = await addRomanShadeOrderPrice(payload, workroomSettings, this.state.client);
      if (!response.error) {
        await editDraperyOrder({
          ...this.state.draperyOrder,
          workOrderId: this.state.workOrder.id,
          draperyOrderPriceId: response.id,
        });

        // trackView(MixpanelEvents.SAVE_ORDER, { orderId: this.state.draperyOrder.id, orderType: this.state.orderType, element: 'order_update' });
        this.setState((state) => ({
          ...state,
          draperyOrderPriceId: response.id || 0,
          draperyOrderPriceRefreshKey: state.draperyOrderPriceRefreshKey + 1,
          isLoading: false,
          copyState: {
            ...state.copyState,
            draperyOrderPriceId: response.id || 0,
          },
          stateObj: {
            ...state.stateObj,
            draperyOrderPriceId: response.id || 0,
          },
        }));
      }
    } else if (this.state.isLoading) {
      setTimeout(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      }, 1500);
    }
  }

  @Bind()
  private changeIsLoading(isLoading: boolean) {
    this.setState((state) => ({
      ...state,
      isLoading,
    }));
  }

  private changeSummaryTabLoading = (summaryTabLoading: boolean) => {
    this.summaryTabLoadingRequests = summaryTabLoading
      ? this.summaryTabLoadingRequests + 1
      : Math.max(0, this.summaryTabLoadingRequests - 1);
    const nextSummaryTabLoading = this.summaryTabLoadingRequests > 0;

    this.setState((state) => {
      if (state.summaryTabLoading === nextSummaryTabLoading) {
        return null;
      }

      return {
        ...state,
        summaryTabLoading: nextSummaryTabLoading,
      };
    });
  };

  private async saveDraperyOrderPricing(
    workroomSettings: any,
    widthConfiguration: Array<number | undefined>
  ) {
    // const { dispatch } = this.props;
    const { workOrderEditMode } = this.state;
    const panelJson = {
      pannel1Width: widthConfiguration[0],
      pannel2Width: widthConfiguration[1],
      pannel3Width: widthConfiguration[2],
      pannel4Width: widthConfiguration[3],
      pannel5Width: widthConfiguration[4],
    };
    const category = this.state.draperyOrderDesign.category;
    const arg =
      category === 0
        ? {
            ...this.state,
            draperyOrderDesign: {
              ...this.state.draperyOrderDesign,
              panelJson,
            },
            draperyOrderUploads: null,
            stateObj: { ...this.state.stateObj, draperyOrderUploads: null },
            copyState: { ...this.state.copyState, draperyOrderUploads: null },
          }
        : {
            ...this.state,
            draperyOrderUploads: null,
            stateObj: { ...this.state.stateObj, draperyOrderUploads: null },
            copyState: { ...this.state.copyState, draperyOrderUploads: null },
          };

    if (workOrderEditMode) {
      const updateResponse = await updateDraperyOrderPrice(
        arg,
        workroomSettings,
        this.state.draperyOrderPriceId,
        this.state.client
      );

      if (!updateResponse.error) {
        await editDraperyOrder({
          ...this.state.draperyOrder,
          workOrderId: this.state.workOrder.id,
          draperyOrderPriceId: updateResponse.id,
        });
        this.setState((state) => ({
          ...state,
          draperyOrderPriceId: updateResponse.id || 0,
          draperyOrderPriceRefreshKey: state.draperyOrderPriceRefreshKey + 1,
          loadingUpdate: false,
          isLoading: false,
          copyState: {
            ...state.copyState,
            draperyOrderPriceId: updateResponse.id || 0,
          },
          stateObj: {
            ...state.stateObj,
            draperyOrderPriceId: updateResponse.id || 0,
          },
        }));

        // trackView(MixpanelEvents.SAVE_ORDER, { orderId: this.state.draperyOrder.id, orderType: this.state.orderType, element: 'order_update' });
      }
    } else if (!this.state.draperyOrderPriceId) {
      const response = await addDraperyOrderPrice(arg, workroomSettings, this.state.client);
      if (!response.error) {
        await editDraperyOrder({
          ...this.state.draperyOrder,
          workOrderId: this.state.workOrder.id,
          draperyOrderPriceId: response.id,
        });

        // trackView(MixpanelEvents.SAVE_ORDER, { orderId: this.state.draperyOrder.id, orderType: this.state.orderType, element: 'order_update' });

        this.setState((state) => ({
          ...state,
          draperyOrderPriceId: response.id || 0,
          draperyOrderPriceRefreshKey: state.draperyOrderPriceRefreshKey + 1,
          isLoading: false,
          copyState: {
            ...state.copyState,
            draperyOrderPriceId: response.id || 0,
          },
          stateObj: {
            ...state.stateObj,
            draperyOrderPriceId: response.id || 0,
          },
        }));
      }
    } else if (this.state.isLoading) {
      setTimeout(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      }, 1500);
    }
  }
  @Bind()
  private async fetchEmbellishment(embelishment: any): Promise<any> {
    const cordingsList = await Promise.all(
      embelishment.map(async (emb: any) => {
        if (emb.draperyOrderFabric && emb.draperyOrderFabric.itemId) {
          return getFabricsOrLiningsRecord({
            recordId: emb.draperyOrderFabric.itemId,
            draperyOrderFabricId: emb.draperyOrderFabric.id,
          });
        }
        if (emb.draperyOrderLiningsFabric && emb.draperyOrderLiningsFabric.itemId) {
          return getFabricsOrLiningsRecord({
            recordId: emb.draperyOrderLiningsFabric.itemId,
            draperyOrderFabricId: emb.draperyOrderLiningsFabric.id,
          });
        }
      })
    );
    return cordingsList;
  }
  @Bind()
  private async fetchEmbellishmentMain(embelishment: any): Promise<any> {
    const mainFabric = await Promise.all(
      embelishment.map(async (emb: any) => {
        if (emb && emb.itemId) {
          return getFabricsOrLiningsRecord({
            recordId: emb.itemId,
            draperyOrderFabricId: emb.id,
          });
        }
      })
    );

    return mainFabric;
  }
  @Bind()
  private async fetchEmbellishmentHeadRail(embelishment: any): Promise<any> {
    const headRailFabric = await Promise.all(
      embelishment.map(async (emb: any) => {
        if (emb && emb.itemId) {
          return getFabricsOrLiningsRecord({
            recordId: emb.itemId,
            draperyOrderFabricId: emb.id,
          });
        }
      })
    );

    return headRailFabric;
  }

  @Bind()
  private async handleDuplicateRomanShadeOrder(): Promise<void> {
    const { accountId } = this.props;
    const can_create_order = await userCanCreateNewOrder(accountId);
    if (
      !can_create_order &&
      this.state.remainingItemOrder === 0 &&
      this.state.orderType !== 'custom-order'
    ) {
      this.props.handleOpenSubscriptionPlanModal();
      return;
    }

    let { draperyOrder, isChanged } = this.state;
    if (!draperyOrder.id) {
      draperyOrder = {
        ...draperyOrder,
      };
      this.setState({ draperyOrder });
    }

    let draperyOrderAllInfo: DraperyModule.DraperyOrderAllInfo =
      {} as DraperyModule.DraperyOrderAllInfo;
    let draperyOrderLiningsList: DraperyOrderDesignLining[];

    if (draperyOrder && draperyOrder.id) {
      const res = await getAllInfo(draperyOrder.id);
      this.processResponseErrors(res, -1, 'draperyOrderErrors');
      if (res.error) {
        return;
      }
      draperyOrderAllInfo = res;
      draperyOrderLiningsList = draperyLiningsList();
    }

    if (draperyOrderAllInfo.draperyOrderDesignId !== undefined) {
      const res = await searchDraperyOrderDesignLining(draperyOrderAllInfo.draperyOrderDesignId);
      this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
      if (res.error) {
        return;
      }
      draperyOrderLiningsList = res;
      draperyOrderLiningsList = mergeDraperyOrderLiningFabric({
        draperyOrderLiningsList,
        draperyOrderAllFabrics: draperyOrderAllInfo.draperyOrderFabrics,
        romanShadeJson:
          draperyOrderAllInfo &&
          draperyOrderAllInfo.draperyOrderDesign &&
          draperyOrderAllInfo.draperyOrderDesign.romanShadeJson
            ? draperyOrderAllInfo.draperyOrderDesign.romanShadeJson
            : {},
        orderType: this.state.orderType,
      });
    }
    let draperyOrderSummaryComponents: DraperyModule.DraperyOrderSummaryComponent[] = [];
    if (draperyOrderAllInfo.draperyOrderSummaryId) {
      const res = await searchDraperyOrderSummaryComponents(
        draperyOrderAllInfo.draperyOrderSummaryId
      );
      this.processResponseErrors(res, 2, 'draperyOrderSummaryErrors');
      if (res.error) {
        return;
      }
      draperyOrderSummaryComponents = res;
    }
    let mainFabricObj: any = {};
    let headRailObj: any = {};
    let trimsObj: any = {};
    let liningsObj: any = {};
    let othersEmbellishmentsObj: any = {};
    mainFabricObj = await this.fetchEmbellishmentMain([this.state.mainFabric]);
    headRailObj = await this.fetchEmbellishmentHeadRail([this.state.headRail]);
    trimsObj = await this.fetchEmbellishment(this.state.trims);
    liningsObj = await this.fetchEmbellishment(this.state.liningsList);
    othersEmbellishmentsObj = await this.fetchEmbellishment(this.state.othersEmbellishments);
    const embellishmentsList: EmbellishmentCheckInfo[] = defaultEmbellishmentsList();
    const trims: DraperyOrderDesignEmbellishment[] = [];
    const othersEmbellishments: DraperyOrderDesignEmbellishment[] = [];
    let newTrims: any;
    let newLinings: any;
    let newOtherEmbellishment: any;
    let mainNew: any = {};
    let headRailNew: any = {};
    let supplierName;
    const check_case =
      this.state.orderType === 'roman-shade-order' &&
      (this.state.draperyOrder.id === 0 || this.state.draperyOrder.newRomanShade);
    if (draperyOrderAllInfo.draperyOrderDesignId !== undefined) {
      const res = await searchDraperyOrderDesignEmbellishments(
        draperyOrderAllInfo.draperyOrderDesignId
      );
      this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
      if (res.error) {
        return;
      }
      const draperyOrderEmbellishmentList: DraperyOrderDesignEmbellishment[] = res;
      for (const embellishment of draperyOrderEmbellishmentList) {
        if (embellishment.type === 4) {
          addEmbellishment(
            trims,
            embellishment,
            embellishmentsList[3],
            draperyOrderAllInfo.draperyOrderFabrics,
            draperyOrderSummaryComponents
          );
        }
        if (embellishment.type === 5) {
          addEmbellishment(
            othersEmbellishments,
            embellishment,
            embellishmentsList[4],
            draperyOrderAllInfo.draperyOrderFabrics,
            draperyOrderSummaryComponents
          );
        }
      }
      newTrims =
        this.state.trims &&
        this.state.trims.map((trim, index) => {
          let trimsNew = {};
          if (trim.draperyOrderFabric && trim.draperyOrderFabric.itemId) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: trimsObj[index].supplierId,
              nameField: 'displayName',
            });
            trimsNew = {
              ...trim,
              draperyOrderFabric: {
                ...trim.draperyOrderFabric,
                itemId: trimsObj[index].itemId,
                supplierId: trimsObj[index].supplierId,
                supplierName,
                patternId: trimsObj[index].patternId,
                pattern: trimsObj[index].name,
                imageId: trimsObj[index].avatarId,
                values: {
                  fabricWidth: trimsObj[index].fabricWidthInches,
                  verticalRepeat: trimsObj[index].verticalRepeatInches,
                  horizontalRepeat: trimsObj[index].horizontalRepeatInches,
                },
                isDropRepeat: trimsObj[index].isDropRepeatOn,
                isSpecialtyFabricHandling: trimsObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
                name: 'TRIM (PRE-MADE) ',
                type: 8,
              },
              subType: 0,
            };
          } else if (trim.draperyOrderFabric) {
            trimsNew = {
              ...trim,
              draperyOrderFabric: {
                ...trim.draperyOrderFabric,
                yardsNeeded: null,
              },
              subType: 0,
            };
          } else {
            trimsNew = defaultEmbellishment('trims', check_case)!;
          }
          return trimsNew;
        });
      newOtherEmbellishment =
        this.state.othersEmbellishments && this.state.othersEmbellishments.length > 0
          ? this.state.othersEmbellishments.map((othersEmbellishments, index) => {
              let otherEmbellismentsNew = {};
              if (
                othersEmbellishments.draperyOrderFabric &&
                othersEmbellishments.draperyOrderFabric.itemId
              ) {
                supplierName = getSelectedName({
                  list: this.state.suppliers as [],
                  findByKey: 'id',
                  findValue: othersEmbellishmentsObj[index].supplierId,
                  nameField: 'displayName',
                });
                otherEmbellismentsNew = {
                  ...othersEmbellishments,
                  draperyOrderFabric: {
                    ...othersEmbellishments.draperyOrderFabric,
                    itemId: othersEmbellishmentsObj[index].itemId,
                    supplierId: othersEmbellishmentsObj[index].supplierId,
                    supplierName,
                    patternId: othersEmbellishmentsObj[index].patternId,
                    pattern: othersEmbellishmentsObj[index].name,
                    imageId: othersEmbellishmentsObj[index].avatarId,
                    values: {
                      fabricWidth: othersEmbellishmentsObj[index].fabricWidthInches,
                      verticalRepeat: othersEmbellishmentsObj[index].verticalRepeatInches,
                      horizontalRepeat: othersEmbellishmentsObj[index].horizontalRepeatInches,
                    },
                    isDropRepeat: othersEmbellishmentsObj[index].isDropRepeatOn,
                    isSpecialtyFabricHandling:
                      othersEmbellishmentsObj[index].isSpecialtyFabricHandlingOn,
                    customSupplier: '',
                    yardsNeeded: null,
                  },
                };
              } else if (othersEmbellishments.draperyOrderFabric) {
                otherEmbellismentsNew = {
                  ...othersEmbellishments,
                  draperyOrderFabric: {
                    ...othersEmbellishments.draperyOrderFabric,
                    yardsNeeded: null,
                  },
                };
              } else {
                otherEmbellismentsNew = defaultEmbellishment('othersEmbellishments')!;
              }
              return otherEmbellismentsNew;
            })
          : [defaultEmbellishment('othersEmbellishments')!];
      newLinings =
        this.state.liningsList &&
        this.state.liningsList.map((lining, index) => {
          let liningsNew = {};
          if (lining.draperyOrderLiningsFabric && lining.draperyOrderLiningsFabric.itemId) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: liningsObj[index].supplierId,
              nameField: 'displayName',
            });
            liningsNew = {
              ...lining,
              id: 0,
              draperyOrderDesignId: 0,
              draperyOrderLiningsFabric: {
                ...lining.draperyOrderLiningsFabric,
                id: 0,
                itemId: liningsObj[index].itemId,
                supplierId: liningsObj[index].supplierId,
                supplierName,
                patternId: liningsObj[index].patternId,
                pattern: liningsObj[index].name,
                imageId: liningsObj[index].avatarId,
                values: {
                  fabricWidth: liningsObj[index].fabricWidthInches,
                  verticalRepeat: liningsObj[index].verticalRepeatInches,
                  horizontalRepeat: liningsObj[index].horizontalRepeat,
                },
                isSpecialtyFabricHandling: liningsObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
              },
            };
          } else if (lining.draperyOrderLiningsFabric) {
            liningsNew = {
              ...lining,
              id: 0,
              draperyOrderDesignId: 0,
              draperyOrderLiningsFabric: {
                ...lining.draperyOrderLiningsFabric,
                id: 0,
                yardsNeeded: null,
              },
            };
          } else {
            liningsNew = {
              ...lining,
              id: 0,
              draperyOrderDesignId: 0,
            };
          }
          return liningsNew;
        });
    } else {
      newTrims =
        this.state.trims &&
        this.state.trims.map((trim, index) => {
          let trimsNew = {};
          if (trim.draperyOrderFabric && trim.draperyOrderFabric.itemId) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: trimsObj[index].supplierId,
              nameField: 'displayName',
            });
            trimsNew = {
              ...trim,
              draperyOrderFabric: {
                ...trim.draperyOrderFabric,
                itemId: trimsObj[index].itemId,
                supplierId: trimsObj[index].supplierId,
                supplierName,
                patternId: trimsObj[index].patternId,
                pattern: trimsObj[index].name,
                imageId: trimsObj[index].avatarId,
                values: {
                  fabricWidth: trimsObj[index].fabricWidthInches,
                  verticalRepeat: trimsObj[index].verticalRepeatInches,
                  horizontalRepeat: trimsObj[index].horizontalRepeatInches,
                },
                isDropRepeat: trimsObj[index].isDropRepeatOn,
                isSpecialtyFabricHandling: trimsObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yarsNeeded: null,
              },
              subType: 0,
            };
          } else if (trim.draperyOrderFabric) {
            trimsNew = {
              ...trim,
              draperyOrderFabric: {
                ...trim.draperyOrderFabric,
                yardsNeeded: null,
              },
              subType: 0,
            };
          } else {
            trimsNew = defaultEmbellishment('trims', check_case)!;
          }
          return trimsNew;
        });
      newOtherEmbellishment =
        this.state.othersEmbellishments &&
        this.state.othersEmbellishments.map((othersEmbellishments, index) => {
          let otherEmbellismentsNew = {};
          if (
            othersEmbellishments.draperyOrderFabric &&
            othersEmbellishments.draperyOrderFabric.itemId
          ) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: othersEmbellishmentsObj[index].supplierId,
              nameField: 'displayName',
            });
            otherEmbellismentsNew = {
              ...othersEmbellishments,
              draperyOrderFabric: {
                ...othersEmbellishments.draperyOrderFabric,
                itemId: othersEmbellishmentsObj[index].itemId,
                supplierId: othersEmbellishmentsObj[index].supplierId,
                supplierName,
                patternId: othersEmbellishmentsObj[index].patternId,
                pattern: othersEmbellishmentsObj[index].name,
                imageId: othersEmbellishmentsObj[index].avatarId,
                values: {
                  fabricWidth: othersEmbellishmentsObj[index].fabricWidthInches,
                  verticalRepeat: othersEmbellishmentsObj[index].verticalRepeatInches,
                  horizontalRepeat: othersEmbellishmentsObj[index].horizontalRepeatInches,
                },
                isDropRepeat: othersEmbellishmentsObj[index].isDropRepeatOn,
                isSpecialtyFabricHandling:
                  othersEmbellishmentsObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
              },
            };
          } else if (othersEmbellishments.draperyOrderFabric) {
            otherEmbellismentsNew = {
              ...othersEmbellishments,
              draperyOrderFabric: {
                ...othersEmbellishments.draperyOrderFabric,
                yardsNeeded: null,
              },
            };
          } else {
            otherEmbellismentsNew = defaultEmbellishment('othersEmbellishments')!;
          }
          return otherEmbellismentsNew;
        });
      newLinings =
        this.state.liningsList &&
        this.state.liningsList.map((lining, index) => {
          let liningsNew = {};
          if (lining.draperyOrderLiningsFabric && lining.draperyOrderLiningsFabric.itemId) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: liningsObj[index].supplierId,
              nameField: 'displayName',
            });
            liningsNew = {
              ...lining,
              id: 0,
              draperyOrderDesignId: 0,
              draperyOrderLiningsFabric: {
                ...lining.draperyOrderLiningsFabric,
                id: 0,
                itemId: liningsObj[index].itemId,
                supplierId: liningsObj[index].supplierId,
                supplierName,
                patternId: liningsObj[index].patternId,
                pattern: liningsObj[index].name,
                imageId: liningsObj[index].avatarId,
                values: {
                  fabricWidth: liningsObj[index].fabricWidthInches,
                  verticalRepeat: liningsObj[index].verticalRepeatInches,
                  horizontalRepeat: liningsObj[index].horizontalRepeat,
                },
                isSpecialtyFabricHandling: liningsObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
              },
            };
          } else if (lining.draperyOrderLiningsFabric) {
            liningsNew = {
              ...lining,
              id: 0,
              draperyOrderDesignId: 0,
              draperyOrderLiningsFabric: {
                ...lining.draperyOrderLiningsFabric,
                id: 0,
                yardsNeeded: null,
              },
            };
          } else {
            liningsNew = {
              ...lining,
              id: 0,
              draperyOrderDesignId: 0,
            };
          }
          return liningsNew;
        });
    }

    if (this.state.headRail && this.state.headRail.itemId) {
      headRailNew = {
        ...this.state.headRail,
        itemId: headRailObj[0].itemId,
      };
    } else {
      headRailNew = {
        ...this.state.headRail,
      };
    }
    if (this.state.mainFabric && this.state.mainFabric.itemId) {
      supplierName = getSelectedName({
        list: this.state.suppliers as [],
        findByKey: 'id',
        findValue: mainFabricObj[0].supplierId,
        nameField: 'displayName',
      });
      mainNew = {
        ...this.state.mainFabric,
        itemId: mainFabricObj[0].itemId,
        supplierId: mainFabricObj[0].supplierId,
        patternId: mainFabricObj[0].patternId,
        supplierName,
        pattern: mainFabricObj[0].name,
        imageId: mainFabricObj[0].avatarId,
        values: {
          fabricWidth: mainFabricObj[0].fabricWidthInches,
          verticalRepeat: mainFabricObj[0].verticalRepeatInches,
          horizontalRepeat: mainFabricObj[0].horizontalRepeatInches,
        },
        isDropRepeat: mainFabricObj[0].isDropRepeatOn,
        isSpecialtyFabricHandling: mainFabricObj[0].isSpecialtyFabricHandlingOn,
        customSupplier: '',
      };
    } else {
      mainNew = {
        ...this.state.mainFabric,
      };
    }

    let yard = {} as CalculatorState['yardage'];

    if (this.state.orderType === 'roman-shade-order') {
      yard = this.state.yardage;
    }

    this.setState({
      yardage: yard,
    });

    if (isChanged && !this.state.noChanges) {
      const confirmed = await this.showSaveConfirm();
      if (confirmed) {
        if (this.state.draperyOrder.id === 0) {
          const can_create_order = await userCanCreateNewOrder(this.props.accountId);
          if (
            !can_create_order &&
            this.state.remainingItemOrder === 0 &&
            this.state.orderType !== 'custom-order'
          ) {
            this.props.handleOpenSubscriptionPlanModal();
            return;
          }
        }
        if (!(await this.handleSaveAll())) {
          return;
        }
      }
    }

    const workOrderNum = await this.getNextWorkOrderNum();
    this.setState((state) => ({
      ...state,
      tabIndex: 0,
      isCopy: true,
      isChanged: true,
      draperyOrder: duplicateDraperyOrder({
        ...state.draperyOrder,
        userConfirmation: { allowExtraWideMainFabric: false },
        qbEstimateId: undefined,
        qbEstimateNumber: undefined,
      }),
      draperyOrderDesign: duplicateDraperyOrderDesign(state.draperyOrderDesign),
      draperyOrderUploads: duplicateUploadTab(state.draperyOrderUploads),
      draperyOrderHardware: duplicateDraperyOrderHardware(state.draperyOrderHardware),
      draperyOrderHeadrail: duplicateDraperyOrderHeadrail(state.draperyOrderHeadrail),
      liningsList: newLinings,
      trims: newTrims.map(duplicateEmbellishment),
      othersEmbellishments: newOtherEmbellishment.map(duplicateEmbellishment),
      mainFabric: duplicateFabric(mainNew),
      headRail: duplicateHeadRail(headRailNew),
      draperyOrderSummary: defaultDraperyOrderSummary(),
      draperyOrderFees: duplicateDraperyOrderFees(state.draperyOrderFees),
      draperyOrderSummaryComponents: [],
      workOrder: defaultWorkOrder(accountId, workOrderNum),
      isWorkOrderValidation: false,
      draperyOrderErrors: [],
      draperyOrderDesignErrors: [],
      draperyOrderFabricsErrors: [],
      draperyOrderFabricsConfirmations: [],
      draperyOrderSummaryErrors: [],
      draperyOrderPriceId: 0,
      highlightedSection: null,
      isDraft: false,
      checkedAllowExtraWidthOne: false,
      checkedAllowExtraWidthTwo: false,
    }));

    this.setState({
      yardage: {
        mainFabricYardage: null,
        bandingsYardage: [],
        cordingsPreMadeYardage: [],
        flangesPreMadeYardage: [],
        trimsPreMadeYardage: [],
        cordingsFabricYardage: [],
        flangesFabricYardage: [],
        trimsFabricYardage: [],
        liningsYardage: [],
        otherEmbellishmentsYardage: [],
      },
    });

    this.setState({
      isDuplicate: true,
    });

    let clientName = '';
    if (this.state && this.state.client && this.state.client.displayName) {
      clientName = this.state.client.displayName;
    }

    trackView(MixpanelEvents.DUPLICATE_ORDER, {
      orderId: this.state.draperyOrder.id,
      orderType: this.state.orderType,
      element: 'order_form',
      client_name: clientName,
    });

    if (!draperyOrder.newRomanShade && draperyOrder.id) {
      await this.getDefaultConstruction();
    }
  }

  @Bind()
  private async handleBundleConfigSettings(type): Promise<void> {
    let nextBundleConfigJson: any = {};
    this.setState(
      (state) => {
        const currentBundleConfigJson = normalizeBundleSelections(
          state.draperyOrder.bundleConfigJson
        );
        nextBundleConfigJson = {
          ...currentBundleConfigJson,
          [type]: !currentBundleConfigJson[type],
        };
        return {
          ...state,
          draperyOrder: {
            ...state.draperyOrder,
            bundleConfigJson: nextBundleConfigJson,
          },
        };
      },
      () => {
        if (
          this.state.draperyOrder &&
          this.state.draperyOrder.id &&
          !this.state.workOrderEditMode
        ) {
          this.saveDraperyOrderApi();
        }
      }
    );
  }

  @Bind()
  private async handleDuplicateDraperyOrder(): Promise<void> {
    const { accountId } = this.props;
    const can_create_order = await userCanCreateNewOrder(accountId);
    if (
      !can_create_order &&
      this.state.remainingItemOrder === 0 &&
      this.state.orderType !== 'custom-order'
    ) {
      this.props.handleOpenSubscriptionPlanModal();
      return;
    }

    let { draperyOrder, isChanged } = this.state;

    if (!draperyOrder.id) {
      draperyOrder = {
        ...draperyOrder,
      };
      this.setState({ draperyOrder });
    }

    let draperyOrderAllInfo: DraperyModule.DraperyOrderAllInfo =
      {} as DraperyModule.DraperyOrderAllInfo;
    let draperyOrderSummaryComponents: DraperyModule.DraperyOrderSummaryComponent[] = [];

    if (draperyOrder && draperyOrder.id) {
      const res = await getAllInfo(draperyOrder.id);

      this.processResponseErrors(res, -1, 'draperyOrderErrors');
      if (res.error) {
        return;
      }
      draperyOrderAllInfo = res;

      let draperyOrderLiningsList: DraperyOrderDesignLining[] = draperyLiningsList();
      if (draperyOrderAllInfo.draperyOrderDesignId !== undefined) {
        const res = await searchDraperyOrderDesignLining(draperyOrderAllInfo.draperyOrderDesignId);

        this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
        if (res.error) {
          return;
        }
        draperyOrderLiningsList = res;
        draperyOrderLiningsList = mergeDraperyOrderLiningFabric({
          draperyOrderLiningsList,
          draperyOrderAllFabrics: draperyOrderAllInfo.draperyOrderFabrics,
          romanShadeJson:
            draperyOrderAllInfo &&
            draperyOrderAllInfo.draperyOrderDesign &&
            draperyOrderAllInfo.draperyOrderDesign.romanShadeJson
              ? draperyOrderAllInfo.draperyOrderDesign.romanShadeJson
              : {},
          orderType: this.state.orderType,
        });
      }

      if (draperyOrderAllInfo.draperyOrderSummaryId) {
        const res = await searchDraperyOrderSummaryComponents(
          draperyOrderAllInfo.draperyOrderSummaryId
        );
        this.processResponseErrors(res, 2, 'draperyOrderSummaryErrors');
        if (res.error) {
          return;
        }
        draperyOrderSummaryComponents = res;
      }
    }

    let mainFabricObj: any = {};
    let cordingsObj: any = {};
    let bandingsObj: any = {};
    let flangesObj: any = {};
    let trimsObj: any = {};
    let liningsObj: any = {};
    let othersEmbellishmentsObj: any = {};

    mainFabricObj = await this.fetchEmbellishmentMain([this.state.mainFabric]);
    cordingsObj = await this.fetchEmbellishment(this.state.cordings);
    bandingsObj = await this.fetchEmbellishment(this.state.bandings);
    flangesObj = await this.fetchEmbellishment(this.state.flanges);
    trimsObj = await this.fetchEmbellishment(this.state.trims);
    liningsObj = await this.fetchEmbellishment(this.state.liningsList);
    othersEmbellishmentsObj = await this.fetchEmbellishment(this.state.othersEmbellishments);

    const embellishmentsList: EmbellishmentCheckInfo[] = defaultEmbellishmentsList();
    const bandings: DraperyOrderDesignEmbellishment[] = [];
    const cordings: DraperyOrderDesignEmbellishment[] = [];
    const flanges: DraperyOrderDesignEmbellishment[] = [];
    const trims: DraperyOrderDesignEmbellishment[] = [];
    const othersEmbellishments: DraperyOrderDesignEmbellishment[] = [];

    let newCording: any = [];
    let newBanding: any = [];
    let newFlange: any = [];
    let newTrims: any = [];
    let newLinings: any;
    let newOtherEmbellishment: any = [];
    let mainNew: any = undefined;
    let supplierName;
    if (this.state.mainFabric && this.state.mainFabric.itemId) {
      supplierName = getSelectedName({
        list: this.state.suppliers as [],
        findByKey: 'id',
        findValue: mainFabricObj[0].supplierId,
        nameField: 'displayName',
      });
      mainNew = {
        ...this.state.mainFabric,
        itemId: mainFabricObj[0].itemId,
        values: {
          fabricWidth: mainFabricObj[0].fabricWidthInches,
          verticalRepeat: mainFabricObj[0].verticalRepeatInches,
          horizontalRepeat: mainFabricObj[0].horizontalRepeatInches,
        },
        supplierId: mainFabricObj[0].supplierId,
        patternId: mainFabricObj[0].patternId,
        supplierName,
        pattern: mainFabricObj[0].name,
        imageId: mainFabricObj[0].avatarId,
        isDropRepeat: mainFabricObj[0].isDropRepeatOn,
        isSpecialtyFabricHandling: mainFabricObj[0].isSpecialtyFabricHandlingOn,
        customSupplier: '',
      };
    } else {
      mainNew = {
        ...this.state.mainFabric,
      };
    }
    if (draperyOrderAllInfo && draperyOrderAllInfo.draperyOrderDesignId !== undefined) {
      const res = await searchDraperyOrderDesignEmbellishments(
        draperyOrderAllInfo.draperyOrderDesignId
      );
      this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
      if (res.error) {
        return;
      }
      const draperyOrderEmbellishmentList: DraperyOrderDesignEmbellishment[] = res;

      for (const embellishment of draperyOrderEmbellishmentList) {
        if (embellishment.type === 1) {
          addEmbellishment(
            bandings,
            embellishment,
            embellishmentsList[0],
            draperyOrderAllInfo.draperyOrderFabrics,
            draperyOrderSummaryComponents
          );
        }
        if (embellishment.type === 2) {
          addEmbellishment(
            cordings,
            embellishment,
            embellishmentsList[1],
            draperyOrderAllInfo.draperyOrderFabrics,
            draperyOrderSummaryComponents
          );
        }
        if (embellishment.type === 3) {
          addEmbellishment(
            flanges,
            embellishment,
            embellishmentsList[2],
            draperyOrderAllInfo.draperyOrderFabrics,
            draperyOrderSummaryComponents
          );
        }
        if (embellishment.type === 4) {
          addEmbellishment(
            trims,
            embellishment,
            embellishmentsList[3],
            draperyOrderAllInfo.draperyOrderFabrics,
            draperyOrderSummaryComponents
          );
        }
        if (embellishment.type === 5) {
          addEmbellishment(
            othersEmbellishments,
            embellishment,
            embellishmentsList[4],
            draperyOrderAllInfo.draperyOrderFabrics,
            draperyOrderSummaryComponents
          );
        }
      }

      newCording =
        this.state.cordings &&
        this.state.cordings.map((cording, index) => {
          let cordingNew = {};
          if (cording.draperyOrderFabric && cording.draperyOrderFabric.itemId) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: cordingsObj[index].supplierId,
              nameField: 'displayName',
            });
            cordingNew = {
              ...cording,
              draperyOrderFabric: {
                ...cording.draperyOrderFabric,
                itemId: cordingsObj[index].itemId,
                supplierId: cordingsObj[index].supplierId,
                patternId: cordingsObj[index].patternId,
                supplierName,
                pattern: cordingsObj[index].name,
                imageId: cordingsObj[index].avatarId,
                values: {
                  fabricWidth: cordingsObj[index].fabricWidthInches,
                  verticalRepeat: cordingsObj[index].verticalRepeatInches,
                  horizontalRepeat: cordingsObj[index].horizontalRepeatInches,
                },
                isSpecialtyFabricHandling: cordingsObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
              },
            };
          } else if (cording.draperyOrderFabric) {
            cordingNew = {
              ...cording,
              draperyOrderFabric: {
                ...cording.draperyOrderFabric,
                yardsNeeded: null,
              },
            };
          } else {
            cordingNew = defaultEmbellishment('cordings')!;
          }

          return cordingNew;
        });

      newBanding =
        this.state.bandings &&
        this.state.bandings.map((banding, index) => {
          let bandingNew = {};
          if (banding.draperyOrderFabric && banding.draperyOrderFabric.itemId) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: bandingsObj[index].supplierId,
              nameField: 'displayName',
            });
            bandingNew = {
              ...banding,
              draperyOrderFabric: {
                ...banding.draperyOrderFabric,
                itemId: bandingsObj[index].itemId,
                supplierId: bandingsObj[index].supplierId,
                patternId: bandingsObj[index].patternId,
                supplierName,
                pattern: bandingsObj[index].name,
                imageId: bandingsObj[index].avatarId,
                values: {
                  fabricWidth: bandingsObj[index].fabricWidthInches,
                  verticalRepeat: bandingsObj[index].verticalRepeatInches,
                  horizontalRepeat: bandingsObj[index].horizontalRepeatInches,
                },
                isDropRepeat: bandingsObj[index].isDropRepeatOn,
                isSpecialtyFabricHandling: bandingsObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
              },
            };
          } else if (banding.draperyOrderFabric) {
            bandingNew = {
              ...banding,
              draperyOrderFabric: {
                ...banding.draperyOrderFabric,
                yardsNeeded: null,
              },
            };
          } else {
            bandingNew = defaultEmbellishment('bandings')!;
          }
          return bandingNew;
        });

      newFlange =
        this.state.flanges &&
        this.state.flanges.map((flange, index) => {
          let flangesNew = {};
          if (flange.draperyOrderFabric && flange.draperyOrderFabric.itemId) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: flangesObj[index].supplierId,
              nameField: 'displayName',
            });
            flangesNew = {
              ...flange,
              draperyOrderFabric: {
                ...flange.draperyOrderFabric,
                itemId: flangesObj[index].itemId,
                supplierId: flangesObj[index].supplierId,
                patternId: flangesObj[index].patternId,
                supplierName,
                pattern: flangesObj[index].name,
                imageId: flangesObj[index].avatarId,
                values: {
                  fabricWidth: flangesObj[index].fabricWidthInches,
                  verticalRepeat: flangesObj[index].verticalRepeatInches,
                  horizontalRepeat: flangesObj[index].horizontalRepeatInches,
                },
                isSpecialtyFabricHandling: flangesObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
              },
            };
          } else if (flange.draperyOrderFabric) {
            flangesNew = {
              ...flange,
              draperyOrderFabric: {
                ...flange.draperyOrderFabric,
                yardsNeeded: null,
              },
            };
          } else {
            flangesNew = defaultEmbellishment('flanges')!;
          }
          return flangesNew;
        });

      newTrims =
        this.state.trims &&
        this.state.trims.map((trim, index) => {
          let trimsNew = {};
          if (trim.draperyOrderFabric && trim.draperyOrderFabric.itemId) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: trimsObj[index].supplierId,
              nameField: 'displayName',
            });
            trimsNew = {
              ...trim,
              draperyOrderFabric: {
                ...trim.draperyOrderFabric,
                itemId: trimsObj[index].itemId,
                supplierId: trimsObj[index].supplierId,
                supplierName,
                patternId: trimsObj[index].patternId,
                pattern: trimsObj[index].name,
                imageId: trimsObj[index].avatarId,
                values: {
                  fabricWidth: trimsObj[index].fabricWidthInches,
                  verticalRepeat: trimsObj[index].verticalRepeatInches,
                  horizontalRepeat: trimsObj[index].horizontalRepeatInches,
                },
                isDropRepeat: trimsObj[index].isDropRepeatOn,
                isSpecialtyFabricHandling: trimsObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
              },
            };
          } else if (trim.draperyOrderFabric) {
            trimsNew = {
              ...trim,
              draperyOrderFabric: {
                ...trim.draperyOrderFabric,
                yardsNeeded: null,
              },
            };
          } else {
            trimsNew = defaultEmbellishment('trims')!;
          }
          return trimsNew;
        });

      newOtherEmbellishment =
        this.state.othersEmbellishments && this.state.othersEmbellishments.length > 0
          ? this.state.othersEmbellishments.map((othersEmbellishments, index) => {
              let otherEmbellismentsNew = {};
              if (
                othersEmbellishments.draperyOrderFabric &&
                othersEmbellishments.draperyOrderFabric.itemId
              ) {
                supplierName = getSelectedName({
                  list: this.state.suppliers as [],
                  findByKey: 'id',
                  findValue: othersEmbellishmentsObj[index].supplierId,
                  nameField: 'displayName',
                });
                otherEmbellismentsNew = {
                  ...othersEmbellishments,
                  draperyOrderFabric: {
                    ...othersEmbellishments.draperyOrderFabric,
                    itemId: othersEmbellishmentsObj[index].itemId,
                    supplierId: othersEmbellishmentsObj[index].supplierId,
                    supplierName,
                    patternId: othersEmbellishmentsObj[index].patternId,
                    pattern: othersEmbellishmentsObj[index].name,
                    imageId: othersEmbellishmentsObj[index].avatarId,
                    values: {
                      fabricWidth: othersEmbellishmentsObj[index].fabricWidthInches,
                      verticalRepeat: othersEmbellishmentsObj[index].verticalRepeatInches,
                      horizontalRepeat: othersEmbellishmentsObj[index].horizontalRepeatInches,
                    },
                    isDropRepeat: othersEmbellishmentsObj[index].isDropRepeatOn,
                    isSpecialtyFabricHandling:
                      othersEmbellishmentsObj[index].isSpecialtyFabricHandlingOn,
                    customSupplier: '',
                    yardsNeeded: null,
                  },
                };
              } else if (othersEmbellishments.draperyOrderFabric) {
                otherEmbellismentsNew = {
                  ...othersEmbellishments,
                  draperyOrderFabric: {
                    ...othersEmbellishments.draperyOrderFabric,
                    yardsNeeded: null,
                  },
                };
              } else {
                otherEmbellismentsNew = defaultEmbellishment('othersEmbellishments')!;
              }
              return otherEmbellismentsNew;
            })
          : [defaultEmbellishment('othersEmbellishments')!];
    } else {
      newCording =
        this.state.cordings &&
        this.state.cordings.map((cording, index) => {
          let cordingNew = {};
          if (cording.draperyOrderFabric && cording.draperyOrderFabric.itemId) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: cordingsObj[index].supplierId,
              nameField: 'displayName',
            });
            cordingNew = {
              ...cording,
              draperyOrderFabric: {
                ...cording.draperyOrderFabric,
                itemId: cordingsObj[index].itemId,
                supplierId: cordingsObj[index].supplierId,
                patternId: cordingsObj[index].patternId,
                supplierName,
                pattern: cordingsObj[index].name,
                imageId: cordingsObj[index].avatarId,
                values: {
                  fabricWidth: cordingsObj[index].fabricWidthInches,
                  verticalRepeat: cordingsObj[index].verticalRepeatInches,
                  horizontalRepeat: cordingsObj[index].horizontalRepeatInches,
                },
                isSpecialtyFabricHandling: cordingsObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
              },
            };
          } else if (cording.draperyOrderFabric) {
            cordingNew = {
              ...cording,
              draperyOrderFabric: {
                ...cording.draperyOrderFabric,
                yardsNeeded: null,
              },
            };
          } else {
            cordingNew = defaultEmbellishment('cordings')!;
          }

          return cordingNew;
        });

      newBanding =
        this.state.bandings &&
        this.state.bandings.map((banding, index) => {
          let bandingNew = {};
          if (banding.draperyOrderFabric && banding.draperyOrderFabric.itemId) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: bandingsObj[index].supplierId,
              nameField: 'displayName',
            });
            bandingNew = {
              ...banding,
              draperyOrderFabric: {
                ...banding.draperyOrderFabric,
                itemId: bandingsObj[index].itemId,
                supplierId: bandingsObj[index].supplierId,
                patternId: bandingsObj[index].patternId,
                supplierName,
                pattern: bandingsObj[index].name,
                imageId: bandingsObj[index].avatarId,
                values: {
                  fabricWidth: bandingsObj[index].fabricWidthInches,
                  verticalRepeat: bandingsObj[index].verticalRepeatInches,
                  horizontalRepeat: bandingsObj[index].horizontalRepeatInches,
                },
                isDropRepeat: bandingsObj[index].isDropRepeatOn,
                isSpecialtyFabricHandling: bandingsObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
              },
            };
          } else if (banding.draperyOrderFabric) {
            bandingNew = {
              ...banding,
              draperyOrderFabric: {
                ...banding.draperyOrderFabric,
                yardsNeeded: null,
              },
            };
          } else {
            bandingNew = defaultEmbellishment('bandings')!;
          }
          return bandingNew;
        });
      newFlange =
        this.state.flanges &&
        this.state.flanges.map((flange, index) => {
          let flangesNew = {};
          if (flange.draperyOrderFabric && flange.draperyOrderFabric.itemId) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: flangesObj[index].supplierId,
              nameField: 'displayName',
            });
            flangesNew = {
              ...flange,
              draperyOrderFabric: {
                ...flange.draperyOrderFabric,
                itemId: flangesObj[index].itemId,
                supplierId: flangesObj[index].supplierId,
                patternId: flangesObj[index].patternId,
                supplierName,
                pattern: flangesObj[index].name,
                imageId: flangesObj[index].avatarId,
                values: {
                  fabricWidth: flangesObj[index].fabricWidthInches,
                  verticalRepeat: flangesObj[index].verticalRepeatInches,
                  horizontalRepeat: flangesObj[index].horizontalRepeatInches,
                },
                isSpecialtyFabricHandling: flangesObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
              },
            };
          } else if (flange.draperyOrderFabric) {
            flangesNew = {
              ...flange,
              draperyOrderFabric: {
                ...flange.draperyOrderFabric,
                yardsNeeded: null,
              },
            };
          } else {
            flangesNew = defaultEmbellishment('flanges')!;
          }
          return flangesNew;
        });
      newTrims =
        this.state.trims &&
        this.state.trims.map((trim, index) => {
          let trimsNew = {};
          if (trim.draperyOrderFabric && trim.draperyOrderFabric.itemId) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: trimsObj[index].supplierId,
              nameField: 'displayName',
            });

            trimsNew = {
              ...trim,
              draperyOrderFabric: {
                ...trim.draperyOrderFabric,
                itemId: trimsObj[index].itemId,
                supplierId: trimsObj[index].supplierId,
                supplierName,
                patternId: trimsObj[index].patternId,
                pattern: trimsObj[index].name,
                imageId: trimsObj[index].avatarId,
                values: {
                  fabricWidth: trimsObj[index].fabricWidthInches,
                  verticalRepeat: trimsObj[index].verticalRepeatInches,
                  horizontalRepeat: trimsObj[index].horizontalRepeatInches,
                },
                isDropRepeat: trimsObj[index].isDropRepeatOn,
                isSpecialtyFabricHandling: trimsObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
              },
            };
          } else if (trim.draperyOrderFabric) {
            trimsNew = {
              ...trim,
              draperyOrderFabric: {
                ...trim.draperyOrderFabric,
                yardsNeeded: null,
              },
            };
          } else {
            trimsNew = defaultEmbellishment('trims')!;
          }
          return trimsNew;
        });

      newOtherEmbellishment =
        this.state.othersEmbellishments &&
        this.state.othersEmbellishments.map((othersEmbellishments, index) => {
          let otherEmbellismentsNew = {};
          if (
            othersEmbellishments.draperyOrderFabric &&
            othersEmbellishments.draperyOrderFabric.itemId
          ) {
            supplierName = getSelectedName({
              list: this.state.suppliers as [],
              findByKey: 'id',
              findValue: othersEmbellishmentsObj[index].supplierId,
              nameField: 'displayName',
            });
            otherEmbellismentsNew = {
              ...othersEmbellishments,
              draperyOrderFabric: {
                ...othersEmbellishments.draperyOrderFabric,
                itemId: othersEmbellishmentsObj[index].itemId,
                supplierId: othersEmbellishmentsObj[index].supplierId,
                supplierName,
                patternId: othersEmbellishmentsObj[index].patternId,
                pattern: othersEmbellishmentsObj[index].name,
                imageId: othersEmbellishmentsObj[index].avatarId,
                values: {
                  fabricWidth: othersEmbellishmentsObj[index].fabricWidthInches,
                  verticalRepeat: othersEmbellishmentsObj[index].verticalRepeatInches,
                  horizontalRepeat: othersEmbellishmentsObj[index].horizontalRepeatInches,
                },
                isDropRepeat: othersEmbellishmentsObj[index].isDropRepeatOn,
                isSpecialtyFabricHandling:
                  othersEmbellishmentsObj[index].isSpecialtyFabricHandlingOn,
                customSupplier: '',
                yardsNeeded: null,
              },
            };
          } else if (othersEmbellishments.draperyOrderFabric) {
            otherEmbellismentsNew = {
              ...othersEmbellishments,
              draperyOrderFabric: {
                ...othersEmbellishments.draperyOrderFabric,
                yardsNeeded: null,
              },
            };
          } else {
            otherEmbellismentsNew = defaultEmbellishment('othersEmbellishments')!;
          }
          return otherEmbellismentsNew;
        });
    }
    newLinings =
      this.state.liningsList &&
      this.state.liningsList.map((lining, index) => {
        let liningsNew = {};
        if (lining.draperyOrderLiningsFabric && lining.draperyOrderLiningsFabric.itemId) {
          supplierName = getSelectedName({
            list: this.state.suppliers as [],
            findByKey: 'id',
            findValue: liningsObj[index].supplierId,
            nameField: 'displayName',
          });
          liningsNew = {
            ...lining,
            draperyOrderLiningsFabric: {
              ...lining.draperyOrderLiningsFabric,
              itemId: liningsObj[index].itemId,
              supplierId: liningsObj[index].supplierId,
              supplierName,
              patternId: liningsObj[index].patternId,
              pattern: liningsObj[index].name,
              imageId: liningsObj[index].avatarId,
              values: {
                fabricWidth: liningsObj[index].fabricWidthInches,
                verticalRepeat: liningsObj[index].verticalRepeatInches,
                horizontalRepeat: liningsObj[index].horizontalRepeat,
              },
              isSpecialtyFabricHandling: liningsObj[index].isSpecialtyFabricHandlingOn,
              customSupplier: '',
              yardsNeeded: null,
            },
          };
        } else if (lining.draperyOrderLiningsFabric) {
          liningsNew = {
            ...lining,
            draperyOrderLiningsFabric: {
              ...lining.draperyOrderLiningsFabric,
              yardsNeeded: null,
            },
          };
        } else {
          liningsNew = {
            ...lining,
          };
        }
        return liningsNew;
      });

    let yard = {} as CalculatorState['yardage'];

    if (this.state.orderType === 'custom-order') {
      yard = { ...this.state.yardage };
    }

    this.setState({
      yardage: yard,
    });

    if (isChanged && !this.state.noChanges) {
      const confirmed = await this.showSaveConfirm();
      if (confirmed) {
        if (this.state.draperyOrder.id === 0) {
          const can_create_order = await userCanCreateNewOrder(this.props.accountId);
          if (
            !can_create_order &&
            this.state.remainingItemOrder === 0 &&
            this.state.orderType !== 'custom-order'
          ) {
            this.props.handleOpenSubscriptionPlanModal();
            return;
          }
        }
        if (!(await this.handleSaveAll())) {
          return;
        }
      }
    }

    const workOrderNum = await this.getNextWorkOrderNum();
    this.setState((state) => ({
      ...state,
      tabIndex: 0,
      isCopy: true,
      isChanged: true,
      draperyOrder: duplicateDraperyOrder({
        ...state.draperyOrder,
        userConfirmation: { allowExtraWideMainFabric: false },
        qbEstimateId: undefined,
        qbEstimateNumber: undefined,
      }),
      draperyOrderDesign: duplicateDraperyOrderDesign(state.draperyOrderDesign),
      draperyOrderUploads: duplicateUploadTab(state.draperyOrderUploads),
      draperyOrderHardware: duplicateDraperyOrderHardware(state.draperyOrderHardware),
      liningsList: newLinings.map(duplicateLining),
      bandings: newBanding.map(duplicateEmbellishment),
      cordings: newCording.map(duplicateEmbellishment),
      flanges: newFlange.map(duplicateEmbellishment),
      trims: newTrims.map(duplicateEmbellishment),
      othersEmbellishments: newOtherEmbellishment.map(duplicateEmbellishment),
      mainFabric: duplicateFabric(mainNew),
      draperyOrderSummary: defaultDraperyOrderSummary(),
      draperyOrderFees: duplicateDraperyOrderFees(state.draperyOrderFees),
      draperyOrderSummaryComponents: [],
      workOrder: defaultWorkOrder(accountId, workOrderNum),
      isWorkOrderValidation: false,
      draperyOrderErrors: [],
      draperyOrderDesignErrors: [],
      draperyOrderFabricsErrors: [],
      draperyOrderFabricsConfirmations: [],
      draperyOrderSummaryErrors: [],
      draperyOrderPriceId: 0,
      highlightedSection: null,
      isDraft: false,
      checkedAllowExtraWidthOne: false,
      checkedAllowExtraWidthTwo: false,
    }));
    if (this.summaryRef && this.summaryRef.current) {
      this.setState({
        yardage: {
          mainFabricYardage: null,
          bandingsYardage: [],
          cordingsPreMadeYardage: [],
          flangesPreMadeYardage: [],
          trimsPreMadeYardage: [],
          cordingsFabricYardage: [],
          flangesFabricYardage: [],
          trimsFabricYardage: [],
          liningsYardage: [],
          otherEmbellishmentsYardage: [],
        },
      });
    }
    this.setState({
      isDuplicate: true,
    });

    let clientName = '';
    if (this.state && this.state.client && this.state.client.displayName) {
      clientName = this.state.client.displayName;
    }

    trackView(MixpanelEvents.DUPLICATE_ORDER, {
      orderId: this.state.draperyOrder.id,
      orderType: this.state.orderType,
      element: 'order_form',
      client_name: clientName,
    });
  }

  private resetDraperyOrderNewFabrics = (): void => {
    this.setState((prev) => {
      return {
        ...prev,
        newDraperyOrderFabrics: [],
        draperyOrderDesign: {
          ...prev.draperyOrderDesign,
          draperyOrderDesignEmbellishments: [],
        },
        copyState: {
          ...prev.copyState,
          draperyOrderDesign: {
            ...prev.copyState.draperyOrderDesign,
            draperyOrderDesignEmbellishments: [],
          },
        },
      };
    });
  };

  private resetLinings = (): void => {
    this.setState((prev) => {
      return {
        ...prev,
        draperyOrderDesign: {
          ...prev.draperyOrderDesign,
          draperyOrderDesignLinings: [],
        },
        newDraperyOrderFabrics: [],
      };
    });
  };

  private resetAfterUpdatingEmbellishments = (): void => {
    this.setState((prev) => {
      return {
        ...prev,
        newDraperyOrderFabrics: [],
        draperyOrderDesign: {
          ...prev.draperyOrderDesign,
          draperyOrderDesignLinings: [],
          draperyOrderDesignEmbellishments: [],
        },
      };
    });
  };

  private resetDraperyOrderEmbellishments = (): void => {
    const newDraperyOrderFabricsKeys = [
      'bandings',
      'cordings',
      'flanges',
      'trims',
      'othersEmbellishments',
    ];
    newDraperyOrderFabricsKeys.forEach((k) => {
      const newMappedArray =
        this.state[k] &&
        this.state[k].length > 0 &&
        this.state[k].map((item: any) => {
          return {
            ...item,
            draperyOrderFabric: null,
          };
        });
      this.setState((prev) => {
        return {
          ...prev,
          [k]: newMappedArray,
          newDraperyOrderFabrics: [],
          draperyOrderDesign: {
            ...prev.draperyOrderDesign,
            draperyOrderDesignEmbellishments: [],
          },
        };
      });
    });
  };

  private addDraperyOrderNewFabrics = (keys: string[]): void => {
    if (keys && keys.length > 0) {
      keys.forEach((k) => {
        switch (k) {
          case 'bandings':
          case 'cordings':
          case 'flanges':
          case 'othersEmbellishments':
          case 'trims':
            if (this.state[k] && this.state[k].length > 0) {
              for (const item of this.state[k]) {
                if (item && item.draperyOrderFabric && item.draperyOrderFabric !== null) {
                  const { draperyOrderFabric, ...rest } = item;
                  this.setState((prev) => {
                    return {
                      ...prev,
                      newDraperyOrderFabrics: [...prev.newDraperyOrderFabrics, draperyOrderFabric],
                      draperyOrderDesign: {
                        ...prev.draperyOrderDesign,
                        draperyOrderDesignEmbellishments: [
                          ...(prev.draperyOrderDesign.draperyOrderDesignEmbellishments || []),
                          rest,
                        ],
                      },
                    };
                  });
                }
              }
            }
            break;
          case 'mainFabric':
            if (this.state[k]) {
              const mainFabricPaylod = {
                ...this.state.mainFabric,
                values: {
                  ...this.state.mainFabric.values,
                  fabricWidth: this.state.mainFabric.values.fabricWidth
                    ? Number(this.state.mainFabric.values.fabricWidth)
                    : this.state.mainFabric.values.fabricWidth,
                  horizontalRepeat: this.state.mainFabric.values.horizontalRepeat
                    ? Number(this.state.mainFabric.values.horizontalRepeat)
                    : this.state.mainFabric.values.horizontalRepeat,
                  verticalRepeat: this.state.mainFabric.values.verticalRepeat
                    ? Number(this.state.mainFabric.values.verticalRepeat)
                    : this.state.mainFabric.values.verticalRepeat,
                },
              };
              this.setState((prev) => {
                return {
                  ...prev,
                  newDraperyOrderFabrics: [...prev.newDraperyOrderFabrics, mainFabricPaylod],
                };
              });
            }
            break;
          case 'liningsList':
            if (this.state[k] && this.state[k].length > 0) {
              const romanShadeProps = this.state.draperyOrderDesign.romanShadeJson;

              for (const l of this.state[k]) {
                if (
                  (l.active ||
                    (l.name === 'Lining' &&
                      this.state.orderType === 'roman-shade-order' &&
                      romanShadeProps &&
                      romanShadeProps.valanceAndReturns &&
                      romanShadeProps.valanceAndReturns.backValance)) &&
                  l.draperyOrderLiningsFabric
                ) {
                  this.setState((prev) => {
                    const { draperyOrderLiningsFabric, ...rest } = l;

                    return {
                      ...prev,
                      newDraperyOrderFabrics: [
                        ...prev.newDraperyOrderFabrics,
                        draperyOrderLiningsFabric,
                      ],
                      draperyOrderDesign: {
                        ...prev.draperyOrderDesign,
                        draperyOrderDesignLinings:
                          this.state.draperyOrderDesign.draperyOrderDesignLinings &&
                          this.state.draperyOrderDesign.draperyOrderDesignLinings.find(
                            (i) => i.name === rest.name
                          )
                            ? [...(prev.draperyOrderDesign.draperyOrderDesignLinings || [])]
                            : [...(prev.draperyOrderDesign.draperyOrderDesignLinings || []), rest],
                      },
                    };
                  });
                }
              }
            }
            break;
          default:
            return;
        }
      });
    }
  };

  @Bind()
  private handleRemoveRomanShadeCategory(e: React.ChangeEvent<HTMLInputElement>): void {
    const { value, name } = e.target as {
      value: string;
      name: keyof CalculatorState;
    };

    // Split the `name` into parts and access the property dynamically
    const nameParts = name.split('.');
    let currentValue: any = this.state;

    for (const part of nameParts) {
      if (currentValue && currentValue[part] !== undefined) {
        currentValue = currentValue[part];
      } else {
        console.log(`Property ${name} does not exist`);
        return; // Early exit if property is undefined at any point
      }
    }

    if (
      ((name as any) === 'draperyOrderDesign.romanShadeJson.headrail.controlType' ||
        (name as any) === 'draperyOrderDesign.romanShadeJson.valanceAndReturns.sides') &&
      currentValue === value
    ) {
      const keyName = name.split('.').pop();
      const parentKey = name.split('.').slice(2, -1)[0];
      this.setState(
        (prevState: any) => {
          return {
            ...prevState,
            draperyOrderDesign: {
              ...prevState.draperyOrderDesign,
              romanShadeJson: {
                ...prevState.draperyOrderDesign.romanShadeJson,
                [parentKey]: {
                  ...prevState.draperyOrderDesign.romanShadeJson[parentKey],
                  [keyName as string]: null,
                },
              },
            },
          };
        },
        async () => {
          this.validateAll('update');
        }
      );
      // this.updateStateByName(name, null);
      return;
    }

    // Check if the current value matches the input value
    if (currentValue === +value) {
      // Reset the Valance column values for the Trim embellishment
      if (
        this.state.trims &&
        this.state.trims.length > 0 &&
        +value === 1 &&
        (name as any) === 'draperyOrderDesign.romanShadeJson.valanceAndReturns.frontValance'
      ) {
        for (const trim of this.state.trims) {
          ['topEdge', 'bottomEdge', 'leadReturnEdge'].forEach((item) => {
            if (trim[item] && 'valance' in trim[item]) {
              delete trim[item].valance;
            }

            if (trim[item] && !trim[item].valance && !trim[item].shade) {
              trim[item].size = undefined;
              trim[item].insetSize = undefined;
              trim[item].insetActive = false;
            }
          });
        }
      }

      const keyName = name.split('.').pop();
      const parentKey = name.split('.').slice(2, -1)[0];
      this.setState(
        (prevState: any) => {
          return {
            ...prevState,
            draperyOrderDesign: {
              ...prevState.draperyOrderDesign,
              romanShadeJson: {
                ...prevState.draperyOrderDesign.romanShadeJson,
                [parentKey]: {
                  ...prevState.draperyOrderDesign.romanShadeJson[parentKey],
                  [keyName as string]: -1,
                },
              },
            },
            romanShadeJson: {
              ...prevState.romanShadeJson,
              [parentKey]: {
                ...prevState.romanShadeJson[parentKey],
                [keyName as string]: -1,
              },
            },
          };
        },
        async () => {
          this.validateAll('update');
        }
      );

      // this.updateStateByName(name, -1);
    }
  }

  private handleSaveFirst = async (openPdf: boolean, yardage?: any) => {
    if (this.state.draperyOrder.id === 0) {
      const can_create_order = await userCanCreateNewOrder(this.props.accountId);
      if (
        !can_create_order &&
        this.state.remainingItemOrder === 0 &&
        this.state.orderType !== 'custom-order'
      ) {
        this.props.handleOpenSubscriptionPlanModal();
        return;
      }
    }

    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));

    this.setState({ isWorkOrderValidation: true, yardage: yardage || {} }, async () => {
      if (!this.validateAll('workOrder')) {
        this.toggleErrorMessage();
        this.setState((state) => ({ ...state, clientAndRoomHighlight: true }));
        this.setState((state) => ({ ...state, isLoading: false }));
        return;
      }

      if (!this.state.workOrderEditMode) {
        if (!(await this.saveAll(undefined, undefined, 'workOrder'))) {
          this.setState((state) => ({ ...state, isLoading: false }));
          return;
        }
      }
      this.state.orderType === 'roman-shade-order' && (await this.updateWorkOrder(''));
      this.setState((state) => ({
        ...state,
        workOrderReady: this.state.orderType !== 'roman-shade-order',
        openPdf: openPdf,
      }));
    });

    if (this.state.workOrderEditMode) {
      trackView(MixpanelEvents.UPDATE_ORDER, {
        orderId: this.state.draperyOrder.id,
        orderType: this.state.orderType,
      });
    }
  };
  private handleCreateOtherItemOrder = async (openPdf: boolean) => {
    const { draperyOrder } = this.state;
    this.setState((prev) => {
      return {
        ...prev,
        tabIndex: 5,
        workOrderReady: false,
      };
    });
    if (!this.state.workOrderEditMode) {
      const res = await addWorkOrder({
        ...this.state.workOrder,
        draperyOrderId: draperyOrder.id,
        edit_mode: false,
      });
      this.processResponseErrors(res, -1, 'draperyOrderErrors');

      trackView(MixpanelEvents.CREATE_NEW_ORDER, {
        orderId: this.state.draperyOrder.id,
        orderType: this.state.orderType,
      });

      if (res.error) {
        trackView(MixpanelEvents.CREATE_NEW_ORDER, {
          orderId: this.state.draperyOrder.id,
          orderType: this.state.orderType,
          be_error_text:
            res.error && res.message
              ? res.message
              : res.error
                ? res.error
                : 'Error with creating new order',
        });
        return;
      }
      const workOrder = res;
      const res1 = await editDraperyOrder({
        ...draperyOrder,
        workOrderId: workOrder.id,
        editable: false,
      });

      trackView(MixpanelEvents.SAVE_ORDER, {
        orderId: this.state.draperyOrder.id,
        orderType: this.state.orderType,
        element: 'order_update',
      });

      if (res1.error) {
        trackView(MixpanelEvents.SAVE_ORDER, {
          orderId: this.state.draperyOrder.id,
          orderType: this.state.orderType,
          be_error_text:
            res1.error && res1.message
              ? res1.message
              : res1.error
                ? res1.error
                : 'Error with saving order',
        });
      }

      this.processResponseErrors(res1, -1, 'draperyOrderErrors');
      if (res1.error) {
        this.setState((state) => ({
          ...state,
          isLoading: false,
          loadingUpdate: false,
        }));
        return;
      }

      this.setState(
        (state) => ({
          ...state,
          draperyOrder: {
            ...draperyOrder,
            workOrderId: workOrder.id,
            editable: false,
          },
          workOrder,
          loadingUpdate: false,
        }),
        async () => {
          if (!(await this.saveDraperyOrderDrawing())) {
            return;
          }
          if (!(await this.saveDraperyOrderDesignApi())) {
            return;
          }
          await this.handleDownloadWorkOrderPdf(openPdf);
        }
      );
    }
    if (this.state.workOrderEditMode) {
      const res = await addWorkOrder({
        ...this.state.workOrder,
        draperyOrderId: draperyOrder.id,
        edit_mode: true,
      });
      this.processResponseErrors(res, -1, 'draperyOrderErrors');
      trackView(MixpanelEvents.CREATE_NEW_ORDER, {
        orderId: this.state.draperyOrder.id,
        orderType: this.state.orderType,
      });

      if (res.error) {
        trackView(MixpanelEvents.CREATE_NEW_ORDER, {
          orderId: this.state.draperyOrder.id,
          orderType: this.state.orderType,
          be_error_text:
            res.error && res.message
              ? res.message
              : res.error
                ? res.error
                : 'Error with creating new order',
        });
        return;
      }
      const workOrder = res;
      const res1 = await editDraperyOrder({
        ...draperyOrder,
        workOrderId: workOrder.id,
        editable: false,
      });

      trackView(MixpanelEvents.SAVE_ORDER, {
        orderId: this.state.draperyOrder.id,
        orderType: this.state.orderType,
        element: 'order_update',
      });

      if (res1.error) {
        trackView(MixpanelEvents.SAVE_ORDER, {
          orderId: this.state.draperyOrder.id,
          orderType: this.state.orderType,
          be_error_text:
            res1.error && res1.message
              ? res1.message
              : res1.error
                ? res1.error
                : 'Error with saving order',
        });
      }
      this.processResponseErrors(res1, -1, 'draperyOrderErrors');
      if (res1.error) {
        this.setState((state) => ({
          ...state,
          isLoading: false,
          loadingUpdate: false,
        }));
        return;
      }
      this.setState(
        (prev) => {
          return {
            ...prev,
            draperyOrder: {
              ...draperyOrder,
              workOrderId: workOrder.id,
              editable: false,
            },
            workOrder,
            loadingUpdate: false,
          };
        },
        async () => {
          if (!(await this.saveDraperyOrderDrawing())) {
            this.setState((state) => ({
              ...state,
              isLoading: false,
            }));
            return;
          }
          if (!(await this.saveDraperyOrderDesignApi())) {
            this.setState((state) => ({
              ...state,
              isLoading: false,
            }));
            return;
          }
          if (!(await this.saveDraperyOrderDesignTab())) {
            this.setState((state) => ({
              ...state,
              isLoading: false,
            }));
            return;
          }
          if (!(await this.saveDraperyOrderFabricsTab(draperyOrder.id, 'workOrder'))) {
            this.setState((state) => ({
              ...state,
              isLoading: false,
            }));
            return;
          }
          if (!(await this.saveHardwareTab())) {
            this.setState((state) => ({
              ...state,
              isLoading: false,
            }));
            return;
          }
          if (!(await this.saveUploadTab())) {
            this.setState((state) => ({
              ...state,
              isLoading: false,
            }));
            return;
          }
          if (!(await this.saveSummaryTab())) {
            this.setState((state) => ({
              ...state,
              isLoading: false,
            }));
            return;
          }
          if (!(await this.saveDraperyOrderApi())) {
            this.setState((state) => ({
              ...state,
              isLoading: false,
            }));
            return;
          }
          await this.handleDownloadWorkOrderPdf(openPdf);
        }
      );
    }

    this.setState((prev) => {
      return {
        ...prev,
        openPdf: false,
      };
    });
  };

  private handleCancelRecommendationsOverrides = () => {
    this.setState({
      loadingUpdate: false,
      isLoading: false,
      isRecommendationsOverridesModalOpen: false,
    });
  };
  private handleCancelRecommendationsRomanShadeOverrides = () => {
    this.setState({
      loadingUpdate: false,
      isLoading: false,
      isRecommendationsOverridesModalRomanShadeOpen: false,
    });
  };

  private handleConfirmRecommendationOverride = async (
    panelJson: DraperyModule.DraperyOrderDesignPanelJson,
    workRoomSettings: any[],
    widthConfiguration: Array<number | undefined>
  ) => {
    const { dispatch } = this.props;
    const { draperyOrder } = this.state;

    this.setState((state) => ({
      ...state,
      isRecommendationsOverridesModalOpen: false,
      isRecommendationsOverridesModalRomanShadeOpen: false,
      isLoading: true,
      // tabIndex: 5,
      draperyOrderDesign:
        state.draperyOrderDesign.category === 0
          ? {
              ...state.draperyOrderDesign,
              panelJson,
            }
          : state.draperyOrderDesign,
    }));

    const edit_mode = this.state.workOrderEditMode;
    const res = await addWorkOrder({
      ...this.state.workOrder,
      draperyOrderId: draperyOrder.id,
      edit_mode: edit_mode,
    });
    this.processResponseErrors(res, -1, 'draperyOrderErrors');

    trackView(MixpanelEvents.CREATE_NEW_ORDER, {
      orderId: this.state.draperyOrder.id,
      orderType: this.state.orderType,
    });

    if (res.error) {
      trackView(MixpanelEvents.CREATE_NEW_ORDER, {
        orderId: this.state.draperyOrder.id,
        orderType: this.state.orderType,
        be_error_text:
          res.error && res.message
            ? res.message
            : res.error
              ? res.error
              : 'Error with creating new order',
      });
      return;
    }

    const workOrder = res;
    const res1 = await editDraperyOrder({
      ...draperyOrder,
      workOrderId: workOrder.id,
      editable: false,
    });

    trackView(MixpanelEvents.SAVE_ORDER, {
      orderId: this.state.draperyOrder.id,
      orderType: this.state.orderType,
      element: 'order_update',
    });

    if (res1.error) {
      trackView(MixpanelEvents.SAVE_ORDER, {
        orderId: this.state.draperyOrder.id,
        orderType: this.state.orderType,
        be_error_text:
          res1.error && res1.message
            ? res1.message
            : res1.error
              ? res1.error
              : 'Error with saving order',
      });
    }

    this.processResponseErrors(res1, -1, 'draperyOrderErrors');
    if (res1.error) {
      this.setState((state) => ({
        ...state,
        isLoading: false,
        loadingUpdate: false,
      }));
      return;
    }

    if (this.state.workOrderEditMode) {
      this.setState(
        (prev) => {
          return {
            ...prev,
            workRoomSettings,
            widthConfiguration,
            draperyOrder: {
              ...draperyOrder,
              workOrderId: workOrder.id,
              editable: false,
            },
            workOrder,
            loadingUpdate: false,
          };
        },
        async () => {
          if (
            this.state.orderType === 'roman-shade-order' &&
            !this.state.draperyOrder.newRomanShade
          ) {
            if (!(await this.saveDraperyOrderDesignTab())) {
              this.setState((state) => ({
                ...state,
                isLoading: false,
              }));
              return;
            }
            if (!(await this.saveDraperyOrderFabricsTab(draperyOrder.id, 'workOrder'))) {
              this.setState((state) => ({
                ...state,
                isLoading: false,
              }));
              return;
            }
            if (!(await this.saveHardwareTab())) {
              this.setState((state) => ({
                ...state,
                isLoading: false,
              }));
              return;
            }
            if (!(await this.saveUploadTab())) {
              this.setState((state) => ({
                ...state,
                isLoading: false,
              }));
              return;
            }
            if (!(await this.saveSummaryTab())) {
              this.setState((state) => ({
                ...state,
                isLoading: false,
              }));
              return;
            }
            if (!(await this.saveDraperyOrderApi())) {
              this.setState((state) => ({
                ...state,
                isLoading: false,
              }));
              return;
            }
          } else {
            if (!(await this.saveDraperyOrderDrawing())) {
              this.setState((state) => ({
                ...state,
                isLoading: false,
              }));
              return;
            }
            if (!(await this.saveDraperyOrderDesignApi())) {
              this.setState((state) => ({
                ...state,
                isLoading: false,
              }));
              return;
            }
          }
          await this.handleDownloadWorkOrderPdf(false);
          const notification: NotificationsModule.Notification = {
            id: 0,
            message: 'Success!',
            subMessage: 'Your progress has been saved',
            type: 'info',
          };
          dispatch(NotificationsModule.addNotification(notification));
        }
      );
    } else {
      this.setState(
        (state) => ({
          ...state,
          workRoomSettings,
          widthConfiguration,
          draperyOrder: {
            ...draperyOrder,
            workOrderId: workOrder.id,
            editable: false,
          },
          workOrder,
          loadingUpdate: false,
        }),
        async () => {
          if (!(await this.saveDraperyOrderDrawing())) {
            return;
          }
          if (!(await this.saveDraperyOrderDesignApi())) {
            return;
          }
          await this.handleDownloadWorkOrderPdf(false);
        }
      );
    }

    // trackView(MixpanelEvents.CREATE_NEW_ORDER, { orderId: this.state.draperyOrder.id, orderType: this.state.orderType, element: 'page_button' });
  };

  @Bind()
  private async handleAddSummaryComponent(): Promise<void> {
    this.setState({
      draperyOrderSummaryComponents: [
        ...this.state.draperyOrderSummaryComponents,
        defaultDraperyOrderSummaryComponent(''),
      ],
    });
  }

  @Bind()
  private async handleDeleteSummaryComponent(id: number): Promise<void> {
    this.state.draperyOrderSummaryComponents.splice(id, 1);
    this.setState({
      draperyOrderSummaryComponents: [...this.state.draperyOrderSummaryComponents],
    });
  }

  @Bind()
  private async handleEditWorkOrder(): Promise<void> {
    const res = await editWorkOrder(this.state.workOrder);
    if (res.error) {
      return;
    }
  }

  @Bind()
  private async handleDownloadWorkOrderPdf(
    open: boolean,
    options: { refreshOrder?: boolean; saveBeforeLoad?: boolean; updatePricing?: boolean } = {}
  ): Promise<void> {
    const { draperyOrder, workOrderPdfStatus, workRoomSettings, widthConfiguration } = this.state;
    const accountId = this.props.accountId;
    const shouldRefreshOrder = options.refreshOrder !== false;
    const shouldSaveBeforeLoad = options.saveBeforeLoad !== false;
    const shouldUpdatePricing = options.updatePricing !== false;
    if (shouldSaveBeforeLoad && !(await this.saveDraperyOrderDesignTab())) {
      return false;
    }
    if (
      draperyOrder.id &&
      // draperyOrder.workOrderId &&
      workOrderPdfStatus === 'none'
    ) {
      const res = await getWorkOrderPDFContent(draperyOrder.id);
      if (res.error) {
        this.processResponseErrors(res, 4, 'draperyOrderSummaryErrors');
        return;
      }

      if (this.state.orderType === 'custom-order' || this.state.orderType === 'roman-shade-order') {
        for (let key in res) {
          if (key === 'mainFabricContent') {
            if (!this.state.mainFabric.yardsNeeded) {
              res[key].yardsNeeded = null;
            }
          }
          if (key === 'bandingFabricContents') {
            res[key].map((item: any, index: any) => {
              const banding = this.state.bandings[index];
              if (
                banding &&
                banding.draperyOrderFabric &&
                !banding.draperyOrderFabric.yardsNeeded
              ) {
                res[key][index].yardsNeeded = null;
              }
            });
          }
          if (key === 'premadeCordingFabricContents') {
            res[key].map((item: any, index: any) => {
              const cording = this.state.cordings.filter((item) => item.subType === 0)[index];
              if (
                cording &&
                cording.draperyOrderFabric &&
                !cording.draperyOrderFabric.yardsNeeded
              ) {
                res[key][index].yardsNeeded = null;
              }
            });
          }
          if (key === 'weltCordingFabricContents') {
            res[key].map((item: any, index: any) => {
              const cording = this.state.cordings.filter((item) => item.subType === 1)[index];
              if (
                cording &&
                cording.draperyOrderFabric &&
                !cording.draperyOrderFabric.yardsNeeded
              ) {
                res[key][index].yardsNeeded = null;
              }
            });
          }
          if (key === 'premadeFlangeFabricContents') {
            res[key].map((item: any, index: any) => {
              const flange = this.state.flanges.filter((item) => item.subType === 0)[index];
              if (flange && flange.draperyOrderFabric && !flange.draperyOrderFabric.yardsNeeded) {
                res[key][index].yardsNeeded = null;
              }
            });
          }
          if (key === 'fabricFlangeFabricContents') {
            res[key].map((item: any, index: any) => {
              const flange = this.state.flanges.filter((item) => item.subType === 1)[index];
              if (flange && flange.draperyOrderFabric && !flange.draperyOrderFabric.yardsNeeded) {
                res[key][index].yardsNeeded = null;
              }
            });
          }
          if (key === 'premadeTrimFabricContents') {
            res[key].map((item: any, index: any) => {
              const trim = this.state.trims.filter((item) => item.subType === 0)[index];
              if (trim && trim.draperyOrderFabric && !trim.draperyOrderFabric.yardsNeeded) {
                res[key][index].yardsNeeded = null;
              }
            });
          }
          if (key === 'fabricTrimFabricContents') {
            res[key].map((item: any, index: any) => {
              const trim = this.state.trims.filter((item) => item.subType === 1)[index];
              if (trim && trim.draperyOrderFabric && !trim.draperyOrderFabric.yardsNeeded) {
                res[key][index].yardsNeeded = null;
              }
            });
          }
          if (key === 'otherFabricContents') {
            res[key].map((item: any, index: any) => {
              const othersEmbellishment = this.state.othersEmbellishments[index];
              if (
                othersEmbellishment &&
                othersEmbellishment.draperyOrderFabric &&
                !othersEmbellishment.draperyOrderFabric.yardsNeeded
              ) {
                res[key][index].yardsNeeded = null;
              }
            });
          }
        }
      }

      if (shouldRefreshOrder) {
        await this.getExistingDraperyOrder();
      }
      if (draperyOrder.workOrderId) {
        this.setState(
          (state) => ({
            ...state,
            isLoadingOpen: open,
            workOrderPdfStatus: open ? 'downloading' : 'none',
            workOrderPdfContent: res,
            workOrderEditMode: false,
            loadingUpdate: false,
            isLoading: shouldUpdatePricing || open ? true : state.isLoading,
            workOrderPdfContentSummery: res,
          }),
          async () => {
            if (!shouldUpdatePricing) {
              this.setState((prev) => {
                return {
                  ...prev,
                  loadingUpdate: false,
                  isLoading: false,
                };
              });
            } else if (this.state.orderType === 'custom-order') {
              this.setState((prev) => {
                return {
                  ...prev,
                  loadingUpdate: false,
                  isLoading: false,
                };
              });
            } else {
              if (this.state.orderType === 'roman-shade-order') {
                await this.saveRomanShadePricing(workRoomSettings);
              } else {
                await this.saveDraperyOrderPricing(workRoomSettings, widthConfiguration);
              }
            }
            if (open && draperyOrder.workOrderId) {
              const resDraperyOrder = await getAllInfo(draperyOrder.id);
              const workOrder: WorkOrderModule.WorkOrder = resDraperyOrder.workOrder;
              const storeId = `${accountId}_pdfs`;
              let pdfLink;
              let buffer;
              // let dueDate = res.dueDate
              let currentDateFromSummary = this.state.draperyOrderSummary.productionJson.dueDate;
              let currentHasRelatedWorkOrders = this.state.draperyOrder.hasRelatedWorkOrders
                ? 1
                : 0;
              let currentRelatedWorkOrders = this.state.draperyOrder.related;
              let dueDateForLambda = currentDateFromSummary
                ? moment(currentDateFromSummary).local().format('MM/DD/YYYY')
                : '';

              const needNewPDF =
                !moment
                  .utc(workOrder.dueDatePdf || undefined)
                  .startOf('day')
                  .isSame(moment.utc(currentDateFromSummary || undefined).startOf('day')) ||
                workOrder.relatedPdf !== currentRelatedWorkOrders ||
                workOrder.hasRelatedWorkOrdersPdf !== currentHasRelatedWorkOrders;
              const responseForLambda = {
                ...res,
                dueDate: dueDateForLambda,
                needNewPDF: needNewPDF,
              };

              if (!workOrder.pdfLink || needNewPDF) {
                const lambdaResponse = await callLambda(
                  responseForLambda,
                  accountId,
                  '',
                  workOrder
                );
                const { pdfData } = lambdaResponse;
                pdfLink = getPdfFileNameFromLambdaResponse(lambdaResponse);
                buffer = pdfData ? Buffer.from(pdfData, 'base64') : undefined;
                await editWorkOrder({
                  ...workOrder,
                  dueDatePdf: currentDateFromSummary,
                  pdfLink,
                  hasRelatedWorkOrdersPdf: currentHasRelatedWorkOrders ? 1 : 0,
                  relatedPdf: currentRelatedWorkOrders,
                });
              }

              if (buffer && pdfLink) {
                await storeFile(storeId, pdfLink, buffer, Config.fileStoreUrl);
              }

              if (buffer) {
                const blob = new Blob([buffer], {
                  type: 'application/pdf',
                });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
              } else {
                const fileName = pdfLink ? pdfLink : workOrder.pdfLink;
                if (fileName) {
                  await openStoredPdf(storeId, fileName, Config.fileStoreUrl);
                }
              }
              if (!workOrder.pdfLink) {
                await editWorkOrder({ ...workOrder, pdfLink, pdfGeneratedAt: new Date() });
              }

              this.handleDraperyPdfFinished(true);
            }
          }
        );
      } else {
        this.setState(
          (state) => ({
            ...state,
            workOrderPdfStatus: 'none',
            workOrderPdfContent: res,
            workOrderPdfContentSummery: res,
          }),
          async () => {
            if (!shouldUpdatePricing) {
              this.setState((prev) => {
                return {
                  ...prev,
                  loadingUpdate: false,
                  isLoading: false,
                };
              });
            } else if (this.state.orderType === 'custom-order') {
              this.setState((prev) => {
                return {
                  ...prev,
                  loadingUpdate: false,
                  isLoading: false,
                };
              });
            } else {
              if (this.state.orderType === 'roman-shade-order') {
                await this.saveRomanShadePricing(workRoomSettings);
              } else {
                await this.saveDraperyOrderPricing(workRoomSettings, widthConfiguration);
              }
            }
          }
        );
      }
    }
  }

  @Bind()
  private async handleDraperyPdfFinished(success: boolean): Promise<void> {
    const { dispatch } = this.props;
    const { isLoadingOpen } = this.state;

    if (success) {
      if (!isLoadingOpen) {
        const notification: NotificationsModule.Notification = {
          id: 0,
          message: 'Work order created successfully!',
          type: 'info',
        };
        dispatch(NotificationsModule.addNotification(notification));
      }
      this.setState({
        workOrderPdfStatus: 'none',
        isLoadingOpen: false,
      });
    } else {
      if (!isLoadingOpen) {
        const notification: NotificationsModule.Notification = {
          id: 0,
          message: 'Failed to create work order !',
          type: 'error',
        };
        dispatch(NotificationsModule.addNotification(notification));
      }
      this.setState({
        workOrderPdfStatus: 'error',
        isLoadingOpen: false,
      });
    }
  }

  @Bind()
  private async getDefaultConstruction(): Promise<void> {
    let type = -1;
    if (this.state.draperyOrderDesign.headingType === 'rodandrings') {
      switch (this.state.draperyOrderDesign.draperyType) {
        case 'full-length':
          type = 1;
          break;
        case 'cafe-curtain':
          type = 2;
          break;
      }
    }
    if (this.state.draperyOrderDesign.headingType === 'ripplefold') {
      type = 3;
    }
    if (this.state.orderType === 'roman-shade-order') {
      type = 4;
    }
    if (type === -1) {
      return;
    }

    await new Promise<void>((resolve) => {
      this.setState(
        (state) => ({
          ...state,
          isLoadingConstructionDefaults: true,
        }),
        resolve
      );
    });

    await this.getDraperyItems({
      isReload: false,
      showDraperyItemModal: false,
    });

    if (name === 'romanShadeJson.style.function') {
      this.setState((state) => ({
        ...state,
        ['style.function']: -1,
      }));
    }

    const { accountId } = this.props;
    const res = await searchWorkroomSetting(accountId, type);
    this.processResponseErrors(res, 0, 'draperyOrderDesignErrors');
    if (res.error) {
      this.setState((state) => ({
        ...state,
        isLoadingConstructionDefaults: false,
      }));
      return;
    }
    if (res.length === 0) {
      this.setState((state) => ({
        ...state,
        isLoadingConstructionDefaults: false,
        draperyOrderDesignErrors: [{ tabIndex: 1, name: '', message: 'Invalid drapery type' }],
      }));
      return;
    }

    const resRomanShade = await searchWorkroomSetting(accountId, 4);

    if (resRomanShade.length > 0 && this.state.orderType === 'roman-shade-order') {
      this.setState((state) => ({
        ...state,
        mainFabric: {
          ...state.mainFabric,
          orderOrigin:
            resRomanShade[0].fabricPurchaser === 'Workroom'
              ? 1
              : resRomanShade[0].fabricPurchaser === 'Installer'
                ? 2
                : -1,
        },
        romanShadeSettings: resRomanShade[0],
      }));
    }

    let fold_size_override = this.state.isUpdateRomanShadeCSField;
    let wsIndex = 0;
    if (res.length > 1) {
      if (type === 2) {
        wsIndex = res.findIndex((ws: any) => ws.name === 'Drapery | Cafe Curtain');
      } else if (type === 3) {
        wsIndex = res.findIndex((ws: any) => ws.name === 'Drapery | Ripplefold');
      }
    }
    const workroomSetting = res[wsIndex];

    const buckram = workroomSetting.buckram;
    if (workroomSetting) {
      const isWorkRoom = workroomSetting.draperyPinInstaller === 'Workroom' ? true : false;
      await new Promise<void>((resolve) => {
        this.setState(
          (state) => ({
            ...state,
            reloadOnSaveConstructions: false,
            isLoadingConstructionDefaults: false,
            workroomSetting: workroomSetting,
            draperyOrderDesign: {
              ...state.draperyOrderDesign,
              customIsYardageAddOneExtra: !!workroomSetting.presetIsYardageAddOneExtra,
              customIsYardageAddExcess: !!workroomSetting.presetIsYardageAddExcess,
              customAddExcessValue: workroomSetting.presetAddExcessValue,
              customAddExcessUnit: workroomSetting.presetAddExcessUnit,
              customEmbellishmentJson: workroomSetting.presetEmbellishmentJson || {
                ...WorkroomSettingModule.defaultWorkroomPresetEmbellishmentJson,
              },
              customHEMSJson:
                this.state.orderType !== 'roman-shade-order'
                  ? workroomSetting.presetHEMSJson || {
                      ...WorkroomSettingModule.defaultWorkroomPresetHEMSJson,
                    }
                  : workroomSetting.presetHemsAndFoldsJson || {
                      ...WorkroomSettingModule.defaultWorkroomPresetHEMSJson,
                    },
              customReturnOverlapJson: workroomSetting.presetReturnOverlapJson || {
                ...WorkroomSettingModule.defaultWorkroomPresetReturnOverlapJson,
              },
              customCutLengthJson: workroomSetting.presetCutLengthJson || {
                ...WorkroomSettingModule.defaultWorkroomPresetCutLengthJson,
              },
              customDraperyFullnessJson: workroomSetting.presetDraperyFullnessJson || {
                ...WorkroomSettingModule.defaultWorkroomPresetDraperyFullnessJson,
              },
              draperyFullness:
                workroomSetting.presetDraperyFullnessJson &&
                workroomSetting.presetDraperyFullnessJson.value
                  ? workroomSetting.presetDraperyFullnessJson.value
                  : 0,
              isPinSet: isWorkRoom,
              buckram,
              customHemsAndFoldsJson: workroomSetting.presetHemsAndFoldsJson || {},
              customValanceAndReturnsJson: workroomSetting.presetValanceAndReturnsJson || {},
              customLiningsJson: workroomSetting.presetLiningsJson || {},
              romanShadeJson: {
                ...state.draperyOrderDesign.romanShadeJson,
                dimensions: {
                  ...((state.draperyOrderDesign &&
                    state.draperyOrderDesign.romanShadeJson &&
                    state.draperyOrderDesign.romanShadeJson.dimensions) ||
                    {}),
                  foldSize:
                    !fold_size_override &&
                    workroomSetting.presetHemsAndFoldsJson &&
                    workroomSetting.presetHemsAndFoldsJson.foldsFinishedSize
                      ? workroomSetting.presetHemsAndFoldsJson.foldsFinishedSize
                      : (state.draperyOrderDesign &&
                          state.draperyOrderDesign.romanShadeJson &&
                          state.draperyOrderDesign.romanShadeJson.dimensions &&
                          state.draperyOrderDesign.romanShadeJson.dimensions.foldSize) ||
                        null,
                },
              },
            },
            // mainFabric: {
            //     ...state.mainFabric,
            //     orderOrigin:
            //         workroomSetting.fabricPurchaser === "Workroom"
            //             ? 1
            //             : workroomSetting.fabricPurchaser === "No Default"
            //             ? -1
            //             : 2,
            // },
          }),
          resolve
        );
      });
    } else {
      await new Promise<void>((resolve) => {
        this.setState(
          (state) => ({
            ...state,
            reloadOnSaveConstructions: false,
            isLoadingConstructionDefaults: false,
            draperyOrderDesign: {
              ...state.draperyOrderDesign,
              customIsYardageAddOneExtra: false,
              customIsYardageAddExcess: false,
              customAddExcessValue: undefined,
              customAddExcessUnit: undefined,
              customEmbellishmentJson: {
                ...WorkroomSettingModule.defaultWorkroomPresetEmbellishmentJson,
              },
              customHEMSJson: {
                ...WorkroomSettingModule.defaultWorkroomPresetHEMSJson,
              },
              customReturnOverlapJson: {
                ...WorkroomSettingModule.defaultWorkroomPresetReturnOverlapJson,
              },
              customCutLengthJson: {
                ...WorkroomSettingModule.defaultWorkroomPresetCutLengthJson,
              },
              customDraperyFullnessJson: {
                ...WorkroomSettingModule.defaultWorkroomPresetDraperyFullnessJson,
              },
              customHemsAndFoldsJson: {},
              customValanceAndReturnsJson: {},
              customLiningsJson: {},
            },
          }),
          resolve
        );
      });
    }
  }

  @Bind()
  private setChanges(isChanged: boolean): void {
    this.setState((state) => ({
      ...state,
      isChanged,
    }));
  }

  // FE-4 section dirty tracking. lastSavedSnapshot is a deep-cloned copy of
  // the state slices each sub-save persists, captured (a) after the order data
  // loads in getExistingDraperyOrder and (b) after every successful saveAll.
  // captureCurrentSectionSlices reads live state (no clone) for comparison —
  // we only clone when storing as the "saved" baseline.
  private lastSavedSnapshot: {
    fabrics: any;
    hardware: any;
    upload: any;
    summary: any;
  } | null = null;

  private captureCurrentSectionSlices() {
    const s = this.state;
    const embellishmentSummaryComponents = [
      ...s.bandings,
      ...s.cordings,
      ...s.flanges,
      ...s.trims,
      ...s.othersEmbellishments,
    ].map(embellishment => embellishment.draperyOrderFabric?.draperyOrderSummaryComponent);

    return {
      fabrics: {
        mainFabric: s.mainFabric,
        headRail: s.headRail,
        bandings: s.bandings,
        cordings: s.cordings,
        flanges: s.flanges,
        trims: s.trims,
        othersEmbellishments: s.othersEmbellishments,
        liningsList: s.liningsList,
      },
      hardware: {
        hardware: s.draperyOrderHardware,
        headrail: s.draperyOrderHeadrail,
      },
      upload: {
        uploads: s.draperyOrderUploads,
      },
      summary: {
        summary: s.draperyOrderSummary,
        mainFabricComponent: s.mainFabric.draperyOrderSummaryComponent,
        headRailComponent: s.headRail.draperyOrderSummaryComponent,
        hardwareComponent: s.hardware.draperyOrderSummaryComponent,
        embellishmentComponents: embellishmentSummaryComponents,
        components: s.draperyOrderSummaryComponents,
      },
    };
  }

  private hasPendingSummaryComponentCreates(): boolean {
    const s = this.state;
    const embellishmentSummaryComponents = [
      ...s.bandings,
      ...s.cordings,
      ...s.flanges,
      ...s.trims,
      ...s.othersEmbellishments,
    ].map(embellishment => embellishment.draperyOrderFabric?.draperyOrderSummaryComponent);
    const components = [
      s.mainFabric.draperyOrderSummaryComponent,
      s.headRail.draperyOrderSummaryComponent,
      s.hardware.draperyOrderSummaryComponent,
      ...embellishmentSummaryComponents,
      ...s.draperyOrderSummaryComponents,
    ];

    return components.some(component => component?.id === 0 && !!component.item);
  }

  private captureSavedSnapshot(): void {
    try {
      this.lastSavedSnapshot = _.cloneDeep(this.captureCurrentSectionSlices());
    } catch (err) {
      // If cloning fails (e.g. circular refs in state), fall back to "always
      // dirty" by leaving lastSavedSnapshot null.
      // eslint-disable-next-line no-console
      console.warn(
        'captureSavedSnapshot failed; section dirty tracking disabled until next save',
        err
      );
      this.lastSavedSnapshot = null;
    }
  }

  @Bind()
  private handleToggleDesc(): void {
    this.setState((state) => ({
      ...state,
      isCollapsedDesc: !state.isCollapsedDesc,
    }));
  }

  @Bind()
  private clearErrors(): void {
    this.setState((state) => ({
      ...state,
      draperyOrderErrors: [],
      draperyOrderDesignErrors: [],
      draperyOrderFabricsErrors: [],
      draperyOrderHardwareErrors: [],
      draperyOrderSummaryErrors: [],
    }));
  }

  @Bind()
  private getEmbellishmentsByIndex(index: number): {
    name: string;
    list: DraperyOrderDesignEmbellishment[];
  } {
    const { bandings, cordings, flanges, trims, othersEmbellishments } = this.state;

    if (index === 0) {
      return { name: 'bandings', list: bandings };
    }
    if (index === 1) {
      return { name: 'cordings', list: cordings };
    }
    if (index === 2) {
      return { name: 'flanges', list: flanges };
    }
    if (index === 3) {
      return { name: 'trims', list: trims };
    }
    return { name: 'othersEmbellishments', list: othersEmbellishments };
  }

  @Bind()
  private handleAddUploads(uploads: any[], newUploads?: boolean): void {
    this.setState((prev) => {
      return {
        ...prev,
        draperyOrderUploads: {
          ...prev.draperyOrderUploads,
          items: newUploads ? [...prev.draperyOrderUploads.items, ...uploads] : uploads,
        },
      };
    });
  }

  @Bind()
  private handleDeleteTableRow(
    index: number,
    arrayName: string,
    targetKey: 'draperyOrderHardware' | 'draperyOrderHeadrail' = 'draperyOrderHardware'
  ): void {
    //@ts-ignore
    if (this.state[targetKey][arrayName] && this.state[targetKey][arrayName].length > 0) {
      //@ts-ignore
      const filteredArray = this.state[targetKey][arrayName].filter(
        (item: any, idx: number) => idx !== index
      );
      this.setState((prev) => {
        return {
          ...prev,
          [targetKey]: {
            ...prev[targetKey],
            [arrayName]: filteredArray,
          },
        };
      });
    }
  }

  @Bind()
  private updateHardwareState(e: any, newValue?: boolean, id?: number): void {
    const { name, value } = e.currentTarget;
    const key = name.split('.');
    const targetKey = key[0];
    const isHardware = targetKey === 'draperyOrderHardware';
    const isHeadrail = targetKey === 'draperyOrderHeadrail';
    const isHardwareLike = isHardware || isHeadrail;
    const stateKey = isHardwareLike
      ? key.includes('rods')
        ? 'rods'
        : key.includes('otherItems')
          ? 'otherItems'
          : ''
      : '';
    if (newValue) {
      if (!stateKey) return;
      this.setState((prev) => {
        const payload = {
          item: '',
          quantity: '',
          description: '',
          finish: '',
          newItem: true,
        };
        return {
          ...prev,
          [targetKey]: {
            ...prev[targetKey],
            [stateKey]: [...(prev[targetKey][stateKey] || []), payload],
          },
        };
      });
      return;
    }
    if (key && key.length === 2) {
      this.setState((prev) => {
        return {
          ...prev,
          [targetKey]: {
            ...prev[targetKey],
            [key[key.length - 1]]: value,
          },
        };
      });
    } else if (key && key.length === 3) {
      if (!stateKey || !isHardwareLike) return;

      const numberRegex = /^\d*\.?\d{0,2}$/;
      if (key[key.length - 1] === 'quantity') {
        const testRegex = numberRegex.test(value);
        if (!testRegex) return;
      }
      this.setState((prev) => {
        const newArray =
          prev[targetKey][stateKey] && prev[targetKey][stateKey].length > 0
            ? prev[targetKey][stateKey].map((item: any, index: any) => {
                if (index === id) {
                  return {
                    ...item,
                    [key[key.length - 1]]: value,
                  };
                }
                return item;
              })
            : [];
        return {
          ...prev,
          [targetKey]: {
            ...prev[targetKey],
            [stateKey]: newArray,
          },
        };
      });
    }
  }

  private calculateHardwarePricing(row: any, client?: any): string {
    // additional price adjustment
    const additionalPriceAdjustment = client?.billToParent
      ? client?.billingDetails?.additionalPriceAdjustment || 'none'
      : client?.billingDetailsDirectly?.additionalPriceAdjustment || 'none';
    // additional price adjustment value
    const additionalPriceAdjustmentValue = client?.billToParent
      ? Number(client?.billingDetails?.additionalPriceAdjustmentValue) || 0
      : Number(client?.billingDetailsDirectly?.additionalPriceAdjustmentValue) || 0;
    // additional price adjustment (discount or markup)
    const additionalPriceAdjustmentCalculate =
      additionalPriceAdjustment === 'discount'
        ? -additionalPriceAdjustmentValue
        : additionalPriceAdjustmentValue;

    const rawQuantity = row && row.quantity !== undefined ? row.quantity : '';
    const rawCost = row && row.cost !== undefined ? row.cost : '';
    const rawMarkup = row && row.markup !== undefined ? row.markup : '';

    const quantityStr =
      rawQuantity !== null && rawQuantity !== undefined ? String(rawQuantity) : '';
    const costStr = rawCost !== null && rawCost !== undefined ? String(rawCost) : '';
    const markupStr = rawMarkup !== null && rawMarkup !== undefined ? String(rawMarkup) : '';

    if (quantityStr === '' || costStr === '') return '';

    const quantity = parseFloat(quantityStr.replace(/,/g, ''));
    const cost = parseFloat(costStr.replace(/,/g, ''));
    const markup = parseFloat(markupStr.replace(/,/g, '')) || 0;

    if (!isFinite(quantity) || !isFinite(cost)) return '';

    // Total sum of client additional price adjustment and markup
    const totalPercentage = markup / 100 + additionalPriceAdjustmentCalculate / 100;

    const calculatedPrice = quantity * cost * (1 + totalPercentage);
    if (!isFinite(calculatedPrice)) return '';

    return calculatedPrice.toFixed(2);
  }

  private normalizeShippingDecimalValue(value: any) {
    if (value === null || value === undefined || value === '') {
      return value;
    }
    const parsed = Number(String(value).replace(/,/g, ''));
    if (!Number.isFinite(parsed)) {
      return value;
    }
    return parsed.toFixed(2);
  }

  private normalizeMarkupValue(value: any) {
    if (value === null || value === undefined || value === '') {
      return '0.00';
    }
    const parsed = Number(String(value).replace(/,/g, ''));
    if (!Number.isFinite(parsed)) {
      return value;
    }
    return parsed.toFixed(2);
  }

  private normalizeShippingRowDecimals(
    row: any,
    customerKey: 'customerPrice' | 'customerFacingPrice'
  ) {
    if (!row) {
      return row;
    }
    return {
      ...row,
      cost: this.normalizeShippingDecimalValue(row.cost),
      markup: this.normalizeMarkupValue(row.markup),
      [customerKey]: this.normalizeShippingDecimalValue(row[customerKey]),
    };
  }

  @Bind()
  private handleHardwarePricingChange(
    index: number,
    field: 'item' | 'estimateDescription' | 'cost' | 'quantity' | 'markup' | 'customerPrice',
    rawValue: string,
    isShipping?: boolean
  ): void {
    // additional price adjustment
    const additionalPriceAdjustment =
      this.state.draperyOrderHardware?.hardwareAdditionalPriceAdjustmentType || 'none';
    // additional price adjustment value
    const additionalPriceAdjustmentValue =
      Number(this.state.draperyOrderHardware?.hardwareAdditionalPriceAdjustment) || 0;
    // additional price adjustment (discount or markup)
    const additionalPriceAdjustmentCalculate =
      additionalPriceAdjustment === 'discount'
        ? -additionalPriceAdjustmentValue
        : additionalPriceAdjustmentValue;

    this.setState((prev) => {
      const isHeadrail = prev.orderType === 'roman-shade-order';
      const isDraperyOrder = prev.orderType === 'drapery-order';
      const pricingSource = isHeadrail ? prev.draperyOrderHeadrail : prev.draperyOrderHardware;
      const headrailCustomerRaw = prev.draperyOrderHeadrail.customerFacingPrice;
      const hardwareCustomerRaw = pricingSource?.hardwareCustomerFacingPrice;
      const currentMain = isHeadrail
        ? {
            estimateDescription: prev.draperyOrderHeadrail.estimateDescription || '',
            quantity:
              prev.draperyOrderHeadrail.quantity !== undefined &&
              prev.draperyOrderHeadrail.quantity !== null
                ? String(prev.draperyOrderHeadrail.quantity)
                : '',
            cost:
              prev.draperyOrderHeadrail.cost !== undefined &&
              prev.draperyOrderHeadrail.cost !== null
                ? String(prev.draperyOrderHeadrail.cost)
                : '',
            markup:
              prev.draperyOrderHeadrail.markup !== undefined &&
              prev.draperyOrderHeadrail.markup !== null
                ? String(prev.draperyOrderHeadrail.markup)
                : '',
            customerPrice:
              headrailCustomerRaw === null
                ? null
                : headrailCustomerRaw !== undefined
                  ? String(headrailCustomerRaw)
                  : '',
          }
        : {
            item: pricingSource?.hardwareItem || '',
            estimateDescription: pricingSource?.hardwareDescription || '',
            quantity:
              pricingSource?.hardwareQuantity !== undefined &&
              pricingSource?.hardwareQuantity !== null
                ? String(pricingSource.hardwareQuantity)
                : '1',
            cost:
              pricingSource?.hardwareUnitPrice !== undefined &&
              pricingSource?.hardwareUnitPrice !== null
                ? String(pricingSource.hardwareUnitPrice)
                : '',
            markup:
              pricingSource?.hardwareMarkup !== undefined && pricingSource?.hardwareMarkup !== null
                ? String(pricingSource.hardwareMarkup)
                : '',
            customerPrice:
              hardwareCustomerRaw === null
                ? null
                : hardwareCustomerRaw !== undefined
                  ? String(hardwareCustomerRaw)
                  : '',
          };

      const headrailSih = prev.draperyOrderHeadrail.headrailSih || {
        description: 'Shipping & Handling for Headrail',
        cost: '',
        markup: '',
        calculatedPrice: '',
        customerFacingPrice: '',
        active: false,
      };

      const shippingRow = isHeadrail
        ? {
            estimateDescription: headrailSih.description || 'Shipping & Handling for Headrail',
            quantity: '1',
            cost: headrailSih.cost ?? '',
            markup: headrailSih.markup ?? '',
            customerPrice:
              headrailSih.customerFacingPrice === null
                ? null
                : headrailSih.customerFacingPrice !== undefined
                  ? headrailSih.customerFacingPrice
                  : '',
            active: !!headrailSih.active,
          }
        : (pricingSource as any).hardwareSih || {
            item: '',
            estimateDescription: isDraperyOrder
              ? 'Shipping & Handling for Hardware'
              : 'Shipping & Handling for Components',
            quantity: '1',
            cost: '',
            markup: '',
            customerPrice: '',
            active: false,
          };

      const targetRow = isShipping ? shippingRow : currentMain;

      let value = rawValue;
      if (field !== 'estimateDescription' && field !== 'item') {
        value = value.replace(/,/g, '');
        if (field === 'quantity') {
          const quantityRegex = /^\d*\.?\d*$/;
          if (value && !quantityRegex.test(value)) {
            return prev;
          }
        } else {
          const decimalRegex = /^\d*\.?\d{0,2}$/;
          if (value && !decimalRegex.test(value)) {
            return prev;
          }
        }
      }

      const updatedRow = { ...targetRow, [field]: value };
      const calculatedPrice = this.calculateHardwarePricing(updatedRow, this.state.client);
      let nextCustomerPrice = targetRow.customerPrice;
      if (field === 'customerPrice') {
        nextCustomerPrice = value === '' ? calculatedPrice : value;
      } else if (['cost', 'quantity', 'markup'].includes(field)) {
        nextCustomerPrice = calculatedPrice;
      }
      const rowWithPricing = {
        ...updatedRow,
        calculatedPrice,
        customerPrice: nextCustomerPrice,
      };

      if (isHeadrail) {
        if (isShipping) {
          const nextHeadrailSih = {
            ...headrailSih,
            description: rowWithPricing.estimateDescription,
            cost: rowWithPricing.cost,
            markup: rowWithPricing.markup,
            calculatedPrice: rowWithPricing.calculatedPrice,
            customerFacingPrice: rowWithPricing.customerPrice,
          };

          return {
            ...prev,
            draperyOrderHeadrail: {
              ...prev.draperyOrderHeadrail,
              headrailSih: nextHeadrailSih,
            },
          };
        }

        const nextMainPricing = {
          ...currentMain,
          ...rowWithPricing,
        };

        return {
          ...prev,
          draperyOrderHeadrail: {
            ...prev.draperyOrderHeadrail,
            estimateDescription: nextMainPricing.estimateDescription,
            quantity: nextMainPricing.quantity,
            cost: nextMainPricing.cost,
            markup: nextMainPricing.markup,
            calculatedPrice: nextMainPricing.calculatedPrice,
            customerFacingPrice: nextMainPricing.customerPrice,
          },
        };
      }

      if (isShipping) {
        const nextHardwareSih = {
          ...shippingRow,
          ...rowWithPricing,
        };

        return {
          ...prev,
          draperyOrderHardware: {
            ...prev.draperyOrderHardware,
            hardwareSih: nextHardwareSih,
          },
        };
      }

      const nextMainPricing = {
        ...currentMain,
        ...rowWithPricing,
      };

      return {
        ...prev,
        draperyOrderHardware: {
          ...prev.draperyOrderHardware,
          hardwareItem: nextMainPricing.item,
          hardwareDescription: nextMainPricing.estimateDescription,
          hardwareQuantity: nextMainPricing.quantity,
          hardwareUnitPrice: nextMainPricing.cost,
          hardwareMarkup: nextMainPricing.markup,
          hardwareCustomerFacingPrice: nextMainPricing.customerPrice,
        },
      };
    });
  }

  @Bind()
  private handleToggleHardwareShipping(include: boolean): void {
    this.setState((prev) => {
      if (prev.orderType === 'roman-shade-order') {
        const headrailSih = prev.draperyOrderHeadrail.headrailSih || {};
        return {
          ...prev,
          draperyOrderHeadrail: {
            ...prev.draperyOrderHeadrail,
            headrailSih: {
              ...headrailSih,
              description: headrailSih.description || 'Shipping & Handling for Headrail',
              cost: headrailSih.cost || '',
              markup: headrailSih.markup ?? '',
              calculatedPrice: headrailSih.calculatedPrice || '',
              customerFacingPrice:
                headrailSih.customerFacingPrice !== undefined
                  ? headrailSih.customerFacingPrice
                  : '',
              active: include,
            },
          },
        };
      }

      const isDraperyOrder = prev.orderType === 'drapery-order';
      const pricingSource = prev.draperyOrderHardware;
      const defaultDescription = isDraperyOrder
        ? 'Shipping & Handling for Hardware'
        : 'Shipping & Handling for Components';
      const hardwareSih = (pricingSource as any).hardwareSih || {};
      const nextHardwareSih = {
        ...hardwareSih,
        item: hardwareSih.item || '',
        estimateDescription: hardwareSih.estimateDescription || defaultDescription,
        quantity: hardwareSih.quantity || '1',
        cost: hardwareSih.cost || '',
        markup: hardwareSih.markup ?? '',
        customerPrice: hardwareSih.customerPrice !== undefined ? hardwareSih.customerPrice : '',
        active: include,
      };

      return {
        ...prev,
        draperyOrderHardware: {
          ...prev.draperyOrderHardware,
          hardwareSih: nextHardwareSih,
        },
      };
    });
  }

  private endsWithNumber = (str: string) => {
    return /\d$/.test(str);
  };

  private setSavingStateByName(
    name: string,
    value: string | number | boolean | number[] | undefined | object | Date | null,
  ): Promise<void> {
    const nameList = name.split(".");
    const nextValue = value === undefined ? null : value;

    return new Promise(resolve => {
      this.setState(
        state => {
          const nextState = { ...state };
          let target: any = nextState;

          for (const key of nameList.slice(0, nameList.length - 1)) {
            const currentValue = target[key];
            target[key] = Array.isArray(currentValue)
              ? [...currentValue]
              : currentValue && typeof currentValue === "object"
                ? { ...currentValue }
                : {};
            target = target[key];
          }

          target[nameList[nameList.length - 1]] = nextValue;
          return nextState;
        },
        () => resolve()
      );
    });
  }

  @Bind()
  private updateStateByName(
    name: string,
    value: string | number | boolean | number[] | undefined | object | Date | null,
    isSaving?: boolean
  ) {
    const nameList = name.split('.');

    if (value === undefined) value = null;
    this.setState(
      (state) => {
        if (nameList.length === 1 && name.includes('isNoneEmbellishment')) {
          return {
            ...state,
            [name]: value,
            embellishmentsList: state.embellishmentsList.map((emb) => {
              return { ...emb, checked: false };
            }),
          };
        }
        if (nameList.length === 1 && name.includes('isNoneLinings')) {
          return {
            ...state,
            [name]: value,
            liningsList: state.liningsList.map((ling) => {
              return { ...ling, active: false };
            }),
          };
        }
        if (
          nameList.length === 1 &&
          !name.includes('isNoneLinings') &&
          !name.includes('isNoneEmbellishment')
        ) {
          return {
            ...state,
            [name]: value,
          };
        }
        if (nameList.length === 2) {
          if (nameList[1] === 'itemTypeId') {
            return {
              ...state,
              [nameList[0]]: {
                ...state[nameList[0]],
                itemType: {
                  ...state[nameList[0]].itemType,
                  id: value,
                },
                [nameList[1]]: value,
              },
            };
          } else if (nameList[1] === 'itemTypeName') {
            return {
              ...state,
              [nameList[0]]: {
                ...state[nameList[0]],
                itemType: {
                  ...state[nameList[0]].itemType,
                  name: value,
                },
                [nameList[1]]: value,
              },
            };
          } else {
            return {
              ...state,
              [nameList[0]]: {
                ...state[nameList[0]],
                [nameList[1]]: value,
              },
            };
          }
        }

        if (nameList.length >= 3) {
          let target = state[nameList[0]];
          for (const name of nameList.slice(1, nameList.length - 1)) {
            target = target[name];
          }
          if (
            nameList[0] === 'othersEmbellishments' &&
            nameList[2] === 'name' &&
            target.draperyOrderFabric &&
            target.draperyOrderFabric.draperyOrderSummaryComponent
          ) {
            target.draperyOrderFabric.draperyOrderSummaryComponent.item = `${value} FABRIC`;
          }
          if (nameList[0] === 'liningsList' && nameList[2] === 'description') {
            if (
              target.active === false &&
              value !== '' &&
              typeof value === 'string' &&
              target.description &&
              target.description.length < value.length
            ) {
              target.active = true;
            }
          }
          const propertyName = nameList.pop();
          if (
            propertyName !== undefined &&
            target &&
            typeof target === 'object' &&
            !Array.isArray(target)
          ) {
            target[propertyName] = value;
            if (propertyName === 'sideHemFabricAllowance' && (value || value === 0)) {
              state.draperyOrderDesign.customEmbellishmentJson.bandingHorizontal = +value * 2;
              state.draperyOrderDesign.customEmbellishmentJson.cordingHorizontal = +value * 2;
              if (state.draperyOrderDesign.headingType === 'ripplefold') {
                state.draperyOrderDesign.customEmbellishmentJson.flangeHorizontal = +value * 2;
              } else {
                state.draperyOrderDesign.customEmbellishmentJson.flangeHorizontal = +value;
              }
            }
          }

          if (name.includes('checked') && value) {
            return {
              ...state,
              isNoneEmbellishment: false,
            };
          }

          if (name.includes('liningsList.') && name.includes('active') && value) {
            return {
              ...state,
              isNoneLinings: false,
            };
          }
          if (name.includes('draperyOrder.userConfirmation.') && typeof value === 'boolean') {
            if (this.state.mainFabric.directionOfUse === 1) {
              return {
                ...state,
                checkedAllowExtraWidthOne: value,
              };
            } else {
              return {
                ...state,
                checkedAllowExtraWidthTwo: value,
              };
            }
          }
        }

        const stateNameList = state[nameList[0]];
        return {
          ...state,
          [nameList[0]]: Array.isArray(stateNameList) ? [...stateNameList] : { ...stateNameList },
        };
      },
      async () => {
        const updateArr: any = [];
        if (nameList[1] === '4' && name.includes('checked')) {
          this.state.othersEmbellishments.map((item) => {
            if (item.draperyOrderFabric) {
              item.draperyOrderFabric = {
                ...item.draperyOrderFabric,
                name: ' FABRIC',
              };
              updateArr.push(item);
            }
          });
        }
        if (updateArr.length > 0) {
          this.setState({ othersEmbellishments: updateArr });
        }
        if (name === 'draperyOrderDesign.draperyType') {
          await this.getDefaultConstruction();
        }
        if (name === 'draperyOrderDesign.headingType') {
          await this.getDefaultConstruction();
        }
        this.setState((state) => ({ ...state, validateClient: true }));
        if (!isSaving) {
          this.setChanges(true);
          this.validateAll('update');
          if (this.validateAll('workOrder')) {
            // this.setState((state) => ({
            //   ...state,
            //   isSidebarHidden: false,
            // }));
          }
        }
        if (name === 'draperyOrder.isDraft') {
          if (!this.state.workOrderEditMode) {
            await this.saveDraperyOrderApi();
          }
        }
        const highlightedSectionArr = this.state.highlightedSection
          ? this.state.highlightedSection.split('.')
          : [];
        if (
          (name.includes('pattern') || name.includes('patternId')) &&
          highlightedSectionArr.length === 3 &&
          ![null, undefined, ''].includes(
            this.state[highlightedSectionArr[0]][highlightedSectionArr[1]][highlightedSectionArr[2]]
          )
        ) {
          this.setState({
            highlightedSection: null,
          });
        } else if (
          (name.includes('pattern') ||
            name.includes('patternId') ||
            name.includes('liningsList')) &&
          highlightedSectionArr.length === 5 &&
          ![null, undefined, ''].includes(
            this.state[highlightedSectionArr[0]][highlightedSectionArr[1]][
              highlightedSectionArr[2]
            ][highlightedSectionArr[3]][highlightedSectionArr[4]]
          )
        ) {
          this.setState({
            highlightedSection: null,
          });
        }
      }
    );
  }

  private numberingTrims = (arg?: string | undefined): void => {
    if (
      (arg === undefined && this.state.trims.length > 1) ||
      (arg !== undefined && this.state.trims.length > 0)
    ) {
      let result = this.state.trims.map((trim, index) => {
        if (trim.draperyOrderFabric) {
          if (this.endsWithNumber(trim.draperyOrderFabric.name)) {
            return {
              ...trim,
              draperyOrderFabric: {
                ...trim.draperyOrderFabric,
                name: `${trim.draperyOrderFabric.name
                  .slice(0, trim.draperyOrderFabric.name.length - 1)
                  .trim()} ${this.state.trims.length > 1 ? index + 1 : ''}`,
                draperyOrderSummaryComponent: {
                  ...trim.draperyOrderFabric.draperyOrderSummaryComponent,
                  item: `${trim.draperyOrderFabric.name
                    .slice(0, trim.draperyOrderFabric.name.length - 1)
                    .trim()} ${this.state.trims.length > 1 ? index + 1 : ''}`,
                },
              },
            };
          } else {
            return {
              ...trim,
              draperyOrderFabric: {
                ...trim.draperyOrderFabric,
                name: `${trim.draperyOrderFabric.name.trim()} ${
                  this.state.trims.length > 1 ? index + 1 : ''
                }`,
                draperyOrderSummaryComponent: {
                  ...trim.draperyOrderFabric.draperyOrderSummaryComponent,
                  item: `${trim.draperyOrderFabric.name.trim()} ${
                    this.state.trims.length > 1 ? index + 1 : ''
                  }`,
                },
              },
            };
          }
        }
        return trim;
      });
      this.setState({ trims: result });
    }
  };

  @Bind()
  private handleInputChangeForNumber(e: ChangeEvent<HTMLInputElement>): void {
    let { name, value } = e.currentTarget;
    if (value.startsWith('00')) {
      e.currentTarget.value = value.replace(/^0+/, '0');
    }
    const nValue = value ? +value : undefined;
    const romanShadeSettings = this.state.romanShadeSettings;
    this.clearHighlightSection(name);

    if (name.includes('draperyOrderFabric.yardsRecommended') && nValue) {
      const regex = /^(?:\d{1,3})(?:\.\d{1,3})?$/;
      if (!regex.test(value) || nValue > 999.999 || nValue < 0) {
        value = value.slice(0, -1);
        this.updateStateByName(name, value);
        return;
      }
    }
    if (
      [
        'draperyOrderDesign.customLiningsJson.liningVerticalAllowance',
        'draperyOrderDesign.customLiningsJson.interliningVerticalAllowance',
      ].includes(name) &&
      value
    ) {
      const regex = /^-?(\d{0,2}(\.\d{0,2})?|\.\d{1,2})$/;

      if (value === '') {
        this.updateStateByName(name, undefined);
        return;
      }
      if (value === '-' || value === '.') {
        this.updateStateByName(name, value);
        return;
      }
      if (value === '-.') {
        value = '-0.';
      }
      if (value.startsWith('.')) {
        value = '0.' + value.slice(1);
      }
      if (value.includes('-.')) {
        value = '-0.' + value.slice(2);
      }
      if (regex.test(value)) {
        const num = parseFloat(value);
        if (num >= -99.99 && num <= 99.99) {
          this.updateStateByName(name, value);
        }
        return;
      }
      return;
    }
    if (name === 'draperyOrderDesign.customAddExcessValue' && nValue) {
      const regex = /^(?:[1-9]\d?(?:\.\d{1,2})?|\d\.\d{1,2})$/;
      if (!regex.test(value) || nValue > 99.99 || nValue < 0) {
        value = value.slice(0, -1);
        this.updateStateByName(name, value);
        return;
      }
    }
    if (name === 'draperyOrderSummary.totalPerUnit') {
      // Remove non-numeric characters except for the decimal point, limit to 5 digits before decimal
      const sanitizedValue =
        value
          .replace(/[^0-9.]/g, '') // Allow only numbers and decimal
          .replace(/(\..*?)\..*/g, '$1') // Prevent multiple decimals
          .replace(/^0+(\d)/, '$1')
          .match(/^\d{0,5}(\.\d{0,2})?/)![0] || '';

      // Allow empty input to set the state to null
      if (sanitizedValue === '') {
        this.updateStateByName(name, null);
        this.setState((prev) => ({
          ...prev,
          totalPerUnit: null,
        }));
        return;
      }

      // // Parse as float to validate within the range
      const numberValue = parseFloat(sanitizedValue);

      if (!isNaN(numberValue) && numberValue >= 0 && numberValue < 100000) {
        this.updateStateByName(name, sanitizedValue);
        this.setState((prev) => ({
          ...prev,
          totalPerUnit: sanitizedValue,
        }));
      } else {
        console.error('Invalid input for totalPerUnit. Must be a number between 0 and 99,999.99.');
      }
      return;
    }
    if (name === 'draperyOrderSummary.headrailPerUnit') {
      // Remove non-numeric characters except for the decimal point, limit to 5 digits before decimal
      const sanitizedValue =
        value
          .replace(/[^0-9.]/g, '') // Allow only numbers and decimal
          .replace(/(\..*?)\..*/g, '$1') // Prevent multiple decimals
          .replace(/^0+(\d)/, '$1')
          .match(/^\d{0,5}(\.\d{0,2})?/)![0] || '';

      // Allow empty input to set the state to null
      if (sanitizedValue === '') {
        this.updateStateByName(name, null);
        this.setState((prev) => ({
          ...prev,
          headrailPerUnit: null,
        }));
        return;
      }

      // // Parse as float to validate within the range
      const numberValue = parseFloat(sanitizedValue);

      if (!isNaN(numberValue) && numberValue >= 0 && numberValue < 100000) {
        this.updateStateByName(name, sanitizedValue);
        this.setState((prev) => ({
          ...prev,
          headrailPerUnit: sanitizedValue,
        }));
      } else {
        console.error(
          'Invalid input for headrailPerUnit. Must be a number between 0 and 99,999.99.'
        );
      }
      return;
    }

    if (name === 'draperyOrderDesign.category') {
      this.state.draperyOrderDesign.rodWidth = undefined;
      // if (!value) {
        this.state.draperyOrderDesign.panelJson = defaultWidthEachPanelList();
      // }
    } else if (name.endsWith('.orderOrigin')) {
      if (nValue === 2) {
        this.updateStateByName(
          name.replace('.orderOrigin', '.draperyOrderSummaryComponent.orderedDate'),
          undefined
        );
      } else if (nValue === 1) {
        this.updateStateByName(
          name.replace('.orderOrigin', '.draperyOrderSummaryComponent.orderedDate'),
          undefined
        );
      }
    } else if (
      name === 'draperyOrderDesign.rodWidth' ||
      name === 'draperyOrderDesign.finishedLengthOfPanels'
    ) {
      let roundedValue;

      if (nValue !== undefined) {
        const roundedDecimal = +nValue.toFixed(3);

        roundedValue = Math.min(Math.max(roundedDecimal, 1), 999);
      } else {
        roundedValue = undefined;
      }

      this.updateStateByName(name, roundedValue);
      return;
    }

    if (
      name === 'mainFabric.values.horizontalRepeat' ||
      name === 'mainFabric.values.verticalRepeat'
    ) {
      const currentHorizontalRepeat =
        name === 'mainFabric.values.horizontalRepeat'
          ? Number(nValue || 0)
          : Number(this.state.mainFabric?.values?.horizontalRepeat || 0);
      const currentVerticalRepeat =
        name === 'mainFabric.values.verticalRepeat'
          ? Number(nValue || 0)
          : Number(this.state.mainFabric?.values?.verticalRepeat || 0);

      const hasHorizontalRepeat = currentHorizontalRepeat > 0;
      const hasAnyRepeat = hasHorizontalRepeat || currentVerticalRepeat > 0;

      if (!hasHorizontalRepeat) {
        this.updateStateByName('mainFabric.isPleatToPattern', false);
      }

      if (!hasAnyRepeat) {
        this.updateStateByName('mainFabric.isMatchRepeatAtSeams', false);
      } else {
        const previousHasAnyRepeat =
          Number(this.state.mainFabric?.values?.horizontalRepeat || 0) > 0 ||
          Number(this.state.mainFabric?.values?.verticalRepeat || 0) > 0;

        if (!previousHasAnyRepeat && !this.state.mainFabric?.isMatchRepeatAtSeams) {
          this.updateStateByName('mainFabric.isMatchRepeatAtSeams', true);
        }
      }
    }
    const constructionSettingsInputs = [
      'draperyOrderDesign.customHEMSJson.topHemFinishedSize',
      'draperyOrderDesign.customHEMSJson.topHemFabricAllowance',
      'draperyOrderDesign.customHEMSJson.bottomHemFinishedSize',
      'draperyOrderDesign.customHEMSJson.bottomHemFabricAllowance',
      'draperyOrderDesign.customHEMSJson.sideHemFinishedSize',
      'draperyOrderDesign.customHEMSJson.sideHemFabricAllowance',
      'draperyOrderDesign.customCutLengthJson.lining',
      'draperyOrderDesign.customCutLengthJson.interlining',
      'draperyOrderDesign.customEmbellishmentJson.flangeVertical',
      'draperyOrderDesign.customEmbellishmentJson.flangeHorizontal',
      'draperyOrderDesign.customEmbellishmentJson.trimVertical',
      'draperyOrderDesign.customEmbellishmentJson.trimHorizontal',
      'draperyOrderDesign.customEmbellishmentJson.cordingVertical',
      'draperyOrderDesign.customEmbellishmentJson.cordingHorizontal',
      'draperyOrderDesign.customEmbellishmentJson.trimVertical',
      'draperyOrderDesign.customEmbellishmentJson.trimVertical',
      'draperyOrderDesign.customReturnOverlapJson.leadSize',
      'draperyOrderDesign.customReturnOverlapJson.returnSize',
      'draperyOrderDesign.customReturnOverlapJson.overlapSize',
      'draperyOrderDesign.customHemsAndFoldsJson.topHemFabricAllowance',
      'draperyOrderDesign.customHemsAndFoldsJson.bottomNoSkirtHemFinishedSize',
      'draperyOrderDesign.customHemsAndFoldsJson.bottomNoSkirtHemAllowance',
      'draperyOrderDesign.customHemsAndFoldsJson.bottomWithSkirtHemFinishedSize',
      'draperyOrderDesign.customHemsAndFoldsJson.bottomWithSkirtHemAllowance',
      'draperyOrderDesign.customHemsAndFoldsJson.sideHemFinishedSize',
      'draperyOrderDesign.customHemsAndFoldsJson.sideHemFabricAllowance',
      'draperyOrderDesign.customValanceAndReturnsJson.frontValanceVerticalAllowance',
      'draperyOrderDesign.customValanceAndReturnsJson.frontValanceHorizontalAllowance',
      'draperyOrderDesign.customValanceAndReturnsJson.backValanceVerticalAllowance',
      'draperyOrderDesign.customValanceAndReturnsJson.backValanceHorizontalAllowance',
      'draperyOrderDesign.customValanceAndReturnsJson.sideFlapsVerticalAllowance',
      'draperyOrderDesign.customValanceAndReturnsJson.sideFlapsHorizontalAllowance',
      'draperyOrderDesign.customLiningsJson.liningVerticalAllowance',
      'draperyOrderDesign.customLiningsJson.interliningVerticalAllowance',
    ];

    if (name === 'draperyOrderDesign.romanShadeJson.dimensions.numOfPermanentFolds') {
      // Allow the value to be null or empty string
      if (value === '' || value === null || /^\d+$/.test(value.toString())) {
        // Update state with validated value (allow null or empty string)

        this.setState(
          (prev: any) => {
            return {
              ...prev,
              draperyOrderDesign: {
                ...prev.draperyOrderDesign,
                romanShadeJson: {
                  ...prev.draperyOrderDesign.romanShadeJson,
                  dimensions: {
                    ...prev.draperyOrderDesign.romanShadeJson.dimensions,
                    numOfPermanentFolds: value === '' || value === null ? null : value,
                  },
                },
              },
            };
          },
          async () => {
            this.validateAll('update');
          }
        );
      }
      this.clearHighlightSection('draperyOrderDesign.romanShadeJson.dimensions.foldSize');
      return;
    }

    const numericalRomanShadeInputs = [
      'frontValanceLength',
      'finishedWidth',
      'finishedLength',
      'foldSize',
      'bottomSkirtLength',
      'frontValanceLength',
      'sidesValanceLength',
      'backValanceLength',
      'boardFace',
      'boardDepth',
    ];
    // Validate input: up to 3 digits before and after the dot, no leading zeros unless '0.xxx'
    if (
      numericalRomanShadeInputs.includes(name.split('.').pop() as string) &&
      name.startsWith('draperyOrderDesign.romanShadeJson')
    ) {
      // Extract parent key
      const isValidFormat = /^(0|[1-9]\d{0,2})(\.\d{0,3})?$/.test(value) || value === '';

      if (!isValidFormat) {
        return;
      }

      this.setState(
        (prev: CalculatorState) => {
          const keys = name.split('.');
          const parentKey = keys.slice(-2, -1)[0]; // Get parent key, e.g., 'dimensions'
          const dimensionKey = keys.pop(); // Get base key, e.g., 'foldSize'

          return {
            ...prev,
            draperyOrderDesign: {
              ...prev.draperyOrderDesign,
              romanShadeJson: {
                ...prev.draperyOrderDesign.romanShadeJson,
                [parentKey]: {
                  ...prev.draperyOrderDesign.romanShadeJson[parentKey],
                  [dimensionKey as string]: value || null,
                },
              },
            },
          };
        },
        async () => {
          this.validateAll('update');
        }
      );

      return;
    }

    if (constructionSettingsInputs.includes(name)) {
      const regex = /^-?\d{0,2}(\.\d{0,2})?$/;
      const targetValue = e.currentTarget.value;

      if (!regex.test(targetValue)) {
        return;
      }

      if (targetValue && targetValue.includes('.') && targetValue.split('.')[1].length > 2) {
        return;
      }
    }

    if (name.includes('draperyOrderDesign.romanShadeJson.valanceAndReturns')) {
      if (
        this.state.trims &&
        this.state.trims.length > 0 &&
        +value === 0 &&
        name.includes('frontValance')
      ) {
        for (const trim of this.state.trims) {
          ['topEdge', 'bottomEdge', 'leadReturnEdge'].forEach((item) => {
            if (trim[item] && 'valance' in trim[item]) {
              delete trim[item].valance;
            }

            if (trim[item] && !trim[item].valance && !trim[item].shade) {
              trim[item].size = undefined;
              trim[item].insetSize = undefined;
              trim[item].insetActive = false;
            }
          });
        }
      }

      const field = name.split('.').pop();
      if (+value === 0) {
        if (
          this.state.liningsList &&
          this.state.liningsList.length > 0 &&
          this.state.liningsList[0] &&
          this.state.liningsList[1] &&
          !this.state.liningsList[0].active &&
          !this.state.liningsList[1].active
        ) {
          this.state.liningsList.forEach((item, index) => {
            const liningNameForErrorMessage = `liningsList.${index}.draperyOrderLiningsFabric.values.fabricWidth`;
            this.clearHighlightSection(liningNameForErrorMessage);
          });
        }
      }

      if (name === 'draperyOrderDesign.romanShadeJson.valanceAndReturns.frontValance') {
        if (
          value === '1' &&
          this.state.romanShadeSettingsChangedField &&
          !this.state.romanShadeSettingsChangedField.frontValanceLength
        ) {
          this.setState(
            (prevState) => ({
              ...prevState,
              draperyOrderDesign: {
                ...prevState.draperyOrderDesign,
                romanShadeJson: {
                  ...prevState.draperyOrderDesign.romanShadeJson,
                  valanceAndReturns: {
                    ...prevState.draperyOrderDesign.romanShadeJson.valanceAndReturns,
                    frontValanceLength:
                      this.state.romanShadeSettings.presetValanceAndReturnsJson.frontValanceLength,
                  },
                },
              },
            }),
            async () => {
              this.validateAll('update');
            }
          );
        } else if (
          value === '0' &&
          this.state.romanShadeSettingsChangedField &&
          !this.state.romanShadeSettingsChangedField.sidesValanceLength &&
          (this.state.romanShadeJson.valanceAndReturns.sides === 'returns' ||
            this.state.romanShadeJson.valanceAndReturns.sides === 'side-flaps')
        ) {
          this.setState(
            (prevState) => ({
              ...prevState,
              draperyOrderDesign: {
                ...prevState.draperyOrderDesign,
                romanShadeJson: {
                  ...prevState.draperyOrderDesign.romanShadeJson,
                  valanceAndReturns: {
                    ...prevState.draperyOrderDesign.romanShadeJson.valanceAndReturns,
                    sidesValanceLength:
                      this.state.romanShadeSettings.presetValanceAndReturnsJson.sideFlapsLength,
                  },
                },
              },
            }),
            async () => {
              this.validateAll('update');
            }
          );
        }
      }

      if (name === 'draperyOrderDesign.romanShadeJson.valanceAndReturns.backValance') {
        if (
          value === '1' &&
          this.state.romanShadeSettingsChangedField &&
          !this.state.romanShadeSettingsChangedField.backValanceLength
        ) {
          const orderOrigin =
            romanShadeSettings &&
            romanShadeSettings.liningsPurchaser &&
            romanShadeSettings.liningsPurchaser === 'Workroom'
              ? 1
              : romanShadeSettings.liningsPurchaser === 'Installer'
                ? 2
                : -1;

          this.setState(
            (prevState) => ({
              ...prevState,
              liningsList: [
                {
                  ...prevState.liningsList[0],
                  draperyOrderLiningsFabric: {
                    orderOrigin,
                    id: 0,
                    draperyOrderId: 0,
                    name: 'LINING FABRIC',
                    type: 20,
                    supplierId: 0,
                    pattern: '',
                    imageId: null,
                    isSpecialtyFabricHandling: false,
                    values: {},
                    supplierName: '',
                    draperyOrderSummaryComponent: {
                      id: 0,
                      item: 'LINING FABRIC',
                      draperyOrderSummaryId: 0,
                    },
                    ...prevState.liningsList[0].draperyOrderLiningsFabric,
                    isBackValance: true,
                  },
                },
                prevState.liningsList[1],
              ],
              draperyOrderDesign: {
                ...prevState.draperyOrderDesign,
                romanShadeJson: {
                  ...prevState.draperyOrderDesign.romanShadeJson,
                  valanceAndReturns: {
                    ...prevState.draperyOrderDesign.romanShadeJson.valanceAndReturns,
                    backValanceLength:
                      this.state.romanShadeSettings.presetValanceAndReturnsJson.backValanceLength,
                  },
                },
              },
            }),
            async () => {
              this.validateAll('update');
            }
          );
        }
      }

      this.setState(
        (prevState) => ({
          ...prevState,
          draperyOrderDesign: {
            ...prevState.draperyOrderDesign,
            romanShadeJson: {
              ...prevState.draperyOrderDesign.romanShadeJson,
              valanceAndReturns: {
                ...prevState.draperyOrderDesign.romanShadeJson.valanceAndReturns,
                [field as string]: +value,
              },
            },
          },
          romanShadeJson: {
            ...prevState.romanShadeJson,
            valanceAndReturns: {
              ...prevState.romanShadeJson.valanceAndReturns,
              [field as string]: +value,
            },
          },
        }),
        async () => {
          this.validateAll('update');
        }
      );
      return;
    }

    if (name.includes('draperyOrderDesign.romanShadeJson.style')) {
      const field = name.split('.').pop();

      if (name === 'draperyOrderDesign.romanShadeJson.style.function') {
        if (
          value === '0' &&
          this.state.romanShadeJson.style.type === 'relaxed' &&
          this.state.romanShadeSettingsChangedField &&
          !this.state.romanShadeSettingsChangedField.numOfPermanentFolds
        ) {
          this.setState(
            (prevState) => ({
              ...prevState,
              draperyOrderDesign: {
                ...prevState.draperyOrderDesign,
                romanShadeJson: {
                  ...prevState.draperyOrderDesign.romanShadeJson,
                  dimensions: {
                    ...prevState.draperyOrderDesign.romanShadeJson.dimensions,
                    numOfPermanentFolds:
                      this.state.romanShadeSettings.presetHemsAndFoldsJson.permanentFoldsFunctional,
                  },
                },
              },
            }),
            async () => {
              this.validateAll('update');
            }
          );
        } else if (
          value === '1' &&
          this.state.romanShadeSettingsChangedField &&
          !this.state.romanShadeSettingsChangedField.numOfPermanentFolds
        ) {
          this.setState(
            (prevState) => ({
              ...prevState,
              draperyOrderDesign: {
                ...prevState.draperyOrderDesign,
                romanShadeJson: {
                  ...prevState.draperyOrderDesign.romanShadeJson,
                  dimensions: {
                    ...prevState.draperyOrderDesign.romanShadeJson.dimensions,
                    numOfPermanentFolds:
                      this.state.romanShadeSettings.presetHemsAndFoldsJson.permanentFoldsFaux,
                  },
                },
              },
            }),
            async () => {
              this.validateAll('update');
            }
          );
        }
      }

      this.setState(
        (prevState) => ({
          ...prevState,
          draperyOrderDesign: {
            ...prevState.draperyOrderDesign,
            romanShadeJson: {
              ...prevState.draperyOrderDesign.romanShadeJson,
              style: {
                ...prevState.draperyOrderDesign.romanShadeJson.style,
                [field as string]: +value,
              },
            },
          },
          romanShadeJson: {
            ...prevState.romanShadeJson,
            style: {
              ...prevState.romanShadeJson.style,
              [field as string]: +value,
            },
          },
        }),
        async () => {
          this.validateAll('update');
        }
      );
      return;
    }

    if (name.includes('draperyOrderDesign.romanShadeJson.dimensions')) {
      const field = name.split('.').pop();

      if (name === 'draperyOrderDesign.romanShadeJson.dimensions.bottomSkirit') {
        if (
          value === '1' &&
          this.state.romanShadeSettingsChangedField &&
          !this.state.romanShadeSettingsChangedField.bottomSkirtLength
        ) {
          this.setState(
            (prevState) => ({
              ...prevState,
              draperyOrderDesign: {
                ...prevState.draperyOrderDesign,
                romanShadeJson: {
                  ...prevState.draperyOrderDesign.romanShadeJson,
                  dimensions: {
                    ...prevState.draperyOrderDesign.romanShadeJson.dimensions,
                    bottomSkirtLength:
                      this.state.romanShadeSettings.presetHemsAndFoldsJson
                        .bottomWithSkirtHemFinishedSize,
                  },
                },
              },
            }),
            async () => {
              this.validateAll('update');
            }
          );
        }
      }
      this.setState(
        (prevState) => ({
          ...prevState,
          draperyOrderDesign: {
            ...prevState.draperyOrderDesign,
            romanShadeJson: {
              ...prevState.draperyOrderDesign.romanShadeJson,
              dimensions: {
                ...prevState.draperyOrderDesign.romanShadeJson.dimensions,
                [field as string]: value ? +value : -1,
              },
            },
          },
          romanShadeJson: {
            ...prevState.romanShadeJson,
            dimensions: {
              ...prevState.romanShadeJson.dimensions,
              [field as string]: value ? +value : -1,
            },
          },
        }),
        async () => {
          this.validateAll('update');
        }
      );
      return;
    }

    this.updateStateByName(name, nValue);
  }

  @Bind()
  private handleChangeRipplefoldOptions(e: ChangeEvent<HTMLInputElement>): void {
    const { name, value } = e.currentTarget;

    this.clearHighlightSection(name);
    this.updateStateByName(name, value);
  }

  @Bind()
  private handleRemoveDraperyDesignCategory(value: number): void {
    if (this.state.draperyOrderDesign.category === value) {
      this.updateStateByName(`draperyOrderDesign.category`, value);
      this.setState((prev) => {
        return {
          ...prev,
          draperyOrderDesign: {
            ...prev.draperyOrderDesign,
            category: -1,
          },
        };
      });
    }
  }

  @Bind()
  private handleRemovePurchaser(field: 'purchaser' | 'receiver', value: number): void {
    const targetKey =
      this.state.orderType === 'roman-shade-order'
        ? 'draperyOrderHeadrail'
        : 'draperyOrderHardware';
    const target = this.state[targetKey];
    if (target[field] === value) {
      this.updateStateByName(`${targetKey}.${field}`, value);
      this.setState((prev) => {
        return {
          ...prev,
          [targetKey]: {
            ...prev[targetKey],
            [field]: 0,
          },
        };
      });
    }
  }

  @Bind()
  private handleRemoveRipplefoldDetail(key: string, value: string | undefined | null) {
    if (this.state.draperyOrderDesign.ripplefoldOptions[key] === value) {
      this.updateStateByName(`draperyOrderDesign.ripplefoldOptions.${key}`, value);
      this.setState((prev) => {
        return {
          ...prev,
          draperyOrderDesign: {
            ...prev.draperyOrderDesign,
            ripplefoldOptions: {
              ...prev.draperyOrderDesign.ripplefoldOptions,
              [key]: null,
            },
          },
        };
      });
    }
  }

  @Bind()
  private handleInputChangeForNumberPrice(
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void {
    const { name, value } = e.currentTarget;
    const clean = value.replace(/,/g, '');
    const regex = /^[+-]?[0-9]*\.?[0-9]*$/;
    this.clearHighlightSection(name);
    // Check if the input value contains a dot and if adding another dot would be invalid

    if (
      value.includes('+') ||
      value.includes('-') ||
      (value.includes('.') && value.match(/\./g)!.length > 1)
    ) {
      return;
    }
    if (
      (!value.includes('.') && value.length > 6) ||
      (value.includes('.') && value.split('.')[1].length > 2)
    )
      return;

    if (clean) {
      if (value === '.' || clean === '.' || clean.match(regex)) {
        if (!value.includes('.')) {
          const formattedValue = new Intl.NumberFormat().format(parseFloat(clean));
          this.updateStateByName(name, formattedValue);
        } else {
          this.updateStateByName(name, value);
        }
      }
    } else {
      this.updateStateByName(name, '');
    }
  }

  @Bind()
  private handleInputChangeForString(e: any, position?: string): void {
    const { name } = e.currentTarget;
    let { value } = e.currentTarget;

    if (name === 'draperyOrderDesign.weightRadio') {
      this.updateStateByName('draperyOrderDesign.isWeight', true);
    }
    const isDeselectingPanel = this.state.draperyOrderDesign.panelType === value;
    const isDeselectingPleat = this.state.draperyOrderDesign.pleatType === value;
    const isDeselectingDraperyType = this.state.draperyOrderDesign.draperyType === value;

    const isDeselectHeadingType = this.state.draperyOrderDesign.headingType === value;

    if (
      name === 'draperyOrderDesign.ripplefoldOptions.headerTape' ||
      name === 'draperyOrderDesign.ripplefoldOptions.controlLocation'
    ) {
      this.updateStateByName(name, value);
    }

    if (name === 'draperyOrder.window') {
      this.updateStateByName(name, value);
    }

    if (name === 'draperyOrderDesign.pinSetText') {
      this.updateStateByName(name, value);
    }

    if (name === 'draperyOrder.locationId') {
      this.updateStateByName(name, value);
    }

    if (name.split('.').length === 4 && !name.includes('romanShadeJson')) {
      if (value.length > 0) {
        this.updateStateByName(name, value);
      } else {
        this.updateStateByName(name, '');
      }
    }

    if (
      name.split('.').length === 3 &&
      !name.includes('romanShadeJson') &&
      !name.includes('qty') &&
      !name.includes('draperyOrderSummaryComponents')
    ) {
      const splited = name.split('.');
      for (let i = 0; i < this.state.othersEmbellishments.length; i++) {
        const name = `${splited[0]}.${i}.${splited[2]}`;
        this.clearHighlightSection(name);
      }
      if (value.length > 0) {
        this.updateStateByName(name, value);
      } else {
        this.updateStateByName(name, '');
      }
    }

    this.clearHighlightSection(name);
    if (name === 'draperyOrderDesign.panelType') {
      const currentConf = panelsConfiguration.filter((el) => el.name === value)[0];
      this.state.draperyOrderDesign.numOfPanels = currentConf.numberPanels;
    } else if (name === 'draperyOrderDesign.pleatType') {
      this.state.draperyOrderDesign.otherPleatImageId = undefined;
    } else if (name.endsWith('.insetSize')) {
      const nameList = name.split('.');
      const oldValue = this.state[nameList[0]][nameList[1]][nameList[2]][nameList[3]];

      if (!oldValue || oldValue.length < value.length) {
        this.updateStateByName(name.replace('.insetSize', '.insetActive'), true);
      }
      const decimalPlaces = value.split('.')[1];
      if (
        value.match(/[a-z]/i) ||
        (!value.includes('.') && value.length > 2) ||
        (value.includes('.') && decimalPlaces.length > 2) ||
        (!value.includes('.') && Number(oldValue) === 0 && value.length > 1) ||
        value.includes('+') ||
        value.includes('-')
      )
        return;
    } else if (name === 'draperyOrderDesign.notes') {
      // value = value.replace(/(\r\n|\n|\r)/gm, " ");
      if (this.state.orderType === 'custom-order') {
        value = value.length > 280 ? value.substr(0, 280) : value;
      } else if (this.state.orderType === 'roman-shade-order') {
        value = value.length > 150 ? value.substr(0, 150) : value;
      } else {
        value = value.length > 140 ? value.substr(0, 140) : value;
      }
      if (value.length > 0) this.updateStateByName(name, value);
      else this.updateStateByName(name, '');
    } else if (name === 'draperyOrderDesign.description') {
      if (value.length > 0) this.updateStateByName(name, value);
      else this.updateStateByName(name, '');
    } else if (name === 'draperyOrderSummary.notes') {
      // value = value.replace(/(\r\n|\n|\r)/gm, " ");
      value = value.length > 1000 ? value.substr(0, 1000) : value;
      if (value.length > 0) this.updateStateByName(name, value);
      else this.updateStateByName(name, '');
    } else if (name.includes('draperyOrderSummaryComponents.') && name.includes('.qty')) {
      const onlyNumbersRegex = /^\d*$/;

      if (value === '' || onlyNumbersRegex.test(value)) {
        this.updateStateByName(name, value);
      }

      return;
    } else if (name === 'draperyOrderDesign.draperyType') {
      this.setState({
        isCustomizeConstructionOpen: true,
      });
    }
    if (isDeselectingPanel) {
      this.updateStateByName('draperyOrderDesign.panelType', '');
    } else if (isDeselectingPleat) {
      this.updateStateByName('draperyOrderDesign.pleatType', '');
    } else if (isDeselectingDraperyType) {
      this.updateStateByName('draperyOrderDesign.draperyType', '');
      this.setState((prev) => {
        return {
          ...prev,
          isCustomizeConstructionOpen: false,
        };
      });
    } else if (isDeselectHeadingType) {
      this.updateStateByName('draperyOrderDesign.headingType', '');
      this.setState((prev) => {
        return {
          ...prev,
          isCustomizeConstructionOpen: false,
        };
      });
    } else if (!name.includes('romanShadeJson')) {
      this.updateStateByName(name, value);
    }

    if (name === 'draperyOrderDesign.romanShadeJson.style.type') {
      const currentType =
        this.state.romanShadeJson &&
        this.state.romanShadeJson.style &&
        this.state.romanShadeJson.style.type;
      const newTypeValue = currentType === value ? '' : value;

      if (
        value === 'relaxed' &&
        this.state.romanShadeJson.style.function === 0 &&
        this.state.romanShadeSettingsChangedField &&
        !this.state.romanShadeSettingsChangedField.numOfPermanentFolds
      ) {
        this.setState(
          (prevState) => ({
            ...prevState,
            draperyOrderDesign: {
              ...prevState.draperyOrderDesign,
              romanShadeJson: {
                ...prevState.draperyOrderDesign.romanShadeJson,
                dimensions: {
                  ...prevState.draperyOrderDesign.romanShadeJson.dimensions,
                  numOfPermanentFolds:
                    this.state.romanShadeSettings.presetHemsAndFoldsJson.permanentFoldsFunctional,
                },
              },
            },
          }),
          async () => {
            this.validateAll('update');
          }
        );
      }

      this.clearHighlightSection(name);
      this.setState(
        (prevState) => {
          return {
            ...prevState,
            draperyOrderDesign: {
              ...prevState.draperyOrderDesign,
              romanShadeJson: {
                ...prevState.draperyOrderDesign.romanShadeJson,
                style: {
                  ...prevState.draperyOrderDesign.romanShadeJson.style,
                  type: newTypeValue,
                },
              },
            },
            romanShadeJson: {
              ...prevState.romanShadeJson,
              style: {
                ...prevState.romanShadeJson.style,
                type: newTypeValue,
              },
            },
          };
        },
        () => {
          this.validateAll('update');
        }
      );
      return;
    }
    if (name.includes('draperyOrderDesign.romanShadeJson.valanceAndReturns')) {
      if (name === 'draperyOrderDesign.romanShadeJson.valanceAndReturns.sides') {
        if (
          (value === 'side-flaps' || value === 'returns') &&
          this.state.romanShadeJson.valanceAndReturns.frontValance !== 1 &&
          this.state.romanShadeSettingsChangedField &&
          !this.state.romanShadeSettingsChangedField.sidesValanceLength
        ) {
          this.setState(
            (prevState) => ({
              ...prevState,
              draperyOrderDesign: {
                ...prevState.draperyOrderDesign,
                romanShadeJson: {
                  ...prevState.draperyOrderDesign.romanShadeJson,
                  valanceAndReturns: {
                    ...prevState.draperyOrderDesign.romanShadeJson.valanceAndReturns,
                    sidesValanceLength:
                      this.state.romanShadeSettings.presetValanceAndReturnsJson.sideFlapsLength,
                  },
                },
              },
            }),
            async () => {
              this.validateAll('update');
            }
          );
        }
      }

      const field = name.split('.').pop();
      // this.updateStateByName(name, value);
      this.setState(
        (prevState) => ({
          ...prevState,
          draperyOrderDesign: {
            ...prevState.draperyOrderDesign,
            romanShadeJson: {
              ...prevState.draperyOrderDesign.romanShadeJson,
              valanceAndReturns: {
                ...prevState.draperyOrderDesign.romanShadeJson.valanceAndReturns,
                [field]: value,
              },
            },
          },
          romanShadeJson: {
            ...prevState.romanShadeJson,
            valanceAndReturns: {
              ...prevState.romanShadeJson.valanceAndReturns,
              [field]: value,
            },
          },
        }),
        async () => {
          this.validateAll('update');
        }
      );
      if (value === 'none') {
        this.clearHighlightSection('draperyOrderDesign.romanShadeJson.headrail.boardDepth');
      }
      return;
    }
    if (name.includes('draperyOrderDesign.romanShadeJson.headrail.liftSystem')) {
      const field = name.split('.').pop();
      // this.updateStateByName(name, value);
      this.setState((prevState) => ({
        ...prevState,
        draperyOrderDesign: {
          ...prevState.draperyOrderDesign,
          romanShadeJson: {
            ...prevState.draperyOrderDesign.romanShadeJson,
            headrail: {
              ...prevState.draperyOrderDesign.romanShadeJson.headrail,
              [field]: value ? value : null,
            },
          },
        },
        romanShadeJson: {
          ...prevState.romanShadeJson,
          headrail: {
            ...prevState.romanShadeJson.headrail,
            [field]: value ? value : null,
          },
        },
      }));
      return;
    }

    if (name.includes('draperyOrderDesign.romanShadeJson.headrail.controlType')) {
      // this.updateStateByName(name, value);
      this.setState(
        (prevState) => {
          return {
            ...prevState,
            draperyOrderDesign: {
              ...prevState.draperyOrderDesign,
              romanShadeJson: {
                ...prevState.draperyOrderDesign.romanShadeJson,
                headrail: {
                  ...prevState.draperyOrderDesign.romanShadeJson.headrail,
                  controlType: value,
                },
              },
            },
            romanShadeJson: {
              ...prevState.romanShadeJson,
              headrail: {
                ...prevState.romanShadeJson.headrail,
                controlType: value,
              },
            },
          };
        },
        async () => {
          this.validateAll('update');
        }
      );
    }

    if (name.includes('draperyOrder.related')) {
      this.setState(
        (state) => ({
          ...state,
          draperyOrder: {
            ...state.draperyOrder,
            related: value,
          },
        }),
        () => {
          if (
            this.state.draperyOrder &&
            this.state.draperyOrder.id &&
            !this.state.workOrderEditMode
          ) {
            this.saveDraperyOrderApi();
          }
        }
      );
    }
  }

  @Bind()
  private async handleChangeDates(value: Date | null, field: string): Promise<void> {
    const { draperyOrderSummary } = this.state;

    if (value) {
      const date = new Date(value);
      await this.updateStateByName(field, date);
    } else {
      await this.updateStateByName(field, null);
    }

    if (draperyOrderSummary.id && !this.state.workOrderEditMode) {
      await editDraperyOrderSummary(draperyOrderSummary);
    }
  }

  @Bind()
  private returnDates(): any {
    const dates = {
      installDate: !this.state.draperyOrderSummary.installationJson.dateOfInstall
        ? null
        : moment(this.state.draperyOrderSummary.installationJson.dateOfInstall).isValid()
          ? moment(this.state.draperyOrderSummary.installationJson.dateOfInstall).toDate()
          : null,
      finishedDate: !this.state.draperyOrderSummary.productionJson.finishedDate
        ? null
        : moment(this.state.draperyOrderSummary.productionJson.finishedDate).isValid()
          ? moment(this.state.draperyOrderSummary.productionJson.finishedDate).toDate()
          : null,
      dueDate: !this.state.draperyOrderSummary.productionJson.dueDate
        ? null
        : moment(this.state.draperyOrderSummary.productionJson.dueDate).isValid()
          ? moment(this.state.draperyOrderSummary.productionJson.dueDate).toDate()
          : null,
      startDate: !this.state.draperyOrderSummary.productionJson.startDate
        ? null
        : moment(this.state.draperyOrderSummary.productionJson.startDate).isValid()
          ? moment(this.state.draperyOrderSummary.productionJson.startDate).toDate()
          : null,
      dateSent: !this.state.draperyOrderSummary.estimateJson.dateSent
        ? null
        : moment(this.state.draperyOrderSummary.estimateJson.dateSent).isValid()
          ? moment(this.state.draperyOrderSummary.estimateJson.dateSent).toDate()
          : null,
      invoiceDateSent: !this.state.draperyOrderSummary.invoiceJson.invoiceDateSent
        ? null
        : moment(this.state.draperyOrderSummary.invoiceJson.invoiceDateSent).isValid()
          ? moment(this.state.draperyOrderSummary.invoiceJson.invoiceDateSent).toDate()
          : null,
    };

    return dates;
  }

  @Bind()
  private handleInputBlur(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    let { value, name } = e.currentTarget;
    let nValue = value.includes('.')
      ? value.replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1')
      : value;
    if (nValue.charAt(value.length - 1) === '.') {
      nValue = nValue.slice(0, value.length - 1);
    }
    this.updateStateByName(name, nValue);
  }

  @Bind()
  private generateDefaultFabricsLiningName({ liningName }: { liningName: string }): string {
    const isOtherInterlining = liningName.toLowerCase().includes('other interlining');

    const nameSet = isOtherInterlining
      ? `INTERLINING FABRIC ${this.state.liningsList.length}`
      : `${liningName.toUpperCase()} FABRIC`;

    return nameSet;
  }

  @Bind()
  private handleCheckLiningsList({
    itemIndex,
    checked,
  }: {
    itemIndex: number;
    checked: boolean;
  }): void {
    const stateLiningsList = [...this.state.liningsList];
    const selectedItem = stateLiningsList[itemIndex];
    if (checked) {
      if (
        !selectedItem.draperyOrderLiningsFabric ||
        selectedItem.draperyOrderLiningsFabric.id === 0
      ) {
        const defaultLiningsName = this.generateDefaultFabricsLiningName({
          liningName: selectedItem.name,
        });
        selectedItem.draperyOrderLiningsFabric = defaultLiningsFabric(defaultLiningsName);
      }
    } else {
      if (selectedItem.draperyOrderLiningsFabric) {
        let settings =
          this.state.orderType === 'roman-shade-order'
            ? this.state.romanShadeSettings
            : this.state.workRoomSettings;

        const orderOrigin =
          settings && settings.liningsPurchaser && settings.liningsPurchaser === 'Workroom'
            ? 1
            : settings && settings.liningsPurchaser && settings.liningsPurchaser === 'Installer'
              ? 2
              : -1;

        const defaultLiningsName = this.generateDefaultFabricsLiningName({
          liningName: selectedItem.name,
        });
        selectedItem.draperyOrderLiningsFabric = defaultLiningsFabric(
          defaultLiningsName,
          orderOrigin
        );
      }
    }
    this.setState({
      liningsList: stateLiningsList,
    });
  }

  @Bind()
  getDefaultValue(): void {
    const value =
      this.state.workroomSetting === null ||
      (this.state.workroomSetting && this.state.workroomSetting.fabricPurchaser === 'No Default') ||
      (this.state.workroomSetting && !this.state.workroomSetting.fabricPurchaser)
        ? -1
        : this.state.workroomSetting &&
            this.state.workroomSetting.fabricPurchaser &&
            this.state.workroomSetting.fabricPurchaser === 'Workroom'
          ? 1
          : 2;
    const valueEmb =
      this.state.workroomSetting === null ||
      (this.state.workroomSetting &&
        this.state.workroomSetting.embellishmentsPurchaser === 'No Default') ||
      (this.state.workroomSetting && !this.state.workroomSetting.embellishmentsPurchaser)
        ? -1
        : this.state.workroomSetting &&
            this.state.workroomSetting.embellishmentsPurchaser &&
            this.state.workroomSetting.embellishmentsPurchaser === 'Workroom'
          ? 1
          : 2;

    const valueLining =
      this.state.workroomSetting === null ||
      (this.state.workroomSetting &&
        this.state.workroomSetting.liningsPurchaser === 'No Default') ||
      (this.state.workroomSetting && !this.state.workroomSetting.liningsPurchaser)
        ? -1
        : this.state.workroomSetting &&
            this.state.workroomSetting.liningsPurchaser &&
            this.state.workroomSetting.liningsPurchaser === 'Workroom'
          ? 1
          : 2;

    this.setState({
      orderOriginState: value,
      orderOriginStateEmb: valueEmb,
      orderOriginStateLining: valueLining,
    });
  }

  @Bind()
  private handleInputChangeForBoolean(
    e: ChangeEvent<HTMLInputElement>,
    targetArray?: string,
    targetArrayIndex?: number
  ): void {
    const { name, checked } = e.currentTarget;
    const nameList = name.split('.');
    const nameListLength = nameList.length;

    if (name === 'draperyOrderDesign.isWeight') {
      if (checked) {
        this.updateStateByName('draperyOrderDesign.weightRadio', 'standard-corner');
      } else {
        this.updateStateByName('draperyOrderDesign.weightRadio', null);
      }
    }
    if (name.endsWith('topEdge.active') || name.endsWith('bottomEdge.active')) {
      this.clearHighlightSection(`${targetArray}.${targetArrayIndex}.leadReturnEdge.active`);
    } else if (name.includes('shade') || name.includes('valance')) {
      const splitName = name.split('.');
      this.clearHighlightSection(`${splitName[0]}.${splitName[1]}.topEdge.shade`);
    } else {
      this.clearHighlightSection(name);
    }
    if (name === 'draperyOrder.isDraft' && checked) {
      trackView(MixpanelEvents.SET_AS_DRAFT, {
        item_type: this.resolveDraftFinalItemType(),
        item_status: this.state.draperyOrder.status || '',
        estimate_status: this.resolveDraftFinalEstimateStatus(),
      });
    }
    if (nameListLength === 3) {
      if (name.startsWith('embellishmentsList.') && !checked) {
        this.deleteEmbellishments(+nameList[1]);
      } else if (name.startsWith('embellishmentsList.') && checked) {
        this.clearHighlightSection('isNoneEmbellishment');
      } else if (name.startsWith('liningsList.')) {
        this.handleCheckLiningsList({
          itemIndex: +nameList[1],
          checked,
        });
        this.clearHighlightSection('isNoneLinings');
      } else if (name === 'draperyOrder.userConfirmation.allowExtraWideMainFabric') {
        this.clearHighlightSection('mainFabric.values.fabricWidth');
      }
    }

    if (name.includes('draperyOrder.hasRelatedWorkOrders')) {
      this.setState(
        (state) => ({
          ...state,
          draperyOrder: {
            ...state.draperyOrder,
            hasRelatedWorkOrders: checked,
            related: checked ? state.draperyOrder.related : '',
          },
        }),
        () => {
          if (
            this.state.draperyOrder &&
            this.state.draperyOrder.id &&
            !this.state.workOrderEditMode
          ) {
            this.saveDraperyOrderApi();
          }
        }
      );
    }

    this.updateStateByName(name, checked);
  }

  @Bind()
  private handleSelectListChange(value: string | number, name: string): void {
    let targetValue: string | number | undefined = value;
    if (name === 'draperyOrder.roomId') {
      targetValue = value === '' ? undefined : value;
    }
    if (name === 'draperyOrderSummary.estimateJson.num') {
      targetValue = value === '' ? undefined : value;
    }
    if (name !== 'draperyOrderDesign.panelJson.pannel1Width') {
      this.clearHighlightSection(name);
    }
    if (name.includes('draperyOrderDesign.romanShadeJson.headrail.controlLocation')) {
      const keyName = name.split('.').pop();
      this.setState(
        (prev) => {
          return {
            ...prev,
            draperyOrderDesign: {
              ...prev.draperyOrderDesign,
              romanShadeJson: {
                ...prev.draperyOrderDesign.romanShadeJson,
                headrail: {
                  ...prev.draperyOrderDesign.romanShadeJson.headrail,
                  [keyName as string]: value ? value : null,
                },
              },
            },
          };
        },
        async () => {
          this.validateAll('update');
        }
      );
      return;
    }
    this.updateStateByName(name, targetValue);
  }

  @Bind()
  private async handleSearchSelectChange(
    id: number,
    name: string,
    pathId: string,
    pathName: string,
    itemId?: number,
    search?: string
  ) {
    this.updateStateByName(pathId, id);
    this.updateStateByName(pathName, name);

    if (document.getElementsByName(pathId)[0]) {
      this.clearHighlightSection(pathId);
    } else if (document.getElementsByName(pathName)[0]) {
      this.clearHighlightSection(pathName);
    }
    if (pathId.startsWith('draperyOrderHardware.') || pathId.startsWith('draperyOrderHeadrail.')) {
      return;
    }
    if (pathId === 'draperyOrder.clientId') {
      await this.getRooms(id);
      await this.getClient();
    } else if (pathId === 'mainFabric.patternId') {
      await this.setFabricsPatternDefaults({ patternId: id, itemId });
    } else if (pathId.includes('liningsList')) {
      await this.setLiningsPatternDefaults({
        patternId: id,
        pathId,
        itemId,
      });
    } else {
      await this.setDraperyOrderFabricPatternDefaults({
        patternId: id,
        pathId,
        itemId,
      });
    }
    if (pathId === 'draperyOrder.roomId') {
      const { clientId } = this.state.draperyOrder;

      let res: any;

      if (clientId) {
        res = await getRooms(clientId, name);
      }
      if (res.error) {
        return [];
      }
      const rooms = res.map((r: any) => ({
        id: r.id,
        displayName: r.name,
      }));

      if (
        !rooms.some(
          (room: { id: any; displayName: any }) =>
            room.displayName === this.state.draperyOrder.roomName
        )
      ) {
        this.setState(
          (state) => ({
            ...state,
            draperyOrder: {
              ...state.draperyOrder,
              customRoom: state.draperyOrder.roomName
                ? state.draperyOrder.roomName
                : state.draperyOrder.customRoom,
            },
          }),
          () => {
            if (this.validateAll('workOrder')) {
              // this.setState((state) => ({
              //   ...state,
              //   isSidebarHidden: false,
              // }));
            }
          }
        );
      }

      return rooms;
    }
    if (pathId.startsWith('draperyOrderHardware') || pathId.startsWith('draperyOrderHeadrail')) {
      return;
    }
    // this.setState({patternId:itemId})
  }

  @Bind()
  private async setFabricsPatternDefaults({
    patternId,
    itemId,
  }: {
    patternId: number;
    itemId?: number;
  }) {
    const { fabricsPatternItems, mainFabric } = this.state;
    const { accountId } = this.props;
    if (!patternId || !fabricsPatternItems || !fabricsPatternItems.length) {
      return;
    }
    const selectedPattern = fabricsPatternItems.find((f) => f.id === patternId);

    if (!selectedPattern) {
      return;
    }

    const {
      isSpecialtyFabricHandlingOn,
      fabricWidthInches,
      verticalRepeatInches,
      horizontalRepeatInches,
      isDropRepeatOn,
      isMatchRepeatAtSeamsOn,
      isPleatToPatternOn,
      supplierId,
      isActive,
    } = selectedPattern;

    const hasHorizontalRepeat = Number(horizontalRepeatInches || 0) > 0;
    const hasAnyRepeat = hasHorizontalRepeat || Number(verticalRepeatInches || 0) > 0;
    const normalizedIsMatchRepeatAtSeams = hasAnyRepeat
      ? typeof isMatchRepeatAtSeamsOn === 'boolean'
        ? isMatchRepeatAtSeamsOn
        : true
      : false;
    const normalizedIsPleatToPattern = hasHorizontalRepeat ? !!isPleatToPatternOn : false;

    // let orderOriginNum = -1;
    // if (
    //     this.state &&
    //     this.state.workroomSetting &&
    //     this.state.workroomSetting.fabricPurchaser === "Workroom"
    // ) {
    //     orderOriginNum = 1;
    // } else if (
    //     this.state &&
    //     this.state.workroomSetting &&
    //     this.state.workroomSetting.fabricPurchaser === "Installer"
    // ) {
    //     orderOriginNum = 2;
    // }
    this.setState((state) => {
      return {
        ...state,
        mainFabric: {
          ...state.mainFabric,
          isSpecialtyFabricHandling: isSpecialtyFabricHandlingOn,
          isDropRepeat: isDropRepeatOn,
          isMatchRepeatAtSeams: normalizedIsMatchRepeatAtSeams,
          isPleatToPattern: normalizedIsPleatToPattern,
          imageId: selectedPattern.avatarId || null,
          itemId,
          isActive: isActive,
        },
      };
    });

    if (fabricWidthInches !== undefined && fabricWidthInches !== null) {
      this.updateStateByName('mainFabric.values.fabricWidth', fabricWidthInches);
    } else {
      this.updateStateByName('mainFabric.values.fabricWidth', '');
    }

    if (verticalRepeatInches !== undefined && verticalRepeatInches !== null) {
      this.updateStateByName('mainFabric.values.verticalRepeat', verticalRepeatInches);
    } else {
      this.updateStateByName('mainFabric.values.verticalRepeat', '');
    }

    if (horizontalRepeatInches !== undefined && horizontalRepeatInches !== null) {
      this.updateStateByName('mainFabric.values.horizontalRepeat', horizontalRepeatInches);
    } else {
      this.updateStateByName('mainFabric.values.horizontalRepeat', '');
    }

    const res = await searchSuppliers({
      accountId,
      text: '',
      nameSort: 'asc',
      typeSort: 'asc',
      includeInactive: true,
    });

    if (res.error) {
      return;
    }

    const suppliers: Supplier[] = res;
    if (suppliers && suppliers.length && !mainFabric.customSupplier) {
      const fabricPatternSupplier = suppliers.find((s) => s.id === supplierId);
      if (fabricPatternSupplier) {
        const { id, displayName } = fabricPatternSupplier;
        this.updateStateByName('mainFabric.supplierId', id);
        this.updateStateByName('mainFabric.supplierName', displayName);
      }
    }
  }

  @Bind()
  private async setDraperyOrderFabricPatternDefaults({
    patternId,
    pathId,
    itemId,
  }: {
    patternId: number;
    pathId: string;
    itemId?: number;
  }) {
    let stateList: any[] = [];
    const { fabricsPatternItems } = this.state;
    // const { dispatch, accountId } = this.props;

    if (!patternId || !fabricsPatternItems || !fabricsPatternItems.length) {
      return;
    }

    const selectedPattern = fabricsPatternItems.find((f) => f.id === patternId);

    if (!selectedPattern) {
      return;
    }
    const {
      isSpecialtyFabricHandlingOn,
      horizontalRepeatInches,
      fabricWidthInches,
      verticalRepeatInches,
      supplierId,
      isDropRepeatOn,
      isActive,
    } = selectedPattern;

    // let orderOriginNum = -1;

    // if (
    //     this.state &&
    //     this.state.workroomSetting &&
    //     this.state.workroomSetting.embellishmentsPurchaser === "Workroom"
    // ) {
    //     orderOriginNum = 1;
    // } else if (
    //     this.state &&
    //     this.state.workroomSetting &&
    //     this.state.workroomSetting.embellishmentsPurchaser === "Installer"
    // ) {
    //     orderOriginNum = 2;
    // }

    const suppliers: Supplier[] = this.state.suppliers;
    if (pathId && pathId.includes('trim')) {
      stateList = [...this.state.trims];
    }
    if (pathId && pathId.includes('cordings')) {
      stateList = [...this.state.cordings];
    }
    if (pathId && pathId.includes('bandings')) {
      stateList = [...this.state.bandings];
    }
    if (pathId && pathId.includes('flanges')) {
      stateList = [...this.state.flanges];
    }
    if (pathId && pathId.includes('othersEmbellishments')) {
      stateList = [...this.state.othersEmbellishments];
    }
    const index = +pathId.split('.')[1];

    let selectedFabric = stateList[index];
    if (!selectedFabric) {
      return;
    }
    const draperyOrderFabric: any = {
      ...selectedFabric.draperyOrderFabric,
      isSpecialtyFabricHandling: isSpecialtyFabricHandlingOn,
      isDropRepeat: isDropRepeatOn,
      imageId: selectedPattern.avatarId || null,
      values: {
        fabricWidth: fabricWidthInches !== null ? fabricWidthInches : undefined,
        verticalRepeat: verticalRepeatInches !== null ? verticalRepeatInches : undefined,
        horizontalRepeat: horizontalRepeatInches !== null ? horizontalRepeatInches : undefined,
      },
      itemId,
      isActive: isActive,
    };

    if (suppliers && suppliers.length && !draperyOrderFabric.customSupplier) {
      const liningPatternSupplier = suppliers.find((s) => s.id === supplierId);
      if (liningPatternSupplier) {
        const { id, displayName } = liningPatternSupplier;
        draperyOrderFabric.supplierId = id;
        draperyOrderFabric.supplierName = displayName;
      }
    }
    stateList[index].draperyOrderFabric = draperyOrderFabric;
    if (pathId && pathId.includes('trims')) {
      this.setState({
        trims: stateList,
      });
    }
    if (pathId && pathId.includes('cordings')) {
      this.setState({
        cordings: stateList,
      });
    }
    if (pathId && pathId.includes('flanges')) {
      this.setState({
        flanges: stateList,
      });
    }
    if (pathId && pathId.includes('bandings')) {
      this.setState({
        bandings: stateList,
      });
    }
    if (pathId && pathId.includes('othersEmbellishments')) {
      this.setState({
        othersEmbellishments: stateList,
      });
    }
    this.validateAll('update');
  }

  @Bind()
  private async setLiningsPatternDefaults({
    patternId,
    pathId,
    itemId,
  }: {
    patternId: number;
    pathId: string;
    itemId?: number;
  }) {
    const { liningsPatternItems } = this.state;
    const { accountId } = this.props;

    if (!patternId || !liningsPatternItems || !liningsPatternItems.length) {
      return;
    }

    const selectedPattern = liningsPatternItems.find((f) => f.id === patternId);

    if (!selectedPattern) {
      return;
    }

    const { isSpecialtyFabricHandlingOn, fabricWidthInches, supplierId } = selectedPattern;

    const res = await searchSuppliers({
      accountId,
      text: '',
      nameSort: 'asc',
      typeSort: 'asc',
      includeInactive: true,
    });

    const suppliers: Supplier[] = res.error ? [] : res;

    let stateLiningsList = [...this.state.liningsList];
    const index = +pathId.split('.')[1];

    // let orderOriginNum = -1;

    // if (
    //     this.state &&
    //     this.state.workroomSetting &&
    //     this.state.workroomSetting.fabricPurchaser === "Workroom"
    // ) {
    //     orderOriginNum = 1;
    // } else if (
    //     this.state &&
    //     this.state.workroomSetting &&
    //     this.state.workroomSetting.fabricPurchaser === "Installer"
    // ) {
    //     orderOriginNum = 2;
    // }

    let selectedLiningFabric = stateLiningsList[index];
    if (!selectedLiningFabric) {
      return;
    }
    let draperyOrderLiningsFabric: any = {
      ...selectedLiningFabric.draperyOrderLiningsFabric,
      imageId: selectedPattern.avatarId,
      isSpecialtyFabricHandling: isSpecialtyFabricHandlingOn,
      isActive: selectedPattern.isActive,
      values: {
        fabricWidth: fabricWidthInches !== null ? fabricWidthInches : '',
      },
      itemId,
    };

    if (suppliers && suppliers.length) {
      const liningPatternSupplier = suppliers.find((s) => s.id === supplierId);
      if (liningPatternSupplier) {
        const { id, displayName } = liningPatternSupplier;
        draperyOrderLiningsFabric.supplierId = id;
        draperyOrderLiningsFabric.supplierName = displayName;
      }
    }
    stateLiningsList[index].draperyOrderLiningsFabric = draperyOrderLiningsFabric;

    this.updateStateByName('liningsList', stateLiningsList);
    // this.setState({
    //     liningsList: stateLiningsList,
    // });
  }

  @Bind()
  private handleSearchSelectClear(pathId: string, pathName: string, key?: number) {
    this.updateStateByName(pathId, 0);
    this.updateStateByName(pathName, '');
    if (pathId.includes('mainFabric.patternId')) {
      this.setState((state) => ({
        ...state,
        mainFabric: {
          ...state.mainFabric,
          isMatchRepeatAtSeams: false,
          isPleatToPattern: false,
          isDropRepeat: false,
          imageId: '',
          isSpecialtyFabricHandling: false,
          supplierName: '',
          customSupplier: '',
          itemId: undefined,
          patternId: 0,
          supplierId: 0,
          isActive: undefined,
          values: {
            fabricWidth: undefined,
            horizontalRepeat: undefined,
            verticalRepeat: undefined,
          },
        },
      }));
    }

    if (pathName.includes('trims')) {
      const newTrimList = this.state.trims.map((trims: DraperyOrderDesignEmbellishment, idx) => {
        if (
          pathName.includes(`trims.${idx}.draperyOrderFabric.pattern`) &&
          trims &&
          trims.draperyOrderFabric
        ) {
          return {
            ...trims,
            draperyOrderFabric: {
              ...trims.draperyOrderFabric,
              isSpecialtyFabricHandling: false,
              isDropRepeat: false,
              supplierName: '',
              customSupplier: '',
              imageId: '',
              itemId: undefined,
              patternId: 0,
              supplierId: 0,
              isActive: undefined,
              values: {
                fabricWidth: undefined,
                verticalRepeat: undefined,
                horizontalRepeat: undefined,
                trimWidth: undefined,
              },
              pattern: '',
            },
          };
        }
        return trims;
      });

      this.setState((state) => ({
        ...state,
        trims: newTrimList,
      }));
    }
    if (pathName.includes('bandings')) {
      const newTrimList = this.state.bandings.map(
        (bandings: DraperyOrderDesignEmbellishment, idx) => {
          if (
            pathName.includes(`bandings.${idx}.draperyOrderFabric.pattern`) &&
            bandings &&
            bandings.draperyOrderFabric
          ) {
            return {
              ...bandings,
              draperyOrderFabric: {
                ...bandings.draperyOrderFabric,
                supplierName: '',
                customSupplier: '',
                isSpecialtyFabricHandling: false,
                isDropRepeat: false,
                imageId: '',
                // orderOrigin: -1,
                itemId: undefined,
                patternId: 0,
                supplierId: 0,
                isActive: undefined,
                values: {
                  fabricWidth: undefined,
                  verticalRepeat: undefined,
                  horizontalRepeat: undefined,
                },
                pattern: '',
              },
            };
          }
          return bandings;
        }
      );

      this.setState((state) => ({
        ...state,
        bandings: newTrimList,
      }));
    }
    if (pathName.includes('cordings')) {
      const newTrimList = this.state.cordings.map(
        (cordings: DraperyOrderDesignEmbellishment, idx) => {
          if (
            pathName.includes(`cordings.${idx}.draperyOrderFabric.pattern`) &&
            cordings &&
            cordings.draperyOrderFabric
          ) {
            return {
              ...cordings,
              draperyOrderFabric: {
                ...cordings.draperyOrderFabric,
                isSpecialtyFabricHandling: false,
                imageId: '',
                // orderOrigin: -1,
                itemId: undefined,
                patternId: 0,
                supplierId: 0,
                supplierName: '',
                customSupplier: '',
                isActive: undefined,
                values: {
                  fabricWidth: undefined,
                  verticalRepeat: undefined,
                  horizontalRepeat: undefined,
                },
                pattern: '',
              },
            };
          }
          return cordings;
        }
      );

      this.setState((state) => ({
        ...state,
        cordings: newTrimList,
      }));
    }
    if (pathName.includes('flanges')) {
      const newTrimList = this.state.flanges.map(
        (flanges: DraperyOrderDesignEmbellishment, idx) => {
          if (
            pathName.includes(`flanges.${idx}.draperyOrderFabric.pattern`) &&
            flanges &&
            flanges.draperyOrderFabric
          ) {
            return {
              ...flanges,
              draperyOrderFabric: {
                ...flanges.draperyOrderFabric,
                isSpecialtyFabricHandling: false,
                imageId: '',
                // orderOrigin: -1,
                itemId: undefined,
                patternId: 0,
                supplierId: 0,
                supplierName: '',
                customSupplier: '',
                isActive: undefined,
                values: {
                  fabricWidth: undefined,
                  verticalRepeat: undefined,
                  horizontalRepeat: undefined,
                },
                pattern: '',
              },
            };
          }
          return flanges;
        }
      );

      this.setState((state) => ({
        ...state,
        flanges: newTrimList,
      }));
    }
    if (pathName.includes('othersEmbellishments')) {
      const newTrimList = this.state.othersEmbellishments.map(
        (othersEmbellishments: DraperyOrderDesignEmbellishment, idx) => {
          if (
            pathName.includes(`othersEmbellishments.${idx}.draperyOrderFabric.pattern`) &&
            othersEmbellishments &&
            othersEmbellishments.draperyOrderFabric
          ) {
            return {
              ...othersEmbellishments,
              draperyOrderFabric: {
                ...othersEmbellishments.draperyOrderFabric,
                isSpecialtyFabricHandling: false,
                isDropRepeat: false,
                supplierName: '',
                customSupplier: '',
                imageId: '',
                // orderOrigin: -1,
                itemId: undefined,
                patternId: 0,
                supplierId: 0,
                isActive: undefined,
                values: {
                  fabricWidth: undefined,
                  verticalRepeat: undefined,
                  horizontalRepeat: undefined,
                },
                pattern: '',
              },
            };
          }
          return othersEmbellishments;
        }
      );

      this.setState((state) => ({
        ...state,
        othersEmbellishments: newTrimList,
      }));
    }

    if (pathName.includes('liningsList')) {
      const newLiningsList = this.state.liningsList.map((lining: DraperyOrderDesignLining, idx) => {
        if (
          pathName.includes(`liningsList.${idx}.draperyOrderLiningsFabric.pattern`) &&
          lining &&
          lining.draperyOrderLiningsFabric
        ) {
          return {
            ...lining,
            draperyOrderLiningsFabric: {
              ...lining.draperyOrderLiningsFabric,
              // orderOrigin: -1,
              itemId: undefined,
              patternId: 0,
              supplierId: 0,
              values: { fabricWidth: undefined },
              isSpecialtyFabricHandling: false,
              supplierName: '',
              customSupplier: '',
              imageId: '',
              pattern: '',
              isActive: undefined,
            },
          };
        }
        return lining;
      });

      this.setState((state) => ({
        ...state,
        liningsList: newLiningsList,
      }));
    }

    if (pathId === 'draperyOrder.clientId') {
      this.setState(
        (state) => ({
          ...state,
          roomList: [],
          client: undefined,
          clientId: 0,
          draperyOrder: {
            ...state.draperyOrder,
            roomId: undefined,
            roomName: '',
            customRoom: '',
          },
        }),
        () => {
          this.validateAll('workOrder');
        }
      );
    }
    if (pathId === 'draperyOrder.roomId') {
      this.setState(
        (state) => ({
          ...state,
          draperyOrder: {
            ...state.draperyOrder,
            roomId: undefined,
            roomName: '',
            customRoom: '',
          },
        }),
        () => {
          this.validateAll('workOrder');
        }
      );
    }
  }

  @Bind()
  private handleShapeChanged(shapes: DraperyModule.Shape[]): void {
    this.setState({
      draperyOrderDesign: {
        ...this.state.draperyOrderDesign,
        drawingShapeJson: shapes,
      },
      isDrawingDirty: true,
    });
  }

  @Bind()
  changeTrimValue(name: string, value: string): void {
    if (name.includes('trimWidth')) {
      const newTrimList = this.state.trims.map((trims: any, idx) => {
        if (name.includes(`trims.${idx}.draperyOrderFabric.values.trimWidth`)) {
          return {
            ...trims,
            draperyOrderFabric: {
              ...trims.draperyOrderFabric,

              values: {
                trimWidth: +value || undefined,
              },
            },
          };
        }
        return trims;
      });
      this.setState((state) => ({
        ...state,
        trims: newTrimList,
      }));
    }
  }

  private handleResetPanelConf = async (
    val: string | number | undefined,
    name: string | undefined
  ) => {
    const { drawingShapeJson } = this.state.draperyOrderDesign;
    const { embellishmentsList } = this.state;
    let isChecked = false;
    for (const embellishment of embellishmentsList) {
      isChecked = isChecked || embellishment.checked;
    }
    let allowed = true;
    if ((drawingShapeJson && drawingShapeJson.length > 0) || isChecked) {
      allowed = await confirmation(
        <ResetPanelConfirmation>
          Changing the panel configuration will alter the image in the Drawing section below and
          some entries for Embellishements. &nbsp; Please revisit these sections if previously
          completed.
          <span>Are you sure you want to change the panel configuration?</span>
        </ResetPanelConfirmation>,
        {
          uiHeader: 'Confirmation',
          uiAcceptLabel: 'Yes',
          uiDeclineLabel: 'No',
        }
      );
    }

    if (allowed) {
      for (const [index, embellishmentInfo] of embellishmentsList.entries()) {
        if (embellishmentInfo.checked) {
          const { name, list } = this.getEmbellishmentsByIndex(index);

          for (const [subIndex] of list.entries()) {
            this.updateStateByName(`${name}.${subIndex}.totalStrips`, undefined);
          }
        }
      }
      this.updateStateByName('draperyOrderDesign.numOfPanels', 1);
      this.updateStateByName('draperyOrderDesign.panelJson', defaultWidthEachPanelList());
      if (val === 1) {
        this.updateStateByName('draperyOrderDesign.panelType', '');
      }
    } else {
      if (val === 1) {
        this.updateStateByName('draperyOrderDesign.panelType', name);
      } else {
        this.updateStateByName('draperyOrderDesign.panelType', val);
      }
    }
  };

  private handleResetPleatType = (): void => {
    this.updateStateByName('draperyOrderDesign.pleatType', '');
    this.updateStateByName('draperyOrderDesign.otherPleatImageId', undefined);
  };

  private handleAddNewLining = () => {
    const name = 'Other interlining';
    const defaultLiningsName = this.generateDefaultFabricsLiningName({
      liningName: name,
    });
    // `Interlining Fabric ${this.state.liningsList.length}`;
    const newLining: DraperyOrderDesignLining = {
      id: 0,
      name,
      active: true,
      description: '',
      draperyOrderDesignId: null,
      draperyOrderLiningsFabric: defaultLiningsFabric(
        defaultLiningsName,
        this.state.orderOriginStateLining
      ),
    };
    const updateList = [...this.state.liningsList, newLining];
    this.setState({
      liningsList: updateList,
    });
  };

  private handleAddEmbellishment = (targetArray: string) => {
    const check_case =
      this.state.orderType === 'roman-shade-order' &&
      (this.state.draperyOrder.id === 0 || this.state.draperyOrder.newRomanShade);
    const newEmbellishment = defaultEmbellishment(targetArray, check_case);
    this.setState(
      (state) => ({
        ...state,
        [targetArray]: [...state[targetArray], newEmbellishment],
      }),
      () => {
        this.validateAll('update');
      }
    );
  };

  private deleteEmbellishments = (index: number) => {
    const { name, list } = this.getEmbellishmentsByIndex(index);

    const removedIds: number[] = [];
    for (const item of list) {
      if (item.id) {
        removedIds.push(item.id);
      }
    }

    const check_case =
      this.state.orderType === 'roman-shade-order' &&
      (this.state.draperyOrder.id === 0 || this.state.draperyOrder.newRomanShade);
    const newEmbellishment = defaultEmbellishment(name, check_case);
    this.setState((state) => ({
      ...state,
      [name]: [newEmbellishment!],
      removedEmbellishmentIds: [...state.removedEmbellishmentIds, ...removedIds],
    }));
  };

  private handleDeleteEmbellishment = (targetArray: string, index: number): void => {
    const list: DraperyOrderDesignEmbellishment[] = this.state[targetArray];
    const removedItem: DraperyOrderDesignEmbellishment = list.splice(index, 1)[0];

    const check_case =
      this.state.orderType === 'roman-shade-order' &&
      (this.state.draperyOrder.id === 0 || this.state.draperyOrder.newRomanShade);
    if (list.length === 0) {
      const newEmbellishment = defaultEmbellishment(targetArray, check_case);
      list.push(newEmbellishment!);
      this.state.embellishmentsList.filter((em) => em.stateName === targetArray)[0].checked = false;
    }

    this.setState(
      (state) => ({
        ...state,
        [targetArray]: [...list],
        removedEmbellishmentIds: [...this.state.removedEmbellishmentIds, removedItem.id],
      }),
      () => {
        this.validateAll('update');
      }
    );
    if (targetArray === 'trims') {
      this.numberingTrims('delete');
    }
  };

  private handleToggleCustomizeConstruction = () => {
    this.setState(
      {
        isCustomizeConstructionOpen: !this.state.isCustomizeConstructionOpen,
      },
      () => {
        const e = document.getElementById('customize-construction-div');
        if (e) {
          e.scrollIntoView();
        }
      }
    );
  };

  private handleOpenClientModalClick = (pathId: string, pathName: string) => {
    this.setState(
      {
        isAddClientModalOpen: true,
        pathIdForModal: pathId,
        pathNameForModal: pathName,
      },
      () => {
        if (this.setFocusFirstFieldOnClientModal) {
          this.setFocusFirstFieldOnClientModal();
        }
      }
    );
  };

  private handleOpenSupplierModalClick = (pathId: string, pathName: string) => {
    this.setState(
      {
        isAddSupplierModalOpen: true,
        pathIdForModal: pathId,
        pathNameForModal: pathName,
      },
      () => {
        if (this.setFocusFirstFieldOnSupplierModal) {
          this.setFocusFirstFieldOnSupplierModal();
        }
      }
    );
  };

  private normalizeFabricUrlSupplierName = (supplierName?: string | null): string =>
    String(supplierName || '').trim();

  private findFabricUrlSupplierByName = (
    suppliers: Supplier[] = [],
    supplierName?: string | null
  ): Supplier | null => {
    const normalizedName = this.normalizeFabricUrlSupplierName(supplierName).toLowerCase();
    if (!normalizedName) {
      return null;
    }

    const supplier = suppliers.find((candidate: any) => {
      const displayName = String(candidate.displayName || candidate.name || '')
        .trim()
        .toLowerCase();
      return displayName === normalizedName;
    });

    return supplier || null;
  };

  private mergeFabricUrlSupplier = (suppliers: Supplier[] = [], supplier?: Supplier | null) => {
    if (!supplier || !supplier.id) {
      return suppliers;
    }

    const byId = new Map<number, Supplier>();
    suppliers.forEach((existingSupplier) => {
      if (existingSupplier?.id) {
        byId.set(existingSupplier.id, existingSupplier);
      }
    });
    byId.set(supplier.id, supplier);

    return Array.from(byId.values()).sort((a, b) =>
      String(a.displayName || '').localeCompare(String(b.displayName || ''))
    );
  };

  private getFabricUrlSupplierWebsite = (sourceUrl?: string | null): string => {
    const domain = getUrlDomain(sourceUrl);
    return domain ? `https://${domain}` : '';
  };

  private getFabricUrlSupplierContactDefaults = (supplierName: string, website: string) => ({
    id: 0,
    accountNumber: '',
    cellPhone: '',
    cityTown: '',
    company: supplierName,
    country: '',
    email: '',
    fax: '',
    firstName: '',
    homePhone: '',
    lastName: '',
    mainPhone: '',
    officePhone: '',
    paymentTerms: '',
    relation: '',
    stateProvince: '',
    streetAddress: '',
    unitSuite: '',
    website,
    zipCode: '',
  });

  private buildFabricUrlSupplierPayload = (supplierName: string, sourceUrl?: string | null) => {
    const website = this.getFabricUrlSupplierWebsite(sourceUrl);
    return {
      id: 0,
      active: true,
      avatarId: '',
      accountNumber: '',
      mainPhone: '',
      displayName: supplierName,
      companyName: supplierName,
      fax: '',
      notes: '',
      tags: '',
      type: 'installer',
      shippingAddress: this.getFabricUrlSupplierContactDefaults(supplierName, website),
      billingAddress: this.getFabricUrlSupplierContactDefaults(supplierName, website),
      additionalContacts: [],
      isCustom: false,
      accountId: this.props.accountId,
    };
  };

  private isDuplicateFabricUrlSupplierError = (response: any): boolean => {
    const message = String(response?.message || response?.msg || '').toLowerCase();
    return message.includes('not unique') || message.includes('already in use');
  };

  private getSuppliersIncludingInactive = async (): Promise<Supplier[]> => {
    const response: any = await getAllSuppliersList({ includeInactive: true });
    const suppliers =
      response && !response.error && Array.isArray(response) ? response : this.state.suppliers;
    this.setState({ suppliers });
    return suppliers;
  };

  private ensureFabricUrlSupplier = async (
    supplierName?: string | null,
    sourceUrl?: string | null
  ): Promise<{ supplierId: number | null; suppliers: Supplier[] }> => {
    const normalizedName = this.normalizeFabricUrlSupplierName(supplierName);

    if (!normalizedName) {
      return { supplierId: null, suppliers: this.state.suppliers };
    }

    const localSupplier = this.findFabricUrlSupplierByName(this.state.suppliers, normalizedName);
    if (localSupplier?.id) {
      return { supplierId: localSupplier.id, suppliers: this.state.suppliers };
    }

    const searchResult: any = await searchSuppliers({
      text: normalizedName,
      accountId: this.props.accountId,
      excludeId: 0,
      includeInactive: true,
      nameSort: 'asc',
      typeSort: 'asc',
    });

    if (Array.isArray(searchResult)) {
      const searchedSupplier = this.findFabricUrlSupplierByName(searchResult, normalizedName);
      if (searchedSupplier?.id) {
        return {
          supplierId: searchedSupplier.id,
          suppliers: this.mergeFabricUrlSupplier(this.state.suppliers, searchedSupplier),
        };
      }
    }

    const createdSupplier = await addSupplier(
      this.buildFabricUrlSupplierPayload(normalizedName, sourceUrl)
    );

    if (createdSupplier?.error) {
      const suppliers = await this.getSuppliersIncludingInactive();
      const existingSupplier = this.findFabricUrlSupplierByName(suppliers, normalizedName);

      if (existingSupplier?.id && this.isDuplicateFabricUrlSupplierError(createdSupplier)) {
        return { supplierId: existingSupplier.id, suppliers };
      }

      throw new Error(
        createdSupplier.message || createdSupplier.msg || 'Unable to create supplier from fabric URL.'
      );
    }

    const suppliers = this.mergeFabricUrlSupplier(this.state.suppliers, createdSupplier);
    return {
      supplierId: createdSupplier?.id || null,
      suppliers,
    };
  };

  private getFabricUrlOutcomeTrackingProps = (item?: any) => {
    const itemId = item?.id || item?.item?.id || item?.itemId || null;

    return {
      ...(this.state.fabricUrlImportTrackingProps || {}),
      fabric_import_session_id: this.state.fabricUrlImportSessionId,
      fabric_item_id: itemId || undefined,
    };
  };

  private resetFabricUrlImportState = () => ({
    fabricUrlPrefill: null,
    fabricUrlDetailsPrefill: null,
    fabricUrlImportTrackingProps: null,
    fabricUrlImportSessionId: null,
  });

  private handleFabricUrlSubmit = async ({
    url,
    sectionName,
    categoryId,
    pathId,
    pathName,
  }: FabricUrlImportSubmitPayload): Promise<void> => {
    const sessionId = crypto.randomUUID();
    const submitTrackingProps = buildFabricUrlTrackingProps({
      sourceUrl: url,
      orderType: this.state.orderType,
      sectionName,
      categoryId,
    });

    trackView(MixpanelEvents.FABRIC_URL_SUBMIT, {
      ...submitTrackingProps,
      fabric_import_session_id: sessionId,
    });

    const extractedFabricDetails = await extractFabricFromUrl(url);
    const supplierResolution = await this.ensureFabricUrlSupplier(
      extractedFabricDetails.supplier,
      extractedFabricDetails.sourceUrl || url
    );
    const { prefill, detailsPrefill } = buildFabricUrlImportPrefill(extractedFabricDetails, {
      categoryId,
      supplierId: supplierResolution.supplierId,
    });
    const outcomeTrackingProps = buildFabricUrlTrackingProps({
      sourceUrl: extractedFabricDetails.sourceUrl || url,
      orderType: this.state.orderType,
      sectionName,
      categoryId,
    });

    this.setState({
      isAddFabricsPatternModalOpen: true,
      selectedItemId: null,
      activeItemClassId: null,
      pathIdForModal: pathId,
      pathNameForModal: pathName,
      fabricPatternModalCategoryId: categoryId,
      fabricUrlPrefill: prefill,
      fabricUrlDetailsPrefill: detailsPrefill,
      fabricUrlImportTrackingProps: outcomeTrackingProps,
      fabricUrlImportSessionId: sessionId,
      suppliers: supplierResolution.suppliers,
      supplierId: supplierResolution.supplierId,
      supplierName: prefill.supplierName || '',
    });
  };

  private handleOpenPatternModalClick = (pathId: string, pathName: string) => {
    const fabricPatternModalCategoryId: number = pathId.includes('liningsList')
      ? CategoryIds.Linings
      : CategoryIds.FabricsAndTrims;
    this.setState({
      isAddFabricsPatternModalOpen: true,
      pathIdForModal: pathId,
      pathNameForModal: pathName,
      fabricPatternModalCategoryId,
      ...this.resetFabricUrlImportState(),
    });
  };

  private handleOpenEditPatternModal = (
    pathName: string,
    itemId?: number | null,
    wideSheetFocusField?: string | null
  ) => {
    this.setState({
      isEditFabricsPatternModalOpen: true,
      pathNameForModal: pathName,
      itemId,
      activeItemClassId: 3,
      wideSheetFocusField: wideSheetFocusField ?? null,
      // pathIdForModal: pathId,
      // pathNameForModal: pathName,
      // fabricPatternModalCategoryId,
    });
  };

  private handleCloseFabricsPatternModal = (item?: any) => {
    if (this.state.fabricUrlImportSessionId) {
      trackView(
        item ? MixpanelEvents.FABRIC_SAVE : MixpanelEvents.FABRIC_URL_DISMISS,
        this.getFabricUrlOutcomeTrackingProps(item)
      );
    }

    this.setState({
      isAddFabricsPatternModalOpen: false,
      activeItemClassId: null,
      pathIdForModal: '',
      pathNameForModal: '',
      fabricPatternModalCategoryId: 0,
      ...this.resetFabricUrlImportState(),
    });
  };

  private handleCloseEditFabricsPatternModal = async () => {
    this.setState({
      isEditFabricsPatternModalOpen: false,
      pathIdForModal: '',
      pathNameForModal: '',
      highlightedSection: '',
      wideSheetFocusField: null,
      fabricPatternModalCategoryId: 0,
    });
  };

  @Bind()
  private async updateLinings(payload: any): Promise<void> {
    try {
      const {
        isSpecialtyFabricHandlingOn,
        fabricWidthInches,
        verticalRepeatInches,
        horizontalRepeatInches,
        isDropRepeatOn,
        directionOfUseTypeId,
        isPleatToPatternOn,
        isMatchRepeatAtSeamsOn,
        supplierId,
        name,
        avatarId,
        isActive,
        patternId,
        cost,
        msrp,
        retailPricingMethod,
        retailPricingValue,
        tradePricingMethod,
        tradePricingValue,
        shippingCost,
        sihCostType,
        handlingFeeMethod,
        handlingFeeValue,
      } = payload;
      const targetPatternId = patternId ?? this.state?.itemId;
      const hasHorizontalRepeat = Number(horizontalRepeatInches || 0) > 0;
      const hasAnyRepeat = hasHorizontalRepeat || Number(verticalRepeatInches || 0) > 0;
      const normalizedIsMatchRepeatAtSeamsOn = hasAnyRepeat
        ? typeof isMatchRepeatAtSeamsOn === 'boolean'
          ? isMatchRepeatAtSeamsOn
          : true
        : false;
      const normalizedIsPleatToPatternOn = hasHorizontalRepeat ? !!isPleatToPatternOn : false;

      await this.getSuppliers();
      const { suppliers } = this.state;

      const liningPatternSupplier = suppliers.find((s) => s.id === supplierId);
      const liningsList = [...this.state.liningsList];
      const liningsPatternItems = this.state.liningsPatternItems
        ? this.state.liningsPatternItems.map((item) =>
            item.id === targetPatternId
              ? {
                  ...item,
                  name,
                  supplierId,
                  avatarId,
                  isActive,
                  cost,
                  msrp,
                  retailPricingMethod,
                  retailPricingValue,
                  tradePricingMethod,
                  tradePricingValue,
                  shippingCost,
                  sihCostType,
                  handlingFeeMethod,
                  handlingFeeValue,
                  fabricWidthInches,
                  verticalRepeatInches,
                  horizontalRepeatInches,
                  isDropRepeatOn,
                  isMatchRepeatAtSeamsOn: normalizedIsMatchRepeatAtSeamsOn,
                  isPleatToPatternOn: normalizedIsPleatToPatternOn,
                  directionOfUseTypeId,
                  isSpecialtyFabricHandlingOn,
                }
              : item
          )
        : this.state.liningsPatternItems;

      for (let i = 0; i < liningsList.length; i++) {
        const { draperyOrderLiningsFabric } = liningsList[i];

        const currentLiningId = draperyOrderLiningsFabric
          ? draperyOrderLiningsFabric?.patternId || draperyOrderLiningsFabric?.itemId
          : undefined;

        if (draperyOrderLiningsFabric && currentLiningId === targetPatternId) {
          liningsList[i].draperyOrderLiningsFabric = {
            ...draperyOrderLiningsFabric,
            pattern: name,
            isMatchRepeatAtSeams: normalizedIsMatchRepeatAtSeamsOn,
            isSpecialtyFabricHandling: isSpecialtyFabricHandlingOn,
            isDropRepeat: isDropRepeatOn,
            isPleatToPattern: normalizedIsPleatToPatternOn,
            directionOfUse: directionOfUseTypeId,
            values: {
              fabricWidth: fabricWidthInches !== null ? fabricWidthInches : undefined,
              verticalRepeat: verticalRepeatInches !== null ? verticalRepeatInches : undefined,
              horizontalRepeat:
                horizontalRepeatInches !== null ? horizontalRepeatInches : undefined,
            },
            supplierId,
            supplierName: liningPatternSupplier ? liningPatternSupplier.displayName : '',
            imageId: avatarId,
            isActive: isActive,
          };
        }
      }
      this.state.liningsList.forEach((item, index) => {
        const { draperyOrderLiningsFabric } = item;

        const currentLiningId = draperyOrderLiningsFabric
          ? draperyOrderLiningsFabric?.patternId || draperyOrderLiningsFabric?.itemId
          : undefined;

        if (draperyOrderLiningsFabric && currentLiningId === targetPatternId) {
          if (
            supplierId &&
            this.state.highlightedSection ===
              `liningsList.${index}.draperyOrderLiningsFabric.supplierId`
          )
            this.clearHighlightSection(`liningsList.${index}.draperyOrderLiningsFabric.supplierId`);
          if (
            fabricWidthInches &&
            this.state.highlightedSection ===
              `liningsList.${index}.draperyOrderLiningsFabric.values.fabricWidth`
          )
            this.clearHighlightSection(
              `liningsList.${index}.draperyOrderLiningsFabric.values.fabricWidth`
            );
          if (
            verticalRepeatInches &&
            this.state.highlightedSection ===
              `liningsList.${index}.draperyOrderLiningsFabric.values.verticalRepeat`
          )
            this.clearHighlightSection(
              `liningsList.${index}.draperyOrderLiningsFabric.values.verticalRepeat`
            );
          if (
            horizontalRepeatInches &&
            this.state.highlightedSection ===
              `liningsList.${index}.draperyOrderLiningsFabric.values.horizontalRepeat`
          )
            this.clearHighlightSection(
              `liningsList.${index}.draperyOrderLiningsFabric.values.horizontalRepeat`
            );
        }
      });
      this.setState(
        (state) => ({
          ...state,
          liningsList,
          liningsPatternItems,
        }),
        () => {
          this.validateAll('save');
          this.validateAll('workOrder');
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  @Bind()
  private async updateFabrics(payload: any): Promise<void> {
    try {
      const {
        isSpecialtyFabricHandlingOn,
        fabricWidthInches,
        verticalRepeatInches,
        horizontalRepeatInches,
        isDropRepeatOn,
        directionOfUseTypeId,
        isPleatToPatternOn,
        isMatchRepeatAtSeamsOn,
        supplierId,
        name,
        avatarId,
        isActive,
        patternId,
        cost,
        msrp,
        retailPricingMethod,
        retailPricingValue,
        tradePricingMethod,
        tradePricingValue,
        shippingCost,
        sihCostType,
        handlingFeeMethod,
        handlingFeeValue,
      } = payload;

      const targetPatternId = patternId ?? this.state.itemId;
      const hasHorizontalRepeat = Number(horizontalRepeatInches || 0) > 0;
      const hasAnyRepeat = hasHorizontalRepeat || Number(verticalRepeatInches || 0) > 0;
      const normalizedIsMatchRepeatAtSeamsOn = hasAnyRepeat
        ? typeof isMatchRepeatAtSeamsOn === 'boolean'
          ? isMatchRepeatAtSeamsOn
          : true
        : false;
      const normalizedIsPleatToPatternOn = hasHorizontalRepeat ? !!isPleatToPatternOn : false;

      const { bandings, cordings, flanges, trims, othersEmbellishments } = this.state;

      await this.getSuppliers();
      const { suppliers, pathNameForModal } = this.state;

      const fabricPatternSupplier = suppliers.find((s) => s.id === supplierId);
      const fabricsPatternItems = this.state.fabricsPatternItems
        ? this.state.fabricsPatternItems.map((item) =>
            item.id === targetPatternId
              ? {
                  ...item,
                  name,
                  supplierId,
                  avatarId,
                  isActive,
                  cost,
                  msrp,
                  retailPricingMethod,
                  retailPricingValue,
                  tradePricingMethod,
                  tradePricingValue,
                  shippingCost,
                  sihCostType,
                  handlingFeeMethod,
                  handlingFeeValue,
                  fabricWidthInches,
                  verticalRepeatInches,
                  horizontalRepeatInches,
                  isDropRepeatOn,
                  isMatchRepeatAtSeamsOn: normalizedIsMatchRepeatAtSeamsOn,
                  isPleatToPatternOn: normalizedIsPleatToPatternOn,
                  directionOfUseTypeId,
                  isSpecialtyFabricHandlingOn,
                }
              : item
          )
        : this.state.fabricsPatternItems;
      const liningsPatternItems = this.state.liningsPatternItems
        ? this.state.liningsPatternItems.map((item) =>
            item.id === targetPatternId
              ? {
                  ...item,
                  name,
                  supplierId,
                  avatarId,
                  isActive,
                  cost,
                  msrp,
                  retailPricingMethod,
                  retailPricingValue,
                  tradePricingMethod,
                  tradePricingValue,
                  shippingCost,
                  sihCostType,
                  handlingFeeMethod,
                  handlingFeeValue,
                  fabricWidthInches,
                  verticalRepeatInches,
                  horizontalRepeatInches,
                  isDropRepeatOn,
                  isMatchRepeatAtSeamsOn: normalizedIsMatchRepeatAtSeamsOn,
                  isPleatToPatternOn: normalizedIsPleatToPatternOn,
                  directionOfUseTypeId,
                  isSpecialtyFabricHandlingOn,
                }
              : item
          )
        : this.state.liningsPatternItems;
      const embellishmentsList = [
        ...this.state.bandings,
        ...this.state.cordings,
        ...this.state.trims,
        ...this.state.flanges,
        ...this.state.othersEmbellishments,
      ].filter((item) => item.hasOwnProperty('draperyOrderFabric'));
      const updateObj: {
        mainFabric: any;
        bandings: DraperyOrderDesignEmbellishment[];
        cordings: DraperyOrderDesignEmbellishment[];
        trims: DraperyOrderDesignEmbellishment[];
        flanges: DraperyOrderDesignEmbellishment[];
        othersEmbellishments: DraperyOrderDesignEmbellishment[];
      } = {
        mainFabric: { ...this.state.mainFabric },
        bandings: [...this.state.bandings],
        cordings: [...this.state.cordings],
        trims: [...this.state.trims],
        flanges: [...this.state.flanges],
        othersEmbellishments: [...this.state.othersEmbellishments],
      };

      for (let i = 0; i < embellishmentsList.length; i++) {
        const { draperyOrderFabric } = embellishmentsList[i];

        const currentEmbId = draperyOrderFabric?.patternId || draperyOrderFabric?.itemId;

        if (draperyOrderFabric && currentEmbId === targetPatternId) {
          embellishmentsList[i].draperyOrderFabric = {
            ...draperyOrderFabric,
            pattern: name,
            isMatchRepeatAtSeams: normalizedIsMatchRepeatAtSeamsOn,
            isSpecialtyFabricHandling: isSpecialtyFabricHandlingOn,
            isDropRepeat: isDropRepeatOn,
            isPleatToPattern: normalizedIsPleatToPatternOn,
            directionOfUse: directionOfUseTypeId,
            values: {
              fabricWidth: fabricWidthInches !== null ? fabricWidthInches : undefined,
              verticalRepeat: verticalRepeatInches !== null ? verticalRepeatInches : undefined,
              horizontalRepeat:
                horizontalRepeatInches !== null ? horizontalRepeatInches : undefined,
            },
            supplierId,
            supplierName: fabricPatternSupplier ? fabricPatternSupplier.displayName : '',
            imageId: avatarId,
            isActive: isActive,
          };
        }
      }
      this.state.bandings.forEach((item, index) => {
        const { draperyOrderFabric } = item;

        const currentEmbId = draperyOrderFabric?.patternId || draperyOrderFabric?.itemId;

        if (draperyOrderFabric && currentEmbId === targetPatternId) {
          if (
            supplierId &&
            this.state.highlightedSection === `bandings.${index}.draperyOrderFabric.supplierId`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            fabricWidthInches &&
            this.state.highlightedSection ===
              `bandings.${index}.draperyOrderFabric.values.fabricWidth`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            verticalRepeatInches &&
            this.state.highlightedSection ===
              `bandings.${index}.draperyOrderFabric.values.verticalRepeat`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            horizontalRepeatInches &&
            this.state.highlightedSection ===
              `bandings.${index}.draperyOrderFabric.values.horizontalRepeat`
          )
            this.clearHighlightSection(this.state.highlightedSection);
        }
      });

      this.state.trims.forEach((item, index) => {
        const { draperyOrderFabric } = item;

        const currentEmbId = draperyOrderFabric?.patternId || draperyOrderFabric?.itemId;

        if (draperyOrderFabric && currentEmbId === targetPatternId) {
          if (
            supplierId &&
            this.state.highlightedSection === `trims.${index}.draperyOrderFabric.supplierId`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            fabricWidthInches &&
            this.state.highlightedSection ===
              `trims.${index}.draperyOrderFabric.values.${
                draperyOrderFabric.type === 7 ? 'fabricWidth' : 'trimWidth'
              }`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            verticalRepeatInches &&
            this.state.highlightedSection ===
              `trims.${index}.draperyOrderFabric.values.verticalRepeat`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            horizontalRepeatInches &&
            this.state.highlightedSection ===
              `trims.${index}.draperyOrderFabric.values.horizontalRepeat`
          )
            this.clearHighlightSection(this.state.highlightedSection);
        }
      });

      this.state.cordings.forEach((item, index) => {
        const { draperyOrderFabric } = item;

        const currentEmbId = draperyOrderFabric?.patternId || draperyOrderFabric?.itemId;

        if (draperyOrderFabric && currentEmbId === targetPatternId) {
          if (
            supplierId &&
            this.state.highlightedSection === `cordings.${index}.draperyOrderFabric.supplierId`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            fabricWidthInches &&
            this.state.highlightedSection ===
              `cordings.${index}.draperyOrderFabric.values.fabricWidth`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            verticalRepeatInches &&
            this.state.highlightedSection ===
              `cordings.${index}.draperyOrderFabric.values.verticalRepeat`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            horizontalRepeatInches &&
            this.state.highlightedSection ===
              `cordings.${index}.draperyOrderFabric.values.horizontalRepeat`
          )
            this.clearHighlightSection(this.state.highlightedSection);
        }
      });

      this.state.flanges.forEach((item, index) => {
        const { draperyOrderFabric } = item;

        const currentEmbId = draperyOrderFabric?.patternId || draperyOrderFabric?.itemId;

        if (draperyOrderFabric && currentEmbId === targetPatternId) {
          if (
            supplierId &&
            this.state.highlightedSection === `flanges.${index}.draperyOrderFabric.supplierId`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            fabricWidthInches &&
            this.state.highlightedSection ===
              `flanges.${index}.draperyOrderFabric.values.fabricWidth`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            verticalRepeatInches &&
            this.state.highlightedSection ===
              `flanges.${index}.draperyOrderFabric.values.verticalRepeat`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            horizontalRepeatInches &&
            this.state.highlightedSection ===
              `flanges.${index}.draperyOrderFabric.values.horizontalRepeat`
          )
            this.clearHighlightSection(this.state.highlightedSection);
        }
      });

      this.state.othersEmbellishments.forEach((item, index) => {
        const { draperyOrderFabric } = item;

        const currentEmbId = draperyOrderFabric?.patternId || draperyOrderFabric?.itemId;

        if (draperyOrderFabric && currentEmbId === targetPatternId) {
          if (
            supplierId &&
            this.state.highlightedSection ===
              `othersEmbellishments.${index}.draperyOrderFabric.supplierId`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            fabricWidthInches &&
            this.state.highlightedSection ===
              `othersEmbellishments.${index}.draperyOrderFabric.values.fabricWidth`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            verticalRepeatInches &&
            this.state.highlightedSection ===
              `othersEmbellishments.${index}.draperyOrderFabric.values.verticalRepeat`
          )
            this.clearHighlightSection(this.state.highlightedSection);
          if (
            horizontalRepeatInches &&
            this.state.highlightedSection ===
              `othersEmbellishments.${index}.draperyOrderFabric.values.horizontalRepeat`
          )
            this.clearHighlightSection(this.state.highlightedSection);
        }
      });

      const currentMainFabricId =
        this.state?.mainFabric?.patternId || this.state?.mainFabric?.itemId;

      if (currentMainFabricId === targetPatternId) {
        updateObj.mainFabric = {
          ...this.state.mainFabric,
          pattern: name,
          supplierId,
          supplierName: fabricPatternSupplier ? fabricPatternSupplier.displayName : '',
          directionOfUse: directionOfUseTypeId,
          isPleatToPattern: normalizedIsPleatToPatternOn,
          isMatchRepeatAtSeams: normalizedIsMatchRepeatAtSeamsOn,
          values: {
            fabricWidth: fabricWidthInches !== null ? fabricWidthInches : undefined,
            verticalRepeat: verticalRepeatInches !== null ? verticalRepeatInches : undefined,
            horizontalRepeat: horizontalRepeatInches !== null ? horizontalRepeatInches : undefined,
          },
          isSpecialtyFabricHandling: isSpecialtyFabricHandlingOn,
          isDropRepeat: isDropRepeatOn,
          imageId: avatarId,
          isActive: isActive,
        };
        if (supplierId && this.state.highlightedSection === `${pathNameForModal}.supplierId`)
          this.clearHighlightSection(this.state.highlightedSection);
        if (
          fabricWidthInches &&
          this.state.highlightedSection === `${pathNameForModal}.values.fabricWidth`
        )
          this.clearHighlightSection(this.state.highlightedSection);
        if (
          verticalRepeatInches &&
          this.state.highlightedSection === `${pathNameForModal}.values.verticalRepeat`
        )
          this.clearHighlightSection(this.state.highlightedSection);
        if (
          horizontalRepeatInches &&
          this.state.highlightedSection === `${pathNameForModal}.values.horizontalRepeat`
        )
          this.clearHighlightSection(this.state.highlightedSection);
      }
      const liningPatternSupplier = suppliers.find((s) => s.id === supplierId);
      const liningsList = [...this.state.liningsList];

      for (let i = 0; i < liningsList.length; i++) {
        const { draperyOrderLiningsFabric } = liningsList[i];

        const currentLiningId = draperyOrderLiningsFabric
          ? draperyOrderLiningsFabric?.patternId || draperyOrderLiningsFabric?.itemId
          : undefined;

        if (draperyOrderLiningsFabric && currentLiningId === targetPatternId) {
          liningsList[i].draperyOrderLiningsFabric = {
            ...draperyOrderLiningsFabric,
            pattern: name,
            isMatchRepeatAtSeams: normalizedIsMatchRepeatAtSeamsOn,
            isSpecialtyFabricHandling: isSpecialtyFabricHandlingOn,
            isDropRepeat: isDropRepeatOn,
            isPleatToPattern: normalizedIsPleatToPatternOn,
            directionOfUse: directionOfUseTypeId,
            values: {
              fabricWidth: fabricWidthInches !== null ? fabricWidthInches : undefined,
              verticalRepeat: verticalRepeatInches !== null ? verticalRepeatInches : undefined,
              horizontalRepeat:
                horizontalRepeatInches !== null ? horizontalRepeatInches : undefined,
            },
            supplierId,
            supplierName: liningPatternSupplier ? liningPatternSupplier.displayName : '',
            imageId: avatarId,
            isActive: isActive,
          };
        }
      }
      this.state.liningsList.forEach((item, index) => {
        const { draperyOrderLiningsFabric } = item;

        const currentLiningId = draperyOrderLiningsFabric
          ? draperyOrderLiningsFabric?.patternId || draperyOrderLiningsFabric?.itemId
          : undefined;

        if (draperyOrderLiningsFabric && currentLiningId === targetPatternId) {
          if (
            supplierId &&
            this.state.highlightedSection ===
              `liningsList.${index}.draperyOrderLiningsFabric.supplierId`
          )
            this.clearHighlightSection(`liningsList.${index}.draperyOrderLiningsFabric.supplierId`);
          if (
            fabricWidthInches &&
            this.state.highlightedSection ===
              `liningsList.${index}.draperyOrderLiningsFabric.values.fabricWidth`
          )
            this.clearHighlightSection(
              `liningsList.${index}.draperyOrderLiningsFabric.values.fabricWidth`
            );
          if (
            verticalRepeatInches &&
            this.state.highlightedSection ===
              `liningsList.${index}.draperyOrderLiningsFabric.values.verticalRepeat`
          )
            this.clearHighlightSection(
              `liningsList.${index}.draperyOrderLiningsFabric.values.verticalRepeat`
            );
          if (
            horizontalRepeatInches &&
            this.state.highlightedSection ===
              `liningsList.${index}.draperyOrderLiningsFabric.values.horizontalRepeat`
          )
            this.clearHighlightSection(
              `liningsList.${index}.draperyOrderLiningsFabric.values.horizontalRepeat`
            );
        }
      });

      this.setState(
        (state) => ({
          ...state,
          ...updateObj,
          liningsList,
          fabricsPatternItems,
          liningsPatternItems,
        }),
        () => {
          this.validateAll('save');
          this.validateAll('workOrder');
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  private handleCloseClientModal = () => {
    this.setState({
      isAddClientModalOpen: false,
      pathIdForModal: '',
      pathNameForModal: '',
    });
  };

  private handleCloseSupplierModal = () => {
    this.setState({
      isAddSupplierModalOpen: false,
      pathIdForModal: '',
      pathNameForModal: '',
    });
  };

  private formatClientDisplayName = (client: any): string => {
    if (!client) return '';

    const seenParentIds = new Set<number>();
    const parentNames: string[] = [];

    if (Array.isArray(client.parentClients) && client.parentClients.length > 0) {
      parentNames.push(
        ...client.parentClients
          .slice()
          .reverse()
          .filter((parent: any) => {
            if (!parent || seenParentIds.has(parent.id)) {
              return false;
            }
            seenParentIds.add(parent.id);
            return true;
          })
          .map((parent: any) => parent.displayName)
          .filter(Boolean)
      );
    } else {
      let cursor = client.parent;
      while (cursor && !seenParentIds.has(cursor.id)) {
        if (cursor.displayName) {
          parentNames.push(cursor.displayName);
        }
        seenParentIds.add(cursor.id);
        cursor = cursor.parent;
      }
      parentNames.reverse();
    }

    return [...parentNames, client.displayName].filter(Boolean).join(' | ');
  };

  private handleClientChanged = (client: ClientModule.Client) => {
    this.updateStateByName(this.state.pathIdForModal, client.id);
    this.updateStateByName('client', client);
    const formattedName = this.formatClientDisplayName(client) || client.displayName;
    this.updateStateByName(this.state.pathNameForModal, formattedName);
  };

  private handleSupplierChanged = async (supplier: SuppliersModule.Supplier) => {
    const { accountId } = this.props;

    const res = await addSupplier({
      ...supplier,
      isCustom: false,
      accountId,
    });

    if (res.error) {
      if (
        res.msg === 'User name not unique.' ||
        res.message === 'User name not unique.' ||
        res.msg === 'Supplier name not unique.' ||
        res.message === 'Supplier name not unique.'
      ) {
        let errors = { displayName: 'Display Name already in use' };
        throw FormValidationError.fromErrorDictionary(errors);
      } else {
        throw new Error(res.message || res.msg);
      }
    }
    const supplierId = res.id;
    const supplierDisplayName = res.displayName;
    this.updateStateByName(this.state.pathIdForModal, supplierId);
    this.updateStateByName(this.state.pathNameForModal, supplierDisplayName);
    await this.getSuppliers();
    this.setState({
      supplierName: supplierDisplayName,
      supplierId: supplierId,
    });
  };

  private handleSearchClient: SearchSelectProps['onSearch'] = async (search: string) => {
    const { accountId } = this.props;
    const trimmedSearch = search.trim();

    if (!this.clientSearchCacheLoaded && trimmedSearch.length > 0) {
      const cacheRes = await searchClients({ text: '', accountId });
      if (!cacheRes.error) {
        const uniqueCacheClients = Array.from(
          new Map(cacheRes.map((client: any) => [client.id, client])).values()
        );
        uniqueCacheClients.forEach((client: any) => this.clientSearchCache.set(client.id, client));
        this.clientSearchCacheLoaded = true;
      }
    }

    const res = await searchClients({ text: search, accountId });

    if (res.error) {
      return [];
    } else if (res.length === 0) {
      this.setState({ clientId: null });
    }
    const formatDisplayName = (client: any, clientLookup: Map<number, any>) => {
      const parentNames: string[] = [];
      const seenParentIds = new Set<number>();
      if (Array.isArray(client.parentClients) && client.parentClients.length > 0) {
        parentNames.push(
          ...client.parentClients
            .slice()
            .reverse()
            .filter((parent: any) => {
              if (!parent || seenParentIds.has(parent.id)) {
                return false;
              }
              seenParentIds.add(parent.id);
              return true;
            })
            .map((parent: any) => parent.displayName)
            .filter(Boolean)
        );
      } else {
        let cursor = client.parent;
        while (cursor && !seenParentIds.has(cursor.id)) {
          if (cursor.displayName) {
            parentNames.push(cursor.displayName);
          }
          seenParentIds.add(cursor.id);
          const next = clientLookup.get(cursor.id);
          cursor = next?.parent ?? cursor.parent;
        }
        parentNames.reverse();
      }
      return [...parentNames, client.displayName].filter(Boolean).join(' | ');
    };
    const uniqueClients = Array.from(
      new Map(res.map((client: any) => [client.id, client])).values()
    );
    uniqueClients.forEach((client: any) => this.clientSearchCache.set(client.id, client));
    if (trimmedSearch.length === 0) {
      this.clientSearchCacheLoaded = true;
    }

    const clientLookup = new Map(this.clientSearchCache);
    return uniqueClients.map((r: any) => ({
      id: r.id,
      displayName: formatDisplayName(r, clientLookup),
    }));
  };

  private handleSearchRoom: SearchSelectProps['onSearch'] = async (search: string) => {
    // const { dispatch } = this.props;
    const { clientId } = this.state.draperyOrder;
    this.clearHighlightSection('draperyOrder.roomId');

    let res: any;

    if (clientId) {
      res = await getRooms(clientId, search);
    }
    if (res.error) {
      return [];
    }
    return res.map((r: any) => ({
      id: r.id,
      displayName: r.name,
    }));
  };

  private handleSearchItemType: SearchSelectProps['onSearch'] = async (search: string) => {
    const { accountId } = this.props;
    this.clearHighlightSection('draperyOrder.itemType');

    let res: any;
    if (accountId) {
      res = await getAllOtherItems(accountId, search);
    }
    if (res.error) {
      return [];
    }
    return res.map((r: any) => ({
      id: r.id,
      displayName: r.name,
    }));
  };

  private handleSearchSupplier: SearchSelectProps['onSearch'] = async (search: string) => {
    const { accountId } = this.props;
    const res = await searchSuppliers({
      accountId,
      text: '',
      nameSort: 'asc',
      typeSort: 'asc',
      includeInactive: true,
    });
    if (res.error) {
      return [];
    }
    const filterRes = res.filter((supp: any) => supp.active);
    return filterRes.map((s: any) => ({
      id: s.id,
      displayName: s.displayName,
      tags: s.tags,
    }));
  };

  private handleSearchPattern = ({
    search,
    list,
  }: {
    search: string;
    list: FabricPatternItem[];
  }) => {
    if (!list || !list.length) {
      return [];
    }
    if (search && search.length) {
      list = list.filter((r) => {
        const { name, itemNumber, salesDescription, orderingDescription } = r;

        if (
          (name && name.toLowerCase().includes(search.toLowerCase())) ||
          (itemNumber && itemNumber.includes(search)) ||
          (salesDescription && salesDescription.toLowerCase().includes(search.toLowerCase())) ||
          (orderingDescription && orderingDescription.toLowerCase().includes(search.toLowerCase()))
        ) {
          return true;
        }
      });
    }
    return list.map((l) => ({
      id: l.id!,
      displayName: l.name!,
      itemId: l.itemId!,
      isActive: l.isActive!,
    }));
  };

  private handleSearchFabricsPattern: SearchSelectProps['onSearch'] = async (search: string) => {
    let res = this.state.fabricsPatternItems;
    if (!res) return [];
    // const activeItems = res.filter((item) => item.isActive === true);
    return this.handleSearchPattern({ search, list: res });
  };

  private handleSearchFabricsLiningPattern: SearchSelectProps['onSearch'] = async (
    search: string
  ) => {
    let res = this.state.liningsPatternItems;
    if (!res) return [];
    // const activeItems = res.filter((item) => item.isActive === true);
    return this.handleSearchPattern({ search, list: res });
  };

  private handleAddSupplierByName: SearchSelectProps['onAddByName'] = async (name: string) => {
    return false;
  };

  private handleAddRoom = async (
    value: string,
    reffererModal?: string
  ): Promise<string | undefined> => {
    if (!this.state.draperyOrder.clientId) {
      return 'Please select a client before adding a room.';
    }

    const { accountId } = this.props;

    const res = await addRoom({
      accountId,
      name: value,
      clientId: this.state.draperyOrder.clientId,
    });

    if (!res) {
      const message = 'Failed to add room. Please try again.';
      return message;
    }

    if (res.error) {
      return res.message;
    }
    const room: RoomModule.Room = res;
    const roomList = [...this.state.roomList];
    roomList.push({
      key: room.id,
      label: room.name,
    });
    this.setState({
      roomList,
      draperyOrder: {
        ...this.state.draperyOrder,
        roomId: room.id,
        roomName: room.name,
      },
    });
    this.validateDraperyOrder();
    return undefined;
  };

  public romanShadeFieldsChanged = (name: string): void => {
    this.setState((prevState) => ({
      ...prevState,
      romanShadeSettingsChangedField: {
        ...prevState.romanShadeSettingsChangedField,
        [name]: true,
      },
    }));
  };

  private handleOpenImageModal = (name: string, option: 'add' | 'delete'): void => {
    if (option === 'add') {
      this.setState({
        imageModalOpen: true,
        imageModalRelatedName: name,
      });
    } else {
      this.updateStateByName(name, '');
    }
  };

  private handleCloseImageModal = () => {
    this.setState({
      imageModalOpen: false,
      imageModalRelatedName: '',
    });
  };

  private handleSaveImage = async (file: File) => {
    const { accountId } = this.props;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('accountId', accountId.toString());
    formData.append('fileStoreUrl', Config.fileStoreUrl);
    const res = await uploadImage(formData);
    if (res.error) {
      throw new Error(res.message);
    }

    if (this.state.imageModalRelatedName === 'draperyOrderDesign.otherPleatImageId') {
      this.state.draperyOrderDesign.pleatType = 'OTHER';
    }
    this.updateStateByName(this.state.imageModalRelatedName, res.url);
    this.setState((state) => ({
      ...state,
      imageModalOpen: false,
      imageModalRelatedName: '',
    }));
  };

  private toggleCancelModal = async () => {
    const { history } = this.props;
    if (this.state && this.state.client && this.state.client.id) {
      if (
        this.state.noChanges ||
        (!this.state.isChanged && this.state.draperyOrder.id) ||
        (this.state.draperyOrder.id && !this.state.stateObj.draperyOrder.id)
      ) {
        const duplicate = localStorage.getItem('duplicate');
        if (duplicate) {
          const { id, orderType } = JSON.parse(duplicate);
          await deleteClientProject({
            id: Number(id),
            duplicateNotSaved: true,
          } as unknown as ClientProject);
          localStorage.removeItem('duplicate');

          const canCreateOrder = await userCanCreateNewOrder(this.props.accountId);
          if (
            !canCreateOrder &&
            this.state.remainingItemOrder >= 0 &&
            orderType !== 'custom-order'
          ) {
            await updateAccount({
              accountId: this.props.accountId,
              remainingItemOrder: this.state.remainingItemOrder + 1,
            });
          }
        }
      }

      if (this.state?.client?.id) {
        // Track lastViewedAt for project
        await handleUpdateLastViewedProject(this.state?.client?.id);
      }

      history.push(
        `/clients/${
          this.state && this.state.client && this.state.client.id === 0
            ? ''
            : this.state && this.state.client && this.state.client.id
        }`
      );
    } else {
      history.push(
        history.location && history.location.state && history.location.state.referrer
          ? history.location.state.referrer
          : '/overview'
      );
    }
  };

  private toggleErrorMessage = () => {
    this.findFirstErrorsCalled = false;
    this.setState((state) => ({
      ...state,
      isSidebarHidden: false,
      isErrorMessageOpen: !state.isErrorMessageOpen,
      isError: false,
    }));
  };

  private toggleLoadingModal = () => {
    this.setState({ isLoadingOpen: !this.state.isLoadingOpen });
  };

  private handleKeyPressForm = (e: KeyboardEvent<HTMLElement>) => {
    if (
      e.which === 13 &&
      (e.target as HTMLTextAreaElement).name !== 'draperyOrderDesign.notes' &&
      (e.target as HTMLTextAreaElement).name !== 'othersEmbellishments.details'
    ) {
      e.preventDefault();
      return;
    }
  };

  private toggleSidebar = () => {
    this.setState({
      isSidebarHidden: !this.state.isSidebarHidden,
    });
  };

  private navigateToField = (name: string | string[]) => {
    if (Array.isArray(name)) {
      const e = ['Trade', 'Retail'].some((item) => name.includes(item))
        ? document.getElementById('Trade')
        : document.getElementsByName(name[0])[0];
      if (e) {
        e.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => name.map((n) => this.highlightSection(n), 200)); // Remove the highlight after 1 second
      }
    } else {
      const e = document.getElementsByName(name)[0];
      if (name === 'mainFabric.values.fabricWidth') {
        if (
          this.state.draperyOrderFabricsConfirmations &&
          this.state.draperyOrderFabricsConfirmations.length > 0 &&
          this.state.mainFabric.directionOfUse === 1 &&
          !this.state.checkedAllowExtraWidthOne &&
          e
        ) {
          e.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => this.highlightSection(name), 100);
        } else if (
          this.state.draperyOrderFabricsConfirmations &&
          this.state.draperyOrderFabricsConfirmations.length > 0 &&
          this.state.mainFabric.directionOfUse === 2 &&
          !this.state.checkedAllowExtraWidthTwo &&
          e
        ) {
          e.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => this.highlightSection(name), 100);
        } else if (
          this.state.draperyOrderFabricsConfirmations &&
          this.state.draperyOrderFabricsConfirmations.length === 0 &&
          e
        ) {
          e.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => this.highlightSection(name), 100);
        }
      } else if (e) {
        e.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => this.highlightSection(name), 200);
      }
    }
  };

  private navigateToFieldWithoutHighlight = (name: string | string[]) => {
    if (Array.isArray(name)) {
      const e = ['Trade', 'Retail'].some((item) => name.includes(item))
        ? document.getElementById('Trade')
        : document.getElementsByName(name[0])[0];
      if (e) {
        e.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    } else {
      const e = document.getElementsByName(name)[0];
      if (name === 'mainFabric.values.fabricWidth') {
        if (
          this.state.draperyOrderFabricsConfirmations &&
          this.state.draperyOrderFabricsConfirmations.length > 0 &&
          this.state.mainFabric.directionOfUse === 1 &&
          !this.state.checkedAllowExtraWidthOne &&
          e
        ) {
          e.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (
          this.state.draperyOrderFabricsConfirmations &&
          this.state.draperyOrderFabricsConfirmations.length > 0 &&
          this.state.mainFabric.directionOfUse === 2 &&
          !this.state.checkedAllowExtraWidthTwo &&
          e
        ) {
          e.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (
          this.state.draperyOrderFabricsConfirmations &&
          this.state.draperyOrderFabricsConfirmations.length === 0 &&
          e
        ) {
          e.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } else if (e) {
        e.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  };

  private getValidationPathName = (nameOther?: string): string | undefined => {
    if (!nameOther) {
      return undefined;
    }

    const separatorIndex = nameOther.indexOf('.');

    return separatorIndex >= 0 ? nameOther.substring(separatorIndex + 1) : undefined;
  };

  private getPricingWideSheetFocusField = (name: string[]): string => {
    if (name.includes('Trade')) {
      return 'tradePricingValue';
    }

    if (name.includes('Retail')) {
      return 'retailPricingValue';
    }

    const billingType = this.state.client?.billToParent
      ? this.state.client?.billingDetails?.billingType
      : this.state.client?.billingDetailsDirectly?.billingType;

    return billingType === 'Trade' ? 'tradePricingValue' : 'retailPricingValue';
  };

  @Bind()
  private openItemModal(item: MyShopItem | null = null, tabIndex: number, name: string | string[]) {
    if (item) {
      const resolvedItemId = item.id || item.itemId || null;
      this.setState(
        {
          activeModal: ModalName.StandardItem,
          selectedItem: item,
          selectedItemId: resolvedItemId,
          pricingTabIndex: tabIndex,
          itemId: resolvedItemId,
        },
        () => {
          this.navigateToField(name);
        }
      );
    } else {
      this.setState({
        activeModal: ModalName.StandardItem,
        selectedItemId: null,
        selectedItem: {} as MyShopItem | null,
        activeItemClassId: 3,
      });
      // this.setState({});
    }
  }

  private async openDraperyModal(
    item: MyShopItem | null,
    tabIndex: number,
    name: string | string[]
  ) {
    if (item) {
      const resolvedItemId = item.id || item.itemId || null;
      const romanShadeDefaultSupplier =
        this.state.suppliers && this.state.suppliers.length > 0
          ? this.state.suppliers.find((i) => {
              if (item && item.supplierId) {
                return i.id === item.supplierId;
              }
              return false;
            })
          : false;
      this.setState(
        (prev: any) => {
          return {
            ...prev,
            activeModal:
              this.state.orderType === 'roman-shade-order'
                ? ModalName.RomanShadeItem
                : ModalName.DraperyItem,
            selectedItem: item,
            selectedItemId: resolvedItemId,
            pricingTabIndex: tabIndex,
            supplierName:
              this.state.orderType === 'roman-shade-order' && romanShadeDefaultSupplier
                ? romanShadeDefaultSupplier.displayName
                : prev.supplierName,
            supplierId:
              this.state.orderType === 'roman-shade-order' ? item.supplierId : prev.supplierId,
          };
        },
        () => {
          this.navigateToField(name);
        }
      );
    } else {
      this.setState({
        activeModal:
          this.state.orderType === 'roman-shade-order'
            ? ModalName.RomanShadeItem
            : ModalName.DraperyItem,
        selectedItemId: null,
        selectedItem: {} as MyShopItem | null,
      });
      // this.setState({activeItemClassId: ItemClasses.Standard});
    }
  }

  private navigateValidation = async (
    tabIndex: number,
    name: string | string[],
    itemId?: number,
    itemClassId?: number,
    nameOther?: string,
    confirmationType?: string
  ) => {
    const validationPathName = this.getValidationPathName(nameOther);
    const isMyShopPricingValidation =
      Array.isArray(name) &&
      ['Item Cost', 'Item MSRP', 'Retail', 'Trade'].some((item) => name.includes(item));

    if (
      isMyShopPricingValidation &&
      validationPathName &&
      itemId !== undefined &&
      itemId !== null
    ) {
      this.setState(
        {
          activeModal: null,
          highlightedSection: null,
          tabIndex: 2,
        },
        () => {
          this.handleOpenEditPatternModal(
            validationPathName,
            itemId,
            this.getPricingWideSheetFocusField(name)
          );
        }
      );
      return;
    }

    if (nameOther && this.state.orderType && this.state.orderType === 'custom-order') {
      const fieldName = nameOther.substring(nameOther.indexOf('.') + 1);

      this.setState(
        {
          tabIndex: 2,
          isCustomizeConstructionOpen: false,
        },
        () => {
          this.navigateToFieldWithoutHighlight(fieldName);
        }
      );
    }

    if (
      confirmationType &&
      confirmationType === 'confirmation' &&
      (this.state.checkedAllowExtraWidthOne || this.state.checkedAllowExtraWidthTwo)
    ) {
      return;
    }

    // const modalName = Array.isArray(name) ? name[0] : name

    if (tabIndex === 2) {
      this.setState({
        activeItemClassId: 3,
      });
      const { fabricsPatternItems, liningsPatternItems } = this.state;

      let selectedPattern;
      let itemsArr: any[] = [];
      if (fabricsPatternItems) {
        itemsArr = [...fabricsPatternItems];
      }
      if (liningsPatternItems) {
        itemsArr = [...itemsArr, ...liningsPatternItems];
      }
      selectedPattern = itemsArr ? itemsArr.find((item) => item.id === itemId) : undefined;

      if (selectedPattern) {
        this.openItemModal(selectedPattern as MyShopItem, tabIndex, name);
      }
    }

    if (Array.isArray(name)) {
      if (['Item Cost', 'Item MSRP', 'Retail', 'Trade'].some((item) => name.includes(item))) {
        const { fabricsPatternItems, liningsPatternItems } = this.state;
        let selectedPattern;
        let itemsArr: any[] = [];
        if (fabricsPatternItems) {
          itemsArr = [...fabricsPatternItems];
        }
        if (liningsPatternItems) {
          itemsArr = [...itemsArr, ...liningsPatternItems];
        }
        selectedPattern = itemsArr ? itemsArr.find((item) => item.id === itemId) : undefined;

        if (selectedPattern) {
          this.openItemModal(selectedPattern as MyShopItem, tabIndex, name);
        }
      } else if (name[0] === 'draperyItemPricing') {
        await getAll().then((res) => {
          const draperyItem = res.filter((item) => item.name === 'Drapery');
          this.openDraperyModal(draperyItem[0], tabIndex, name);
        });
      } else if (name[0] === 'romanShadeItemPricing') {
        await getAll().then((res) => {
          const romanShadeItem = res.filter((item) => item.name === 'Roman Shade');
          this.openDraperyModal(romanShadeItem[0], tabIndex, name);
        });
      } else if (name[0] === 'billingType') {
        this.setState(
          {
            tabIndex,
            isEditClientModalOpen: true,
          },
          () => {
            this.navigateToField(name);
          }
        );
      }
    } else if (tabIndex === -1) {
      this.navigateToField(name);
    } else if (tabIndex === -2) {
      if (this.state.draperyOrderDesign.draperyType) {
        this.setState(
          {
            tabIndex: 1,
            isCustomizeConstructionOpen: false,
          },
          () => {
            this.navigateToField(name);
          }
        );
      }
    } else if (name.includes('openModalForPattern')) {
      !this.state.isLoading &&
        this.setState(
          {
            tabIndex,
          },
          () => {
            this.handleOpenEditPatternModal(name, 0);
          }
        );
    } else {
      !this.state.isLoading &&
        this.setState(
          {
            tabIndex,
          },
          () => {
            this.navigateToField(name);
          }
        );
    }
  };
  @Bind()
  private findFirstErrors() {
    if (this.state.draperyOrderErrors && this.state.draperyOrderErrors.length > 0) {
      this.navigateValidation(
        this.state.draperyOrderErrors[0].tabIndex,
        this.state.draperyOrderErrors[0].name
      );
      this.setState({ isModalClosed: false });
      return;
    }
    if (this.state.draperyOrderDesignErrors && this.state.draperyOrderDesignErrors.length > 0) {
      this.navigateValidation(
        this.state.draperyOrderDesignErrors[0].tabIndex,
        this.state.draperyOrderDesignErrors[0].name
      );
      this.setState({ isModalClosed: false });
      return;
    }
    if (this.state.draperyOrderFabricsErrors && this.state.draperyOrderFabricsErrors.length > 0) {
      this.navigateValidation(
        this.state.draperyOrderFabricsErrors[0].tabIndex,
        this.state.draperyOrderFabricsErrors[0].name
      );
      this.setState({ isModalClosed: false });
      return;
    }
    if (this.state.draperyOrderHardwareErrors && this.state.draperyOrderHardwareErrors.length > 0) {
      this.navigateValidation(
        this.state.draperyOrderHardwareErrors[0].tabIndex,
        this.state.draperyOrderHardwareErrors[0].name
      );
      this.setState({ isModalClosed: false });
      return;
    }
    if (
      this.state.draperyOrderFabricsConfirmations &&
      this.state.draperyOrderFabricsConfirmations.length > 0
    ) {
      this.navigateValidation(
        this.state.draperyOrderFabricsConfirmations[0].tabIndex,
        this.state.draperyOrderFabricsConfirmations[0].name,
        undefined,
        undefined,
        undefined,
        'confirmation'
      );
      this.setState({ isModalClosed: false });
      return;
    }
    if (this.state.draperyOrderSummaryErrors && this.state.draperyOrderSummaryErrors.length > 0) {
      this.navigateValidation(
        this.state.draperyOrderSummaryErrors[0].tabIndex,
        this.state.draperyOrderSummaryErrors[0].name
      );
      this.setState({ isModalClosed: false });
      return;
    }
  }

  private highlightSection = (name: string) => {
    if (this.state.highlightedSection === name) {
      return;
    }
    const element = document.getElementsByName(name)[0] || document.getElementById(name);
    const elementType = element.getAttribute('type');
    if (elementType && ['text', 'number'].includes(elementType)) {
      element.focus();
    }
    this.setState({ highlightedSection: name });
  };

  private clearHighlightSection = (name: string) => {
    if (
      name === 'isNoneEmbellishment' &&
      this.state.highlightedSection &&
      this.state.highlightedSection.includes('leadReturnEdge')
    ) {
      this.setState({
        highlightedSection: null,
      });
    }
    if (this.state.highlightedSection !== name) {
      return;
    }
    this.setState({
      highlightedSection: null,
    });
  };

  private drawingBlob = async (): Promise<Blob | null> => {
    if (this.designTabRef.current) {
      return this.designTabRef.current.drawingBlob();
    } else {
      return null;
    }
  };

  private showSaveConfirm = async (): Promise<boolean> => {
    return confirmation(<div>Would you like to save your progress?</div>, {
      uiHeader: 'Confirmation',
      uiAcceptLabel: 'Yes, save progress',
      uiDeclineLabel: 'No, cancel edits',
    });
  };

  private showEditWorkOrderConfirm = async (): Promise<boolean> => {
    return confirmation(<div>Would you like to cancel your edits?</div>, {
      uiHeader: 'Confirmation',
      uiAcceptLabel: 'No, continue editing',
      uiDeclineLabel: 'Yes, cancel edits',
      workOrderEditMode: this.state.workOrderEditMode,
      cancelEditing: this.cancelEditing,
    });
  };

  private cancelEditing = async () => {
    this.setState((prev) => {
      return {
        ...prev,
        workOrderEditMode: false,
        tabIndex: 5,
        isUpdateChanged: false,
        draperyOrderDesignErrors: [],
        draperyOrderFabricsErrors: [],
        draperyOrderSummaryErrors: [],
        draperyOrderErrors: [],
      };
    });
    await this.getExistingDraperyOrder(true);
    await this.getClient();
    if (this.state.draperyOrder.clientId) {
      await this.getRooms(this.state.draperyOrder.clientId);
    }
    if (this.state.highlightedSection) {
      await this.clearHighlightSection(this.state.highlightedSection);
    }
  };

  private cancelEditingWorkOrder = async () => {
    if (this.state.workOrderEditMode && !this.state.noChanges) {
      await this.showEditWorkOrderConfirm();
    } else {
      this.setState((prev) => {
        return {
          ...prev,
          tabIndex: 5,
          workOrderEditMode: false,
          isUpdateChanged: false,
        };
      });
      await this.getExistingDraperyOrder(true);
      await this.getClient();
      if (this.state.draperyOrder.clientId) {
        await this.getRooms(this.state.draperyOrder.clientId);
      }
      if (this.state.highlightedSection) {
        await this.clearHighlightSection(this.state.highlightedSection);
      }
    }
  };

  private isNilOrZero(value: any): boolean {
    return value === 0 || value === null || value === undefined || value === '';
  }

  private deepEqual(obj1: any, obj2: any): boolean {
    // if (!this.state.draperyOrder.id) return false;

    if (this.isNilOrZero(obj1) && this.isNilOrZero(obj2)) return true;

    if (obj1 === obj2) return true;

    if (obj1 == null || obj2 == null) return false;

    if (Array.isArray(obj1) && Array.isArray(obj2)) {
      if (obj1.length !== obj2.length) return false;

      for (let i = 0; i < obj1.length; i++) {
        if (!this.deepEqual(obj1[i], obj2[i])) return false;
      }
      return true;
    }

    if (Array.isArray(obj1) !== Array.isArray(obj2)) return false;
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;

    const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

    for (let key of keys) {
      if (!this.deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  }

  private customNavigation = async (location: any): Promise<void> => {
    if (this.state.workOrderEditMode) {
      // if (!this.state.noChanges) {
      const editConfirmed = await this.showEditWorkOrderConfirm();
      if (!editConfirmed) return;
      // }
    } else {
      // Disable save changes when Setup Needed modal needs to open - 1767
      if (
        !this.state.noChanges &&
        !this.state.showDraperyItemModal &&
        !this.state.showRomanShadeItemModal
      ) {
        const confirmed = await this.showSaveConfirm();

        if (confirmed) {
          if (this.state.draperyOrder.id === 0) {
            const can_create_order = await userCanCreateNewOrder(this.props.accountId);
            if (
              !can_create_order &&
              this.state.remainingItemOrder === 0 &&
              this.state.orderType !== 'custom-order'
            ) {
              this.props.handleOpenSubscriptionPlanModal();
              return;
            }
          }
          if (!(await this.handleSaveAll(true))) {
            return;
          }
        } else {
          const duplicate = localStorage.getItem('duplicate');
          if (duplicate) {
            const { id, orderType } = JSON.parse(duplicate);
            await deleteClientProject({
              id: Number(id),
              duplicateNotSaved: true,
            } as unknown as ClientProject);
          }
        }
      }
    }

    this.setState(
      (state) => ({
        ...state,
        navigationConfirmed: true,
      }),
      () => {
        if (location.pathname === '/calculator') {
          this.props.history.push(
            `${location.pathname}${
              this.props.location.state &&
              this.props.location.state.type &&
              this.props.location.state.from
                ? `?type=${this.props.location.state.type}`
                : location.state && location.state.type
                  ? `?type=${location.state.type}`
                  : ''
            }`,
            {
              tempKey: Math.random(),
              type:
                this.props.location.state &&
                this.props.location.state.type &&
                this.props.location.state.from
                  ? this.props.location.state.type
                  : location.state && location.state.type
                    ? location.state.type
                    : undefined,
              referrer: location.state.referrer,
            }
          );
        } else {
          this.props.history.push(location.pathname);
        }
        this.props.handleNotSavedOrder(false);
      }
    );
  };

  @Bind()
  openSupplierModalaOnWo() {
    this.setState({
      pathNameForModal: `${this.state.pathNameForModal}.supplierName`,
      previousPathNameForModal: this.state.pathNameForModal,
      isModalOpenWo: true,
    });
  }

  @Bind()
  closeSupplierModal() {
    this.setState({
      isModalOpenWo: false,
      pathNameForModal: this.state.previousPathNameForModal,
    });
  }

  @Bind()
  resetSupplier() {
    this.setState({
      supplierId: 0,
      supplierName: '',
    });
  }

  @Bind()
  private async navigateToClient(id: number) {
    const { history } = this.props;
    if (id) {
      await handleUpdateLastViewedProject(id);
    }
    history.push(`/clients/${id === 0 ? '' : id}`);
  }
  @Bind()
  private handleBuckramSelect(e: ChangeEvent<HTMLSelectElement>): void {
    const name = e.target.name;
    const value = e.target.value;

    this.clearHighlightSection(name);

    this.updateStateByName(name, value);
  }
  @Bind()
  private handleFullnessSelect(e: ChangeEvent<HTMLSelectElement>): void {
    const name = e.target.name;
    const value = e.target.value;
    e.target.style.fontStyle = 'italic';
    this.clearHighlightSection(name);

    if (value !== '0') this.updateStateByName(name, value);
  }
}

/**
 * Return component properties from the redux state
 */
function mapStateToProps(state: RootState, ownProps: CalculatorOwnProps): CalculatorProps {
  return {
    ...ownProps,
    accountId: parseFloat(localStorage.getItem('accountId') || '0'),
    calculatorDefaults: state.account.calculatorDefaults,
    handleCloseModal: ownProps.handleCloseModal,
    handleNotSavedOrder: ownProps.handleNotSavedOrder,
    handleNewNavigation: ownProps.handleNewNavigation,
    triggerModal: ownProps.triggerModal,
    cantLogOut: ownProps.cantLogOut,
  };
}

export const CalculatorContainer = connect(mapStateToProps)(Calculator);
